
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9a5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9a5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dMrst", function(module, exports) {
module.exports = new URL("mid_ground_cloud_2-min.fd8940e5.png", import.meta.url).toString();

});

parcelRegister("5fPAV", function(module, exports) {
module.exports = new URL("midground_mountains-min.fcc27b4f.png", import.meta.url).toString();

});

parcelRegister("hzI90", function(module, exports) {
module.exports = new URL("mid_ground_cloud_1-min.43d652b5.png", import.meta.url).toString();

});

parcelRegister("lFo5J", function(module, exports) {
module.exports = new URL("farground_cloud_1.97eb9072.png", import.meta.url).toString();

});

parcelRegister("l6Gsm", function(module, exports) {
module.exports = new URL("torpedo.3fd5eec3.png", import.meta.url).toString();

});

parcelRegister("4b9q4", function(module, exports) {
module.exports = new URL("plane_1_blue.4bf9d835.png", import.meta.url).toString();

});

parcelRegister("gMZyJ", function(module, exports) {
module.exports = new URL("plane_2_blue.df65d8f9.png", import.meta.url).toString();

});

parcelRegister("h8hLB", function(module, exports) {
module.exports = new URL("plane_3_blue.7d0ec18d.png", import.meta.url).toString();

});

parcelRegister("eu2SF", function(module, exports) {
module.exports = new URL("plane_1_red.7236be4a.png", import.meta.url).toString();

});

parcelRegister("6lz8J", function(module, exports) {
module.exports = new URL("plane_2_red.6361f4a2.png", import.meta.url).toString();

});

parcelRegister("do74n", function(module, exports) {
module.exports = new URL("plane_3_red.419ba714.png", import.meta.url).toString();

});

parcelRegister("hBAKe", function(module, exports) {
module.exports = new URL("explosion.31069264.png", import.meta.url).toString();

});

parcelRegister("ikgU7", function(module, exports) {
module.exports = new URL("Smoke15Frames_White.563ab519.png", import.meta.url).toString();

});

parcelRegister("6ZeC8", function(module, exports) {
module.exports = new URL("Smoke15Frames_Black.bd896f7e.png", import.meta.url).toString();

});

parcelRegister("b51Pn", function(module, exports) {
module.exports = new URL("click.92e05379.mp3", import.meta.url).toString();

});

parcelRegister("5TVnK", function(module, exports) {
module.exports = new URL("joined.a7a4ca91.mp3", import.meta.url).toString();

});

parcelRegister("4V4tw", function(module, exports) {
module.exports = new URL("background.2ee6fce2.mp3", import.meta.url).toString();

});

parcelRegister("4qKe5", function(module, exports) {
module.exports = new URL("logo.b93ae0f9.png", import.meta.url).toString();

});

parcelRegister("3v9yr", function(module, exports) {

var $gcVP2 = parcelRequire("gcVP2");
var $28cbadb174d61f39$var$gen = function(text, options) {
    options = options || {};
    var typeNumber = options.typeNumber || 4;
    var errorCorrectLevel = options.errorCorrectLevel || "M";
    var size = options.size || 500;
    var qr;
    try {
        qr = $gcVP2(typeNumber, errorCorrectLevel || "M");
        qr.addData(text);
        qr.make();
    } catch (e) {
        if (typeNumber >= 40) throw new Error("Text too long to encode");
        else return $28cbadb174d61f39$var$gen(text, {
            size: size,
            errorCorrectLevel: errorCorrectLevel,
            typeNumber: typeNumber + 1
        });
    }
    // calc cellsize and margin
    var cellsize = parseInt(size / qr.getModuleCount());
    var margin = parseInt((size - qr.getModuleCount() * cellsize) / 2);
    return qr.createImgTag(cellsize, margin, size);
};
module.exports = $28cbadb174d61f39$var$gen;

});
parcelRegister("gcVP2", function(module, exports) {
//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//	http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//	http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
//---------------------------------------------------------------------
// qrcode
//---------------------------------------------------------------------
/**
 * qrcode
 * @param typeNumber 1 to 40
 * @param errorCorrectLevel 'L','M','Q','H'
 */ var $bcca9e9ebdf4dcdb$var$qrcode = function(typeNumber, errorCorrectLevel) {
    var PAD0 = 0xEC;
    var PAD1 = 0x11;
    var _typeNumber = typeNumber;
    var _errorCorrectLevel = $bcca9e9ebdf4dcdb$var$QRErrorCorrectLevel[errorCorrectLevel];
    var _modules = null;
    var _moduleCount = 0;
    var _dataCache = null;
    var _dataList = new Array();
    var _this = {};
    var makeImpl = function(test, maskPattern) {
        _moduleCount = _typeNumber * 4 + 17;
        _modules = function(moduleCount) {
            var modules = new Array(moduleCount);
            for(var row = 0; row < moduleCount; row += 1){
                modules[row] = new Array(moduleCount);
                for(var col = 0; col < moduleCount; col += 1)modules[row][col] = null;
            }
            return modules;
        }(_moduleCount);
        setupPositionProbePattern(0, 0);
        setupPositionProbePattern(_moduleCount - 7, 0);
        setupPositionProbePattern(0, _moduleCount - 7);
        setupPositionAdjustPattern();
        setupTimingPattern();
        setupTypeInfo(test, maskPattern);
        if (_typeNumber >= 7) setupTypeNumber(test);
        if (_dataCache == null) _dataCache = createData(_typeNumber, _errorCorrectLevel, _dataList);
        mapData(_dataCache, maskPattern);
    };
    var setupPositionProbePattern = function(row, col) {
        for(var r = -1; r <= 7; r += 1){
            if (row + r <= -1 || _moduleCount <= row + r) continue;
            for(var c = -1; c <= 7; c += 1){
                if (col + c <= -1 || _moduleCount <= col + c) continue;
                if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    var getBestMaskPattern = function() {
        var minLostPoint = 0;
        var pattern = 0;
        for(var i = 0; i < 8; i += 1){
            makeImpl(true, i);
            var lostPoint = $bcca9e9ebdf4dcdb$var$QRUtil.getLostPoint(_this);
            if (i == 0 || minLostPoint > lostPoint) {
                minLostPoint = lostPoint;
                pattern = i;
            }
        }
        return pattern;
    };
    var setupTimingPattern = function() {
        for(var r = 8; r < _moduleCount - 8; r += 1){
            if (_modules[r][6] != null) continue;
            _modules[r][6] = r % 2 == 0;
        }
        for(var c = 8; c < _moduleCount - 8; c += 1){
            if (_modules[6][c] != null) continue;
            _modules[6][c] = c % 2 == 0;
        }
    };
    var setupPositionAdjustPattern = function() {
        var pos = $bcca9e9ebdf4dcdb$var$QRUtil.getPatternPosition(_typeNumber);
        for(var i = 0; i < pos.length; i += 1)for(var j = 0; j < pos.length; j += 1){
            var row = pos[i];
            var col = pos[j];
            if (_modules[row][col] != null) continue;
            for(var r = -2; r <= 2; r += 1){
                for(var c = -2; c <= 2; c += 1)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    var setupTypeNumber = function(test) {
        var bits = $bcca9e9ebdf4dcdb$var$QRUtil.getBCHTypeNumber(_typeNumber);
        for(var i = 0; i < 18; i += 1){
            var mod = !test && (bits >> i & 1) == 1;
            _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
        }
        for(var i = 0; i < 18; i += 1){
            var mod = !test && (bits >> i & 1) == 1;
            _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
        }
    };
    var setupTypeInfo = function(test, maskPattern) {
        var data = _errorCorrectLevel << 3 | maskPattern;
        var bits = $bcca9e9ebdf4dcdb$var$QRUtil.getBCHTypeInfo(data);
        // vertical
        for(var i = 0; i < 15; i += 1){
            var mod = !test && (bits >> i & 1) == 1;
            if (i < 6) _modules[i][8] = mod;
            else if (i < 8) _modules[i + 1][8] = mod;
            else _modules[_moduleCount - 15 + i][8] = mod;
        }
        // horizontal
        for(var i = 0; i < 15; i += 1){
            var mod = !test && (bits >> i & 1) == 1;
            if (i < 8) _modules[8][_moduleCount - i - 1] = mod;
            else if (i < 9) _modules[8][15 - i - 1 + 1] = mod;
            else _modules[8][15 - i - 1] = mod;
        }
        // fixed module
        _modules[_moduleCount - 8][8] = !test;
    };
    var mapData = function(data, maskPattern) {
        var inc = -1;
        var row = _moduleCount - 1;
        var bitIndex = 7;
        var byteIndex = 0;
        var maskFunc = $bcca9e9ebdf4dcdb$var$QRUtil.getMaskFunction(maskPattern);
        for(var col = _moduleCount - 1; col > 0; col -= 2){
            if (col == 6) col -= 1;
            while(true){
                for(var c = 0; c < 2; c += 1)if (_modules[row][col - c] == null) {
                    var dark = false;
                    if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                    var mask = maskFunc(row, col - c);
                    if (mask) dark = !dark;
                    _modules[row][col - c] = dark;
                    bitIndex -= 1;
                    if (bitIndex == -1) {
                        byteIndex += 1;
                        bitIndex = 7;
                    }
                }
                row += inc;
                if (row < 0 || _moduleCount <= row) {
                    row -= inc;
                    inc = -inc;
                    break;
                }
            }
        }
    };
    var createBytes = function(buffer, rsBlocks) {
        var offset = 0;
        var maxDcCount = 0;
        var maxEcCount = 0;
        var dcdata = new Array(rsBlocks.length);
        var ecdata = new Array(rsBlocks.length);
        for(var r = 0; r < rsBlocks.length; r += 1){
            var dcCount = rsBlocks[r].dataCount;
            var ecCount = rsBlocks[r].totalCount - dcCount;
            maxDcCount = Math.max(maxDcCount, dcCount);
            maxEcCount = Math.max(maxEcCount, ecCount);
            dcdata[r] = new Array(dcCount);
            for(var i = 0; i < dcdata[r].length; i += 1)dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
            offset += dcCount;
            var rsPoly = $bcca9e9ebdf4dcdb$var$QRUtil.getErrorCorrectPolynomial(ecCount);
            var rawPoly = $bcca9e9ebdf4dcdb$var$qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
            var modPoly = rawPoly.mod(rsPoly);
            ecdata[r] = new Array(rsPoly.getLength() - 1);
            for(var i = 0; i < ecdata[r].length; i += 1){
                var modIndex = i + modPoly.getLength() - ecdata[r].length;
                ecdata[r][i] = modIndex >= 0 ? modPoly.getAt(modIndex) : 0;
            }
        }
        var totalCodeCount = 0;
        for(var i = 0; i < rsBlocks.length; i += 1)totalCodeCount += rsBlocks[i].totalCount;
        var data = new Array(totalCodeCount);
        var index = 0;
        for(var i = 0; i < maxDcCount; i += 1){
            for(var r = 0; r < rsBlocks.length; r += 1)if (i < dcdata[r].length) {
                data[index] = dcdata[r][i];
                index += 1;
            }
        }
        for(var i = 0; i < maxEcCount; i += 1){
            for(var r = 0; r < rsBlocks.length; r += 1)if (i < ecdata[r].length) {
                data[index] = ecdata[r][i];
                index += 1;
            }
        }
        return data;
    };
    var createData = function(typeNumber, errorCorrectLevel, dataList) {
        var rsBlocks = $bcca9e9ebdf4dcdb$var$QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
        var buffer = $bcca9e9ebdf4dcdb$var$qrBitBuffer();
        for(var i = 0; i < dataList.length; i += 1){
            var data = dataList[i];
            buffer.put(data.getMode(), 4);
            buffer.put(data.getLength(), $bcca9e9ebdf4dcdb$var$QRUtil.getLengthInBits(data.getMode(), typeNumber));
            data.write(buffer);
        }
        // calc num max data.
        var totalDataCount = 0;
        for(var i = 0; i < rsBlocks.length; i += 1)totalDataCount += rsBlocks[i].dataCount;
        if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
        // end code
        if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
        // padding
        while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
        // padding
        while(true){
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD0, 8);
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD1, 8);
        }
        return createBytes(buffer, rsBlocks);
    };
    _this.addData = function(data) {
        var newData = $bcca9e9ebdf4dcdb$var$qr8BitByte(data);
        _dataList.push(newData);
        _dataCache = null;
    };
    _this.isDark = function(row, col) {
        if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) throw new Error(row + "," + col);
        return _modules[row][col];
    };
    _this.getModuleCount = function() {
        return _moduleCount;
    };
    _this.make = function() {
        makeImpl(false, getBestMaskPattern());
    };
    _this.createTableTag = function(cellSize, margin) {
        cellSize = cellSize || 2;
        margin = typeof margin == "undefined" ? cellSize * 4 : margin;
        var qrHtml = "";
        qrHtml += '<table style="';
        qrHtml += " border-width: 0px; border-style: none;";
        qrHtml += " border-collapse: collapse;";
        qrHtml += " padding: 0px; margin: " + margin + "px;";
        qrHtml += '">';
        qrHtml += "<tbody>";
        for(var r = 0; r < _this.getModuleCount(); r += 1){
            qrHtml += "<tr>";
            for(var c = 0; c < _this.getModuleCount(); c += 1){
                qrHtml += '<td style="';
                qrHtml += " border-width: 0px; border-style: none;";
                qrHtml += " border-collapse: collapse;";
                qrHtml += " padding: 0px; margin: 0px;";
                qrHtml += " width: " + cellSize + "px;";
                qrHtml += " height: " + cellSize + "px;";
                qrHtml += " background-color: ";
                qrHtml += _this.isDark(r, c) ? "#000000" : "#ffffff";
                qrHtml += ";";
                qrHtml += '"/>';
            }
            qrHtml += "</tr>";
        }
        qrHtml += "</tbody>";
        qrHtml += "</table>";
        return qrHtml;
    };
    _this.createImgTag = function(cellSize, margin, size) {
        cellSize = cellSize || 2;
        margin = typeof margin == "undefined" ? cellSize * 4 : margin;
        var min = margin;
        var max = _this.getModuleCount() * cellSize + margin;
        return $bcca9e9ebdf4dcdb$var$createImgTag(size, size, function(x, y) {
            if (min <= x && x < max && min <= y && y < max) {
                var c = Math.floor((x - min) / cellSize);
                var r = Math.floor((y - min) / cellSize);
                return _this.isDark(r, c) ? 0 : 1;
            } else return 1;
        });
    };
    return _this;
};
//---------------------------------------------------------------------
// qrcode.stringToBytes
//---------------------------------------------------------------------
$bcca9e9ebdf4dcdb$var$qrcode.stringToBytes = function(s) {
    var bytes = new Array();
    for(var i = 0; i < s.length; i += 1){
        var c = s.charCodeAt(i);
        bytes.push(c & 0xff);
    }
    return bytes;
};
//---------------------------------------------------------------------
// qrcode.createStringToBytes
//---------------------------------------------------------------------
/**
 * @param unicodeData base64 string of byte array.
 * [16bit Unicode],[16bit Bytes], ...
 * @param numChars
 */ $bcca9e9ebdf4dcdb$var$qrcode.createStringToBytes = function(unicodeData, numChars) {
    // create conversion map.
    var unicodeMap = function() {
        var bin = $bcca9e9ebdf4dcdb$var$base64DecodeInputStream(unicodeData);
        var read = function() {
            var b = bin.read();
            if (b == -1) throw new Error();
            return b;
        };
        var count = 0;
        var unicodeMap = {};
        while(true){
            var b0 = bin.read();
            if (b0 == -1) break;
            var b1 = read();
            var b2 = read();
            var b3 = read();
            var k = String.fromCharCode(b0 << 8 | b1);
            var v = b2 << 8 | b3;
            unicodeMap[k] = v;
            count += 1;
        }
        if (count != numChars) throw new Error(count + " != " + numChars);
        return unicodeMap;
    }();
    var unknownChar = "?".charCodeAt(0);
    return function(s) {
        var bytes = new Array();
        for(var i = 0; i < s.length; i += 1){
            var c = s.charCodeAt(i);
            if (c < 128) bytes.push(c);
            else {
                var b = unicodeMap[s.charAt(i)];
                if (typeof b == "number") {
                    if ((b & 0xff) == b) // 1byte
                    bytes.push(b);
                    else {
                        // 2bytes
                        bytes.push(b >>> 8);
                        bytes.push(b & 0xff);
                    }
                } else bytes.push(unknownChar);
            }
        }
        return bytes;
    };
};
//---------------------------------------------------------------------
// QRMode
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$QRMode = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};
//---------------------------------------------------------------------
// QRErrorCorrectLevel
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$QRErrorCorrectLevel = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};
//---------------------------------------------------------------------
// QRMaskPattern
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
//---------------------------------------------------------------------
// QRUtil
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$QRUtil = function() {
    var PATTERN_POSITION_TABLE = [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ];
    var G15 = 1335;
    var G18 = 7973;
    var G15_MASK = 21522;
    var _this = {};
    var getBCHDigit = function(data) {
        var digit = 0;
        while(data != 0){
            digit += 1;
            data >>>= 1;
        }
        return digit;
    };
    _this.getBCHTypeInfo = function(data) {
        var d = data << 10;
        while(getBCHDigit(d) - getBCHDigit(G15) >= 0)d ^= G15 << getBCHDigit(d) - getBCHDigit(G15);
        return (data << 10 | d) ^ G15_MASK;
    };
    _this.getBCHTypeNumber = function(data) {
        var d = data << 12;
        while(getBCHDigit(d) - getBCHDigit(G18) >= 0)d ^= G18 << getBCHDigit(d) - getBCHDigit(G18);
        return data << 12 | d;
    };
    _this.getPatternPosition = function(typeNumber) {
        return PATTERN_POSITION_TABLE[typeNumber - 1];
    };
    _this.getMaskFunction = function(maskPattern) {
        switch(maskPattern){
            case $bcca9e9ebdf4dcdb$var$QRMaskPattern.PATTERN000:
                return function(i, j) {
                    return (i + j) % 2 == 0;
                };
            case $bcca9e9ebdf4dcdb$var$QRMaskPattern.PATTERN001:
                return function(i, j) {
                    return i % 2 == 0;
                };
            case $bcca9e9ebdf4dcdb$var$QRMaskPattern.PATTERN010:
                return function(i, j) {
                    return j % 3 == 0;
                };
            case $bcca9e9ebdf4dcdb$var$QRMaskPattern.PATTERN011:
                return function(i, j) {
                    return (i + j) % 3 == 0;
                };
            case $bcca9e9ebdf4dcdb$var$QRMaskPattern.PATTERN100:
                return function(i, j) {
                    return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
                };
            case $bcca9e9ebdf4dcdb$var$QRMaskPattern.PATTERN101:
                return function(i, j) {
                    return i * j % 2 + i * j % 3 == 0;
                };
            case $bcca9e9ebdf4dcdb$var$QRMaskPattern.PATTERN110:
                return function(i, j) {
                    return (i * j % 2 + i * j % 3) % 2 == 0;
                };
            case $bcca9e9ebdf4dcdb$var$QRMaskPattern.PATTERN111:
                return function(i, j) {
                    return (i * j % 3 + (i + j) % 2) % 2 == 0;
                };
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    };
    _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
        var a = $bcca9e9ebdf4dcdb$var$qrPolynomial([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i += 1)a = a.multiply($bcca9e9ebdf4dcdb$var$qrPolynomial([
            1,
            $bcca9e9ebdf4dcdb$var$QRMath.gexp(i)
        ], 0));
        return a;
    };
    _this.getLengthInBits = function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_NUMBER:
                return 10;
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_ALPHA_NUM:
                return 9;
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_8BIT_BYTE:
                return 8;
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_NUMBER:
                return 12;
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_ALPHA_NUM:
                return 11;
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_NUMBER:
                return 14;
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_ALPHA_NUM:
                return 13;
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $bcca9e9ebdf4dcdb$var$QRMode.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    };
    _this.getLostPoint = function(qrcode) {
        var moduleCount = qrcode.getModuleCount();
        var lostPoint = 0;
        // LEVEL1
        for(var row = 0; row < moduleCount; row += 1)for(var col = 0; col < moduleCount; col += 1){
            var sameCount = 0;
            var dark = qrcode.isDark(row, col);
            for(var r = -1; r <= 1; r += 1){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c += 1){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrcode.isDark(row + r, col + c)) sameCount += 1;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(var row = 0; row < moduleCount - 1; row += 1)for(var col = 0; col < moduleCount - 1; col += 1){
            var count = 0;
            if (qrcode.isDark(row, col)) count += 1;
            if (qrcode.isDark(row + 1, col)) count += 1;
            if (qrcode.isDark(row, col + 1)) count += 1;
            if (qrcode.isDark(row + 1, col + 1)) count += 1;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(var row = 0; row < moduleCount; row += 1){
            for(var col = 0; col < moduleCount - 6; col += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row, col + 1) && qrcode.isDark(row, col + 2) && qrcode.isDark(row, col + 3) && qrcode.isDark(row, col + 4) && !qrcode.isDark(row, col + 5) && qrcode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col += 1){
            for(var row = 0; row < moduleCount - 6; row += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row + 1, col) && qrcode.isDark(row + 2, col) && qrcode.isDark(row + 3, col) && qrcode.isDark(row + 4, col) && !qrcode.isDark(row + 5, col) && qrcode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col += 1){
            for(var row = 0; row < moduleCount; row += 1)if (qrcode.isDark(row, col)) darkCount += 1;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    };
    return _this;
}();
//---------------------------------------------------------------------
// QRMath
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$QRMath = function() {
    var EXP_TABLE = new Array(256);
    var LOG_TABLE = new Array(256);
    // initialize tables
    for(var i = 0; i < 8; i += 1)EXP_TABLE[i] = 1 << i;
    for(var i = 8; i < 256; i += 1)EXP_TABLE[i] = EXP_TABLE[i - 4] ^ EXP_TABLE[i - 5] ^ EXP_TABLE[i - 6] ^ EXP_TABLE[i - 8];
    for(var i = 0; i < 255; i += 1)LOG_TABLE[EXP_TABLE[i]] = i;
    var _this = {};
    _this.glog = function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return LOG_TABLE[n];
    };
    _this.gexp = function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return EXP_TABLE[n];
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrPolynomial
//---------------------------------------------------------------------
function $bcca9e9ebdf4dcdb$var$qrPolynomial(num, shift) {
    if (typeof num.length == "undefined") throw new Error(num.length + "/" + shift);
    var _num = function() {
        var offset = 0;
        while(offset < num.length && num[offset] == 0)offset += 1;
        var _num = new Array(num.length - offset + shift);
        for(var i = 0; i < num.length - offset; i += 1)_num[i] = num[i + offset];
        return _num;
    }();
    var _this = {};
    _this.getAt = function(index) {
        return _num[index];
    };
    _this.getLength = function() {
        return _num.length;
    };
    _this.multiply = function(e) {
        var num = new Array(_this.getLength() + e.getLength() - 1);
        for(var i = 0; i < _this.getLength(); i += 1)for(var j = 0; j < e.getLength(); j += 1)num[i + j] ^= $bcca9e9ebdf4dcdb$var$QRMath.gexp($bcca9e9ebdf4dcdb$var$QRMath.glog(_this.getAt(i)) + $bcca9e9ebdf4dcdb$var$QRMath.glog(e.getAt(j)));
        return $bcca9e9ebdf4dcdb$var$qrPolynomial(num, 0);
    };
    _this.mod = function(e) {
        if (_this.getLength() - e.getLength() < 0) return _this;
        var ratio = $bcca9e9ebdf4dcdb$var$QRMath.glog(_this.getAt(0)) - $bcca9e9ebdf4dcdb$var$QRMath.glog(e.getAt(0));
        var num = new Array(_this.getLength());
        for(var i = 0; i < _this.getLength(); i += 1)num[i] = _this.getAt(i);
        for(var i = 0; i < e.getLength(); i += 1)num[i] ^= $bcca9e9ebdf4dcdb$var$QRMath.gexp($bcca9e9ebdf4dcdb$var$QRMath.glog(e.getAt(i)) + ratio);
        // recursive call
        return $bcca9e9ebdf4dcdb$var$qrPolynomial(num, 0).mod(e);
    };
    return _this;
}
//---------------------------------------------------------------------
// QRRSBlock
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$QRRSBlock = function() {
    // [1: [L, M, Q, H], ..]
    var RS_BLOCK_TABLE = [
        [
            1,
            26,
            19
        ],
        [
            1,
            26,
            16
        ],
        [
            1,
            26,
            13
        ],
        [
            1,
            26,
            9
        ],
        [
            1,
            44,
            34
        ],
        [
            1,
            44,
            28
        ],
        [
            1,
            44,
            22
        ],
        [
            1,
            44,
            16
        ],
        [
            1,
            70,
            55
        ],
        [
            1,
            70,
            44
        ],
        [
            2,
            35,
            17
        ],
        [
            2,
            35,
            13
        ],
        [
            1,
            100,
            80
        ],
        [
            2,
            50,
            32
        ],
        [
            2,
            50,
            24
        ],
        [
            4,
            25,
            9
        ],
        [
            1,
            134,
            108
        ],
        [
            2,
            67,
            43
        ],
        [
            2,
            33,
            15,
            2,
            34,
            16
        ],
        [
            2,
            33,
            11,
            2,
            34,
            12
        ],
        [
            2,
            86,
            68
        ],
        [
            4,
            43,
            27
        ],
        [
            4,
            43,
            19
        ],
        [
            4,
            43,
            15
        ],
        [
            2,
            98,
            78
        ],
        [
            4,
            49,
            31
        ],
        [
            2,
            32,
            14,
            4,
            33,
            15
        ],
        [
            4,
            39,
            13,
            1,
            40,
            14
        ],
        [
            2,
            121,
            97
        ],
        [
            2,
            60,
            38,
            2,
            61,
            39
        ],
        [
            4,
            40,
            18,
            2,
            41,
            19
        ],
        [
            4,
            40,
            14,
            2,
            41,
            15
        ],
        [
            2,
            146,
            116
        ],
        [
            3,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            36,
            16,
            4,
            37,
            17
        ],
        [
            4,
            36,
            12,
            4,
            37,
            13
        ],
        [
            2,
            86,
            68,
            2,
            87,
            69
        ],
        [
            4,
            69,
            43,
            1,
            70,
            44
        ],
        [
            6,
            43,
            19,
            2,
            44,
            20
        ],
        [
            6,
            43,
            15,
            2,
            44,
            16
        ],
        [
            4,
            101,
            81
        ],
        [
            1,
            80,
            50,
            4,
            81,
            51
        ],
        [
            4,
            50,
            22,
            4,
            51,
            23
        ],
        [
            3,
            36,
            12,
            8,
            37,
            13
        ],
        [
            2,
            116,
            92,
            2,
            117,
            93
        ],
        [
            6,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            46,
            20,
            6,
            47,
            21
        ],
        [
            7,
            42,
            14,
            4,
            43,
            15
        ],
        [
            4,
            133,
            107
        ],
        [
            8,
            59,
            37,
            1,
            60,
            38
        ],
        [
            8,
            44,
            20,
            4,
            45,
            21
        ],
        [
            12,
            33,
            11,
            4,
            34,
            12
        ],
        [
            3,
            145,
            115,
            1,
            146,
            116
        ],
        [
            4,
            64,
            40,
            5,
            65,
            41
        ],
        [
            11,
            36,
            16,
            5,
            37,
            17
        ],
        [
            11,
            36,
            12,
            5,
            37,
            13
        ],
        [
            5,
            109,
            87,
            1,
            110,
            88
        ],
        [
            5,
            65,
            41,
            5,
            66,
            42
        ],
        [
            5,
            54,
            24,
            7,
            55,
            25
        ],
        [
            11,
            36,
            12
        ],
        [
            5,
            122,
            98,
            1,
            123,
            99
        ],
        [
            7,
            73,
            45,
            3,
            74,
            46
        ],
        [
            15,
            43,
            19,
            2,
            44,
            20
        ],
        [
            3,
            45,
            15,
            13,
            46,
            16
        ],
        [
            1,
            135,
            107,
            5,
            136,
            108
        ],
        [
            10,
            74,
            46,
            1,
            75,
            47
        ],
        [
            1,
            50,
            22,
            15,
            51,
            23
        ],
        [
            2,
            42,
            14,
            17,
            43,
            15
        ],
        [
            5,
            150,
            120,
            1,
            151,
            121
        ],
        [
            9,
            69,
            43,
            4,
            70,
            44
        ],
        [
            17,
            50,
            22,
            1,
            51,
            23
        ],
        [
            2,
            42,
            14,
            19,
            43,
            15
        ],
        [
            3,
            141,
            113,
            4,
            142,
            114
        ],
        [
            3,
            70,
            44,
            11,
            71,
            45
        ],
        [
            17,
            47,
            21,
            4,
            48,
            22
        ],
        [
            9,
            39,
            13,
            16,
            40,
            14
        ],
        [
            3,
            135,
            107,
            5,
            136,
            108
        ],
        [
            3,
            67,
            41,
            13,
            68,
            42
        ],
        [
            15,
            54,
            24,
            5,
            55,
            25
        ],
        [
            15,
            43,
            15,
            10,
            44,
            16
        ],
        [
            4,
            144,
            116,
            4,
            145,
            117
        ],
        [
            17,
            68,
            42
        ],
        [
            17,
            50,
            22,
            6,
            51,
            23
        ],
        [
            19,
            46,
            16,
            6,
            47,
            17
        ],
        [
            2,
            139,
            111,
            7,
            140,
            112
        ],
        [
            17,
            74,
            46
        ],
        [
            7,
            54,
            24,
            16,
            55,
            25
        ],
        [
            34,
            37,
            13
        ],
        [
            4,
            151,
            121,
            5,
            152,
            122
        ],
        [
            4,
            75,
            47,
            14,
            76,
            48
        ],
        [
            11,
            54,
            24,
            14,
            55,
            25
        ],
        [
            16,
            45,
            15,
            14,
            46,
            16
        ],
        [
            6,
            147,
            117,
            4,
            148,
            118
        ],
        [
            6,
            73,
            45,
            14,
            74,
            46
        ],
        [
            11,
            54,
            24,
            16,
            55,
            25
        ],
        [
            30,
            46,
            16,
            2,
            47,
            17
        ],
        [
            8,
            132,
            106,
            4,
            133,
            107
        ],
        [
            8,
            75,
            47,
            13,
            76,
            48
        ],
        [
            7,
            54,
            24,
            22,
            55,
            25
        ],
        [
            22,
            45,
            15,
            13,
            46,
            16
        ],
        [
            10,
            142,
            114,
            2,
            143,
            115
        ],
        [
            19,
            74,
            46,
            4,
            75,
            47
        ],
        [
            28,
            50,
            22,
            6,
            51,
            23
        ],
        [
            33,
            46,
            16,
            4,
            47,
            17
        ],
        [
            8,
            152,
            122,
            4,
            153,
            123
        ],
        [
            22,
            73,
            45,
            3,
            74,
            46
        ],
        [
            8,
            53,
            23,
            26,
            54,
            24
        ],
        [
            12,
            45,
            15,
            28,
            46,
            16
        ],
        [
            3,
            147,
            117,
            10,
            148,
            118
        ],
        [
            3,
            73,
            45,
            23,
            74,
            46
        ],
        [
            4,
            54,
            24,
            31,
            55,
            25
        ],
        [
            11,
            45,
            15,
            31,
            46,
            16
        ],
        [
            7,
            146,
            116,
            7,
            147,
            117
        ],
        [
            21,
            73,
            45,
            7,
            74,
            46
        ],
        [
            1,
            53,
            23,
            37,
            54,
            24
        ],
        [
            19,
            45,
            15,
            26,
            46,
            16
        ],
        [
            5,
            145,
            115,
            10,
            146,
            116
        ],
        [
            19,
            75,
            47,
            10,
            76,
            48
        ],
        [
            15,
            54,
            24,
            25,
            55,
            25
        ],
        [
            23,
            45,
            15,
            25,
            46,
            16
        ],
        [
            13,
            145,
            115,
            3,
            146,
            116
        ],
        [
            2,
            74,
            46,
            29,
            75,
            47
        ],
        [
            42,
            54,
            24,
            1,
            55,
            25
        ],
        [
            23,
            45,
            15,
            28,
            46,
            16
        ],
        [
            17,
            145,
            115
        ],
        [
            10,
            74,
            46,
            23,
            75,
            47
        ],
        [
            10,
            54,
            24,
            35,
            55,
            25
        ],
        [
            19,
            45,
            15,
            35,
            46,
            16
        ],
        [
            17,
            145,
            115,
            1,
            146,
            116
        ],
        [
            14,
            74,
            46,
            21,
            75,
            47
        ],
        [
            29,
            54,
            24,
            19,
            55,
            25
        ],
        [
            11,
            45,
            15,
            46,
            46,
            16
        ],
        [
            13,
            145,
            115,
            6,
            146,
            116
        ],
        [
            14,
            74,
            46,
            23,
            75,
            47
        ],
        [
            44,
            54,
            24,
            7,
            55,
            25
        ],
        [
            59,
            46,
            16,
            1,
            47,
            17
        ],
        [
            12,
            151,
            121,
            7,
            152,
            122
        ],
        [
            12,
            75,
            47,
            26,
            76,
            48
        ],
        [
            39,
            54,
            24,
            14,
            55,
            25
        ],
        [
            22,
            45,
            15,
            41,
            46,
            16
        ],
        [
            6,
            151,
            121,
            14,
            152,
            122
        ],
        [
            6,
            75,
            47,
            34,
            76,
            48
        ],
        [
            46,
            54,
            24,
            10,
            55,
            25
        ],
        [
            2,
            45,
            15,
            64,
            46,
            16
        ],
        [
            17,
            152,
            122,
            4,
            153,
            123
        ],
        [
            29,
            74,
            46,
            14,
            75,
            47
        ],
        [
            49,
            54,
            24,
            10,
            55,
            25
        ],
        [
            24,
            45,
            15,
            46,
            46,
            16
        ],
        [
            4,
            152,
            122,
            18,
            153,
            123
        ],
        [
            13,
            74,
            46,
            32,
            75,
            47
        ],
        [
            48,
            54,
            24,
            14,
            55,
            25
        ],
        [
            42,
            45,
            15,
            32,
            46,
            16
        ],
        [
            20,
            147,
            117,
            4,
            148,
            118
        ],
        [
            40,
            75,
            47,
            7,
            76,
            48
        ],
        [
            43,
            54,
            24,
            22,
            55,
            25
        ],
        [
            10,
            45,
            15,
            67,
            46,
            16
        ],
        [
            19,
            148,
            118,
            6,
            149,
            119
        ],
        [
            18,
            75,
            47,
            31,
            76,
            48
        ],
        [
            34,
            54,
            24,
            34,
            55,
            25
        ],
        [
            20,
            45,
            15,
            61,
            46,
            16
        ]
    ];
    var qrRSBlock = function(totalCount, dataCount) {
        var _this = {};
        _this.totalCount = totalCount;
        _this.dataCount = dataCount;
        return _this;
    };
    var _this = {};
    var getRsBlockTable = function(typeNumber, errorCorrectLevel) {
        switch(errorCorrectLevel){
            case $bcca9e9ebdf4dcdb$var$QRErrorCorrectLevel.L:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
            case $bcca9e9ebdf4dcdb$var$QRErrorCorrectLevel.M:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
            case $bcca9e9ebdf4dcdb$var$QRErrorCorrectLevel.Q:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
            case $bcca9e9ebdf4dcdb$var$QRErrorCorrectLevel.H:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
            default:
                return undefined;
        }
    };
    _this.getRSBlocks = function(typeNumber, errorCorrectLevel) {
        var rsBlock = getRsBlockTable(typeNumber, errorCorrectLevel);
        if (typeof rsBlock == "undefined") throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
        var length = rsBlock.length / 3;
        var list = new Array();
        for(var i = 0; i < length; i += 1){
            var count = rsBlock[i * 3 + 0];
            var totalCount = rsBlock[i * 3 + 1];
            var dataCount = rsBlock[i * 3 + 2];
            for(var j = 0; j < count; j += 1)list.push(qrRSBlock(totalCount, dataCount));
        }
        return list;
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrBitBuffer
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$qrBitBuffer = function() {
    var _buffer = new Array();
    var _length = 0;
    var _this = {};
    _this.getBuffer = function() {
        return _buffer;
    };
    _this.getAt = function(index) {
        var bufIndex = Math.floor(index / 8);
        return (_buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    };
    _this.put = function(num, length) {
        for(var i = 0; i < length; i += 1)_this.putBit((num >>> length - i - 1 & 1) == 1);
    };
    _this.getLengthInBits = function() {
        return _length;
    };
    _this.putBit = function(bit) {
        var bufIndex = Math.floor(_length / 8);
        if (_buffer.length <= bufIndex) _buffer.push(0);
        if (bit) _buffer[bufIndex] |= 0x80 >>> _length % 8;
        _length += 1;
    };
    return _this;
};
//---------------------------------------------------------------------
// qr8BitByte
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$qr8BitByte = function(data) {
    var _mode = $bcca9e9ebdf4dcdb$var$QRMode.MODE_8BIT_BYTE;
    var _data = data;
    var _parsedData = [];
    var _this = {};
    // Added to support UTF-8 Characters
    for(var i = 0, l = _data.length; i < l; i++){
        var byteArray = [];
        var code = _data.charCodeAt(i);
        if (code > 0x10000) {
            byteArray[0] = 0xF0 | (code & 0x1C0000) >>> 18;
            byteArray[1] = 0x80 | (code & 0x3F000) >>> 12;
            byteArray[2] = 0x80 | (code & 0xFC0) >>> 6;
            byteArray[3] = 0x80 | code & 0x3F;
        } else if (code > 0x800) {
            byteArray[0] = 0xE0 | (code & 0xF000) >>> 12;
            byteArray[1] = 0x80 | (code & 0xFC0) >>> 6;
            byteArray[2] = 0x80 | code & 0x3F;
        } else if (code > 0x80) {
            byteArray[0] = 0xC0 | (code & 0x7C0) >>> 6;
            byteArray[1] = 0x80 | code & 0x3F;
        } else byteArray[0] = code;
        // Fix Unicode corruption bug
        _parsedData.push(byteArray);
    }
    _parsedData = Array.prototype.concat.apply([], _parsedData);
    if (_parsedData.length != _data.length) {
        _parsedData.unshift(191);
        _parsedData.unshift(187);
        _parsedData.unshift(239);
    }
    var _bytes = _parsedData;
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _bytes.length;
    };
    _this.write = function(buffer) {
        for(var i = 0; i < _bytes.length; i += 1)buffer.put(_bytes[i], 8);
    };
    return _this;
};
//=====================================================================
// GIF Support etc.
//
//---------------------------------------------------------------------
// byteArrayOutputStream
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$byteArrayOutputStream = function() {
    var _bytes = new Array();
    var _this = {};
    _this.writeByte = function(b) {
        _bytes.push(b & 0xff);
    };
    _this.writeShort = function(i) {
        _this.writeByte(i);
        _this.writeByte(i >>> 8);
    };
    _this.writeBytes = function(b, off, len) {
        off = off || 0;
        len = len || b.length;
        for(var i = 0; i < len; i += 1)_this.writeByte(b[i + off]);
    };
    _this.writeString = function(s) {
        for(var i = 0; i < s.length; i += 1)_this.writeByte(s.charCodeAt(i));
    };
    _this.toByteArray = function() {
        return _bytes;
    };
    _this.toString = function() {
        var s = "";
        s += "[";
        for(var i = 0; i < _bytes.length; i += 1){
            if (i > 0) s += ",";
            s += _bytes[i];
        }
        s += "]";
        return s;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64EncodeOutputStream
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$base64EncodeOutputStream = function() {
    var _buffer = 0;
    var _buflen = 0;
    var _length = 0;
    var _base64 = "";
    var _this = {};
    var writeEncoded = function(b) {
        _base64 += String.fromCharCode(encode(b & 0x3f));
    };
    var encode = function(n) {
        if (n < 0) ;
        else if (n < 26) return 0x41 + n;
        else if (n < 52) return 0x61 + (n - 26);
        else if (n < 62) return 0x30 + (n - 52);
        else if (n == 62) return 0x2b;
        else if (n == 63) return 0x2f;
        throw new Error("n:" + n);
    };
    _this.writeByte = function(n) {
        _buffer = _buffer << 8 | n & 0xff;
        _buflen += 8;
        _length += 1;
        while(_buflen >= 6){
            writeEncoded(_buffer >>> _buflen - 6);
            _buflen -= 6;
        }
    };
    _this.flush = function() {
        if (_buflen > 0) {
            writeEncoded(_buffer << 6 - _buflen);
            _buffer = 0;
            _buflen = 0;
        }
        if (_length % 3 != 0) {
            // padding
            var padlen = 3 - _length % 3;
            for(var i = 0; i < padlen; i += 1)_base64 += "=";
        }
    };
    _this.toString = function() {
        return _base64;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64DecodeInputStream
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$base64DecodeInputStream = function(str) {
    var _str = str;
    var _pos = 0;
    var _buffer = 0;
    var _buflen = 0;
    var _this = {};
    _this.read = function() {
        while(_buflen < 8){
            if (_pos >= _str.length) {
                if (_buflen == 0) return -1;
                throw new Error("unexpected end of file./" + _buflen);
            }
            var c = _str.charAt(_pos);
            _pos += 1;
            if (c == "=") {
                _buflen = 0;
                return -1;
            } else if (c.match(/^\s$/)) continue;
            _buffer = _buffer << 6 | decode(c.charCodeAt(0));
            _buflen += 6;
        }
        var n = _buffer >>> _buflen - 8 & 0xff;
        _buflen -= 8;
        return n;
    };
    var decode = function(c) {
        if (0x41 <= c && c <= 0x5a) return c - 0x41;
        else if (0x61 <= c && c <= 0x7a) return c - 0x61 + 26;
        else if (0x30 <= c && c <= 0x39) return c - 0x30 + 52;
        else if (c == 0x2b) return 62;
        else if (c == 0x2f) return 63;
        else throw new Error("c:" + c);
    };
    return _this;
};
//---------------------------------------------------------------------
// gifImage (B/W)
//---------------------------------------------------------------------
var $bcca9e9ebdf4dcdb$var$gifImage = function(width, height) {
    var _width = width;
    var _height = height;
    var _data = new Array(width * height);
    var _this = {};
    _this.setPixel = function(x, y, pixel) {
        _data[y * _width + x] = pixel;
    };
    _this.write = function(out) {
        //---------------------------------
        // GIF Signature
        out.writeString("GIF87a");
        //---------------------------------
        // Screen Descriptor
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0x80); // 2bit
        out.writeByte(0);
        out.writeByte(0);
        //---------------------------------
        // Global Color Map
        // black
        out.writeByte(0x00);
        out.writeByte(0x00);
        out.writeByte(0x00);
        // white
        out.writeByte(0xff);
        out.writeByte(0xff);
        out.writeByte(0xff);
        //---------------------------------
        // Image Descriptor
        out.writeString(",");
        out.writeShort(0);
        out.writeShort(0);
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0);
        //---------------------------------
        // Local Color Map
        //---------------------------------
        // Raster Data
        var lzwMinCodeSize = 2;
        var raster = getLZWRaster(lzwMinCodeSize);
        out.writeByte(lzwMinCodeSize);
        var offset = 0;
        while(raster.length - offset > 255){
            out.writeByte(255);
            out.writeBytes(raster, offset, 255);
            offset += 255;
        }
        out.writeByte(raster.length - offset);
        out.writeBytes(raster, offset, raster.length - offset);
        out.writeByte(0x00);
        //---------------------------------
        // GIF Terminator
        out.writeString(";");
    };
    var bitOutputStream = function(out) {
        var _out = out;
        var _bitLength = 0;
        var _bitBuffer = 0;
        var _this = {};
        _this.write = function(data, length) {
            if (data >>> length != 0) throw new Error("length over");
            while(_bitLength + length >= 8){
                _out.writeByte(0xff & (data << _bitLength | _bitBuffer));
                length -= 8 - _bitLength;
                data >>>= 8 - _bitLength;
                _bitBuffer = 0;
                _bitLength = 0;
            }
            _bitBuffer = data << _bitLength | _bitBuffer;
            _bitLength = _bitLength + length;
        };
        _this.flush = function() {
            if (_bitLength > 0) _out.writeByte(_bitBuffer);
        };
        return _this;
    };
    var getLZWRaster = function(lzwMinCodeSize) {
        var clearCode = 1 << lzwMinCodeSize;
        var endCode = (1 << lzwMinCodeSize) + 1;
        var bitLength = lzwMinCodeSize + 1;
        // Setup LZWTable
        var table = lzwTable();
        for(var i = 0; i < clearCode; i += 1)table.add(String.fromCharCode(i));
        table.add(String.fromCharCode(clearCode));
        table.add(String.fromCharCode(endCode));
        var byteOut = $bcca9e9ebdf4dcdb$var$byteArrayOutputStream();
        var bitOut = bitOutputStream(byteOut);
        // clear code
        bitOut.write(clearCode, bitLength);
        var dataIndex = 0;
        var s = String.fromCharCode(_data[dataIndex]);
        dataIndex += 1;
        while(dataIndex < _data.length){
            var c = String.fromCharCode(_data[dataIndex]);
            dataIndex += 1;
            if (table.contains(s + c)) s = s + c;
            else {
                bitOut.write(table.indexOf(s), bitLength);
                if (table.size() < 0xfff) {
                    if (table.size() == 1 << bitLength) bitLength += 1;
                    table.add(s + c);
                }
                s = c;
            }
        }
        bitOut.write(table.indexOf(s), bitLength);
        // end code
        bitOut.write(endCode, bitLength);
        bitOut.flush();
        return byteOut.toByteArray();
    };
    var lzwTable = function() {
        var _map = {};
        var _size = 0;
        var _this = {};
        _this.add = function(key) {
            if (_this.contains(key)) throw new Error("dup key:" + key);
            _map[key] = _size;
            _size += 1;
        };
        _this.size = function() {
            return _size;
        };
        _this.indexOf = function(key) {
            return _map[key];
        };
        _this.contains = function(key) {
            return typeof _map[key] != "undefined";
        };
        return _this;
    };
    return _this;
};
var $bcca9e9ebdf4dcdb$var$createImgTag = function(width, height, getPixel, alt) {
    var gif = $bcca9e9ebdf4dcdb$var$gifImage(width, height);
    for(var y = 0; y < height; y += 1)for(var x = 0; x < width; x += 1)gif.setPixel(x, y, getPixel(x, y));
    var b = $bcca9e9ebdf4dcdb$var$byteArrayOutputStream();
    gif.write(b);
    var base64 = $bcca9e9ebdf4dcdb$var$base64EncodeOutputStream();
    var bytes = b.toByteArray();
    for(var i = 0; i < bytes.length; i += 1)base64.writeByte(bytes[i]);
    base64.flush();
    var img = "";
    img += "data:image/gif;base64,";
    img += base64;
    return img;
};
//---------------------------------------------------------------------
// returns qrcode function.
module.exports = $bcca9e9ebdf4dcdb$var$qrcode;

});


parcelRegister("bd78o", function(module, exports) {
module.exports = new URL("button.2a63e86a.png", import.meta.url).toString();

});

var $adc7cb3c45508c7c$var$yi = Object.defineProperty;
var $adc7cb3c45508c7c$var$i = (n, e)=>$adc7cb3c45508c7c$var$yi(n, "name", {
        value: e,
        configurable: !0
    });
var $adc7cb3c45508c7c$var$gr = (()=>{
    for(var n = new Uint8Array(128), e = 0; e < 64; e++)n[e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e * 4 - 205] = e;
    return (o)=>{
        for(var c = o.length, g = new Uint8Array((c - (o[c - 1] == "=") - (o[c - 2] == "=")) * 3 / 4 | 0), m = 0, P = 0; m < c;){
            var I = n[o.charCodeAt(m++)], j = n[o.charCodeAt(m++)], y = n[o.charCodeAt(m++)], X = n[o.charCodeAt(m++)];
            g[P++] = I << 2 | j >> 4, g[P++] = j << 4 | y >> 2, g[P++] = y << 6 | X;
        }
        return g;
    };
})();
function $adc7cb3c45508c7c$var$Ge(n) {
    return n * Math.PI / 180;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ge, "deg2rad");
function $adc7cb3c45508c7c$var$ot(n) {
    return n * 180 / Math.PI;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$ot, "rad2deg");
function $adc7cb3c45508c7c$var$Le(n, e, o) {
    return e > o ? $adc7cb3c45508c7c$var$Le(n, o, e) : Math.min(Math.max(n, e), o);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Le, "clamp");
function $adc7cb3c45508c7c$var$Ve(n, e, o) {
    if (typeof n == "number" && typeof e == "number") return n + (e - n) * o;
    if (n instanceof $adc7cb3c45508c7c$var$v && e instanceof $adc7cb3c45508c7c$var$v) return n.lerp(e, o);
    if (n instanceof $adc7cb3c45508c7c$var$W && e instanceof $adc7cb3c45508c7c$var$W) return n.lerp(e, o);
    throw new Error(`Bad value for lerp(): ${n}, ${e}. Only number, Vec2 and Color is supported.`);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ve, "lerp");
function $adc7cb3c45508c7c$var$_e(n, e, o, c, g) {
    return c + (n - e) / (o - e) * (g - c);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$_e, "map");
function $adc7cb3c45508c7c$var$br(n, e, o, c, g) {
    return $adc7cb3c45508c7c$var$Le($adc7cb3c45508c7c$var$_e(n, e, o, c, g), c, g);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$br, "mapc");
var $adc7cb3c45508c7c$var$v = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Vec2");
    }
    x = 0;
    y = 0;
    constructor(e = 0, o = e){
        this.x = e, this.y = o;
    }
    static fromAngle(e) {
        let o = $adc7cb3c45508c7c$var$Ge(e);
        return new n(Math.cos(o), Math.sin(o));
    }
    static LEFT = new n(-1, 0);
    static RIGHT = new n(1, 0);
    static UP = new n(0, -1);
    static DOWN = new n(0, 1);
    clone() {
        return new n(this.x, this.y);
    }
    add(...e) {
        let o = $adc7cb3c45508c7c$var$T(...e);
        return new n(this.x + o.x, this.y + o.y);
    }
    sub(...e) {
        let o = $adc7cb3c45508c7c$var$T(...e);
        return new n(this.x - o.x, this.y - o.y);
    }
    scale(...e) {
        let o = $adc7cb3c45508c7c$var$T(...e);
        return new n(this.x * o.x, this.y * o.y);
    }
    dist(...e) {
        let o = $adc7cb3c45508c7c$var$T(...e);
        return this.sub(o).len();
    }
    sdist(...e) {
        let o = $adc7cb3c45508c7c$var$T(...e);
        return this.sub(o).slen();
    }
    len() {
        return Math.sqrt(this.dot(this));
    }
    slen() {
        return this.dot(this);
    }
    unit() {
        let e = this.len();
        return e === 0 ? new n(0) : this.scale(1 / e);
    }
    normal() {
        return new n(this.y, -this.x);
    }
    reflect(e) {
        return this.sub(e.scale(2 * this.dot(e)));
    }
    project(e) {
        return e.scale(e.dot(this) / e.len());
    }
    reject(e) {
        return this.sub(this.project(e));
    }
    dot(e) {
        return this.x * e.x + this.y * e.y;
    }
    cross(e) {
        return this.x * e.y - this.y * e.x;
    }
    angle(...e) {
        let o = $adc7cb3c45508c7c$var$T(...e);
        return $adc7cb3c45508c7c$var$ot(Math.atan2(this.y - o.y, this.x - o.x));
    }
    angleBetween(...e) {
        let o = $adc7cb3c45508c7c$var$T(...e);
        return $adc7cb3c45508c7c$var$ot(Math.atan2(this.cross(o), this.dot(o)));
    }
    lerp(e, o) {
        return new n($adc7cb3c45508c7c$var$Ve(this.x, e.x, o), $adc7cb3c45508c7c$var$Ve(this.y, e.y, o));
    }
    slerp(e, o) {
        let c = this.dot(e), g = this.cross(e), m = Math.atan2(g, c);
        return this.scale(Math.sin((1 - o) * m)).add(e.scale(Math.sin(o * m))).scale(1 / g);
    }
    isZero() {
        return this.x === 0 && this.y === 0;
    }
    toFixed(e) {
        return new n(Number(this.x.toFixed(e)), Number(this.y.toFixed(e)));
    }
    transform(e) {
        return e.multVec2(this);
    }
    eq(e) {
        return this.x === e.x && this.y === e.y;
    }
    bbox() {
        return new $adc7cb3c45508c7c$var$de(this, 0, 0);
    }
    toString() {
        return `vec2(${this.x.toFixed(2)}, ${this.y.toFixed(2)})`;
    }
};
function $adc7cb3c45508c7c$var$T(...n) {
    if (n.length === 1) {
        if (n[0] instanceof $adc7cb3c45508c7c$var$v) return new $adc7cb3c45508c7c$var$v(n[0].x, n[0].y);
        if (Array.isArray(n[0]) && n[0].length === 2) return new $adc7cb3c45508c7c$var$v(...n[0]);
    }
    return new $adc7cb3c45508c7c$var$v(...n);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$T, "vec2");
var $adc7cb3c45508c7c$var$W = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Color");
    }
    r = 255;
    g = 255;
    b = 255;
    constructor(e, o, c){
        this.r = $adc7cb3c45508c7c$var$Le(e, 0, 255), this.g = $adc7cb3c45508c7c$var$Le(o, 0, 255), this.b = $adc7cb3c45508c7c$var$Le(c, 0, 255);
    }
    static fromArray(e) {
        return new n(e[0], e[1], e[2]);
    }
    static fromHex(e) {
        if (typeof e == "number") return new n(e >> 16 & 255, e >> 8 & 255, e >> 0 & 255);
        if (typeof e == "string") {
            let o = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
            return new n(parseInt(o[1], 16), parseInt(o[2], 16), parseInt(o[3], 16));
        } else throw new Error("Invalid hex color format");
    }
    static fromHSL(e, o, c) {
        if (o == 0) return new n(255 * c, 255 * c, 255 * c);
        let g = $adc7cb3c45508c7c$var$i((X, S, q)=>(q < 0 && (q += 1), q > 1 && (q -= 1), q < 1 / 6 ? X + (S - X) * 6 * q : q < 0.5 ? S : q < 2 / 3 ? X + (S - X) * (2 / 3 - q) * 6 : X), "hue2rgb"), m = c < .5 ? c * (1 + o) : c + o - c * o, P = 2 * c - m, I = g(P, m, e + 1 / 3), j = g(P, m, e), y = g(P, m, e - 1 / 3);
        return new n(Math.round(I * 255), Math.round(j * 255), Math.round(y * 255));
    }
    static RED = new n(255, 0, 0);
    static GREEN = new n(0, 255, 0);
    static BLUE = new n(0, 0, 255);
    static YELLOW = new n(255, 255, 0);
    static MAGENTA = new n(255, 0, 255);
    static CYAN = new n(0, 255, 255);
    static WHITE = new n(255, 255, 255);
    static BLACK = new n(0, 0, 0);
    clone() {
        return new n(this.r, this.g, this.b);
    }
    lighten(e) {
        return new n(this.r + e, this.g + e, this.b + e);
    }
    darken(e) {
        return this.lighten(-e);
    }
    invert() {
        return new n(255 - this.r, 255 - this.g, 255 - this.b);
    }
    mult(e) {
        return new n(this.r * e.r / 255, this.g * e.g / 255, this.b * e.b / 255);
    }
    lerp(e, o) {
        return new n($adc7cb3c45508c7c$var$Ve(this.r, e.r, o), $adc7cb3c45508c7c$var$Ve(this.g, e.g, o), $adc7cb3c45508c7c$var$Ve(this.b, e.b, o));
    }
    toHSL() {
        let e = this.r / 255, o = this.g / 255, c = this.b / 255, g = Math.max(e, o, c), m = Math.min(e, o, c), P = (g + m) / 2, I = P, j = P;
        if (g == m) P = I = 0;
        else {
            let y = g - m;
            switch(I = j > .5 ? y / (2 - g - m) : y / (g + m), g){
                case e:
                    P = (o - c) / y + (o < c ? 6 : 0);
                    break;
                case o:
                    P = (c - e) / y + 2;
                    break;
                case c:
                    P = (e - o) / y + 4;
                    break;
            }
            P /= 6;
        }
        return [
            P,
            I,
            j
        ];
    }
    eq(e) {
        return this.r === e.r && this.g === e.g && this.b === e.b;
    }
    toString() {
        return `rgb(${this.r}, ${this.g}, ${this.b})`;
    }
    toHex() {
        return "#" + (16777216 + (this.r << 16) + (this.g << 8) + this.b).toString(16).slice(1);
    }
};
function $adc7cb3c45508c7c$var$J(...n) {
    if (n.length === 0) return new $adc7cb3c45508c7c$var$W(255, 255, 255);
    if (n.length === 1) {
        if (n[0] instanceof $adc7cb3c45508c7c$var$W) return n[0].clone();
        if (typeof n[0] == "string") return $adc7cb3c45508c7c$var$W.fromHex(n[0]);
        if (Array.isArray(n[0]) && n[0].length === 3) return $adc7cb3c45508c7c$var$W.fromArray(n[0]);
    }
    return new $adc7cb3c45508c7c$var$W(...n);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$J, "rgb");
var $adc7cb3c45508c7c$var$vr = $adc7cb3c45508c7c$var$i((n, e, o)=>$adc7cb3c45508c7c$var$W.fromHSL(n, e, o), "hsl2rgb"), $adc7cb3c45508c7c$var$oe = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Quad");
    }
    x = 0;
    y = 0;
    w = 1;
    h = 1;
    constructor(e, o, c, g){
        this.x = e, this.y = o, this.w = c, this.h = g;
    }
    scale(e) {
        return new n(this.x + this.w * e.x, this.y + this.h * e.y, this.w * e.w, this.h * e.h);
    }
    pos() {
        return new $adc7cb3c45508c7c$var$v(this.x, this.y);
    }
    clone() {
        return new n(this.x, this.y, this.w, this.h);
    }
    eq(e) {
        return this.x === e.x && this.y === e.y && this.w === e.w && this.h === e.h;
    }
    toString() {
        return `quad(${this.x}, ${this.y}, ${this.w}, ${this.h})`;
    }
};
function $adc7cb3c45508c7c$var$ce(n, e, o, c) {
    return new $adc7cb3c45508c7c$var$oe(n, e, o, c);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$ce, "quad");
var $adc7cb3c45508c7c$var$Ue = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Mat4");
    }
    m = [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
    constructor(e){
        e && (this.m = e);
    }
    static translate(e) {
        return new n([
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            e.x,
            e.y,
            0,
            1
        ]);
    }
    static scale(e) {
        return new n([
            e.x,
            0,
            0,
            0,
            0,
            e.y,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    static rotateX(e) {
        e = $adc7cb3c45508c7c$var$Ge(-e);
        let o = Math.cos(e), c = Math.sin(e);
        return new n([
            1,
            0,
            0,
            0,
            0,
            o,
            -c,
            0,
            0,
            c,
            o,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    static rotateY(e) {
        e = $adc7cb3c45508c7c$var$Ge(-e);
        let o = Math.cos(e), c = Math.sin(e);
        return new n([
            o,
            0,
            c,
            0,
            0,
            1,
            0,
            0,
            -c,
            0,
            o,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    static rotateZ(e) {
        e = $adc7cb3c45508c7c$var$Ge(-e);
        let o = Math.cos(e), c = Math.sin(e);
        return new n([
            o,
            -c,
            0,
            0,
            c,
            o,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    translate(e) {
        return this.m[12] += this.m[0] * e.x + this.m[4] * e.y, this.m[13] += this.m[1] * e.x + this.m[5] * e.y, this.m[14] += this.m[2] * e.x + this.m[6] * e.y, this.m[15] += this.m[3] * e.x + this.m[7] * e.y, this;
    }
    scale(e) {
        return this.m[0] *= e.x, this.m[4] *= e.y, this.m[1] *= e.x, this.m[5] *= e.y, this.m[2] *= e.x, this.m[6] *= e.y, this.m[3] *= e.x, this.m[7] *= e.y, this;
    }
    rotate(e) {
        e = $adc7cb3c45508c7c$var$Ge(-e);
        let o = Math.cos(e), c = Math.sin(e), g = this.m[0], m = this.m[1], P = this.m[4], I = this.m[5];
        return this.m[0] = g * o + m * c, this.m[1] = -g * c + m * o, this.m[4] = P * o + I * c, this.m[5] = -P * c + I * o, this;
    }
    mult(e) {
        let o = [];
        for(let c = 0; c < 4; c++)for(let g = 0; g < 4; g++)o[c * 4 + g] = this.m[0 + g] * e.m[c * 4 + 0] + this.m[4 + g] * e.m[c * 4 + 1] + this.m[8 + g] * e.m[c * 4 + 2] + this.m[12 + g] * e.m[c * 4 + 3];
        return new n(o);
    }
    multVec2(e) {
        return new $adc7cb3c45508c7c$var$v(e.x * this.m[0] + e.y * this.m[4] + this.m[12], e.x * this.m[1] + e.y * this.m[5] + this.m[13]);
    }
    getTranslation() {
        return new $adc7cb3c45508c7c$var$v(this.m[12], this.m[13]);
    }
    getScale() {
        if (this.m[0] != 0 || this.m[1] != 0) {
            let e = this.m[0] * this.m[5] - this.m[1] * this.m[4], o = Math.sqrt(this.m[0] * this.m[0] + this.m[1] * this.m[1]);
            return new $adc7cb3c45508c7c$var$v(o, e / o);
        } else if (this.m[4] != 0 || this.m[5] != 0) {
            let e = this.m[0] * this.m[5] - this.m[1] * this.m[4], o = Math.sqrt(this.m[4] * this.m[4] + this.m[5] * this.m[5]);
            return new $adc7cb3c45508c7c$var$v(e / o, o);
        } else return new $adc7cb3c45508c7c$var$v(0, 0);
    }
    getRotation() {
        if (this.m[0] != 0 || this.m[1] != 0) {
            let e = Math.sqrt(this.m[0] * this.m[0] + this.m[1] * this.m[1]);
            return $adc7cb3c45508c7c$var$ot(this.m[1] > 0 ? Math.acos(this.m[0] / e) : -Math.acos(this.m[0] / e));
        } else if (this.m[4] != 0 || this.m[5] != 0) {
            let e = Math.sqrt(this.m[4] * this.m[4] + this.m[5] * this.m[5]);
            return $adc7cb3c45508c7c$var$ot(Math.PI / 2 - (this.m[5] > 0 ? Math.acos(-this.m[4] / e) : -Math.acos(this.m[4] / e)));
        } else return 0;
    }
    getSkew() {
        if (this.m[0] != 0 || this.m[1] != 0) {
            let e = Math.sqrt(this.m[0] * this.m[0] + this.m[1] * this.m[1]);
            return new $adc7cb3c45508c7c$var$v(Math.atan(this.m[0] * this.m[4] + this.m[1] * this.m[5]) / (e * e), 0);
        } else if (this.m[4] != 0 || this.m[5] != 0) {
            let e = Math.sqrt(this.m[4] * this.m[4] + this.m[5] * this.m[5]);
            return new $adc7cb3c45508c7c$var$v(0, Math.atan(this.m[0] * this.m[4] + this.m[1] * this.m[5]) / (e * e));
        } else return new $adc7cb3c45508c7c$var$v(0, 0);
    }
    invert() {
        let e = [], o = this.m[10] * this.m[15] - this.m[14] * this.m[11], c = this.m[9] * this.m[15] - this.m[13] * this.m[11], g = this.m[9] * this.m[14] - this.m[13] * this.m[10], m = this.m[8] * this.m[15] - this.m[12] * this.m[11], P = this.m[8] * this.m[14] - this.m[12] * this.m[10], I = this.m[8] * this.m[13] - this.m[12] * this.m[9], j = this.m[6] * this.m[15] - this.m[14] * this.m[7], y = this.m[5] * this.m[15] - this.m[13] * this.m[7], X = this.m[5] * this.m[14] - this.m[13] * this.m[6], S = this.m[4] * this.m[15] - this.m[12] * this.m[7], q = this.m[4] * this.m[14] - this.m[12] * this.m[6], E = this.m[5] * this.m[15] - this.m[13] * this.m[7], K = this.m[4] * this.m[13] - this.m[12] * this.m[5], Q = this.m[6] * this.m[11] - this.m[10] * this.m[7], te = this.m[5] * this.m[11] - this.m[9] * this.m[7], k = this.m[5] * this.m[10] - this.m[9] * this.m[6], pe = this.m[4] * this.m[11] - this.m[8] * this.m[7], C = this.m[4] * this.m[10] - this.m[8] * this.m[6], Ae = this.m[4] * this.m[9] - this.m[8] * this.m[5];
        e[0] = this.m[5] * o - this.m[6] * c + this.m[7] * g, e[4] = -(this.m[4] * o - this.m[6] * m + this.m[7] * P), e[8] = this.m[4] * c - this.m[5] * m + this.m[7] * I, e[12] = -(this.m[4] * g - this.m[5] * P + this.m[6] * I), e[1] = -(this.m[1] * o - this.m[2] * c + this.m[3] * g), e[5] = this.m[0] * o - this.m[2] * m + this.m[3] * P, e[9] = -(this.m[0] * c - this.m[1] * m + this.m[3] * I), e[13] = this.m[0] * g - this.m[1] * P + this.m[2] * I, e[2] = this.m[1] * j - this.m[2] * y + this.m[3] * X, e[6] = -(this.m[0] * j - this.m[2] * S + this.m[3] * q), e[10] = this.m[0] * E - this.m[1] * S + this.m[3] * K, e[14] = -(this.m[0] * X - this.m[1] * q + this.m[2] * K), e[3] = -(this.m[1] * Q - this.m[2] * te + this.m[3] * k), e[7] = this.m[0] * Q - this.m[2] * pe + this.m[3] * C, e[11] = -(this.m[0] * te - this.m[1] * pe + this.m[3] * Ae), e[15] = this.m[0] * k - this.m[1] * C + this.m[2] * Ae;
        let $ = this.m[0] * e[0] + this.m[1] * e[4] + this.m[2] * e[8] + this.m[3] * e[12];
        for(let Te = 0; Te < 4; Te++)for(let ye = 0; ye < 4; ye++)e[Te * 4 + ye] *= 1 / $;
        return new n(e);
    }
    clone() {
        return new n([
            ...this.m
        ]);
    }
    toString() {
        return this.m.toString();
    }
};
function $adc7cb3c45508c7c$var$In(n, e, o, c = (g)=>-Math.cos(g)) {
    return n + (c(o) + 1) / 2 * (e - n);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$In, "wave");
var $adc7cb3c45508c7c$var$xi = 1103515245, $adc7cb3c45508c7c$var$Ui = 12345, $adc7cb3c45508c7c$var$wr = 2147483648, $adc7cb3c45508c7c$var$bt = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "RNG");
    }
    seed;
    constructor(e){
        this.seed = e;
    }
    gen() {
        return this.seed = ($adc7cb3c45508c7c$var$xi * this.seed + $adc7cb3c45508c7c$var$Ui) % $adc7cb3c45508c7c$var$wr, this.seed / $adc7cb3c45508c7c$var$wr;
    }
    genNumber(e, o) {
        return e + this.gen() * (o - e);
    }
    genVec2(e, o) {
        return new $adc7cb3c45508c7c$var$v(this.genNumber(e.x, o.x), this.genNumber(e.y, o.y));
    }
    genColor(e, o) {
        return new $adc7cb3c45508c7c$var$W(this.genNumber(e.r, o.r), this.genNumber(e.g, o.g), this.genNumber(e.b, o.b));
    }
    genAny(...e) {
        if (e.length === 0) return this.gen();
        if (e.length === 1) {
            if (typeof e[0] == "number") return this.genNumber(0, e[0]);
            if (e[0] instanceof $adc7cb3c45508c7c$var$v) return this.genVec2($adc7cb3c45508c7c$var$T(0, 0), e[0]);
            if (e[0] instanceof $adc7cb3c45508c7c$var$W) return this.genColor($adc7cb3c45508c7c$var$J(0, 0, 0), e[0]);
        } else if (e.length === 2) {
            if (typeof e[0] == "number" && typeof e[1] == "number") return this.genNumber(e[0], e[1]);
            if (e[0] instanceof $adc7cb3c45508c7c$var$v && e[1] instanceof $adc7cb3c45508c7c$var$v) return this.genVec2(e[0], e[1]);
            if (e[0] instanceof $adc7cb3c45508c7c$var$W && e[1] instanceof $adc7cb3c45508c7c$var$W) return this.genColor(e[0], e[1]);
        }
    }
}, $adc7cb3c45508c7c$var$Bn = new $adc7cb3c45508c7c$var$bt(Date.now());
function $adc7cb3c45508c7c$var$yr(n) {
    return n != null && ($adc7cb3c45508c7c$var$Bn.seed = n), $adc7cb3c45508c7c$var$Bn.seed;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$yr, "randSeed");
function $adc7cb3c45508c7c$var$xt(...n) {
    return $adc7cb3c45508c7c$var$Bn.genAny(...n);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$xt, "rand");
function $adc7cb3c45508c7c$var$Ln(...n) {
    return Math.floor($adc7cb3c45508c7c$var$xt(...n));
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ln, "randi");
function $adc7cb3c45508c7c$var$xr(n) {
    return $adc7cb3c45508c7c$var$xt() <= n;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$xr, "chance");
function $adc7cb3c45508c7c$var$Ur(n) {
    return n[$adc7cb3c45508c7c$var$Ln(n.length)];
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ur, "choose");
function $adc7cb3c45508c7c$var$Er(n, e) {
    return n.pos.x + n.width > e.pos.x && n.pos.x < e.pos.x + e.width && n.pos.y + n.height > e.pos.y && n.pos.y < e.pos.y + e.height;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Er, "testRectRect");
function $adc7cb3c45508c7c$var$Ei(n, e) {
    if (n.p1.x === n.p2.x && n.p1.y === n.p2.y || e.p1.x === e.p2.x && e.p1.y === e.p2.y) return null;
    let o = (e.p2.y - e.p1.y) * (n.p2.x - n.p1.x) - (e.p2.x - e.p1.x) * (n.p2.y - n.p1.y);
    if (o === 0) return null;
    let c = ((e.p2.x - e.p1.x) * (n.p1.y - e.p1.y) - (e.p2.y - e.p1.y) * (n.p1.x - e.p1.x)) / o, g = ((n.p2.x - n.p1.x) * (n.p1.y - e.p1.y) - (n.p2.y - n.p1.y) * (n.p1.x - e.p1.x)) / o;
    return c < 0 || c > 1 || g < 0 || g > 1 ? null : c;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ei, "testLineLineT");
function $adc7cb3c45508c7c$var$it(n, e) {
    let o = $adc7cb3c45508c7c$var$Ei(n, e);
    return o ? $adc7cb3c45508c7c$var$T(n.p1.x + o * (n.p2.x - n.p1.x), n.p1.y + o * (n.p2.y - n.p1.y)) : null;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$it, "testLineLine");
function $adc7cb3c45508c7c$var$Sr(n, e) {
    if ($adc7cb3c45508c7c$var$vt(n, e.p1) || $adc7cb3c45508c7c$var$vt(n, e.p2)) return !0;
    let o = n.points();
    return !!$adc7cb3c45508c7c$var$it(e, new $adc7cb3c45508c7c$var$Ie(o[0], o[1])) || !!$adc7cb3c45508c7c$var$it(e, new $adc7cb3c45508c7c$var$Ie(o[1], o[2])) || !!$adc7cb3c45508c7c$var$it(e, new $adc7cb3c45508c7c$var$Ie(o[2], o[3])) || !!$adc7cb3c45508c7c$var$it(e, new $adc7cb3c45508c7c$var$Ie(o[3], o[0]));
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Sr, "testRectLine");
function $adc7cb3c45508c7c$var$vt(n, e) {
    return e.x > n.pos.x && e.x < n.pos.x + n.width && e.y > n.pos.y && e.y < n.pos.y + n.height;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$vt, "testRectPoint");
function $adc7cb3c45508c7c$var$Cr(n, e) {
    let o = e.sub(n.p1), c = n.p2.sub(n.p1);
    if (Math.abs(o.cross(c)) > Number.EPSILON) return !1;
    let g = o.dot(c) / c.dot(c);
    return g >= 0 && g <= 1;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Cr, "testLinePoint");
function $adc7cb3c45508c7c$var$Vn(n, e) {
    let o = n.p2.sub(n.p1), c = o.dot(o), g = n.p1.sub(e.center), m = 2 * o.dot(g), P = g.dot(g) - e.radius * e.radius, I = m * m - 4 * c * P;
    if (c <= Number.EPSILON || I < 0) return !1;
    if (I == 0) {
        let j = -m / (2 * c);
        if (j >= 0 && j <= 1) return !0;
    } else {
        let j = (-m + Math.sqrt(I)) / (2 * c), y = (-m - Math.sqrt(I)) / (2 * c);
        if (j >= 0 && j <= 1 || y >= 0 && y <= 1) return !0;
    }
    return $adc7cb3c45508c7c$var$Ar(e, n.p1);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Vn, "testLineCircle");
function $adc7cb3c45508c7c$var$Ar(n, e) {
    return n.center.sdist(e) < n.radius * n.radius;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ar, "testCirclePoint");
function $adc7cb3c45508c7c$var$Tr(n, e) {
    let o = e.pts[e.pts.length - 1];
    for (let c of e.pts){
        if ($adc7cb3c45508c7c$var$Vn(new $adc7cb3c45508c7c$var$Ie(o, c), n)) return !0;
        o = c;
    }
    return $adc7cb3c45508c7c$var$Ar(n, e.pts[0]) ? !0 : $adc7cb3c45508c7c$var$_n(e, n.center);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Tr, "testCirclePolygon");
function $adc7cb3c45508c7c$var$_n(n, e) {
    let o = !1, c = n.pts;
    for(let g = 0, m = c.length - 1; g < c.length; m = g++)c[g].y > e.y != c[m].y > e.y && e.x < (c[m].x - c[g].x) * (e.y - c[g].y) / (c[m].y - c[g].y) + c[g].x && (o = !o);
    return o;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$_n, "testPolygonPoint");
var $adc7cb3c45508c7c$var$Ie = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Line");
    }
    p1;
    p2;
    constructor(e, o){
        this.p1 = e.clone(), this.p2 = o.clone();
    }
    transform(e) {
        return new n(e.multVec2(this.p1), e.multVec2(this.p2));
    }
    bbox() {
        return $adc7cb3c45508c7c$var$de.fromPoints(this.p1, this.p2);
    }
    area() {
        return this.p1.dist(this.p2);
    }
    clone() {
        return new n(this.p1, this.p2);
    }
}, $adc7cb3c45508c7c$var$de = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Rect");
    }
    pos;
    width;
    height;
    constructor(e, o, c){
        this.pos = e.clone(), this.width = o, this.height = c;
    }
    static fromPoints(e, o) {
        return new n(e.clone(), o.x - e.x, o.y - e.y);
    }
    center() {
        return new $adc7cb3c45508c7c$var$v(this.pos.x + this.width / 2, this.pos.y + this.height / 2);
    }
    points() {
        return [
            this.pos,
            this.pos.add(this.width, 0),
            this.pos.add(this.width, this.height),
            this.pos.add(0, this.height)
        ];
    }
    transform(e) {
        return new $adc7cb3c45508c7c$var$Ke(this.points().map((o)=>e.multVec2(o)));
    }
    bbox() {
        return this.clone();
    }
    area() {
        return this.width * this.height;
    }
    clone() {
        return new n(this.pos.clone(), this.width, this.height);
    }
    distToPoint(e) {
        return Math.sqrt(this.sdistToPoint(e));
    }
    sdistToPoint(e) {
        let o = this.pos, c = this.pos.add(this.width, this.height), g = Math.max(o.x - e.x, 0, e.x - c.x), m = Math.max(o.y - e.y, 0, e.y - c.y);
        return g * g + m * m;
    }
}, $adc7cb3c45508c7c$var$yt = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Circle");
    }
    center;
    radius;
    constructor(e, o){
        this.center = e.clone(), this.radius = o;
    }
    transform(e) {
        return new $adc7cb3c45508c7c$var$Fn(this.center, this.radius, this.radius).transform(e);
    }
    bbox() {
        return $adc7cb3c45508c7c$var$de.fromPoints(this.center.sub($adc7cb3c45508c7c$var$T(this.radius)), this.center.add($adc7cb3c45508c7c$var$T(this.radius)));
    }
    area() {
        return this.radius * this.radius * Math.PI;
    }
    clone() {
        return new n(this.center, this.radius);
    }
}, $adc7cb3c45508c7c$var$Fn = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Ellipse");
    }
    center;
    radiusX;
    radiusY;
    constructor(e, o, c){
        this.center = e.clone(), this.radiusX = o, this.radiusY = c;
    }
    transform(e) {
        return new n(e.multVec2(this.center), e.m[0] * this.radiusX, e.m[5] * this.radiusY);
    }
    bbox() {
        return $adc7cb3c45508c7c$var$de.fromPoints(this.center.sub($adc7cb3c45508c7c$var$T(this.radiusX, this.radiusY)), this.center.add($adc7cb3c45508c7c$var$T(this.radiusX, this.radiusY)));
    }
    area() {
        return this.radiusX * this.radiusY * Math.PI;
    }
    clone() {
        return new n(this.center, this.radiusX, this.radiusY);
    }
}, $adc7cb3c45508c7c$var$Ke = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Polygon");
    }
    pts;
    constructor(e){
        if (e.length < 3) throw new Error("Polygons should have at least 3 vertices");
        this.pts = e;
    }
    transform(e) {
        return new n(this.pts.map((o)=>e.multVec2(o)));
    }
    bbox() {
        let e = $adc7cb3c45508c7c$var$T(Number.MAX_VALUE), o = $adc7cb3c45508c7c$var$T(-Number.MAX_VALUE);
        for (let c of this.pts)e.x = Math.min(e.x, c.x), o.x = Math.max(o.x, c.x), e.y = Math.min(e.y, c.y), o.y = Math.max(o.y, c.y);
        return $adc7cb3c45508c7c$var$de.fromPoints(e, o);
    }
    area() {
        let e = 0, o = this.pts.length;
        for(let c = 0; c < o; c++){
            let g = this.pts[c], m = this.pts[(c + 1) % o];
            e += g.x * m.y * .5, e -= m.x * g.y * .5;
        }
        return Math.abs(e);
    }
    clone() {
        return new n(this.pts.map((e)=>e.clone()));
    }
};
function $adc7cb3c45508c7c$var$Or(n, e) {
    let o = Number.MAX_VALUE, c = $adc7cb3c45508c7c$var$T(0);
    for (let g of [
        n,
        e
    ])for(let m = 0; m < g.pts.length; m++){
        let P = g.pts[m], j = g.pts[(m + 1) % g.pts.length].sub(P).normal().unit(), y = Number.MAX_VALUE, X = -Number.MAX_VALUE;
        for(let K = 0; K < n.pts.length; K++){
            let Q = n.pts[K].dot(j);
            y = Math.min(y, Q), X = Math.max(X, Q);
        }
        let S = Number.MAX_VALUE, q = -Number.MAX_VALUE;
        for(let K = 0; K < e.pts.length; K++){
            let Q = e.pts[K].dot(j);
            S = Math.min(S, Q), q = Math.max(q, Q);
        }
        let E = Math.min(X, q) - Math.max(y, S);
        if (E < 0) return null;
        if (E < Math.abs(o)) {
            let K = q - y, Q = S - X;
            o = Math.abs(K) < Math.abs(Q) ? K : Q, c = j.scale(o);
        }
    }
    return c;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Or, "sat");
var $adc7cb3c45508c7c$var$Ut = class extends Map {
    static{
        $adc7cb3c45508c7c$var$i(this, "Registry");
    }
    lastID;
    constructor(...e){
        super(...e), this.lastID = 0;
    }
    push(e) {
        let o = this.lastID;
        return this.set(o, e), this.lastID++, o;
    }
    pushd(e) {
        let o = this.push(e);
        return ()=>this.delete(o);
    }
}, $adc7cb3c45508c7c$var$ke = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "EventController");
    }
    paused = !1;
    cancel;
    constructor(e){
        this.cancel = e;
    }
    static join(e) {
        let o = new n(()=>e.forEach((c)=>c.cancel()));
        return Object.defineProperty(o, "paused", {
            get: ()=>e[0].paused,
            set: (c)=>e.forEach((g)=>g.paused = c)
        }), o.paused = !1, o;
    }
}, $adc7cb3c45508c7c$var$be = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "Event");
    }
    handlers = new $adc7cb3c45508c7c$var$Ut;
    add(e) {
        let o = this.handlers.pushd((...g)=>{
            c.paused || e(...g);
        }), c = new $adc7cb3c45508c7c$var$ke(o);
        return c;
    }
    addOnce(e) {
        let o = this.add((...c)=>{
            o.cancel(), e(...c);
        });
        return o;
    }
    next() {
        return new Promise((e)=>this.addOnce(e));
    }
    trigger(...e) {
        this.handlers.forEach((o)=>o(...e));
    }
    numListeners() {
        return this.handlers.size;
    }
    clear() {
        this.handlers.clear();
    }
}, $adc7cb3c45508c7c$var$Ne = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "EventHandler");
    }
    handlers = {};
    on(e, o) {
        return this.handlers[e] || (this.handlers[e] = new $adc7cb3c45508c7c$var$be), this.handlers[e].add(o);
    }
    onOnce(e, o) {
        let c = this.on(e, (...g)=>{
            c.cancel(), o(...g);
        });
        return c;
    }
    next(e) {
        return new Promise((o)=>{
            this.onOnce(e, (...c)=>o(c[0]));
        });
    }
    trigger(e, ...o) {
        this.handlers[e] && this.handlers[e].trigger(...o);
    }
    remove(e) {
        delete this.handlers[e];
    }
    clear() {
        this.handlers = {};
    }
    numListeners(e) {
        return this.handlers[e]?.numListeners() ?? 0;
    }
};
function $adc7cb3c45508c7c$var$Wt(n, e) {
    if (n === e) return !0;
    let o = typeof n, c = typeof e;
    if (o !== c) return !1;
    if (o === "object" && c === "object" && n !== null && e !== null) {
        if (Array.isArray(n) !== Array.isArray(e)) return !1;
        let g = Object.keys(n), m = Object.keys(e);
        if (g.length !== m.length) return !1;
        for (let P of g){
            let I = n[P], j = e[P];
            if (!$adc7cb3c45508c7c$var$Wt(I, j)) return !1;
        }
        return !0;
    }
    return !1;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Wt, "deepEq");
function $adc7cb3c45508c7c$var$Si(n) {
    let e = window.atob(n), o = e.length, c = new Uint8Array(o);
    for(let g = 0; g < o; g++)c[g] = e.charCodeAt(g);
    return c.buffer;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Si, "base64ToArrayBuffer");
function $adc7cb3c45508c7c$var$Pr(n) {
    return $adc7cb3c45508c7c$var$Si(n.split(",")[1]);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Pr, "dataURLToArrayBuffer");
function $adc7cb3c45508c7c$var$Xt(n, e) {
    let o = document.createElement("a");
    o.href = e, o.download = n, o.click();
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Xt, "download");
function $adc7cb3c45508c7c$var$kn(n, e) {
    $adc7cb3c45508c7c$var$Xt(n, "data:text/plain;charset=utf-8," + e);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$kn, "downloadText");
function $adc7cb3c45508c7c$var$Dr(n, e) {
    $adc7cb3c45508c7c$var$kn(n, JSON.stringify(e));
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Dr, "downloadJSON");
function $adc7cb3c45508c7c$var$Nn(n, e) {
    let o = URL.createObjectURL(e);
    $adc7cb3c45508c7c$var$Xt(n, o), URL.revokeObjectURL(o);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Nn, "downloadBlob");
var $adc7cb3c45508c7c$var$jn = $adc7cb3c45508c7c$var$i((n)=>n.match(/^data:\w+\/\w+;base64,.+/), "isDataURL");
var $adc7cb3c45508c7c$var$Mr = $adc7cb3c45508c7c$var$i((n)=>n.split(".").slice(0, -1).join("."), "getFileName");
function $adc7cb3c45508c7c$var$Ee(n, e) {
    return (...o)=>{
        let c = o.length;
        if (c === n.length) return n(...o);
        if (c === e.length) return e(...o);
    };
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ee, "overload2");
var $adc7cb3c45508c7c$var$Gr = (()=>{
    let n = 0;
    return ()=>n++;
})(), $adc7cb3c45508c7c$var$Br = $adc7cb3c45508c7c$var$i((n)=>n instanceof Error ? n.message : String(n), "getErrorMessage");
var $adc7cb3c45508c7c$var$Yt = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "BinaryHeap");
    }
    _items;
    _compareFn;
    constructor(e = (o, c)=>o < c){
        this._compareFn = e, this._items = [];
    }
    insert(e) {
        this._items.push(e), this.moveUp(this._items.length - 1);
    }
    remove() {
        if (this._items.length === 0) return null;
        let e = this._items[0], o = this._items.pop();
        return this._items.length !== 0 && (this._items[0] = o, this.moveDown(0)), e;
    }
    clear() {
        this._items.splice(0, this._items.length);
    }
    moveUp(e) {
        for(; e > 0;){
            let o = Math.floor((e - 1) / 2);
            if (!this._compareFn(this._items[e], this._items[o]) && this._items[e] >= this._items[o]) break;
            this.swap(e, o), e = o;
        }
    }
    moveDown(e) {
        for(; e < Math.floor(this._items.length / 2);){
            let o = 2 * e + 1;
            if (o < this._items.length - 1 && !this._compareFn(this._items[o], this._items[o + 1]) && ++o, this._compareFn(this._items[e], this._items[o])) break;
            this.swap(e, o), e = o;
        }
    }
    swap(e, o) {
        [this._items[e], this._items[o]] = [
            this._items[o],
            this._items[e]
        ];
    }
    get length() {
        return this._items.length;
    }
};
var $adc7cb3c45508c7c$var$Ci = Object.freeze([
    776,
    2359,
    2367,
    2984,
    3007,
    3021,
    3633,
    3635,
    3648,
    3657,
    4352,
    4449,
    4520
]);
function $adc7cb3c45508c7c$var$Fr(n) {
    if (typeof n != "string") throw new TypeError("string cannot be undefined or null");
    let e = [], o = 0, c = 0;
    for(; o < n.length;){
        if (c += $adc7cb3c45508c7c$var$Ai(o + c, n), $adc7cb3c45508c7c$var$Gi(n[o + c]) && c++, $adc7cb3c45508c7c$var$Pi(n[o + c]) && c++, $adc7cb3c45508c7c$var$Di(n[o + c]) && c++, $adc7cb3c45508c7c$var$Bi(n[o + c])) {
            c++;
            continue;
        }
        e.push(n.substring(o, o + c)), o += c, c = 0;
    }
    return e;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Fr, "runes");
function $adc7cb3c45508c7c$var$Ai(n, e) {
    let o = e[n];
    if (!$adc7cb3c45508c7c$var$Ti(o) || n === e.length - 1) return 1;
    let c = o + e[n + 1], g = e.substring(n + 2, n + 5);
    return $adc7cb3c45508c7c$var$Rr(c) && $adc7cb3c45508c7c$var$Rr(g) ? 4 : $adc7cb3c45508c7c$var$Oi(c) && $adc7cb3c45508c7c$var$Mi(g) ? e.slice(n).indexOf(String.fromCodePoint(917631)) + 2 : $adc7cb3c45508c7c$var$Ri(g) ? 4 : 2;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ai, "nextUnits");
function $adc7cb3c45508c7c$var$Ti(n) {
    return n && $adc7cb3c45508c7c$var$tt(n[0].charCodeAt(0), 55296, 56319);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ti, "isFirstOfSurrogatePair");
function $adc7cb3c45508c7c$var$Rr(n) {
    return $adc7cb3c45508c7c$var$tt($adc7cb3c45508c7c$var$Hn(n), 127462, 127487);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Rr, "isRegionalIndicator");
function $adc7cb3c45508c7c$var$Oi(n) {
    return $adc7cb3c45508c7c$var$tt($adc7cb3c45508c7c$var$Hn(n), 127988, 127988);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Oi, "isSubdivisionFlag");
function $adc7cb3c45508c7c$var$Ri(n) {
    return $adc7cb3c45508c7c$var$tt($adc7cb3c45508c7c$var$Hn(n), 127995, 127999);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Ri, "isFitzpatrickModifier");
function $adc7cb3c45508c7c$var$Pi(n) {
    return typeof n == "string" && $adc7cb3c45508c7c$var$tt(n.charCodeAt(0), 65024, 65039);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Pi, "isVariationSelector");
function $adc7cb3c45508c7c$var$Di(n) {
    return typeof n == "string" && $adc7cb3c45508c7c$var$tt(n.charCodeAt(0), 8400, 8447);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Di, "isDiacriticalMark");
function $adc7cb3c45508c7c$var$Mi(n) {
    let e = n.codePointAt(0);
    return typeof n == "string" && typeof e == "number" && $adc7cb3c45508c7c$var$tt(e, 917504, 917631);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Mi, "isSupplementarySpecialpurposePlane");
function $adc7cb3c45508c7c$var$Gi(n) {
    return typeof n == "string" && $adc7cb3c45508c7c$var$Ci.includes(n.charCodeAt(0));
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Gi, "isGrapheme");
function $adc7cb3c45508c7c$var$Bi(n) {
    return typeof n == "string" && n.charCodeAt(0) === 8205;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Bi, "isZeroWidthJoiner");
function $adc7cb3c45508c7c$var$Hn(n) {
    let e = n.charCodeAt(0) - 55296, o = n.charCodeAt(1) - 56320;
    return (e << 10) + o + 65536;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Hn, "codePointFromSurrogatePair");
function $adc7cb3c45508c7c$var$tt(n, e, o) {
    return n >= e && n <= o;
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$tt, "betweenInclusive");
var $adc7cb3c45508c7c$var$qn = {
    "Joy-Con L+R (STANDARD GAMEPAD Vendor: 057e Product: 200e)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "6": "ltrigger",
            "7": "rtrigger",
            "8": "select",
            "9": "start",
            "10": "lstick",
            "11": "rstick",
            "12": "dpad-up",
            "13": "dpad-down",
            "14": "dpad-left",
            "15": "dpad-right",
            "16": "home",
            "17": "capture"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            },
            right: {
                x: 2,
                y: 3
            }
        }
    },
    "Joy-Con (L) (STANDARD GAMEPAD Vendor: 057e Product: 2006)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "9": "select",
            "10": "lstick",
            "16": "start"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            }
        }
    },
    "Joy-Con (R) (STANDARD GAMEPAD Vendor: 057e Product: 2007)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "9": "start",
            "10": "lstick",
            "16": "select"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            }
        }
    },
    "Pro Controller (STANDARD GAMEPAD Vendor: 057e Product: 2009)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "6": "ltrigger",
            "7": "rtrigger",
            "8": "select",
            "9": "start",
            "10": "lstick",
            "11": "rstick",
            "12": "dpad-up",
            "13": "dpad-down",
            "14": "dpad-left",
            "15": "dpad-right",
            "16": "home",
            "17": "capture"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            },
            right: {
                x: 2,
                y: 3
            }
        }
    },
    default: {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "6": "ltrigger",
            "7": "rtrigger",
            "8": "select",
            "9": "start",
            "10": "lstick",
            "11": "rstick",
            "12": "dpad-up",
            "13": "dpad-down",
            "14": "dpad-left",
            "15": "dpad-right",
            "16": "home"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            },
            right: {
                x: 2,
                y: 3
            }
        }
    }
};
var $adc7cb3c45508c7c$var$at = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "ButtonState");
    }
    pressed = new Set([]);
    pressedRepeat = new Set([]);
    released = new Set([]);
    down = new Set([]);
    update() {
        this.pressed.clear(), this.released.clear(), this.pressedRepeat.clear();
    }
    press(e) {
        this.pressed.add(e), this.pressedRepeat.add(e), this.down.add(e);
    }
    pressRepeat(e) {
        this.pressedRepeat.add(e);
    }
    release(e) {
        this.down.delete(e), this.pressed.delete(e), this.released.add(e);
    }
}, $adc7cb3c45508c7c$var$$n = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "GamepadState");
    }
    buttonState = new $adc7cb3c45508c7c$var$at;
    stickState = new Map;
}, $adc7cb3c45508c7c$var$zn = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "FPSCounter");
    }
    dts = [];
    timer = 0;
    fps = 0;
    tick(e) {
        this.dts.push(e), this.timer += e, this.timer >= 1 && (this.timer = 0, this.fps = Math.round(1 / (this.dts.reduce((o, c)=>o + c) / this.dts.length)), this.dts = []);
    }
}, $adc7cb3c45508c7c$var$Ir = $adc7cb3c45508c7c$var$i((n)=>{
    if (!n.canvas) throw new Error("Please provide a canvas");
    let e = {
        canvas: n.canvas,
        loopID: null,
        stopped: !1,
        dt: 0,
        time: 0,
        realTime: 0,
        fpsCounter: new $adc7cb3c45508c7c$var$zn,
        timeScale: 1,
        skipTime: !1,
        numFrames: 0,
        mousePos: new $adc7cb3c45508c7c$var$v(0),
        mouseDeltaPos: new $adc7cb3c45508c7c$var$v(0),
        keyState: new $adc7cb3c45508c7c$var$at,
        mouseState: new $adc7cb3c45508c7c$var$at,
        mergedGamepadState: new $adc7cb3c45508c7c$var$$n,
        gamepadStates: new Map,
        gamepads: [],
        charInputted: [],
        isMouseMoved: !1,
        lastWidth: n.canvas.offsetWidth,
        lastHeight: n.canvas.offsetHeight,
        events: new $adc7cb3c45508c7c$var$Ne
    };
    function o() {
        return e.dt * e.timeScale;
    }
    $adc7cb3c45508c7c$var$i(o, "dt");
    function c() {
        return e.time;
    }
    $adc7cb3c45508c7c$var$i(c, "time");
    function g() {
        return e.fpsCounter.fps;
    }
    $adc7cb3c45508c7c$var$i(g, "fps");
    function m() {
        return e.numFrames;
    }
    $adc7cb3c45508c7c$var$i(m, "numFrames");
    function P() {
        return e.canvas.toDataURL();
    }
    $adc7cb3c45508c7c$var$i(P, "screenshot");
    function I(l) {
        e.canvas.style.cursor = l;
    }
    $adc7cb3c45508c7c$var$i(I, "setCursor");
    function j() {
        return e.canvas.style.cursor;
    }
    $adc7cb3c45508c7c$var$i(j, "getCursor");
    function y(l) {
        if (l) try {
            let x = e.canvas.requestPointerLock();
            x.catch && x.catch((R)=>console.error(R));
        } catch (x) {
            console.error(x);
        }
        else document.exitPointerLock();
    }
    $adc7cb3c45508c7c$var$i(y, "setCursorLocked");
    function X() {
        return !!document.pointerLockElement;
    }
    $adc7cb3c45508c7c$var$i(X, "isCursorLocked");
    function S(l) {
        l.requestFullscreen ? l.requestFullscreen() : l.webkitRequestFullscreen && l.webkitRequestFullscreen();
    }
    $adc7cb3c45508c7c$var$i(S, "enterFullscreen");
    function q() {
        document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullScreen && document.webkitExitFullScreen();
    }
    $adc7cb3c45508c7c$var$i(q, "exitFullscreen");
    function E() {
        return document.fullscreenElement || document.webkitFullscreenElement;
    }
    $adc7cb3c45508c7c$var$i(E, "getFullscreenElement");
    function K(l = !0) {
        l ? S(e.canvas) : q();
    }
    $adc7cb3c45508c7c$var$i(K, "setFullscreen");
    function Q() {
        return !!E();
    }
    $adc7cb3c45508c7c$var$i(Q, "isFullscreen");
    function te() {
        e.stopped = !0;
        for(let l in se)e.canvas.removeEventListener(l, se[l]);
        for(let l in le)document.removeEventListener(l, le[l]);
        for(let l in ae)window.removeEventListener(l, ae[l]);
        ge.disconnect();
    }
    $adc7cb3c45508c7c$var$i(te, "quit");
    function k(l) {
        e.loopID !== null && cancelAnimationFrame(e.loopID);
        let x = 0, R = $adc7cb3c45508c7c$var$i((L)=>{
            if (e.stopped) return;
            if (document.visibilityState !== "visible") {
                e.loopID = requestAnimationFrame(R);
                return;
            }
            let he = L / 1e3, z = he - e.realTime, Oe = n.maxFPS ? 1 / n.maxFPS : 0;
            e.realTime = he, x += z, x > Oe && (e.skipTime || (e.dt = x, e.time += o(), e.fpsCounter.tick(e.dt)), x = 0, e.skipTime = !1, e.numFrames++, ft(), l(), vn()), e.loopID = requestAnimationFrame(R);
        }, "frame");
        R(0);
    }
    $adc7cb3c45508c7c$var$i(k, "run");
    function pe() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }
    $adc7cb3c45508c7c$var$i(pe, "isTouchscreen");
    function C() {
        return e.mousePos.clone();
    }
    $adc7cb3c45508c7c$var$i(C, "mousePos");
    function Ae() {
        return e.mouseDeltaPos.clone();
    }
    $adc7cb3c45508c7c$var$i(Ae, "mouseDeltaPos");
    function $(l = "left") {
        return e.mouseState.pressed.has(l);
    }
    $adc7cb3c45508c7c$var$i($, "isMousePressed");
    function Te(l = "left") {
        return e.mouseState.down.has(l);
    }
    $adc7cb3c45508c7c$var$i(Te, "isMouseDown");
    function ye(l = "left") {
        return e.mouseState.released.has(l);
    }
    $adc7cb3c45508c7c$var$i(ye, "isMouseReleased");
    function Se() {
        return e.isMouseMoved;
    }
    $adc7cb3c45508c7c$var$i(Se, "isMouseMoved");
    function st(l) {
        return l === void 0 ? e.keyState.pressed.size > 0 : e.keyState.pressed.has(l);
    }
    $adc7cb3c45508c7c$var$i(st, "isKeyPressed");
    function on(l) {
        return l === void 0 ? e.keyState.pressedRepeat.size > 0 : e.keyState.pressedRepeat.has(l);
    }
    $adc7cb3c45508c7c$var$i(on, "isKeyPressedRepeat");
    function Tt(l) {
        return l === void 0 ? e.keyState.down.size > 0 : e.keyState.down.has(l);
    }
    $adc7cb3c45508c7c$var$i(Tt, "isKeyDown");
    function Ot(l) {
        return l === void 0 ? e.keyState.released.size > 0 : e.keyState.released.has(l);
    }
    $adc7cb3c45508c7c$var$i(Ot, "isKeyReleased");
    function Rt(l) {
        return l === void 0 ? e.mergedGamepadState.buttonState.pressed.size > 0 : e.mergedGamepadState.buttonState.pressed.has(l);
    }
    $adc7cb3c45508c7c$var$i(Rt, "isGamepadButtonPressed");
    function Ye(l) {
        return l === void 0 ? e.mergedGamepadState.buttonState.down.size > 0 : e.mergedGamepadState.buttonState.down.has(l);
    }
    $adc7cb3c45508c7c$var$i(Ye, "isGamepadButtonDown");
    function an(l) {
        return l === void 0 ? e.mergedGamepadState.buttonState.released.size > 0 : e.mergedGamepadState.buttonState.released.has(l);
    }
    $adc7cb3c45508c7c$var$i(an, "isGamepadButtonReleased");
    function un(l) {
        return e.events.on("resize", l);
    }
    $adc7cb3c45508c7c$var$i(un, "onResize");
    let cn = $adc7cb3c45508c7c$var$Ee((l)=>e.events.on("keyDown", l), (l, x)=>e.events.on("keyDown", (R)=>R === l && x(l))), hn = $adc7cb3c45508c7c$var$Ee((l)=>e.events.on("keyPress", l), (l, x)=>e.events.on("keyPress", (R)=>R === l && x(l))), ln = $adc7cb3c45508c7c$var$Ee((l)=>e.events.on("keyPressRepeat", l), (l, x)=>e.events.on("keyPressRepeat", (R)=>R === l && x(l))), dn = $adc7cb3c45508c7c$var$Ee((l)=>e.events.on("keyRelease", l), (l, x)=>e.events.on("keyRelease", (R)=>R === l && x(l))), Pt = $adc7cb3c45508c7c$var$Ee((l)=>e.events.on("mouseDown", (x)=>l(x)), (l, x)=>e.events.on("mouseDown", (R)=>R === l && x(R))), Dt = $adc7cb3c45508c7c$var$Ee((l)=>e.events.on("mousePress", (x)=>l(x)), (l, x)=>e.events.on("mousePress", (R)=>R === l && x(R))), Mt = $adc7cb3c45508c7c$var$Ee((l)=>e.events.on("mouseRelease", (x)=>l(x)), (l, x)=>e.events.on("mouseRelease", (R)=>R === l && x(R)));
    function Gt(l) {
        return e.events.on("mouseMove", ()=>l(C(), Ae()));
    }
    $adc7cb3c45508c7c$var$i(Gt, "onMouseMove");
    function Bt(l) {
        return e.events.on("charInput", l);
    }
    $adc7cb3c45508c7c$var$i(Bt, "onCharInput");
    function fn(l) {
        return e.events.on("touchStart", l);
    }
    $adc7cb3c45508c7c$var$i(fn, "onTouchStart");
    function ct(l) {
        return e.events.on("touchMove", l);
    }
    $adc7cb3c45508c7c$var$i(ct, "onTouchMove");
    function mn(l) {
        return e.events.on("touchEnd", l);
    }
    $adc7cb3c45508c7c$var$i(mn, "onTouchEnd");
    function pn(l) {
        return e.events.on("scroll", l);
    }
    $adc7cb3c45508c7c$var$i(pn, "onScroll");
    function Ft(l) {
        return e.events.on("hide", l);
    }
    $adc7cb3c45508c7c$var$i(Ft, "onHide");
    function gn(l) {
        return e.events.on("show", l);
    }
    $adc7cb3c45508c7c$var$i(gn, "onShow");
    function It(l, x) {
        if (typeof l == "function") return e.events.on("gamepadButtonDown", l);
        if (typeof l == "string" && typeof x == "function") return e.events.on("gamepadButtonDown", (R)=>R === l && x(l));
    }
    $adc7cb3c45508c7c$var$i(It, "onGamepadButtonDown");
    function Lt(l, x) {
        if (typeof l == "function") return e.events.on("gamepadButtonPress", l);
        if (typeof l == "string" && typeof x == "function") return e.events.on("gamepadButtonPress", (R)=>R === l && x(l));
    }
    $adc7cb3c45508c7c$var$i(Lt, "onGamepadButtonPress");
    function wn(l, x) {
        if (typeof l == "function") return e.events.on("gamepadButtonRelease", l);
        if (typeof l == "string" && typeof x == "function") return e.events.on("gamepadButtonRelease", (R)=>R === l && x(l));
    }
    $adc7cb3c45508c7c$var$i(wn, "onGamepadButtonRelease");
    function ht(l, x) {
        return e.events.on("gamepadStick", (R, L)=>R === l && x(L));
    }
    $adc7cb3c45508c7c$var$i(ht, "onGamepadStick");
    function bn(l) {
        e.events.on("gamepadConnect", l);
    }
    $adc7cb3c45508c7c$var$i(bn, "onGamepadConnect");
    function lt(l) {
        e.events.on("gamepadDisconnect", l);
    }
    $adc7cb3c45508c7c$var$i(lt, "onGamepadDisconnect");
    function Pe(l) {
        return e.mergedGamepadState.stickState.get(l) || new $adc7cb3c45508c7c$var$v(0);
    }
    $adc7cb3c45508c7c$var$i(Pe, "getGamepadStick");
    function dt() {
        return [
            ...e.charInputted
        ];
    }
    $adc7cb3c45508c7c$var$i(dt, "charInputted");
    function Vt() {
        return [
            ...e.gamepads
        ];
    }
    $adc7cb3c45508c7c$var$i(Vt, "getGamepads");
    function ft() {
        e.events.trigger("input"), e.keyState.down.forEach((l)=>e.events.trigger("keyDown", l)), e.mouseState.down.forEach((l)=>e.events.trigger("mouseDown", l)), He();
    }
    $adc7cb3c45508c7c$var$i(ft, "processInput");
    function vn() {
        e.keyState.update(), e.mouseState.update(), e.mergedGamepadState.buttonState.update(), e.mergedGamepadState.stickState.forEach((l, x)=>{
            e.mergedGamepadState.stickState.set(x, new $adc7cb3c45508c7c$var$v(0));
        }), e.charInputted = [], e.isMouseMoved = !1, e.gamepadStates.forEach((l)=>{
            l.buttonState.update(), l.stickState.forEach((x, R)=>{
                l.stickState.set(R, new $adc7cb3c45508c7c$var$v(0));
            });
        });
    }
    $adc7cb3c45508c7c$var$i(vn, "resetInput");
    function _t(l) {
        let x = {
            index: l.index,
            isPressed: (R)=>e.gamepadStates.get(l.index).buttonState.pressed.has(R),
            isDown: (R)=>e.gamepadStates.get(l.index).buttonState.down.has(R),
            isReleased: (R)=>e.gamepadStates.get(l.index).buttonState.released.has(R),
            getStick: (R)=>e.gamepadStates.get(l.index).stickState.get(R)
        };
        return e.gamepads.push(x), e.gamepadStates.set(l.index, {
            buttonState: new $adc7cb3c45508c7c$var$at,
            stickState: new Map([
                [
                    "left",
                    new $adc7cb3c45508c7c$var$v(0)
                ],
                [
                    "right",
                    new $adc7cb3c45508c7c$var$v(0)
                ]
            ])
        }), x;
    }
    $adc7cb3c45508c7c$var$i(_t, "registerGamepad");
    function ne(l) {
        e.gamepads = e.gamepads.filter((x)=>x.index !== l.index), e.gamepadStates.delete(l.index);
    }
    $adc7cb3c45508c7c$var$i(ne, "removeGamepad");
    function He() {
        for (let l of navigator.getGamepads())l && !e.gamepadStates.has(l.index) && _t(l);
        for (let l of e.gamepads){
            let x = navigator.getGamepads()[l.index], L = (n.gamepads ?? {})[x.id] ?? $adc7cb3c45508c7c$var$qn[x.id] ?? $adc7cb3c45508c7c$var$qn.default, he = e.gamepadStates.get(l.index);
            for(let z = 0; z < x.buttons.length; z++)x.buttons[z].pressed ? (he.buttonState.down.has(L.buttons[z]) || (e.mergedGamepadState.buttonState.press(L.buttons[z]), he.buttonState.press(L.buttons[z]), e.events.trigger("gamepadButtonPress", L.buttons[z])), e.events.trigger("gamepadButtonDown", L.buttons[z])) : he.buttonState.down.has(L.buttons[z]) && (e.mergedGamepadState.buttonState.release(L.buttons[z]), he.buttonState.release(L.buttons[z]), e.events.trigger("gamepadButtonRelease", L.buttons[z]));
            for(let z in L.sticks){
                let Oe = L.sticks[z], $e = new $adc7cb3c45508c7c$var$v(x.axes[Oe.x], x.axes[Oe.y]);
                he.stickState.set(z, $e), e.mergedGamepadState.stickState.set(z, $e), e.events.trigger("gamepadStick", z, $e);
            }
        }
    }
    $adc7cb3c45508c7c$var$i(He, "processGamepad");
    let se = {}, le = {}, ae = {}, Be = n.pixelDensity || window.devicePixelRatio || 1;
    se.mousemove = (l)=>{
        let x = new $adc7cb3c45508c7c$var$v(l.offsetX, l.offsetY), R = new $adc7cb3c45508c7c$var$v(l.movementX, l.movementY);
        if (Q()) {
            let L = e.canvas.width / Be, he = e.canvas.height / Be, z = window.innerWidth, Oe = window.innerHeight, $e = z / Oe, kt = L / he;
            if ($e > kt) {
                let De = Oe / he, Ce = (z - L * De) / 2;
                x.x = $adc7cb3c45508c7c$var$_e(l.offsetX - Ce, 0, L * De, 0, L), x.y = $adc7cb3c45508c7c$var$_e(l.offsetY, 0, he * De, 0, he);
            } else {
                let De = z / L, Ce = (Oe - he * De) / 2;
                x.x = $adc7cb3c45508c7c$var$_e(l.offsetX, 0, L * De, 0, L), x.y = $adc7cb3c45508c7c$var$_e(l.offsetY - Ce, 0, he * De, 0, he);
            }
        }
        e.events.onOnce("input", ()=>{
            e.isMouseMoved = !0, e.mousePos = x, e.mouseDeltaPos = R, e.events.trigger("mouseMove");
        });
    };
    let We = [
        "left",
        "middle",
        "right",
        "back",
        "forward"
    ];
    se.mousedown = (l)=>{
        e.events.onOnce("input", ()=>{
            let x = We[l.button];
            x && (e.mouseState.press(x), e.events.trigger("mousePress", x));
        });
    }, se.mouseup = (l)=>{
        e.events.onOnce("input", ()=>{
            let x = We[l.button];
            x && (e.mouseState.release(x), e.events.trigger("mouseRelease", x));
        });
    };
    let yn = new Set([
        " ",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab"
    ]), qe = {
        ArrowLeft: "left",
        ArrowRight: "right",
        ArrowUp: "up",
        ArrowDown: "down",
        " ": "space"
    };
    se.keydown = (l)=>{
        yn.has(l.key) && l.preventDefault(), e.events.onOnce("input", ()=>{
            let x = qe[l.key] || l.key.toLowerCase();
            x.length === 1 ? (e.events.trigger("charInput", x), e.charInputted.push(x)) : x === "space" && (e.events.trigger("charInput", " "), e.charInputted.push(" ")), l.repeat ? (e.keyState.pressRepeat(x), e.events.trigger("keyPressRepeat", x)) : (e.keyState.press(x), e.events.trigger("keyPressRepeat", x), e.events.trigger("keyPress", x));
        });
    }, se.keyup = (l)=>{
        e.events.onOnce("input", ()=>{
            let x = qe[l.key] || l.key.toLowerCase();
            e.keyState.release(x), e.events.trigger("keyRelease", x);
        });
    }, se.touchstart = (l)=>{
        l.preventDefault(), e.events.onOnce("input", ()=>{
            let x = [
                ...l.changedTouches
            ], R = e.canvas.getBoundingClientRect();
            n.touchToMouse !== !1 && (e.mousePos = new $adc7cb3c45508c7c$var$v(x[0].clientX - R.x, x[0].clientY - R.y), e.mouseState.press("left"), e.events.trigger("mousePress", "left")), x.forEach((L)=>{
                e.events.trigger("touchStart", new $adc7cb3c45508c7c$var$v(L.clientX - R.x, L.clientY - R.y), L);
            });
        });
    }, se.touchmove = (l)=>{
        l.preventDefault(), e.events.onOnce("input", ()=>{
            let x = [
                ...l.changedTouches
            ], R = e.canvas.getBoundingClientRect();
            n.touchToMouse !== !1 && (e.mousePos = new $adc7cb3c45508c7c$var$v(x[0].clientX - R.x, x[0].clientY - R.y), e.events.trigger("mouseMove")), x.forEach((L)=>{
                e.events.trigger("touchMove", new $adc7cb3c45508c7c$var$v(L.clientX - R.x, L.clientY - R.y), L);
            });
        });
    }, se.touchend = (l)=>{
        e.events.onOnce("input", ()=>{
            let x = [
                ...l.changedTouches
            ], R = e.canvas.getBoundingClientRect();
            n.touchToMouse !== !1 && (e.mousePos = new $adc7cb3c45508c7c$var$v(x[0].clientX - R.x, x[0].clientY - R.y), e.mouseState.release("left"), e.events.trigger("mouseRelease", "left")), x.forEach((L)=>{
                e.events.trigger("touchEnd", new $adc7cb3c45508c7c$var$v(L.clientX - R.x, L.clientY - R.y), L);
            });
        });
    }, se.touchcancel = (l)=>{
        e.events.onOnce("input", ()=>{
            let x = [
                ...l.changedTouches
            ], R = e.canvas.getBoundingClientRect();
            n.touchToMouse !== !1 && (e.mousePos = new $adc7cb3c45508c7c$var$v(x[0].clientX - R.x, x[0].clientY - R.y), e.mouseState.release("left"), e.events.trigger("mouseRelease", "left")), x.forEach((L)=>{
                e.events.trigger("touchEnd", new $adc7cb3c45508c7c$var$v(L.clientX - R.x, L.clientY - R.y), L);
            });
        });
    }, se.wheel = (l)=>{
        l.preventDefault(), e.events.onOnce("input", ()=>{
            e.events.trigger("scroll", new $adc7cb3c45508c7c$var$v(l.deltaX, l.deltaY));
        });
    }, se.contextmenu = (l)=>l.preventDefault(), le.visibilitychange = ()=>{
        document.visibilityState === "visible" ? (e.skipTime = !0, e.events.trigger("show")) : e.events.trigger("hide");
    }, ae.gamepadconnected = (l)=>{
        let x = _t(l.gamepad);
        e.events.onOnce("input", ()=>{
            e.events.trigger("gamepadConnect", x);
        });
    }, ae.gamepaddisconnected = (l)=>{
        let x = Vt().filter((R)=>R.index === l.gamepad.index)[0];
        ne(l.gamepad), e.events.onOnce("input", ()=>{
            e.events.trigger("gamepadDisconnect", x);
        });
    };
    for(let l in se)e.canvas.addEventListener(l, se[l]);
    for(let l in le)document.addEventListener(l, le[l]);
    for(let l in ae)window.addEventListener(l, ae[l]);
    let ge = new ResizeObserver((l)=>{
        for (let x of l)if (x.target === e.canvas) {
            if (e.lastWidth === e.canvas.offsetWidth && e.lastHeight === e.canvas.offsetHeight) return;
            e.lastWidth = e.canvas.offsetWidth, e.lastHeight = e.canvas.offsetHeight, e.events.onOnce("input", ()=>{
                e.events.trigger("resize");
            });
        }
    });
    return ge.observe(e.canvas), {
        dt: o,
        time: c,
        run: k,
        canvas: e.canvas,
        fps: g,
        numFrames: m,
        quit: te,
        setFullscreen: K,
        isFullscreen: Q,
        setCursor: I,
        screenshot: P,
        getGamepads: Vt,
        getCursor: j,
        setCursorLocked: y,
        isCursorLocked: X,
        isTouchscreen: pe,
        mousePos: C,
        mouseDeltaPos: Ae,
        isKeyDown: Tt,
        isKeyPressed: st,
        isKeyPressedRepeat: on,
        isKeyReleased: Ot,
        isMouseDown: Te,
        isMousePressed: $,
        isMouseReleased: ye,
        isMouseMoved: Se,
        isGamepadButtonPressed: Rt,
        isGamepadButtonDown: Ye,
        isGamepadButtonReleased: an,
        getGamepadStick: Pe,
        charInputted: dt,
        onResize: un,
        onKeyDown: cn,
        onKeyPress: hn,
        onKeyPressRepeat: ln,
        onKeyRelease: dn,
        onMouseDown: Pt,
        onMousePress: Dt,
        onMouseRelease: Mt,
        onMouseMove: Gt,
        onCharInput: Bt,
        onTouchStart: fn,
        onTouchMove: ct,
        onTouchEnd: mn,
        onScroll: pn,
        onHide: Ft,
        onShow: gn,
        onGamepadButtonDown: It,
        onGamepadButtonPress: Lt,
        onGamepadButtonRelease: wn,
        onGamepadStick: ht,
        onGamepadConnect: bn,
        onGamepadDisconnect: lt,
        events: e.events
    };
}, "default");
var $adc7cb3c45508c7c$var$Re = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Texture");
    }
    ctx;
    src = null;
    glTex;
    width;
    height;
    constructor(e, o, c, g = {}){
        this.ctx = e;
        let m = e.gl;
        this.glTex = e.gl.createTexture(), e.onDestroy(()=>this.free()), this.width = o, this.height = c;
        let P = {
            linear: m.LINEAR,
            nearest: m.NEAREST
        }[g.filter ?? e.opts.texFilter] ?? m.NEAREST, I = {
            repeat: m.REPEAT,
            clampToEadge: m.CLAMP_TO_EDGE
        }[g.wrap] ?? m.CLAMP_TO_EDGE;
        this.bind(), o && c && m.texImage2D(m.TEXTURE_2D, 0, m.RGBA, o, c, 0, m.RGBA, m.UNSIGNED_BYTE, null), m.texParameteri(m.TEXTURE_2D, m.TEXTURE_MIN_FILTER, P), m.texParameteri(m.TEXTURE_2D, m.TEXTURE_MAG_FILTER, P), m.texParameteri(m.TEXTURE_2D, m.TEXTURE_WRAP_S, I), m.texParameteri(m.TEXTURE_2D, m.TEXTURE_WRAP_T, I), this.unbind();
    }
    static fromImage(e, o, c = {}) {
        let g = new n(e, o.width, o.height, c);
        return g.update(o), g.src = o, g;
    }
    update(e, o = 0, c = 0) {
        let g = this.ctx.gl;
        this.bind(), g.texSubImage2D(g.TEXTURE_2D, 0, o, c, g.RGBA, g.UNSIGNED_BYTE, e), this.unbind();
    }
    bind() {
        this.ctx.pushTexture2D(this.glTex);
    }
    unbind() {
        this.ctx.popTexture2D();
    }
    free() {
        this.ctx.gl.deleteTexture(this.glTex);
    }
}, $adc7cb3c45508c7c$var$rt = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "FrameBuffer");
    }
    ctx;
    tex;
    glFramebuffer;
    glRenderbuffer;
    constructor(e, o, c, g = {}){
        this.ctx = e;
        let m = e.gl;
        e.onDestroy(()=>this.free()), this.tex = new $adc7cb3c45508c7c$var$Re(e, o, c, g), this.glFramebuffer = m.createFramebuffer(), this.glRenderbuffer = m.createRenderbuffer(), this.bind(), m.renderbufferStorage(m.RENDERBUFFER, m.DEPTH_STENCIL, o, c), m.framebufferTexture2D(m.FRAMEBUFFER, m.COLOR_ATTACHMENT0, m.TEXTURE_2D, this.tex.glTex, 0), m.framebufferRenderbuffer(m.FRAMEBUFFER, m.DEPTH_STENCIL_ATTACHMENT, m.RENDERBUFFER, this.glRenderbuffer), this.unbind();
    }
    get width() {
        return this.tex.width;
    }
    get height() {
        return this.tex.height;
    }
    toImageData() {
        let e = this.ctx.gl, o = new Uint8ClampedArray(this.width * this.height * 4);
        this.bind(), e.readPixels(0, 0, this.width, this.height, e.RGBA, e.UNSIGNED_BYTE, o), this.unbind();
        let c = this.width * 4, g = new Uint8Array(c);
        for(let m = 0; m < (this.height / 2 | 0); m++){
            let P = m * c, I = (this.height - m - 1) * c;
            g.set(o.subarray(P, P + c)), o.copyWithin(P, I, I + c), o.set(g, I);
        }
        return new ImageData(o, this.width, this.height);
    }
    toDataURL() {
        let e = document.createElement("canvas"), o = e.getContext("2d");
        return e.width = this.width, e.height = this.height, o.putImageData(this.toImageData(), 0, 0), e.toDataURL();
    }
    draw(e) {
        this.bind(), e(), this.unbind();
    }
    bind() {
        this.ctx.pushFramebuffer(this.glFramebuffer), this.ctx.pushRenderbuffer(this.glRenderbuffer), this.ctx.pushViewport({
            x: 0,
            y: 0,
            w: this.width,
            h: this.height
        });
    }
    unbind() {
        this.ctx.popFramebuffer(), this.ctx.popRenderbuffer(), this.ctx.popViewport();
    }
    free() {
        let e = this.ctx.gl;
        e.deleteFramebuffer(this.glFramebuffer), e.deleteRenderbuffer(this.glRenderbuffer), this.tex.free();
    }
}, $adc7cb3c45508c7c$var$Jt = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "Shader");
    }
    ctx;
    glProgram;
    constructor(e, o, c, g){
        this.ctx = e, e.onDestroy(()=>this.free());
        let m = e.gl, P = m.createShader(m.VERTEX_SHADER), I = m.createShader(m.FRAGMENT_SHADER);
        m.shaderSource(P, o), m.shaderSource(I, c), m.compileShader(P), m.compileShader(I);
        let j = m.createProgram();
        if (this.glProgram = j, m.attachShader(j, P), m.attachShader(j, I), g.forEach((y, X)=>m.bindAttribLocation(j, X, y)), m.linkProgram(j), !m.getProgramParameter(j, m.LINK_STATUS)) {
            let y = m.getShaderInfoLog(P);
            if (y) throw new Error("VERTEX SHADER " + y);
            let X = m.getShaderInfoLog(I);
            if (X) throw new Error("FRAGMENT SHADER " + X);
        }
        m.deleteShader(P), m.deleteShader(I);
    }
    bind() {
        this.ctx.pushProgram(this.glProgram);
    }
    unbind() {
        this.ctx.popProgram();
    }
    send(e) {
        let o = this.ctx.gl;
        for(let c in e){
            let g = e[c], m = o.getUniformLocation(this.glProgram, c);
            typeof g == "number" ? o.uniform1f(m, g) : g instanceof $adc7cb3c45508c7c$var$Ue ? o.uniformMatrix4fv(m, !1, new Float32Array(g.m)) : g instanceof $adc7cb3c45508c7c$var$W ? o.uniform3f(m, g.r, g.g, g.b) : g instanceof $adc7cb3c45508c7c$var$v && o.uniform2f(m, g.x, g.y);
        }
    }
    free() {
        this.ctx.gl.deleteProgram(this.glProgram);
    }
}, $adc7cb3c45508c7c$var$Qt = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "BatchRenderer");
    }
    ctx;
    glVBuf;
    glIBuf;
    vqueue = [];
    iqueue = [];
    stride;
    maxVertices;
    maxIndices;
    vertexFormat;
    numDraws = 0;
    curPrimitive = null;
    curTex = null;
    curShader = null;
    curUniform = {};
    constructor(e, o, c, g){
        let m = e.gl;
        this.vertexFormat = o, this.ctx = e, this.stride = o.reduce((P, I)=>P + I.size, 0), this.maxVertices = c, this.maxIndices = g, this.glVBuf = m.createBuffer(), e.pushArrayBuffer(this.glVBuf), m.bufferData(m.ARRAY_BUFFER, c * 4, m.DYNAMIC_DRAW), e.popArrayBuffer(), this.glIBuf = m.createBuffer(), e.pushElementArrayBuffer(this.glIBuf), m.bufferData(m.ELEMENT_ARRAY_BUFFER, g * 4, m.DYNAMIC_DRAW), e.popElementArrayBuffer();
    }
    push(e, o, c, g, m = null, P = {}) {
        (e !== this.curPrimitive || m !== this.curTex || g !== this.curShader || !$adc7cb3c45508c7c$var$Wt(this.curUniform, P) || this.vqueue.length + o.length * this.stride > this.maxVertices || this.iqueue.length + c.length > this.maxIndices) && this.flush();
        let I = this.vqueue.length / this.stride;
        for (let j of o)this.vqueue.push(j);
        for (let j of c)this.iqueue.push(j + I);
        this.curPrimitive = e, this.curShader = g, this.curTex = m, this.curUniform = P;
    }
    flush() {
        if (!this.curPrimitive || !this.curShader || this.vqueue.length === 0 || this.iqueue.length === 0) return;
        let e = this.ctx.gl;
        this.ctx.pushArrayBuffer(this.glVBuf), e.bufferSubData(e.ARRAY_BUFFER, 0, new Float32Array(this.vqueue)), this.ctx.pushElementArrayBuffer(this.glIBuf), e.bufferSubData(e.ELEMENT_ARRAY_BUFFER, 0, new Uint16Array(this.iqueue)), this.ctx.setVertexFormat(this.vertexFormat), this.curShader.bind(), this.curShader.send(this.curUniform), this.curTex?.bind(), e.drawElements(this.curPrimitive, this.iqueue.length, e.UNSIGNED_SHORT, 0), this.curTex?.unbind(), this.curShader.unbind(), this.ctx.popArrayBuffer(), this.ctx.popElementArrayBuffer(), this.vqueue = [], this.iqueue = [], this.numDraws++;
    }
    free() {
        let e = this.ctx.gl;
        e.deleteBuffer(this.glVBuf), e.deleteBuffer(this.glIBuf);
    }
};
function $adc7cb3c45508c7c$var$nt(n) {
    let e = [], o = $adc7cb3c45508c7c$var$i((m)=>{
        e.push(m), n(m);
    }, "push"), c = $adc7cb3c45508c7c$var$i(()=>{
        e.pop(), n(g() ?? null);
    }, "pop"), g = $adc7cb3c45508c7c$var$i(()=>e[e.length - 1], "cur");
    return [
        o,
        c,
        g
    ];
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$nt, "genStack");
function $adc7cb3c45508c7c$var$Kn(n, e = {}) {
    let o = [];
    function c($) {
        o.push($);
    }
    $adc7cb3c45508c7c$var$i(c, "onDestroy");
    function g() {
        o.forEach(($)=>$()), n.getExtension("WEBGL_lose_context").loseContext();
    }
    $adc7cb3c45508c7c$var$i(g, "destroy");
    let m = null;
    function P($) {
        if ($adc7cb3c45508c7c$var$Wt($, m)) return;
        m = $;
        let Te = $.reduce((ye, Se)=>ye + Se.size, 0);
        $.reduce((ye, Se, st)=>(n.vertexAttribPointer(st, Se.size, n.FLOAT, !1, Te * 4, ye), n.enableVertexAttribArray(st), ye + Se.size * 4), 0);
    }
    $adc7cb3c45508c7c$var$i(P, "setVertexFormat");
    let [I, j] = $adc7cb3c45508c7c$var$nt(($)=>n.bindTexture(n.TEXTURE_2D, $)), [y, X] = $adc7cb3c45508c7c$var$nt(($)=>n.bindBuffer(n.ARRAY_BUFFER, $)), [S, q] = $adc7cb3c45508c7c$var$nt(($)=>n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, $)), [E, K] = $adc7cb3c45508c7c$var$nt(($)=>n.bindFramebuffer(n.FRAMEBUFFER, $)), [Q, te] = $adc7cb3c45508c7c$var$nt(($)=>n.bindRenderbuffer(n.RENDERBUFFER, $)), [k, pe] = $adc7cb3c45508c7c$var$nt(({ x: $, y: Te, w: ye, h: Se })=>{
        n.viewport($, Te, ye, Se);
    }), [C, Ae] = $adc7cb3c45508c7c$var$nt(($)=>n.useProgram($));
    return k({
        x: 0,
        y: 0,
        w: n.drawingBufferWidth,
        h: n.drawingBufferHeight
    }), {
        gl: n,
        opts: e,
        onDestroy: c,
        destroy: g,
        pushTexture2D: I,
        popTexture2D: j,
        pushArrayBuffer: y,
        popArrayBuffer: X,
        pushElementArrayBuffer: S,
        popElementArrayBuffer: q,
        pushFramebuffer: E,
        popFramebuffer: K,
        pushRenderbuffer: Q,
        popRenderbuffer: te,
        pushViewport: k,
        popViewport: pe,
        pushProgram: C,
        popProgram: Ae,
        setVertexFormat: P
    };
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Kn, "initGfx");
var $adc7cb3c45508c7c$var$ve = class n {
    static{
        $adc7cb3c45508c7c$var$i(this, "Asset");
    }
    loaded = !1;
    data = null;
    error = null;
    onLoadEvents = new $adc7cb3c45508c7c$var$be;
    onErrorEvents = new $adc7cb3c45508c7c$var$be;
    onFinishEvents = new $adc7cb3c45508c7c$var$be;
    constructor(e){
        e.then((o)=>{
            this.data = o, this.onLoadEvents.trigger(o);
        }).catch((o)=>{
            if (this.error = o, this.onErrorEvents.numListeners() > 0) this.onErrorEvents.trigger(o);
            else throw o;
        }).finally(()=>{
            this.onFinishEvents.trigger(), this.loaded = !0;
        });
    }
    static loaded(e) {
        let o = new n(Promise.resolve(e));
        return o.data = e, o.loaded = !0, o;
    }
    onLoad(e) {
        return this.loaded && this.data ? e(this.data) : this.onLoadEvents.add(e), this;
    }
    onError(e) {
        return this.loaded && this.error ? e(this.error) : this.onErrorEvents.add(e), this;
    }
    onFinish(e) {
        return this.loaded ? e() : this.onFinishEvents.add(e), this;
    }
    then(e) {
        return this.onLoad(e);
    }
    catch(e) {
        return this.onError(e);
    }
    finally(e) {
        return this.onFinish(e);
    }
}, $adc7cb3c45508c7c$var$je = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "AssetBucket");
    }
    assets = new Map;
    lastUID = 0;
    add(e, o) {
        let c = e ?? this.lastUID++ + "", g = new $adc7cb3c45508c7c$var$ve(o);
        return this.assets.set(c, g), g;
    }
    addLoaded(e, o) {
        let c = e ?? this.lastUID++ + "", g = $adc7cb3c45508c7c$var$ve.loaded(o);
        return this.assets.set(c, g), g;
    }
    get(e) {
        return this.assets.get(e);
    }
    progress() {
        if (this.assets.size === 0) return 1;
        let e = 0;
        return this.assets.forEach((o)=>{
            o.loaded && e++;
        }), e / this.assets.size;
    }
};
function $adc7cb3c45508c7c$var$Yn(n) {
    return fetch(n).then((e)=>{
        if (!e.ok) throw new Error(`Failed to fetch "${n}"`);
        return e;
    });
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Yn, "fetchURL");
function $adc7cb3c45508c7c$var$Et(n) {
    return $adc7cb3c45508c7c$var$Yn(n).then((e)=>e.json());
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Et, "fetchJSON");
function $adc7cb3c45508c7c$var$Lr(n) {
    return $adc7cb3c45508c7c$var$Yn(n).then((e)=>e.text());
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Lr, "fetchText");
function $adc7cb3c45508c7c$var$Vr(n) {
    return $adc7cb3c45508c7c$var$Yn(n).then((e)=>e.arrayBuffer());
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Vr, "fetchArrayBuffer");
function $adc7cb3c45508c7c$var$St(n) {
    let e = new Image;
    return e.crossOrigin = "anonymous", e.src = n, new Promise((o, c)=>{
        e.onload = ()=>o(e), e.onerror = ()=>c(new Error(`Failed to load image from "${n}"`));
    });
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$St, "loadImg");
var $adc7cb3c45508c7c$var$Zt = 2.5949095, $adc7cb3c45508c7c$var$_r = 2.70158, $adc7cb3c45508c7c$var$kr = 2 * Math.PI / 3, $adc7cb3c45508c7c$var$Nr = 2 * Math.PI / 4.5, $adc7cb3c45508c7c$var$en = {
    linear: (n)=>n,
    easeInSine: (n)=>1 - Math.cos(n * Math.PI / 2),
    easeOutSine: (n)=>Math.sin(n * Math.PI / 2),
    easeInOutSine: (n)=>-(Math.cos(Math.PI * n) - 1) / 2,
    easeInQuad: (n)=>n * n,
    easeOutQuad: (n)=>1 - (1 - n) * (1 - n),
    easeInOutQuad: (n)=>n < .5 ? 2 * n * n : 1 - Math.pow(-2 * n + 2, 2) / 2,
    easeInCubic: (n)=>n * n * n,
    easeOutCubic: (n)=>1 - Math.pow(1 - n, 3),
    easeInOutCubic: (n)=>n < .5 ? 4 * n * n * n : 1 - Math.pow(-2 * n + 2, 3) / 2,
    easeInQuart: (n)=>n * n * n * n,
    easeOutQuart: (n)=>1 - Math.pow(1 - n, 4),
    easeInOutQuart: (n)=>n < .5 ? 8 * n * n * n * n : 1 - Math.pow(-2 * n + 2, 4) / 2,
    easeInQuint: (n)=>n * n * n * n * n,
    easeOutQuint: (n)=>1 - Math.pow(1 - n, 5),
    easeInOutQuint: (n)=>n < .5 ? 16 * n * n * n * n * n : 1 - Math.pow(-2 * n + 2, 5) / 2,
    easeInExpo: (n)=>n === 0 ? 0 : Math.pow(2, 10 * n - 10),
    easeOutExpo: (n)=>n === 1 ? 1 : 1 - Math.pow(2, -10 * n),
    easeInOutExpo: (n)=>n === 0 ? 0 : n === 1 ? 1 : n < .5 ? Math.pow(2, 20 * n - 10) / 2 : (2 - Math.pow(2, -20 * n + 10)) / 2,
    easeInCirc: (n)=>1 - Math.sqrt(1 - Math.pow(n, 2)),
    easeOutCirc: (n)=>Math.sqrt(1 - Math.pow(n - 1, 2)),
    easeInOutCirc: (n)=>n < .5 ? (1 - Math.sqrt(1 - Math.pow(2 * n, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * n + 2, 2)) + 1) / 2,
    easeInBack: (n)=>$adc7cb3c45508c7c$var$_r * n * n * n - 1.70158 * n * n,
    easeOutBack: (n)=>1 + $adc7cb3c45508c7c$var$_r * Math.pow(n - 1, 3) + 1.70158 * Math.pow(n - 1, 2),
    easeInOutBack: (n)=>n < .5 ? Math.pow(2 * n, 2) * (($adc7cb3c45508c7c$var$Zt + 1) * 2 * n - $adc7cb3c45508c7c$var$Zt) / 2 : (Math.pow(2 * n - 2, 2) * (($adc7cb3c45508c7c$var$Zt + 1) * (n * 2 - 2) + $adc7cb3c45508c7c$var$Zt) + 2) / 2,
    easeInElastic: (n)=>n === 0 ? 0 : n === 1 ? 1 : -Math.pow(2, 10 * n - 10) * Math.sin((n * 10 - 10.75) * $adc7cb3c45508c7c$var$kr),
    easeOutElastic: (n)=>n === 0 ? 0 : n === 1 ? 1 : Math.pow(2, -10 * n) * Math.sin((n * 10 - .75) * $adc7cb3c45508c7c$var$kr) + 1,
    easeInOutElastic: (n)=>n === 0 ? 0 : n === 1 ? 1 : n < .5 ? -(Math.pow(2, 20 * n - 10) * Math.sin((20 * n - 11.125) * $adc7cb3c45508c7c$var$Nr)) / 2 : Math.pow(2, -20 * n + 10) * Math.sin((20 * n - 11.125) * $adc7cb3c45508c7c$var$Nr) / 2 + 1,
    easeInBounce: (n)=>1 - $adc7cb3c45508c7c$var$en.easeOutBounce(1 - n),
    easeOutBounce: (n)=>n < 1 / 2.75 ? 7.5625 * n * n : n < 2 / 2.75 ? 7.5625 * (n -= 1.5 / 2.75) * n + .75 : n < 2.5 / 2.75 ? 7.5625 * (n -= 2.25 / 2.75) * n + .9375 : 7.5625 * (n -= 2.625 / 2.75) * n + .984375,
    easeInOutBounce: (n)=>n < .5 ? (1 - $adc7cb3c45508c7c$var$en.easeOutBounce(1 - 2 * n)) / 2 : (1 + $adc7cb3c45508c7c$var$en.easeOutBounce(2 * n - 1)) / 2
}, $adc7cb3c45508c7c$var$Ct = $adc7cb3c45508c7c$var$en;
var $adc7cb3c45508c7c$var$At = class {
    static{
        $adc7cb3c45508c7c$var$i(this, "TexPacker");
    }
    textures = [];
    canvas;
    c2d;
    x = 0;
    y = 0;
    curHeight = 0;
    gfx;
    constructor(e, o, c){
        this.gfx = e, this.canvas = document.createElement("canvas"), this.canvas.width = o, this.canvas.height = c, this.textures = [
            $adc7cb3c45508c7c$var$Re.fromImage(e, this.canvas)
        ], this.c2d = this.canvas.getContext("2d");
    }
    add(e) {
        if (e.width > this.canvas.width || e.height > this.canvas.height) throw new Error(`Texture size (${e.width} x ${e.height}) exceeds limit (${this.canvas.width} x ${this.canvas.height})`);
        this.x + e.width > this.canvas.width && (this.x = 0, this.y += this.curHeight, this.curHeight = 0), this.y + e.height > this.canvas.height && (this.c2d.clearRect(0, 0, this.canvas.width, this.canvas.height), this.textures.push($adc7cb3c45508c7c$var$Re.fromImage(this.gfx, this.canvas)), this.x = 0, this.y = 0, this.curHeight = 0);
        let o = this.textures[this.textures.length - 1], c = new $adc7cb3c45508c7c$var$v(this.x, this.y);
        return this.x += e.width, e.height > this.curHeight && (this.curHeight = e.height), e instanceof ImageData ? this.c2d.putImageData(e, c.x, c.y) : this.c2d.drawImage(e, c.x, c.y), o.update(this.canvas), [
            o,
            new $adc7cb3c45508c7c$var$oe(c.x / this.canvas.width, c.y / this.canvas.height, e.width / this.canvas.width, e.height / this.canvas.height)
        ];
    }
    free() {
        for (let e of this.textures)e.free();
    }
};
var $adc7cb3c45508c7c$var$jr = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA1CAYAAADyMeOEAAAAAXNSR0IArs4c6QAAAoVJREFUaIHdm7txwkAQhheGAqACiCHzOKQDQrqgILpwSAeEDBnEUAF0gCMxZ7G72qce/mec2Lpf9+3unaS78wgSNZ8uX5729+d1FNWXUuGmXlBOUUEIMckEpeQJgBu6C+BSFngztBR2vd+ovY+7g+p6LbgaWgJrAeUkDYIUXgXdBBwNi6kpABJwMTQH3AZsXRR8GHTfgEth8E3gjdAUcNewpbTgY85sCMCUuOokozE0YM0YRzM9NGAAXd8+omAF5h4lnmBRvpSnZHyLoLEbaN+aKB9KWv/KWw0tAbbANnlG+UvB2dm77NxxdwgBpjrF/d7rW9cbmpvio2A5z8iAYpVU8pGZlo6/2+MSco2lHfd3rv9jAP038e1xef9o2mjvYb2OqpqKE81028/jeietlSEVO5FRWsxWsJit1G3aFpW8iWe5RwpiCZAk25QvV6nz6fIlynRGuTd5WqpJ4guAlDfVKBK87hXljflgv1ON6fV+4+5gVlA17SfeG0heKqQd4l4jI/wrmaA9N9R4ar+wpHJDZyrrfcH0nB66PqAzPi76pn+faSyJk/vzOorYhGurQrzj/P68jtBMawHaHBIR9xoD5O34dy0qQOSYHvqExq2TpT2nf76+w7y251OYF0CRaU+J920TwLUa6inx6OxE6g80lu2ux7Y2eJLF/rCXE6zEPdnenk9o+4ih9AEdnW2q81HXl5LuU6OTl2fXUhqganbXAGq3g6jJOWV/OnoesO6YqqEB/GdNsjf7uHtwj2DzmRNpp7iOZfm6D9oAxB6Yi1gC4oIYeo4MIPdopEQRB+cAko5J1tW386HpB2Kz1eop4Epdwls/kgZ1sh8gZsEjdcWkr//D8Qu3Z3l5Nl1NtAAAAABJRU5ErkJggg==";
var $adc7cb3c45508c7c$var$Hr = $adc7cb3c45508c7c$var$gr("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");
var $adc7cb3c45508c7c$var$qr = "data:image/png;base64,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";
var $adc7cb3c45508c7c$var$$r = "data:image/png;base64,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";
var $adc7cb3c45508c7c$var$ki = "3000.1.17", $adc7cb3c45508c7c$var$zr = " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~", $adc7cb3c45508c7c$var$tn = "topleft", $adc7cb3c45508c7c$var$Kr = 64, $adc7cb3c45508c7c$var$Ni = "monospace", $adc7cb3c45508c7c$var$nn = "monospace", $adc7cb3c45508c7c$var$ji = 36, $adc7cb3c45508c7c$var$rn = 64, $adc7cb3c45508c7c$var$sn = 256, $adc7cb3c45508c7c$var$Yr = 2048, $adc7cb3c45508c7c$var$Wr = 2048, $adc7cb3c45508c7c$var$Xr = 2048, $adc7cb3c45508c7c$var$Jr = 2048, $adc7cb3c45508c7c$var$Qr = .1, $adc7cb3c45508c7c$var$Hi = 64, $adc7cb3c45508c7c$var$Wn = "linear", $adc7cb3c45508c7c$var$qi = 8, $adc7cb3c45508c7c$var$$i = 4, $adc7cb3c45508c7c$var$Qn = [
    {
        name: "a_pos",
        size: 2
    },
    {
        name: "a_uv",
        size: 2
    },
    {
        name: "a_color",
        size: 4
    }
], $adc7cb3c45508c7c$var$zi = $adc7cb3c45508c7c$var$Qn.reduce((n, e)=>n + e.size, 0), $adc7cb3c45508c7c$var$Zr = 2048, $adc7cb3c45508c7c$var$Ki = $adc7cb3c45508c7c$var$Zr * 4 * $adc7cb3c45508c7c$var$zi, $adc7cb3c45508c7c$var$Yi = $adc7cb3c45508c7c$var$Zr * 6, $adc7cb3c45508c7c$var$Wi = `
attribute vec2 a_pos;
attribute vec2 a_uv;
attribute vec4 a_color;

varying vec2 v_pos;
varying vec2 v_uv;
varying vec4 v_color;

vec4 def_vert() {
	return vec4(a_pos, 0.0, 1.0);
}

{{user}}

void main() {
	vec4 pos = vert(a_pos, a_uv, a_color);
	v_pos = a_pos;
	v_uv = a_uv;
	v_color = a_color;
	gl_Position = pos;
}
`, $adc7cb3c45508c7c$var$Xi = `
precision mediump float;

varying vec2 v_pos;
varying vec2 v_uv;
varying vec4 v_color;

uniform sampler2D u_tex;

vec4 def_frag() {
	return v_color * texture2D(u_tex, v_uv);
}

{{user}}

void main() {
	gl_FragColor = frag(v_pos, v_uv, v_color, u_tex);
	if (gl_FragColor.a == 0.0) {
		discard;
	}
}
`, $adc7cb3c45508c7c$var$Xn = `
vec4 vert(vec2 pos, vec2 uv, vec4 color) {
	return def_vert();
}
`, $adc7cb3c45508c7c$var$Jn = `
vec4 frag(vec2 pos, vec2 uv, vec4 color, sampler2D tex) {
	return def_frag();
}
`, $adc7cb3c45508c7c$var$Ji = new Set([
    "id",
    "require"
]), $adc7cb3c45508c7c$var$Qi = new Set([
    "add",
    "update",
    "draw",
    "destroy",
    "inspect",
    "drawInspect"
]);
function $adc7cb3c45508c7c$var$ut(n) {
    switch(n){
        case "topleft":
            return new $adc7cb3c45508c7c$var$v(-1, -1);
        case "top":
            return new $adc7cb3c45508c7c$var$v(0, -1);
        case "topright":
            return new $adc7cb3c45508c7c$var$v(1, -1);
        case "left":
            return new $adc7cb3c45508c7c$var$v(-1, 0);
        case "center":
            return new $adc7cb3c45508c7c$var$v(0, 0);
        case "right":
            return new $adc7cb3c45508c7c$var$v(1, 0);
        case "botleft":
            return new $adc7cb3c45508c7c$var$v(-1, 1);
        case "bot":
            return new $adc7cb3c45508c7c$var$v(0, 1);
        case "botright":
            return new $adc7cb3c45508c7c$var$v(1, 1);
        default:
            return n;
    }
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$ut, "anchorPt");
function $adc7cb3c45508c7c$var$Zi(n) {
    switch(n){
        case "left":
            return 0;
        case "center":
            return .5;
        case "right":
            return 1;
        default:
            return 0;
    }
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$Zi, "alignPt");
function $adc7cb3c45508c7c$var$eo(n) {
    return n.createBuffer(1, 1, 44100);
}
$adc7cb3c45508c7c$var$i($adc7cb3c45508c7c$var$eo, "createEmptyAudioBuffer");
var $adc7cb3c45508c7c$export$2e2bcd8739ae039 = $adc7cb3c45508c7c$var$i((n = {})=>{
    let e = n.root ?? document.body;
    e === document.body && (document.body.style.width = "100%", document.body.style.height = "100%", document.body.style.margin = "0px", document.documentElement.style.width = "100%", document.documentElement.style.height = "100%");
    let o = n.canvas ?? (()=>{
        let t1 = document.createElement("canvas");
        return e.appendChild(t1), t1;
    })(), c = n.scale ?? 1, g = n.width && n.height && !n.stretch && !n.letterbox;
    g ? (o.width = n.width * c, o.height = n.height * c) : (o.width = o.parentElement.offsetWidth, o.height = o.parentElement.offsetHeight);
    let m = [
        "outline: none",
        "cursor: default"
    ];
    if (g) {
        let t1 = o.width, r = o.height;
        m.push(`width: ${t1}px`), m.push(`height: ${r}px`);
    } else m.push("width: 100%"), m.push("height: 100%");
    n.crisp && (m.push("image-rendering: pixelated"), m.push("image-rendering: crisp-edges")), o.style.cssText = m.join(";");
    let P = n.pixelDensity || window.devicePixelRatio;
    o.width *= P, o.height *= P, o.tabIndex = 0;
    let I = document.createElement("canvas");
    I.width = $adc7cb3c45508c7c$var$sn, I.height = $adc7cb3c45508c7c$var$sn;
    let j = I.getContext("2d", {
        willReadFrequently: !0
    }), y = $adc7cb3c45508c7c$var$Ir({
        canvas: o,
        touchToMouse: n.touchToMouse,
        gamepads: n.gamepads,
        pixelDensity: n.pixelDensity,
        maxFPS: n.maxFPS
    }), X = [], S = y.canvas.getContext("webgl", {
        antialias: !0,
        depth: !0,
        stencil: !0,
        alpha: !0,
        preserveDrawingBuffer: !0
    }), q = $adc7cb3c45508c7c$var$Kn(S, {
        texFilter: n.texFilter
    }), E = (()=>{
        let t1 = ht($adc7cb3c45508c7c$var$Xn, $adc7cb3c45508c7c$var$Jn), r = $adc7cb3c45508c7c$var$Re.fromImage(q, new ImageData(new Uint8ClampedArray([
            255,
            255,
            255,
            255
        ]), 1, 1)), s1 = n.width && n.height ? new $adc7cb3c45508c7c$var$rt(q, n.width * P * c, n.height * P * c) : new $adc7cb3c45508c7c$var$rt(q, S.drawingBufferWidth, S.drawingBufferHeight), u = null, a1 = 1;
        n.background && (u = $adc7cb3c45508c7c$var$J(n.background), a1 = Array.isArray(n.background) ? n.background[3] : 1, S.clearColor(u.r / 255, u.g / 255, u.b / 255, a1 ?? 1)), S.enable(S.BLEND), S.blendFuncSeparate(S.SRC_ALPHA, S.ONE_MINUS_SRC_ALPHA, S.ONE, S.ONE_MINUS_SRC_ALPHA);
        let h1 = new $adc7cb3c45508c7c$var$Qt(q, $adc7cb3c45508c7c$var$Qn, $adc7cb3c45508c7c$var$Ki, $adc7cb3c45508c7c$var$Yi), f = $adc7cb3c45508c7c$var$Re.fromImage(q, new ImageData(new Uint8ClampedArray([
            128,
            128,
            128,
            255,
            190,
            190,
            190,
            255,
            190,
            190,
            190,
            255,
            128,
            128,
            128,
            255
        ]), 2, 2), {
            wrap: "repeat",
            filter: "nearest"
        });
        return {
            lastDrawCalls: 0,
            defShader: t1,
            defTex: r,
            frameBuffer: s1,
            postShader: null,
            postShaderUniform: null,
            renderer: h1,
            transform: new $adc7cb3c45508c7c$var$Ue,
            transformStack: [],
            bgTex: f,
            bgColor: u,
            bgAlpha: a1,
            width: n.width ?? S.drawingBufferWidth / P / c,
            height: n.height ?? S.drawingBufferHeight / P / c,
            viewport: {
                x: 0,
                y: 0,
                width: S.drawingBufferWidth,
                height: S.drawingBufferHeight
            },
            fixed: !1
        };
    })();
    class K {
        static{
            $adc7cb3c45508c7c$var$i(this, "SpriteData");
        }
        tex;
        frames = [
            new $adc7cb3c45508c7c$var$oe(0, 0, 1, 1)
        ];
        anims = {};
        slice9 = null;
        constructor(r, s1, u = {}, a1 = null){
            this.tex = r, s1 && (this.frames = s1), this.anims = u, this.slice9 = a1;
        }
        get width() {
            return this.tex.width * this.frames[0].w;
        }
        get height() {
            return this.tex.height * this.frames[0].h;
        }
        static from(r, s1 = {}) {
            return typeof r == "string" ? K.fromURL(r, s1) : Promise.resolve(K.fromImage(r, s1));
        }
        static fromImage(r, s1 = {}) {
            let [u, a1] = k.packer.add(r), h1 = s1.frames ? s1.frames.map((f)=>new $adc7cb3c45508c7c$var$oe(a1.x + f.x * a1.w, a1.y + f.y * a1.h, f.w * a1.w, f.h * a1.h)) : Tt(s1.sliceX || 1, s1.sliceY || 1, a1.x, a1.y, a1.w, a1.h);
            return new K(u, h1, s1.anims, s1.slice9);
        }
        static fromURL(r, s1 = {}) {
            return $adc7cb3c45508c7c$var$St(r).then((u)=>K.fromImage(u, s1));
        }
    }
    class Q {
        static{
            $adc7cb3c45508c7c$var$i(this, "SoundData");
        }
        buf;
        constructor(r){
            this.buf = r;
        }
        static fromArrayBuffer(r) {
            return new Promise((s1, u)=>te.ctx.decodeAudioData(r, s1, u)).then((s1)=>new Q(s1));
        }
        static fromURL(r) {
            return $adc7cb3c45508c7c$var$jn(r) ? Q.fromArrayBuffer($adc7cb3c45508c7c$var$Pr(r)) : $adc7cb3c45508c7c$var$Vr(r).then((s1)=>Q.fromArrayBuffer(s1));
        }
    }
    let te = (()=>{
        let t1 = new (window.AudioContext || window.webkitAudioContext), r = t1.createGain();
        r.connect(t1.destination);
        let s1 = new Q($adc7cb3c45508c7c$var$eo(t1));
        return t1.decodeAudioData($adc7cb3c45508c7c$var$Hr.buffer.slice(0)).then((u)=>{
            s1.buf = u;
        }).catch((u)=>{
            console.error("Failed to load burp: ", u);
        }), {
            ctx: t1,
            masterNode: r,
            burpSnd: s1
        };
    })(), k = {
        urlPrefix: "",
        sprites: new $adc7cb3c45508c7c$var$je,
        fonts: new $adc7cb3c45508c7c$var$je,
        bitmapFonts: new $adc7cb3c45508c7c$var$je,
        sounds: new $adc7cb3c45508c7c$var$je,
        shaders: new $adc7cb3c45508c7c$var$je,
        custom: new $adc7cb3c45508c7c$var$je,
        packer: new $adc7cb3c45508c7c$var$At(q, $adc7cb3c45508c7c$var$Xr, $adc7cb3c45508c7c$var$Jr),
        loaded: !1
    };
    function pe(t1) {
        return typeof t1 != "string" || $adc7cb3c45508c7c$var$jn(t1) ? t1 : k.urlPrefix + t1;
    }
    $adc7cb3c45508c7c$var$i(pe, "fixURL");
    let C = {
        events: new $adc7cb3c45508c7c$var$Ne,
        objEvents: new $adc7cb3c45508c7c$var$Ne,
        root: Un([]),
        gravity: 0,
        scenes: {},
        logs: [],
        cam: {
            pos: null,
            scale: new $adc7cb3c45508c7c$var$v(1),
            angle: 0,
            shake: 0,
            transform: new $adc7cb3c45508c7c$var$Ue
        }
    };
    C.root.use(An());
    function Ae(t1) {
        return k.custom.add(null, t1);
    }
    $adc7cb3c45508c7c$var$i(Ae, "load");
    function $() {
        let t1 = [
            k.sprites,
            k.sounds,
            k.shaders,
            k.fonts,
            k.bitmapFonts,
            k.custom
        ];
        return t1.reduce((r, s1)=>r + s1.progress(), 0) / t1.length;
    }
    $adc7cb3c45508c7c$var$i($, "loadProgress");
    function Te(t1) {
        return t1 !== void 0 && (k.urlPrefix = t1), k.urlPrefix;
    }
    $adc7cb3c45508c7c$var$i(Te, "loadRoot");
    function ye(t1, r) {
        return k.custom.add(t1, $adc7cb3c45508c7c$var$Et(r));
    }
    $adc7cb3c45508c7c$var$i(ye, "loadJSON");
    class Se {
        static{
            $adc7cb3c45508c7c$var$i(this, "FontData");
        }
        fontface;
        filter = $adc7cb3c45508c7c$var$Wn;
        outline = null;
        size = $adc7cb3c45508c7c$var$rn;
        constructor(r, s1 = {}){
            if (this.fontface = r, this.filter = s1.filter ?? $adc7cb3c45508c7c$var$Wn, this.size = s1.size ?? $adc7cb3c45508c7c$var$rn, this.size > $adc7cb3c45508c7c$var$sn) throw new Error(`Max font size: ${$adc7cb3c45508c7c$var$sn}`);
            s1.outline && (this.outline = {
                width: 1,
                color: $adc7cb3c45508c7c$var$J(0, 0, 0)
            }, typeof s1.outline == "number" ? this.outline.width = s1.outline : typeof s1.outline == "object" && (s1.outline.width && (this.outline.width = s1.outline.width), s1.outline.color && (this.outline.color = s1.outline.color)));
        }
    }
    function st(t1, r, s1 = {}) {
        let u = new FontFace(t1, typeof r == "string" ? `url(${r})` : r);
        return document.fonts.add(u), k.fonts.add(t1, u.load().catch((a1)=>{
            throw new Error(`Failed to load font from "${r}": ${a1}`);
        }).then((a1)=>new Se(a1, s1)));
    }
    $adc7cb3c45508c7c$var$i(st, "loadFont");
    function on(t1, r, s1, u, a1 = {}) {
        return k.bitmapFonts.add(t1, $adc7cb3c45508c7c$var$St(r).then((h1)=>bn($adc7cb3c45508c7c$var$Re.fromImage(q, h1, a1), s1, u, a1.chars ?? $adc7cb3c45508c7c$var$zr)));
    }
    $adc7cb3c45508c7c$var$i(on, "loadBitmapFont");
    function Tt(t1 = 1, r = 1, s1 = 0, u = 0, a1 = 1, h1 = 1) {
        let f = [], b1 = a1 / t1, p1 = h1 / r;
        for(let d1 = 0; d1 < r; d1++)for(let w = 0; w < t1; w++)f.push(new $adc7cb3c45508c7c$var$oe(s1 + w * b1, u + d1 * p1, b1, p1));
        return f;
    }
    $adc7cb3c45508c7c$var$i(Tt, "slice");
    function Ot(t1, r) {
        return t1 = pe(t1), Ae(typeof r == "string" ? new Promise((s1, u)=>{
            $adc7cb3c45508c7c$var$Et(r).then((a1)=>{
                Ot(t1, a1).then(s1).catch(u);
            });
        }) : K.from(t1).then((s1)=>{
            let u = {};
            for(let a1 in r){
                let h1 = r[a1], f = s1.frames[0], b1 = $adc7cb3c45508c7c$var$Xr * f.w, p1 = $adc7cb3c45508c7c$var$Jr * f.h, d1 = h1.frames ? h1.frames.map((A)=>new $adc7cb3c45508c7c$var$oe(f.x + (h1.x + A.x) / b1 * f.w, f.y + (h1.y + A.y) / p1 * f.h, A.w / b1 * f.w, A.h / p1 * f.h)) : Tt(h1.sliceX || 1, h1.sliceY || 1, f.x + h1.x / b1 * f.w, f.y + h1.y / p1 * f.h, h1.width / b1 * f.w, h1.height / p1 * f.h), w = new K(s1.tex, d1, h1.anims);
                k.sprites.addLoaded(a1, w), u[a1] = w;
            }
            return u;
        }));
    }
    $adc7cb3c45508c7c$var$i(Ot, "loadSpriteAtlas");
    function Rt(t1, r = {}) {
        let s1 = document.createElement("canvas"), u = t1[0].width, a1 = t1[0].height;
        s1.width = u * t1.length, s1.height = a1;
        let h1 = s1.getContext("2d");
        t1.forEach((b1, p1)=>{
            b1 instanceof ImageData ? h1.putImageData(b1, p1 * u, 0) : h1.drawImage(b1, p1 * u, 0);
        });
        let f = h1.getImageData(0, 0, t1.length * u, a1);
        return K.fromImage(f, {
            ...r,
            sliceX: t1.length,
            sliceY: 1
        });
    }
    $adc7cb3c45508c7c$var$i(Rt, "createSpriteSheet");
    function Ye(t1, r, s1 = {
        sliceX: 1,
        sliceY: 1,
        anims: {}
    }) {
        return r = pe(r), Array.isArray(r) ? r.some((u)=>typeof u == "string") ? k.sprites.add(t1, Promise.all(r.map((u)=>typeof u == "string" ? $adc7cb3c45508c7c$var$St(u) : Promise.resolve(u))).then((u)=>Rt(u, s1))) : k.sprites.addLoaded(t1, Rt(r, s1)) : typeof r == "string" ? k.sprites.add(t1, K.from(r, s1)) : k.sprites.addLoaded(t1, K.fromImage(r, s1));
    }
    $adc7cb3c45508c7c$var$i(Ye, "loadSprite");
    function an(t1, r) {
        return r = pe(r), k.sprites.add(t1, new Promise(async (s1)=>{
            let u = typeof r == "string" ? await $adc7cb3c45508c7c$var$Et(r) : r, a1 = await Promise.all(u.frames.map($adc7cb3c45508c7c$var$St)), h1 = document.createElement("canvas");
            h1.width = u.width, h1.height = u.height * u.frames.length;
            let f = h1.getContext("2d");
            a1.forEach((p1, d1)=>{
                f.drawImage(p1, 0, d1 * u.height);
            });
            let b1 = await Ye(null, h1, {
                sliceY: u.frames.length,
                anims: u.anims
            });
            s1(b1);
        }));
    }
    $adc7cb3c45508c7c$var$i(an, "loadPedit");
    function un(t1, r, s1) {
        r = pe(r), s1 = pe(s1), typeof r == "string" && !s1 && (s1 = $adc7cb3c45508c7c$var$Mr(r) + ".json");
        let u = typeof s1 == "string" ? $adc7cb3c45508c7c$var$Et(s1) : Promise.resolve(s1);
        return k.sprites.add(t1, u.then((a1)=>{
            let h1 = a1.meta.size, f = a1.frames.map((p1)=>new $adc7cb3c45508c7c$var$oe(p1.frame.x / h1.w, p1.frame.y / h1.h, p1.frame.w / h1.w, p1.frame.h / h1.h)), b1 = {};
            for (let p1 of a1.meta.frameTags)p1.from === p1.to ? b1[p1.name] = p1.from : b1[p1.name] = {
                from: p1.from,
                to: p1.to,
                speed: 10,
                loop: !0,
                pingpong: p1.direction === "pingpong"
            };
            return K.from(r, {
                frames: f,
                anims: b1
            });
        }));
    }
    $adc7cb3c45508c7c$var$i(un, "loadAseprite");
    function cn(t1, r, s1) {
        return k.shaders.addLoaded(t1, ht(r, s1));
    }
    $adc7cb3c45508c7c$var$i(cn, "loadShader");
    function hn(t1, r, s1) {
        r = pe(r), s1 = pe(s1);
        let u = $adc7cb3c45508c7c$var$i((h1)=>h1 ? $adc7cb3c45508c7c$var$Lr(h1) : Promise.resolve(null), "resolveUrl"), a1 = Promise.all([
            u(r),
            u(s1)
        ]).then(([h1, f])=>ht(h1, f));
        return k.shaders.add(t1, a1);
    }
    $adc7cb3c45508c7c$var$i(hn, "loadShaderURL");
    function ln(t1, r) {
        return r = pe(r), k.sounds.add(t1, typeof r == "string" ? Q.fromURL(r) : Q.fromArrayBuffer(r));
    }
    $adc7cb3c45508c7c$var$i(ln, "loadSound");
    function dn(t1 = "bean") {
        return Ye(t1, $adc7cb3c45508c7c$var$jr);
    }
    $adc7cb3c45508c7c$var$i(dn, "loadBean");
    function Pt(t1) {
        return k.sprites.get(t1);
    }
    $adc7cb3c45508c7c$var$i(Pt, "getSprite");
    function Dt(t1) {
        return k.sounds.get(t1);
    }
    $adc7cb3c45508c7c$var$i(Dt, "getSound");
    function Mt(t1) {
        return k.fonts.get(t1);
    }
    $adc7cb3c45508c7c$var$i(Mt, "getFont");
    function Gt(t1) {
        return k.bitmapFonts.get(t1);
    }
    $adc7cb3c45508c7c$var$i(Gt, "getBitmapFont");
    function Bt(t1) {
        return k.shaders.get(t1);
    }
    $adc7cb3c45508c7c$var$i(Bt, "getShader");
    function fn(t1) {
        return k.custom.get(t1);
    }
    $adc7cb3c45508c7c$var$i(fn, "getAsset");
    function ct(t1) {
        if (typeof t1 == "string") {
            let r = Pt(t1);
            if (r) return r;
            if ($() < 1) return null;
            throw new Error(`Sprite not found: ${t1}`);
        } else {
            if (t1 instanceof K) return $adc7cb3c45508c7c$var$ve.loaded(t1);
            if (t1 instanceof $adc7cb3c45508c7c$var$ve) return t1;
            throw new Error(`Invalid sprite: ${t1}`);
        }
    }
    $adc7cb3c45508c7c$var$i(ct, "resolveSprite");
    function mn(t1) {
        if (typeof t1 == "string") {
            let r = Dt(t1);
            if (r) return r;
            if ($() < 1) return null;
            throw new Error(`Sound not found: ${t1}`);
        } else {
            if (t1 instanceof Q) return $adc7cb3c45508c7c$var$ve.loaded(t1);
            if (t1 instanceof $adc7cb3c45508c7c$var$ve) return t1;
            throw new Error(`Invalid sound: ${t1}`);
        }
    }
    $adc7cb3c45508c7c$var$i(mn, "resolveSound");
    function pn(t1) {
        if (!t1) return E.defShader;
        if (typeof t1 == "string") {
            let r = Bt(t1);
            if (r) return r.data ?? r;
            if ($() < 1) return null;
            throw new Error(`Shader not found: ${t1}`);
        } else if (t1 instanceof $adc7cb3c45508c7c$var$ve) return t1.data ? t1.data : t1;
        return t1;
    }
    $adc7cb3c45508c7c$var$i(pn, "resolveShader");
    function Ft(t1) {
        if (!t1) return Ft(n.font ?? $adc7cb3c45508c7c$var$Ni);
        if (typeof t1 == "string") {
            let r = Gt(t1), s1 = Mt(t1);
            if (r) return r.data ?? r;
            if (s1) return s1.data ?? s1;
            if (document.fonts.check(`${$adc7cb3c45508c7c$var$rn}px ${t1}`)) return t1;
            if ($() < 1) return null;
            throw new Error(`Font not found: ${t1}`);
        } else if (t1 instanceof $adc7cb3c45508c7c$var$ve) return t1.data ? t1.data : t1;
        return t1;
    }
    $adc7cb3c45508c7c$var$i(Ft, "resolveFont");
    function gn(t1) {
        return t1 !== void 0 && (te.masterNode.gain.value = t1), te.masterNode.gain.value;
    }
    $adc7cb3c45508c7c$var$i(gn, "volume");
    function It(t1, r = {}) {
        let s1 = te.ctx, u = r.paused ?? !1, a1 = s1.createBufferSource(), h1 = new $adc7cb3c45508c7c$var$be, f = s1.createGain(), b1 = r.seek ?? 0, p1 = 0, d1 = 0, w = !1;
        a1.loop = !!r.loop, a1.detune.value = r.detune ?? 0, a1.playbackRate.value = r.speed ?? 1, a1.connect(f), a1.onended = ()=>{
            N() >= a1.buffer?.duration && h1.trigger();
        }, f.connect(te.masterNode), f.gain.value = r.volume ?? 1;
        let A = $adc7cb3c45508c7c$var$i((M1)=>{
            a1.buffer = M1.buf, u || (p1 = s1.currentTime, a1.start(0, b1), w = !0);
        }, "start"), D = mn(t1);
        D instanceof $adc7cb3c45508c7c$var$ve && D.onLoad(A);
        let N = $adc7cb3c45508c7c$var$i(()=>{
            if (!a1.buffer) return 0;
            let M1 = u ? d1 - p1 : s1.currentTime - p1, O = a1.buffer.duration;
            return a1.loop ? M1 % O : Math.min(M1, O);
        }, "getTime"), _ = $adc7cb3c45508c7c$var$i((M1)=>{
            let O = s1.createBufferSource();
            return O.buffer = M1.buffer, O.loop = M1.loop, O.playbackRate.value = M1.playbackRate.value, O.detune.value = M1.detune.value, O.onended = M1.onended, O.connect(f), O;
        }, "cloneNode");
        return {
            stop () {
                this.paused = !0, this.seek(0);
            },
            set paused (M){
                if (u !== M) {
                    if (u = M, M) w && (a1.stop(), w = !1), d1 = s1.currentTime;
                    else {
                        a1 = _(a1);
                        let O = d1 - p1;
                        a1.start(0, O), w = !0, p1 = s1.currentTime - O, d1 = 0;
                    }
                }
            },
            get paused () {
                return u;
            },
            play (M1 = 0) {
                this.seek(M1), this.paused = !1;
            },
            seek (M1) {
                a1.buffer?.duration && (M1 > a1.buffer.duration || (u ? (a1 = _(a1), p1 = d1 - M1) : (a1.stop(), a1 = _(a1), p1 = s1.currentTime - M1, a1.start(0, M1), w = !0, d1 = 0)));
            },
            set speed (M){
                a1.playbackRate.value = M;
            },
            get speed () {
                return a1.playbackRate.value;
            },
            set detune (M){
                a1.detune.value = M;
            },
            get detune () {
                return a1.detune.value;
            },
            set volume (M){
                f.gain.value = Math.max(M, 0);
            },
            get volume () {
                return f.gain.value;
            },
            set loop (M){
                a1.loop = M;
            },
            get loop () {
                return a1.loop;
            },
            duration () {
                return a1.buffer?.duration ?? 0;
            },
            time () {
                return N() % this.duration();
            },
            onEnd (M1) {
                return h1.add(M1);
            },
            then (M1) {
                return this.onEnd(M1);
            }
        };
    }
    $adc7cb3c45508c7c$var$i(It, "play");
    function Lt(t1) {
        return It(te.burpSnd, t1);
    }
    $adc7cb3c45508c7c$var$i(Lt, "burp");
    function wn(t1, r) {
        return new $adc7cb3c45508c7c$var$rt(q, t1, r);
    }
    $adc7cb3c45508c7c$var$i(wn, "makeCanvas");
    function ht(t1 = $adc7cb3c45508c7c$var$Xn, r = $adc7cb3c45508c7c$var$Jn) {
        let s1 = $adc7cb3c45508c7c$var$Wi.replace("{{user}}", t1 ?? $adc7cb3c45508c7c$var$Xn), u = $adc7cb3c45508c7c$var$Xi.replace("{{user}}", r ?? $adc7cb3c45508c7c$var$Jn);
        try {
            return new $adc7cb3c45508c7c$var$Jt(q, s1, u, $adc7cb3c45508c7c$var$Qn.map((a1)=>a1.name));
        } catch (a1) {
            let f = /(?<type>^\w+) SHADER ERROR: 0:(?<line>\d+): (?<msg>.+)/, b1 = $adc7cb3c45508c7c$var$Br(a1).match(f), p1 = Number(b1.groups.line) - 14, d1 = b1.groups.msg.trim(), w = b1.groups.type.toLowerCase();
            throw new Error(`${w} shader line ${p1}: ${d1}`);
        }
    }
    $adc7cb3c45508c7c$var$i(ht, "makeShader");
    function bn(t1, r, s1, u) {
        let a1 = t1.width / r, h1 = {}, f = u.split("").entries();
        for (let [b1, p1] of f)h1[p1] = new $adc7cb3c45508c7c$var$oe(b1 % a1 * r, Math.floor(b1 / a1) * s1, r, s1);
        return {
            tex: t1,
            map: h1,
            size: s1
        };
    }
    $adc7cb3c45508c7c$var$i(bn, "makeFont");
    function lt(t1, r, s1, u = E.defTex, a1 = E.defShader, h1 = {}) {
        let f = pn(a1);
        if (!f || f instanceof $adc7cb3c45508c7c$var$ve) return;
        let b1 = E.fixed || s1 ? E.transform : C.cam.transform.mult(E.transform), p1 = [];
        for (let d1 of t1){
            let w = vn(b1.multVec2(d1.pos));
            p1.push(w.x, w.y, d1.uv.x, d1.uv.y, d1.color.r / 255, d1.color.g / 255, d1.color.b / 255, d1.opacity);
        }
        E.renderer.push(S.TRIANGLES, p1, r, f, u, h1);
    }
    $adc7cb3c45508c7c$var$i(lt, "drawRaw");
    function Pe() {
        E.renderer.flush();
    }
    $adc7cb3c45508c7c$var$i(Pe, "flush");
    function dt() {
        S.clear(S.COLOR_BUFFER_BIT), E.frameBuffer.bind(), S.clear(S.COLOR_BUFFER_BIT), E.bgColor || Ce(()=>{
            Be({
                width: we(),
                height: xe(),
                quad: new $adc7cb3c45508c7c$var$oe(0, 0, we() / $adc7cb3c45508c7c$var$Kr, xe() / $adc7cb3c45508c7c$var$Kr),
                tex: E.bgTex,
                fixed: !0
            });
        }), E.renderer.numDraws = 0, E.fixed = !1, E.transformStack.length = 0, E.transform = new $adc7cb3c45508c7c$var$Ue;
    }
    $adc7cb3c45508c7c$var$i(dt, "frameStart");
    function Vt(t1, r) {
        E.postShader = t1, E.postShaderUniform = r ?? null;
    }
    $adc7cb3c45508c7c$var$i(Vt, "usePostEffect");
    function ft() {
        Pe(), E.lastDrawCalls = E.renderer.numDraws, E.frameBuffer.unbind(), S.viewport(0, 0, S.drawingBufferWidth, S.drawingBufferHeight);
        let t1 = E.width, r = E.height;
        E.width = S.drawingBufferWidth / P, E.height = S.drawingBufferHeight / P, We({
            flipY: !0,
            tex: E.frameBuffer.tex,
            pos: new $adc7cb3c45508c7c$var$v(E.viewport.x, E.viewport.y),
            width: E.viewport.width,
            height: E.viewport.height,
            shader: E.postShader,
            uniform: typeof E.postShaderUniform == "function" ? E.postShaderUniform() : E.postShaderUniform,
            fixed: !0
        }), Pe(), E.width = t1, E.height = r;
    }
    $adc7cb3c45508c7c$var$i(ft, "frameEnd");
    function vn(t1) {
        return new $adc7cb3c45508c7c$var$v(t1.x / we() * 2 - 1, -t1.y / xe() * 2 + 1);
    }
    $adc7cb3c45508c7c$var$i(vn, "screen2ndc");
    function _t(t1) {
        E.transform = t1.clone();
    }
    $adc7cb3c45508c7c$var$i(_t, "pushMatrix");
    function ne(...t1) {
        if (t1[0] === void 0) return;
        let r = $adc7cb3c45508c7c$var$T(...t1);
        r.x === 0 && r.y === 0 || E.transform.translate(r);
    }
    $adc7cb3c45508c7c$var$i(ne, "pushTranslate");
    function He(...t1) {
        if (t1[0] === void 0) return;
        let r = $adc7cb3c45508c7c$var$T(...t1);
        r.x === 1 && r.y === 1 || E.transform.scale(r);
    }
    $adc7cb3c45508c7c$var$i(He, "pushScale");
    function se(t1) {
        t1 && E.transform.rotate(t1);
    }
    $adc7cb3c45508c7c$var$i(se, "pushRotate");
    function le() {
        E.transformStack.push(E.transform.clone());
    }
    $adc7cb3c45508c7c$var$i(le, "pushTransform");
    function ae() {
        E.transformStack.length > 0 && (E.transform = E.transformStack.pop());
    }
    $adc7cb3c45508c7c$var$i(ae, "popTransform");
    function Be(t1) {
        if (t1.width === void 0 || t1.height === void 0) throw new Error('drawUVQuad() requires property "width" and "height".');
        if (t1.width <= 0 || t1.height <= 0) return;
        let r = t1.width, s1 = t1.height, a1 = $adc7cb3c45508c7c$var$ut(t1.anchor || $adc7cb3c45508c7c$var$tn).scale(new $adc7cb3c45508c7c$var$v(r, s1).scale(-0.5)), h1 = t1.quad || new $adc7cb3c45508c7c$var$oe(0, 0, 1, 1), f = t1.color || $adc7cb3c45508c7c$var$J(255, 255, 255), b1 = t1.opacity ?? 1, p1 = t1.tex ? $adc7cb3c45508c7c$var$Qr / t1.tex.width : 0, d1 = t1.tex ? $adc7cb3c45508c7c$var$Qr / t1.tex.height : 0, w = h1.x + p1, A = h1.y + d1, D = h1.w - p1 * 2, N = h1.h - d1 * 2;
        le(), ne(t1.pos), se(t1.angle), He(t1.scale), ne(a1), lt([
            {
                pos: new $adc7cb3c45508c7c$var$v(-r / 2, s1 / 2),
                uv: new $adc7cb3c45508c7c$var$v(t1.flipX ? w + D : w, t1.flipY ? A : A + N),
                color: f,
                opacity: b1
            },
            {
                pos: new $adc7cb3c45508c7c$var$v(-r / 2, -s1 / 2),
                uv: new $adc7cb3c45508c7c$var$v(t1.flipX ? w + D : w, t1.flipY ? A + N : A),
                color: f,
                opacity: b1
            },
            {
                pos: new $adc7cb3c45508c7c$var$v(r / 2, -s1 / 2),
                uv: new $adc7cb3c45508c7c$var$v(t1.flipX ? w : w + D, t1.flipY ? A + N : A),
                color: f,
                opacity: b1
            },
            {
                pos: new $adc7cb3c45508c7c$var$v(r / 2, s1 / 2),
                uv: new $adc7cb3c45508c7c$var$v(t1.flipX ? w : w + D, t1.flipY ? A : A + N),
                color: f,
                opacity: b1
            }
        ], [
            0,
            1,
            3,
            1,
            2,
            3
        ], t1.fixed, t1.tex, t1.shader, t1.uniform), ae();
    }
    $adc7cb3c45508c7c$var$i(Be, "drawUVQuad");
    function We(t1) {
        if (!t1.tex) throw new Error('drawTexture() requires property "tex".');
        let r = t1.quad ?? new $adc7cb3c45508c7c$var$oe(0, 0, 1, 1), s1 = t1.tex.width * r.w, u = t1.tex.height * r.h, a1 = new $adc7cb3c45508c7c$var$v(1);
        if (t1.tiled) {
            let h1 = Math.ceil((t1.width || s1) / s1), f = Math.ceil((t1.height || u) / u), p1 = $adc7cb3c45508c7c$var$ut(t1.anchor || $adc7cb3c45508c7c$var$tn).add(new $adc7cb3c45508c7c$var$v(1, 1)).scale(.5).scale(h1 * s1, f * u);
            for(let d1 = 0; d1 < h1; d1++)for(let w = 0; w < f; w++)Be(Object.assign({}, t1, {
                pos: (t1.pos || new $adc7cb3c45508c7c$var$v(0)).add(new $adc7cb3c45508c7c$var$v(s1 * d1, u * w)).sub(p1),
                scale: a1.scale(t1.scale || new $adc7cb3c45508c7c$var$v(1)),
                tex: t1.tex,
                quad: r,
                width: s1,
                height: u,
                anchor: "topleft"
            }));
        } else t1.width && t1.height ? (a1.x = t1.width / s1, a1.y = t1.height / u) : t1.width ? (a1.x = t1.width / s1, a1.y = a1.x) : t1.height && (a1.y = t1.height / u, a1.x = a1.y), Be(Object.assign({}, t1, {
            scale: a1.scale(t1.scale || new $adc7cb3c45508c7c$var$v(1)),
            tex: t1.tex,
            quad: r,
            width: s1,
            height: u
        }));
    }
    $adc7cb3c45508c7c$var$i(We, "drawTexture");
    function yn(t1) {
        if (!t1.sprite) throw new Error('drawSprite() requires property "sprite"');
        let r = ct(t1.sprite);
        if (!r || !r.data) return;
        let s1 = r.data.frames[t1.frame ?? 0];
        if (!s1) throw new Error(`Frame not found: ${t1.frame ?? 0}`);
        We(Object.assign({}, t1, {
            tex: r.data.tex,
            quad: s1.scale(t1.quad ?? new $adc7cb3c45508c7c$var$oe(0, 0, 1, 1))
        }));
    }
    $adc7cb3c45508c7c$var$i(yn, "drawSprite");
    function qe(t1, r, s1, u, a1, h1 = 1) {
        u = $adc7cb3c45508c7c$var$Ge(u % 360), a1 = $adc7cb3c45508c7c$var$Ge(a1 % 360), a1 <= u && (a1 += Math.PI * 2);
        let f = [], b1 = Math.ceil((a1 - u) / $adc7cb3c45508c7c$var$Ge(8) * h1), p1 = (a1 - u) / b1;
        for(let d1 = u; d1 < a1; d1 += p1)f.push(t1.add(r * Math.cos(d1), s1 * Math.sin(d1)));
        return f.push(t1.add(r * Math.cos(a1), s1 * Math.sin(a1))), f;
    }
    $adc7cb3c45508c7c$var$i(qe, "getArcPts");
    function ge(t1) {
        if (t1.width === void 0 || t1.height === void 0) throw new Error('drawRect() requires property "width" and "height".');
        if (t1.width <= 0 || t1.height <= 0) return;
        let r = t1.width, s1 = t1.height, a1 = $adc7cb3c45508c7c$var$ut(t1.anchor || $adc7cb3c45508c7c$var$tn).add(1, 1).scale(new $adc7cb3c45508c7c$var$v(r, s1).scale(-0.5)), h1 = [
            new $adc7cb3c45508c7c$var$v(0, 0),
            new $adc7cb3c45508c7c$var$v(r, 0),
            new $adc7cb3c45508c7c$var$v(r, s1),
            new $adc7cb3c45508c7c$var$v(0, s1)
        ];
        if (t1.radius) {
            let f = Math.min(Math.min(r, s1) / 2, t1.radius);
            h1 = [
                new $adc7cb3c45508c7c$var$v(f, 0),
                new $adc7cb3c45508c7c$var$v(r - f, 0),
                ...qe(new $adc7cb3c45508c7c$var$v(r - f, f), f, f, 270, 360),
                new $adc7cb3c45508c7c$var$v(r, f),
                new $adc7cb3c45508c7c$var$v(r, s1 - f),
                ...qe(new $adc7cb3c45508c7c$var$v(r - f, s1 - f), f, f, 0, 90),
                new $adc7cb3c45508c7c$var$v(r - f, s1),
                new $adc7cb3c45508c7c$var$v(f, s1),
                ...qe(new $adc7cb3c45508c7c$var$v(f, s1 - f), f, f, 90, 180),
                new $adc7cb3c45508c7c$var$v(0, s1 - f),
                new $adc7cb3c45508c7c$var$v(0, f),
                ...qe(new $adc7cb3c45508c7c$var$v(f, f), f, f, 180, 270)
            ];
        }
        z(Object.assign({}, t1, {
            offset: a1,
            pts: h1,
            ...t1.gradient ? {
                colors: t1.horizontal ? [
                    t1.gradient[0],
                    t1.gradient[1],
                    t1.gradient[1],
                    t1.gradient[0]
                ] : [
                    t1.gradient[0],
                    t1.gradient[0],
                    t1.gradient[1],
                    t1.gradient[1]
                ]
            } : {}
        }));
    }
    $adc7cb3c45508c7c$var$i(ge, "drawRect");
    function l(t1) {
        let { p1: r, p2: s1 } = t1;
        if (!r || !s1) throw new Error('drawLine() requires properties "p1" and "p2".');
        let u = t1.width || 1, a1 = s1.sub(r).unit().normal().scale(u * .5), h1 = [
            r.sub(a1),
            r.add(a1),
            s1.add(a1),
            s1.sub(a1)
        ].map((f)=>({
                pos: new $adc7cb3c45508c7c$var$v(f.x, f.y),
                uv: new $adc7cb3c45508c7c$var$v(0),
                color: t1.color ?? $adc7cb3c45508c7c$var$W.WHITE,
                opacity: t1.opacity ?? 1
            }));
        lt(h1, [
            0,
            1,
            3,
            1,
            2,
            3
        ], t1.fixed, E.defTex, t1.shader, t1.uniform);
    }
    $adc7cb3c45508c7c$var$i(l, "drawLine");
    function x(t1) {
        let r = t1.pts;
        if (!r) throw new Error('drawLines() requires property "pts".');
        if (!(r.length < 2)) {
            if (t1.radius && r.length >= 3) {
                let s1 = r[0].sdist(r[1]);
                for(let a1 = 1; a1 < r.length - 1; a1++)s1 = Math.min(r[a1].sdist(r[a1 + 1]), s1);
                let u = Math.min(t1.radius, Math.sqrt(s1) / 2);
                l(Object.assign({}, t1, {
                    p1: r[0],
                    p2: r[1]
                }));
                for(let a1 = 1; a1 < r.length - 2; a1++){
                    let h1 = r[a1], f = r[a1 + 1];
                    l(Object.assign({}, t1, {
                        p1: h1,
                        p2: f
                    }));
                }
                l(Object.assign({}, t1, {
                    p1: r[r.length - 2],
                    p2: r[r.length - 1]
                }));
            } else for(let s1 = 0; s1 < r.length - 1; s1++)l(Object.assign({}, t1, {
                p1: r[s1],
                p2: r[s1 + 1]
            })), t1.join !== "none" && L(Object.assign({}, t1, {
                pos: r[s1],
                radius: t1.width / 2
            }));
        }
    }
    $adc7cb3c45508c7c$var$i(x, "drawLines");
    function R(t1) {
        if (!t1.p1 || !t1.p2 || !t1.p3) throw new Error('drawTriangle() requires properties "p1", "p2" and "p3".');
        return z(Object.assign({}, t1, {
            pts: [
                t1.p1,
                t1.p2,
                t1.p3
            ]
        }));
    }
    $adc7cb3c45508c7c$var$i(R, "drawTriangle");
    function L(t1) {
        if (typeof t1.radius != "number") throw new Error('drawCircle() requires property "radius".');
        t1.radius !== 0 && he(Object.assign({}, t1, {
            radiusX: t1.radius,
            radiusY: t1.radius,
            angle: 0
        }));
    }
    $adc7cb3c45508c7c$var$i(L, "drawCircle");
    function he(t1) {
        if (t1.radiusX === void 0 || t1.radiusY === void 0) throw new Error('drawEllipse() requires properties "radiusX" and "radiusY".');
        if (t1.radiusX === 0 || t1.radiusY === 0) return;
        let r = t1.start ?? 0, s1 = t1.end ?? 360, u = $adc7cb3c45508c7c$var$ut(t1.anchor ?? "center").scale(new $adc7cb3c45508c7c$var$v(-t1.radiusX, -t1.radiusY)), a1 = qe(u, t1.radiusX, t1.radiusY, r, s1, t1.resolution);
        a1.unshift(u);
        let h1 = Object.assign({}, t1, {
            pts: a1,
            radius: 0,
            ...t1.gradient ? {
                colors: [
                    t1.gradient[0],
                    ...Array(a1.length - 1).fill(t1.gradient[1])
                ]
            } : {}
        });
        if (s1 - r >= 360 && t1.outline) {
            t1.fill !== !1 && z(Object.assign(h1, {
                outline: null
            })), z(Object.assign(h1, {
                pts: a1.slice(1),
                fill: !1
            }));
            return;
        }
        z(h1);
    }
    $adc7cb3c45508c7c$var$i(he, "drawEllipse");
    function z(t1) {
        if (!t1.pts) throw new Error('drawPolygon() requires property "pts".');
        let r = t1.pts.length;
        if (!(r < 3)) {
            if (le(), ne(t1.pos), He(t1.scale), se(t1.angle), ne(t1.offset), t1.fill !== !1) {
                let s1 = t1.color ?? $adc7cb3c45508c7c$var$W.WHITE, u = t1.pts.map((h1, f)=>({
                        pos: new $adc7cb3c45508c7c$var$v(h1.x, h1.y),
                        uv: new $adc7cb3c45508c7c$var$v(0, 0),
                        color: t1.colors && t1.colors[f] ? t1.colors[f].mult(s1) : s1,
                        opacity: t1.opacity ?? 1
                    })), a1 = [
                    ...Array(r - 2).keys()
                ].map((h1)=>[
                        0,
                        h1 + 1,
                        h1 + 2
                    ]).flat();
                lt(u, t1.indices ?? a1, t1.fixed, E.defTex, t1.shader, t1.uniform);
            }
            t1.outline && x({
                pts: [
                    ...t1.pts,
                    t1.pts[0]
                ],
                radius: t1.radius,
                width: t1.outline.width,
                color: t1.outline.color,
                join: t1.outline.join,
                uniform: t1.uniform,
                fixed: t1.fixed,
                opacity: t1.opacity
            }), ae();
        }
    }
    $adc7cb3c45508c7c$var$i(z, "drawPolygon");
    function Oe(t1, r, s1) {
        Pe(), S.clear(S.STENCIL_BUFFER_BIT), S.enable(S.STENCIL_TEST), S.stencilFunc(S.NEVER, 1, 255), S.stencilOp(S.REPLACE, S.REPLACE, S.REPLACE), r(), Pe(), S.stencilFunc(s1, 1, 255), S.stencilOp(S.KEEP, S.KEEP, S.KEEP), t1(), Pe(), S.disable(S.STENCIL_TEST);
    }
    $adc7cb3c45508c7c$var$i(Oe, "drawStenciled");
    function $e(t1, r) {
        Oe(t1, r, S.EQUAL);
    }
    $adc7cb3c45508c7c$var$i($e, "drawMasked");
    function kt(t1, r) {
        Oe(t1, r, S.NOTEQUAL);
    }
    $adc7cb3c45508c7c$var$i(kt, "drawSubtracted");
    function De() {
        return (E.viewport.width + E.viewport.height) / (E.width + E.height);
    }
    $adc7cb3c45508c7c$var$i(De, "getViewportScale");
    function Ce(t1) {
        Pe();
        let r = E.width, s1 = E.height;
        E.width = E.viewport.width, E.height = E.viewport.height, t1(), Pe(), E.width = r, E.height = s1;
    }
    $adc7cb3c45508c7c$var$i(Ce, "drawUnscaled");
    function Zn(t1, r) {
        r.pos && (t1.pos = t1.pos.add(r.pos)), r.scale && (t1.scale = t1.scale.scale($adc7cb3c45508c7c$var$T(r.scale))), r.angle && (t1.angle += r.angle), r.color && t1.ch.length === 1 && (t1.color = t1.color.mult(r.color)), r.opacity && (t1.opacity *= r.opacity);
    }
    $adc7cb3c45508c7c$var$i(Zn, "applyCharTransform");
    let er = /\[(?<style>\w+)\](?<text>.*?)\[\/\k<style>\]/g;
    function es(t1) {
        let r = {}, s1 = t1.replace(er, "$2"), u = 0;
        for (let a1 of t1.matchAll(er)){
            let h1 = a1.index - u;
            for(let f = 0; f < a1.groups.text.length; f++)r[f + h1] = [
                a1.groups.style
            ];
            u += a1[0].length - a1.groups.text.length;
        }
        return {
            charStyleMap: r,
            text: s1
        };
    }
    $adc7cb3c45508c7c$var$i(es, "compileStyledText");
    let xn = {};
    function Xe(t1) {
        if (t1.text === void 0) throw new Error('formatText() requires property "text".');
        let r = Ft(t1.font);
        if (t1.text === "" || r instanceof $adc7cb3c45508c7c$var$ve || !r) return {
            width: 0,
            height: 0,
            chars: [],
            opt: t1
        };
        let { charStyleMap: s1, text: u } = es(t1.text + ""), a1 = $adc7cb3c45508c7c$var$Fr(u);
        if (r instanceof Se || typeof r == "string") {
            let Z = r instanceof Se ? r.fontface.family : r, H = r instanceof Se ? {
                outline: r.outline,
                filter: r.filter
            } : {
                outline: null,
                filter: $adc7cb3c45508c7c$var$Wn
            }, V = xn[Z] ?? {
                font: {
                    tex: new $adc7cb3c45508c7c$var$Re(q, $adc7cb3c45508c7c$var$Yr, $adc7cb3c45508c7c$var$Wr, {
                        filter: H.filter
                    }),
                    map: {},
                    size: $adc7cb3c45508c7c$var$rn
                },
                cursor: new $adc7cb3c45508c7c$var$v(0),
                outline: H.outline
            };
            xn[Z] || (xn[Z] = V), r = V.font;
            for (let fe of a1)if (!V.font.map[fe]) {
                let U = j;
                U.clearRect(0, 0, I.width, I.height), U.font = `${r.size}px ${Z}`, U.textBaseline = "top", U.textAlign = "left", U.fillStyle = "#ffffff";
                let G = U.measureText(fe), B = Math.ceil(G.width), F = r.size;
                V.outline && (U.lineJoin = "round", U.lineWidth = V.outline.width * 2, U.strokeStyle = V.outline.color.toHex(), U.strokeText(fe, V.outline.width, V.outline.width), B += V.outline.width * 2, F += V.outline.width * 3), U.fillText(fe, V.outline?.width ?? 0, V.outline?.width ?? 0);
                let Y = U.getImageData(0, 0, B, F);
                if (V.cursor.x + B > $adc7cb3c45508c7c$var$Yr && (V.cursor.x = 0, V.cursor.y += F, V.cursor.y > $adc7cb3c45508c7c$var$Wr)) throw new Error("Font atlas exceeds character limit");
                r.tex.update(Y, V.cursor.x, V.cursor.y), r.map[fe] = new $adc7cb3c45508c7c$var$oe(V.cursor.x, V.cursor.y, B, F), V.cursor.x += B;
            }
        }
        let h1 = t1.size || r.size, f = $adc7cb3c45508c7c$var$T(t1.scale ?? 1).scale(h1 / r.size), b1 = t1.lineSpacing ?? 0, p1 = t1.letterSpacing ?? 0, d1 = 0, w = 0, A = 0, D = [], N = [], _ = 0, M1 = null, O = null;
        for(; _ < a1.length;){
            let Z = a1[_];
            if (Z === `
`) A += h1 + b1, D.push({
                width: d1 - p1,
                chars: N
            }), M1 = null, O = null, d1 = 0, N = [];
            else {
                let H = r.map[Z];
                if (H) {
                    let V = H.w * f.x;
                    t1.width && d1 + V > t1.width && (A += h1 + b1, M1 != null && (_ -= N.length - M1, Z = a1[_], H = r.map[Z], V = H.w * f.x, N = N.slice(0, M1 - 1), d1 = O), M1 = null, O = null, D.push({
                        width: d1 - p1,
                        chars: N
                    }), d1 = 0, N = []), N.push({
                        tex: r.tex,
                        width: H.w,
                        height: H.h,
                        quad: new $adc7cb3c45508c7c$var$oe(H.x / r.tex.width, H.y / r.tex.height, H.w / r.tex.width, H.h / r.tex.height),
                        ch: Z,
                        pos: new $adc7cb3c45508c7c$var$v(d1, A),
                        opacity: t1.opacity ?? 1,
                        color: t1.color ?? $adc7cb3c45508c7c$var$W.WHITE,
                        scale: $adc7cb3c45508c7c$var$T(f),
                        angle: 0
                    }), Z === " " && (M1 = N.length, O = d1), d1 += V, w = Math.max(w, d1), d1 += p1;
                }
            }
            _++;
        }
        D.push({
            width: d1 - p1,
            chars: N
        }), A += h1, t1.width && (w = t1.width);
        let ie = [];
        for (let Z of D){
            let H = (w - Z.width) * $adc7cb3c45508c7c$var$Zi(t1.align ?? "left");
            for (let V of Z.chars){
                let fe = r.map[V.ch], U = ie.length;
                if (V.pos = V.pos.add(H, 0).add(fe.w * f.x * .5, fe.h * f.y * .5), t1.transform) {
                    let G = typeof t1.transform == "function" ? t1.transform(U, V.ch) : t1.transform;
                    G && Zn(V, G);
                }
                if (s1[U]) {
                    let G = s1[U];
                    for (let B of G){
                        let F = t1.styles[B], Y = typeof F == "function" ? F(U, V.ch) : F;
                        Y && Zn(V, Y);
                    }
                }
                ie.push(V);
            }
        }
        return {
            width: w,
            height: A,
            chars: ie,
            opt: t1
        };
    }
    $adc7cb3c45508c7c$var$i(Xe, "formatText");
    function tr(t1) {
        Je(Xe(t1));
    }
    $adc7cb3c45508c7c$var$i(tr, "drawText");
    function Je(t1) {
        le(), ne(t1.opt.pos), se(t1.opt.angle), ne($adc7cb3c45508c7c$var$ut(t1.opt.anchor ?? "topleft").add(1, 1).scale(t1.width, t1.height).scale(-0.5)), t1.chars.forEach((r)=>{
            Be({
                tex: r.tex,
                width: r.width,
                height: r.height,
                pos: r.pos,
                scale: r.scale,
                angle: r.angle,
                color: r.color,
                opacity: r.opacity,
                quad: r.quad,
                anchor: "center",
                uniform: t1.opt.uniform,
                shader: t1.opt.shader,
                fixed: t1.opt.fixed
            });
        }), ae();
    }
    $adc7cb3c45508c7c$var$i(Je, "drawFormattedText");
    function we() {
        return E.width;
    }
    $adc7cb3c45508c7c$var$i(we, "width");
    function xe() {
        return E.height;
    }
    $adc7cb3c45508c7c$var$i(xe, "height");
    function ts(t1) {
        return new $adc7cb3c45508c7c$var$v((t1.x - E.viewport.x) * we() / E.viewport.width, (t1.y - E.viewport.y) * xe() / E.viewport.height);
    }
    $adc7cb3c45508c7c$var$i(ts, "windowToContent");
    function ns(t1) {
        return new $adc7cb3c45508c7c$var$v(t1.x * E.viewport.width / E.width, t1.y * E.viewport.height / E.height);
    }
    $adc7cb3c45508c7c$var$i(ns, "contentToView");
    function Nt() {
        return ts(y.mousePos());
    }
    $adc7cb3c45508c7c$var$i(Nt, "mousePos");
    let nr = !1, re = {
        inspect: !1,
        timeScale: 1,
        showLog: !0,
        fps: ()=>y.fps(),
        numFrames: ()=>y.numFrames(),
        stepFrame: dr,
        drawCalls: ()=>E.lastDrawCalls,
        clearLog: ()=>C.logs = [],
        log: (t1)=>{
            let r = n.logMax ?? $adc7cb3c45508c7c$var$qi;
            C.logs.unshift({
                msg: t1,
                time: y.time()
            }), C.logs.length > r && (C.logs = C.logs.slice(0, r));
        },
        error: (t1)=>re.log(new Error(t1.toString ? t1.toString() : t1)),
        curRecording: null,
        numObjects: ()=>On("*", {
                recursive: !0
            }).length,
        get paused () {
            return nr;
        },
        set paused (t){
            nr = t, t ? te.ctx.suspend() : te.ctx.resume();
        }
    };
    function Me() {
        return y.dt() * re.timeScale;
    }
    $adc7cb3c45508c7c$var$i(Me, "dt");
    function rs(...t1) {
        return t1.length > 0 && (C.cam.pos = $adc7cb3c45508c7c$var$T(...t1)), C.cam.pos ? C.cam.pos.clone() : zt();
    }
    $adc7cb3c45508c7c$var$i(rs, "camPos");
    function ss(...t1) {
        return t1.length > 0 && (C.cam.scale = $adc7cb3c45508c7c$var$T(...t1)), C.cam.scale.clone();
    }
    $adc7cb3c45508c7c$var$i(ss, "camScale");
    function is(t1) {
        return t1 !== void 0 && (C.cam.angle = t1), C.cam.angle;
    }
    $adc7cb3c45508c7c$var$i(is, "camRot");
    function os(t1 = 12) {
        C.cam.shake += t1;
    }
    $adc7cb3c45508c7c$var$i(os, "shake");
    function rr(t1) {
        return C.cam.transform.multVec2(t1);
    }
    $adc7cb3c45508c7c$var$i(rr, "toScreen");
    function sr(t1) {
        return C.cam.transform.invert().multVec2(t1);
    }
    $adc7cb3c45508c7c$var$i(sr, "toWorld");
    function jt(t1) {
        let r = new $adc7cb3c45508c7c$var$Ue;
        return t1.pos && r.translate(t1.pos), t1.scale && r.scale(t1.scale), t1.angle && r.rotate(t1.angle), t1.parent ? r.mult(t1.parent.transform) : r;
    }
    $adc7cb3c45508c7c$var$i(jt, "calcTransform");
    function Un(t1 = []) {
        let r = new Map, s1 = {}, u = new $adc7cb3c45508c7c$var$Ne, a1 = [], h1 = null, f = !1, b1 = {
            id: $adc7cb3c45508c7c$var$Gr(),
            hidden: !1,
            transform: new $adc7cb3c45508c7c$var$Ue,
            children: [],
            parent: null,
            set paused (d){
                if (d !== f) {
                    f = d;
                    for (let w of a1)w.paused = d;
                }
            },
            get paused () {
                return f;
            },
            add (d1 = []) {
                let w = Array.isArray(d1) ? Un(d1) : d1;
                if (w.parent) throw new Error("Cannot add a game obj that already has a parent.");
                return w.parent = this, w.transform = jt(w), this.children.push(w), w.trigger("add", w), C.events.trigger("add", w), w;
            },
            readd (d1) {
                let w = this.children.indexOf(d1);
                return w !== -1 && (this.children.splice(w, 1), this.children.push(d1)), d1;
            },
            remove (d1) {
                let w = this.children.indexOf(d1);
                if (w !== -1) {
                    d1.parent = null, this.children.splice(w, 1);
                    let A = $adc7cb3c45508c7c$var$i((D)=>{
                        D.trigger("destroy"), C.events.trigger("destroy", D), D.children.forEach((N)=>A(N));
                    }, "trigger");
                    A(d1);
                }
            },
            removeAll (d1) {
                if (d1) this.get(d1).forEach((w)=>this.remove(w));
                else for (let w of [
                    ...this.children
                ])this.remove(w);
            },
            update () {
                this.paused || (this.children.sort((d1, w)=>(d1.z ?? 0) - (w.z ?? 0)).forEach((d1)=>d1.update()), this.trigger("update"));
            },
            draw () {
                if (this.hidden) return;
                this.canvas && this.canvas.bind();
                let d1 = E.fixed;
                this.fixed && (E.fixed = !0), le(), ne(this.pos), He(this.scale), se(this.angle);
                let w = this.children.sort((A, D)=>(A.z ?? 0) - (D.z ?? 0));
                if (this.mask) {
                    let A = {
                        intersect: $e,
                        subtract: kt
                    }[this.mask];
                    if (!A) throw new Error(`Invalid mask func: "${this.mask}"`);
                    A(()=>{
                        w.forEach((D)=>D.draw());
                    }, ()=>{
                        this.trigger("draw");
                    });
                } else this.trigger("draw"), w.forEach((A)=>A.draw());
                ae(), E.fixed = d1, this.canvas && this.canvas.unbind();
            },
            drawInspect () {
                this.hidden || (le(), ne(this.pos), He(this.scale), se(this.angle), this.children.sort((d1, w)=>(d1.z ?? 0) - (w.z ?? 0)).forEach((d1)=>d1.drawInspect()), this.trigger("drawInspect"), ae());
            },
            use (d1) {
                if (!d1) return;
                if (typeof d1 == "string") return this.use({
                    id: d1
                });
                let w = [];
                d1.id && (this.unuse(d1.id), s1[d1.id] = [], w = s1[d1.id], r.set(d1.id, d1));
                for(let D in d1){
                    if ($adc7cb3c45508c7c$var$Ji.has(D)) continue;
                    let N = Object.getOwnPropertyDescriptor(d1, D);
                    if (typeof N.value == "function" && (d1[D] = d1[D].bind(this)), N.set && Object.defineProperty(d1, D, {
                        set: N.set.bind(this)
                    }), N.get && Object.defineProperty(d1, D, {
                        get: N.get.bind(this)
                    }), $adc7cb3c45508c7c$var$Qi.has(D)) {
                        let _ = D === "add" ? ()=>{
                            h1 = $adc7cb3c45508c7c$var$i((M1)=>w.push(M1), "onCurCompCleanup"), d1[D](), h1 = null;
                        } : d1[D];
                        w.push(this.on(D, _).cancel);
                    } else if (this[D] === void 0) Object.defineProperty(this, D, {
                        get: ()=>d1[D],
                        set: (_)=>d1[D] = _,
                        configurable: !0,
                        enumerable: !0
                    }), w.push(()=>delete this[D]);
                    else throw new Error(`Duplicate component property: "${D}"`);
                }
                let A = $adc7cb3c45508c7c$var$i(()=>{
                    if (d1.require) {
                        for (let D of d1.require)if (!this.c(D)) throw new Error(`Component "${d1.id}" requires component "${D}"`);
                    }
                }, "checkDeps");
                d1.destroy && w.push(d1.destroy.bind(this)), this.exists() ? (A(), d1.add && (h1 = $adc7cb3c45508c7c$var$i((D)=>w.push(D), "onCurCompCleanup"), d1.add.call(this), h1 = null)) : d1.require && w.push(this.on("add", A).cancel);
            },
            unuse (d1) {
                s1[d1] && (s1[d1].forEach((w)=>w()), delete s1[d1]), r.has(d1) && r.delete(d1);
            },
            c (d1) {
                return r.get(d1);
            },
            get (d1, w = {}) {
                let A = w.recursive ? this.children.flatMap($adc7cb3c45508c7c$var$i(function D(N) {
                    return [
                        N,
                        ...N.children.flatMap(D)
                    ];
                }, "recurse")) : this.children;
                if (A = A.filter((D)=>d1 ? D.is(d1) : !0), w.liveUpdate) {
                    let D = $adc7cb3c45508c7c$var$i((_)=>w.recursive ? this.isAncestorOf(_) : _.parent === this, "isChild"), N = [];
                    N.push(En((_)=>{
                        D(_) && _.is(d1) && A.push(_);
                    })), N.push(ir((_)=>{
                        if (D(_) && _.is(d1)) {
                            let M1 = A.findIndex((O)=>O.id === _.id);
                            M1 !== -1 && A.splice(M1, 1);
                        }
                    })), this.onDestroy(()=>{
                        for (let _ of N)_.cancel();
                    });
                }
                return A;
            },
            isAncestorOf (d1) {
                return d1.parent ? d1.parent === this || this.isAncestorOf(d1.parent) : !1;
            },
            exists () {
                return C.root.isAncestorOf(this);
            },
            is (d1) {
                if (d1 === "*") return !0;
                if (Array.isArray(d1)) {
                    for (let w of d1)if (!this.c(w)) return !1;
                    return !0;
                } else return this.c(d1) != null;
            },
            on (d1, w) {
                let A = u.on(d1, w.bind(this));
                return h1 && h1(()=>A.cancel()), A;
            },
            trigger (d1, ...w) {
                u.trigger(d1, ...w), C.objEvents.trigger(d1, this, ...w);
            },
            destroy () {
                this.parent && this.parent.remove(this);
            },
            inspect () {
                let d1 = {};
                for (let [w, A] of r)d1[w] = A.inspect ? A.inspect() : null;
                return d1;
            },
            onAdd (d1) {
                return this.on("add", d1);
            },
            onUpdate (d1) {
                return this.on("update", d1);
            },
            onDraw (d1) {
                return this.on("draw", d1);
            },
            onDestroy (d1) {
                return this.on("destroy", d1);
            },
            clearEvents () {
                u.clear();
            }
        }, p1 = [
            "onKeyPress",
            "onKeyPressRepeat",
            "onKeyDown",
            "onKeyRelease",
            "onMousePress",
            "onMouseDown",
            "onMouseRelease",
            "onMouseMove",
            "onCharInput",
            "onMouseMove",
            "onTouchStart",
            "onTouchMove",
            "onTouchEnd",
            "onScroll",
            "onGamepadButtonPress",
            "onGamepadButtonDown",
            "onGamepadButtonRelease",
            "onGamepadStick"
        ];
        for (let d1 of p1)b1[d1] = (...w)=>{
            let A = y[d1](...w);
            return a1.push(A), b1.onDestroy(()=>A.cancel()), A;
        };
        for (let d1 of t1)b1.use(d1);
        return b1;
    }
    $adc7cb3c45508c7c$var$i(Un, "make");
    function ze(t1, r, s1) {
        return C.objEvents[t1] || (C.objEvents[t1] = new $adc7cb3c45508c7c$var$Ut), C.objEvents.on(t1, (u, ...a1)=>{
            u.is(r) && s1(u, ...a1);
        });
    }
    $adc7cb3c45508c7c$var$i(ze, "on");
    let as = $adc7cb3c45508c7c$var$Ee((t1)=>{
        let r = gt([
            {
                update: t1
            }
        ]);
        return {
            get paused () {
                return r.paused;
            },
            set paused (s){
                r.paused = s;
            },
            cancel: ()=>r.destroy()
        };
    }, (t1, r)=>ze("update", t1, r)), us = $adc7cb3c45508c7c$var$Ee((t1)=>{
        let r = gt([
            {
                draw: t1
            }
        ]);
        return {
            get paused () {
                return r.hidden;
            },
            set paused (s){
                r.hidden = s;
            },
            cancel: ()=>r.destroy()
        };
    }, (t1, r)=>ze("draw", t1, r)), En = $adc7cb3c45508c7c$var$Ee((t1)=>C.events.on("add", t1), (t1, r)=>ze("add", t1, r)), ir = $adc7cb3c45508c7c$var$Ee((t1)=>C.events.on("destroy", t1), (t1, r)=>ze("destroy", t1, r));
    function cs(t1, r, s1) {
        return ze("collide", t1, (u, a1, h1)=>a1.is(r) && s1(u, a1, h1));
    }
    $adc7cb3c45508c7c$var$i(cs, "onCollide");
    function hs(t1, r, s1) {
        return ze("collideUpdate", t1, (u, a1, h1)=>a1.is(r) && s1(u, a1, h1));
    }
    $adc7cb3c45508c7c$var$i(hs, "onCollideUpdate");
    function ls(t1, r, s1) {
        return ze("collideEnd", t1, (u, a1, h1)=>a1.is(r) && s1(u, a1, h1));
    }
    $adc7cb3c45508c7c$var$i(ls, "onCollideEnd");
    function Ht(t1, r) {
        On(t1, {
            recursive: !0
        }).forEach(r), En(t1, r);
    }
    $adc7cb3c45508c7c$var$i(Ht, "forAllCurrentAndFuture");
    let ds = $adc7cb3c45508c7c$var$Ee((t1)=>y.onMousePress(t1), (t1, r)=>{
        let s1 = [];
        return Ht(t1, (u)=>{
            if (!u.area) throw new Error("onClick() requires the object to have area() component");
            s1.push(u.onClick(()=>r(u)));
        }), $adc7cb3c45508c7c$var$ke.join(s1);
    });
    function fs(t1, r) {
        let s1 = [];
        return Ht(t1, (u)=>{
            if (!u.area) throw new Error("onHover() requires the object to have area() component");
            s1.push(u.onHover(()=>r(u)));
        }), $adc7cb3c45508c7c$var$ke.join(s1);
    }
    $adc7cb3c45508c7c$var$i(fs, "onHover");
    function ms(t1, r) {
        let s1 = [];
        return Ht(t1, (u)=>{
            if (!u.area) throw new Error("onHoverUpdate() requires the object to have area() component");
            s1.push(u.onHoverUpdate(()=>r(u)));
        }), $adc7cb3c45508c7c$var$ke.join(s1);
    }
    $adc7cb3c45508c7c$var$i(ms, "onHoverUpdate");
    function ps(t1, r) {
        let s1 = [];
        return Ht(t1, (u)=>{
            if (!u.area) throw new Error("onHoverEnd() requires the object to have area() component");
            s1.push(u.onHoverEnd(()=>r(u)));
        }), $adc7cb3c45508c7c$var$ke.join(s1);
    }
    $adc7cb3c45508c7c$var$i(ps, "onHoverEnd");
    function gs(t1) {
        C.gravity = t1;
    }
    $adc7cb3c45508c7c$var$i(gs, "setGravity");
    function ws() {
        return C.gravity;
    }
    $adc7cb3c45508c7c$var$i(ws, "getGravity");
    function bs(...t1) {
        t1.length === 1 || t1.length === 2 ? (E.bgColor = $adc7cb3c45508c7c$var$J(t1[0]), t1[1] && (E.bgAlpha = t1[1])) : (t1.length === 3 || t1.length === 4) && (E.bgColor = $adc7cb3c45508c7c$var$J(t1[0], t1[1], t1[2]), t1[3] && (E.bgAlpha = t1[3])), S.clearColor(E.bgColor.r / 255, E.bgColor.g / 255, E.bgColor.b / 255, E.bgAlpha);
    }
    $adc7cb3c45508c7c$var$i(bs, "setBackground");
    function vs() {
        return E.bgColor.clone();
    }
    $adc7cb3c45508c7c$var$i(vs, "getBackground");
    function qt(...t1) {
        return {
            id: "pos",
            pos: $adc7cb3c45508c7c$var$T(...t1),
            moveBy (...r) {
                this.pos = this.pos.add($adc7cb3c45508c7c$var$T(...r));
            },
            move (...r) {
                this.moveBy($adc7cb3c45508c7c$var$T(...r).scale(Me()));
            },
            moveTo (...r) {
                if (typeof r[0] == "number" && typeof r[1] == "number") return this.moveTo($adc7cb3c45508c7c$var$T(r[0], r[1]), r[2]);
                let s1 = r[0], u = r[1];
                if (u === void 0) {
                    this.pos = $adc7cb3c45508c7c$var$T(s1);
                    return;
                }
                let a1 = s1.sub(this.pos);
                if (a1.len() <= u * Me()) {
                    this.pos = $adc7cb3c45508c7c$var$T(s1);
                    return;
                }
                this.move(a1.unit().scale(u));
            },
            worldPos () {
                return this.parent ? this.parent.transform.multVec2(this.pos) : this.pos;
            },
            screenPos () {
                let r = this.worldPos();
                return pt(this) ? r : rr(r);
            },
            inspect () {
                return `(${Math.round(this.pos.x)}, ${Math.round(this.pos.y)})`;
            },
            drawInspect () {
                L({
                    color: $adc7cb3c45508c7c$var$J(255, 0, 0),
                    radius: 4 / De()
                });
            }
        };
    }
    $adc7cb3c45508c7c$var$i(qt, "pos");
    function $t(...t1) {
        return t1.length === 0 ? $t(1) : {
            id: "scale",
            scale: $adc7cb3c45508c7c$var$T(...t1),
            scaleTo (...r) {
                this.scale = $adc7cb3c45508c7c$var$T(...r);
            },
            scaleBy (...r) {
                this.scale.scale($adc7cb3c45508c7c$var$T(...r));
            },
            inspect () {
                return `(${mt(this.scale.x, 2)}, ${mt(this.scale.y, 2)})`;
            }
        };
    }
    $adc7cb3c45508c7c$var$i($t, "scale");
    function ys(t1) {
        return {
            id: "rotate",
            angle: t1 ?? 0,
            rotateBy (r) {
                this.angle += r;
            },
            rotateTo (r) {
                this.angle = r;
            },
            inspect () {
                return `${Math.round(this.angle)}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(ys, "rotate");
    function xs(...t1) {
        return {
            id: "color",
            color: $adc7cb3c45508c7c$var$J(...t1),
            inspect () {
                return this.color.toString();
            }
        };
    }
    $adc7cb3c45508c7c$var$i(xs, "color");
    function mt(t1, r) {
        return Number(t1.toFixed(r));
    }
    $adc7cb3c45508c7c$var$i(mt, "toFixed");
    function Us(t1) {
        return {
            id: "opacity",
            opacity: t1 ?? 1,
            inspect () {
                return `${mt(this.opacity, 1)}`;
            },
            fadeOut (r = 1, s1 = $adc7cb3c45508c7c$var$Ct.linear) {
                return Rn(this.opacity, 0, r, (u)=>this.opacity = u, s1);
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Us, "opacity");
    function Sn(t1) {
        if (!t1) throw new Error("Please define an anchor");
        return {
            id: "anchor",
            anchor: t1,
            inspect () {
                return typeof this.anchor == "string" ? this.anchor : this.anchor.toString();
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Sn, "anchor");
    function Es(t1) {
        return {
            id: "z",
            z: t1,
            inspect () {
                return `${this.z}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Es, "z");
    function Ss(t1, r) {
        return {
            id: "follow",
            require: [
                "pos"
            ],
            follow: {
                obj: t1,
                offset: r ?? $adc7cb3c45508c7c$var$T(0)
            },
            add () {
                t1.exists() && (this.pos = this.follow.obj.pos.add(this.follow.offset));
            },
            update () {
                t1.exists() && (this.pos = this.follow.obj.pos.add(this.follow.offset));
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Ss, "follow");
    function Cs(t1, r) {
        let s1 = typeof t1 == "number" ? $adc7cb3c45508c7c$var$v.fromAngle(t1) : t1.unit();
        return {
            id: "move",
            require: [
                "pos"
            ],
            update () {
                this.move(s1.scale(r));
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Cs, "move");
    let As = 200;
    function Ts(t1 = {}) {
        let r = t1.distance ?? As, s1 = !1;
        return {
            id: "offscreen",
            require: [
                "pos"
            ],
            isOffScreen () {
                let u = this.screenPos(), a1 = new $adc7cb3c45508c7c$var$de($adc7cb3c45508c7c$var$T(0), we(), xe());
                return !$adc7cb3c45508c7c$var$vt(a1, u) && a1.sdistToPoint(u) > r * r;
            },
            onExitScreen (u) {
                return this.on("exitView", u);
            },
            onEnterScreen (u) {
                return this.on("enterView", u);
            },
            update () {
                this.isOffScreen() ? (s1 || (this.trigger("exitView"), s1 = !0), t1.hide && (this.hidden = !0), t1.pause && (this.paused = !0), t1.destroy && this.destroy()) : (s1 && (this.trigger("enterView"), s1 = !1), t1.hide && (this.hidden = !1), t1.pause && (this.paused = !1));
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Ts, "offscreen");
    function pt(t1) {
        return t1.fixed ? !0 : t1.parent ? pt(t1.parent) : !1;
    }
    $adc7cb3c45508c7c$var$i(pt, "isFixed");
    function Os(t1 = {}) {
        let r = {}, s1 = new Set;
        return {
            id: "area",
            collisionIgnore: t1.collisionIgnore ?? [],
            add () {
                this.area.cursor && this.onHover(()=>y.setCursor(this.area.cursor)), this.onCollideUpdate((u, a1)=>{
                    r[u.id] || this.trigger("collide", u, a1), r[u.id] = a1, s1.add(u.id);
                });
            },
            update () {
                for(let u in r)s1.has(Number(u)) || (this.trigger("collideEnd", r[u].target), delete r[u]);
                s1.clear();
            },
            drawInspect () {
                let u = this.localArea();
                le(), He(this.area.scale), ne(this.area.offset);
                let a1 = {
                    outline: {
                        width: 4 / De(),
                        color: $adc7cb3c45508c7c$var$J(0, 0, 255)
                    },
                    anchor: this.anchor,
                    fill: !1,
                    fixed: pt(this)
                };
                u instanceof $adc7cb3c45508c7c$var$de ? ge({
                    ...a1,
                    pos: u.pos,
                    width: u.width,
                    height: u.height
                }) : u instanceof $adc7cb3c45508c7c$var$Ke ? z({
                    ...a1,
                    pts: u.pts
                }) : u instanceof $adc7cb3c45508c7c$var$yt && L({
                    ...a1,
                    pos: u.center,
                    radius: u.radius
                }), ae();
            },
            area: {
                shape: t1.shape ?? null,
                scale: t1.scale ? $adc7cb3c45508c7c$var$T(t1.scale) : $adc7cb3c45508c7c$var$T(1),
                offset: t1.offset ?? $adc7cb3c45508c7c$var$T(0),
                cursor: t1.cursor ?? null
            },
            isClicked () {
                return y.isMousePressed() && this.isHovering();
            },
            isHovering () {
                let u = pt(this) ? Nt() : sr(Nt());
                return this.hasPoint(u);
            },
            checkCollision (u) {
                return r[u.id] ?? null;
            },
            getCollisions () {
                return Object.values(r);
            },
            isColliding (u) {
                return !!r[u.id];
            },
            isOverlapping (u) {
                let a1 = r[u.id];
                return a1 && a1.hasOverlap();
            },
            onClick (u) {
                let a1 = y.onMousePress("left", ()=>{
                    this.isHovering() && u();
                });
                return this.onDestroy(()=>a1.cancel()), a1;
            },
            onHover (u) {
                let a1 = !1;
                return this.onUpdate(()=>{
                    a1 ? a1 = this.isHovering() : this.isHovering() && (a1 = !0, u());
                });
            },
            onHoverUpdate (u) {
                return this.onUpdate(()=>{
                    this.isHovering() && u();
                });
            },
            onHoverEnd (u) {
                let a1 = !1;
                return this.onUpdate(()=>{
                    a1 ? this.isHovering() || (a1 = !1, u()) : a1 = this.isHovering();
                });
            },
            onCollide (u, a1) {
                if (typeof u == "function" && a1 === void 0) return this.on("collide", u);
                if (typeof u == "string") return this.onCollide((h1, f)=>{
                    h1.is(u) && a1(h1, f);
                });
            },
            onCollideUpdate (u, a1) {
                if (typeof u == "function" && a1 === void 0) return this.on("collideUpdate", u);
                if (typeof u == "string") return this.on("collideUpdate", (h1, f)=>h1.is(u) && a1(h1, f));
            },
            onCollideEnd (u, a1) {
                if (typeof u == "function" && a1 === void 0) return this.on("collideEnd", u);
                if (typeof u == "string") return this.on("collideEnd", (h1)=>h1.is(u) && a1(h1));
            },
            hasPoint (u) {
                return $adc7cb3c45508c7c$var$_n(this.worldArea(), u);
            },
            resolveCollision (u) {
                let a1 = this.checkCollision(u);
                a1 && !a1.resolved && (this.pos = this.pos.add(a1.displacement), a1.resolved = !0);
            },
            localArea () {
                return this.area.shape ? this.area.shape : this.renderArea();
            },
            worldArea () {
                let u = this.localArea();
                if (!(u instanceof $adc7cb3c45508c7c$var$Ke || u instanceof $adc7cb3c45508c7c$var$de)) throw new Error("Only support polygon and rect shapes for now");
                let a1 = this.transform.clone().scale($adc7cb3c45508c7c$var$T(this.area.scale ?? 1)).translate(this.area.offset);
                if (u instanceof $adc7cb3c45508c7c$var$de) {
                    let h1 = $adc7cb3c45508c7c$var$ut(this.anchor || $adc7cb3c45508c7c$var$tn).add(1, 1).scale(-0.5).scale(u.width, u.height);
                    a1.translate(h1);
                }
                return u.transform(a1);
            },
            screenArea () {
                let u = this.worldArea();
                return pt(this) ? u : u.transform(C.cam.transform);
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Os, "area");
    function Qe(t1) {
        return {
            color: t1.color,
            opacity: t1.opacity,
            anchor: t1.anchor,
            outline: t1.outline,
            shader: t1.shader,
            uniform: t1.uniform
        };
    }
    $adc7cb3c45508c7c$var$i(Qe, "getRenderProps");
    function Cn(t1, r = {}) {
        let s1 = null, u = null, a1 = null, h1 = new $adc7cb3c45508c7c$var$be;
        if (!t1) throw new Error("Please pass the resource name or data to sprite()");
        let f = $adc7cb3c45508c7c$var$i((b1, p1, d1, w)=>{
            let A = $adc7cb3c45508c7c$var$T(1, 1);
            return d1 && w ? (A.x = d1 / (b1.width * p1.w), A.y = w / (b1.height * p1.h)) : d1 ? (A.x = d1 / (b1.width * p1.w), A.y = A.x) : w && (A.y = w / (b1.height * p1.h), A.x = A.y), A;
        }, "calcTexScale");
        return {
            id: "sprite",
            width: 0,
            height: 0,
            frame: r.frame || 0,
            quad: r.quad || new $adc7cb3c45508c7c$var$oe(0, 0, 1, 1),
            animSpeed: r.animSpeed ?? 1,
            flipX: r.flipX ?? !1,
            flipY: r.flipY ?? !1,
            draw () {
                if (!s1) return;
                let b1 = s1.frames[this.frame ?? 0];
                if (!b1) throw new Error(`Frame not found: ${this.frame ?? 0}`);
                if (s1.slice9) {
                    let { left: p1, right: d1, top: w, bottom: A } = s1.slice9, D = s1.tex.width * b1.w, N = s1.tex.height * b1.h, _ = this.width - p1 - d1, M1 = this.height - w - A, O = p1 / D, ie = d1 / D, Z = 1 - O - ie, H = w / N, V = A / N, fe = 1 - H - V, U = [
                        $adc7cb3c45508c7c$var$ce(0, 0, O, H),
                        $adc7cb3c45508c7c$var$ce(O, 0, Z, H),
                        $adc7cb3c45508c7c$var$ce(O + Z, 0, ie, H),
                        $adc7cb3c45508c7c$var$ce(0, H, O, fe),
                        $adc7cb3c45508c7c$var$ce(O, H, Z, fe),
                        $adc7cb3c45508c7c$var$ce(O + Z, H, ie, fe),
                        $adc7cb3c45508c7c$var$ce(0, H + fe, O, V),
                        $adc7cb3c45508c7c$var$ce(O, H + fe, Z, V),
                        $adc7cb3c45508c7c$var$ce(O + Z, H + fe, ie, V),
                        $adc7cb3c45508c7c$var$ce(0, 0, p1, w),
                        $adc7cb3c45508c7c$var$ce(p1, 0, _, w),
                        $adc7cb3c45508c7c$var$ce(p1 + _, 0, d1, w),
                        $adc7cb3c45508c7c$var$ce(0, w, p1, M1),
                        $adc7cb3c45508c7c$var$ce(p1, w, _, M1),
                        $adc7cb3c45508c7c$var$ce(p1 + _, w, d1, M1),
                        $adc7cb3c45508c7c$var$ce(0, w + M1, p1, A),
                        $adc7cb3c45508c7c$var$ce(p1, w + M1, _, A),
                        $adc7cb3c45508c7c$var$ce(p1 + _, w + M1, d1, A)
                    ];
                    for(let G = 0; G < 9; G++){
                        let B = U[G], F = U[G + 9];
                        We(Object.assign(Qe(this), {
                            pos: F.pos(),
                            tex: s1.tex,
                            quad: b1.scale(B),
                            flipX: this.flipX,
                            flipY: this.flipY,
                            tiled: r.tiled,
                            width: F.w,
                            height: F.h
                        }));
                    }
                } else We(Object.assign(Qe(this), {
                    tex: s1.tex,
                    quad: b1.scale(this.quad ?? new $adc7cb3c45508c7c$var$oe(0, 0, 1, 1)),
                    flipX: this.flipX,
                    flipY: this.flipY,
                    tiled: r.tiled,
                    width: this.width,
                    height: this.height
                }));
            },
            add () {
                let b1 = $adc7cb3c45508c7c$var$i((d1)=>{
                    let w = d1.frames[0].clone();
                    r.quad && (w = w.scale(r.quad));
                    let A = f(d1.tex, w, r.width, r.height);
                    this.width = d1.tex.width * w.w * A.x, this.height = d1.tex.height * w.h * A.y, r.anim && this.play(r.anim), s1 = d1, h1.trigger(s1);
                }, "setSpriteData"), p1 = ct(t1);
                p1 ? p1.onLoad(b1) : Tn(()=>b1(ct(t1).data));
            },
            update () {
                if (!u) return;
                let b1 = s1.anims[u.name];
                if (typeof b1 == "number") {
                    this.frame = b1;
                    return;
                }
                if (b1.speed === 0) throw new Error("Sprite anim speed cannot be 0");
                u.timer += Me() * this.animSpeed, u.timer >= 1 / u.speed && (u.timer = 0, this.frame += a1, (this.frame < Math.min(b1.from, b1.to) || this.frame > Math.max(b1.from, b1.to)) && (u.loop ? u.pingpong ? (this.frame -= a1, a1 *= -1, this.frame += a1) : this.frame = b1.from : (this.frame = b1.to, u.onEnd(), this.stop())));
            },
            play (b1, p1 = {}) {
                if (!s1) {
                    h1.add(()=>this.play(b1, p1));
                    return;
                }
                let d1 = s1.anims[b1];
                if (d1 === void 0) throw new Error(`Anim not found: ${b1}`);
                u && this.stop(), u = typeof d1 == "number" ? {
                    name: b1,
                    timer: 0,
                    loop: !1,
                    pingpong: !1,
                    speed: 0,
                    onEnd: ()=>{}
                } : {
                    name: b1,
                    timer: 0,
                    loop: p1.loop ?? d1.loop ?? !1,
                    pingpong: p1.pingpong ?? d1.pingpong ?? !1,
                    speed: p1.speed ?? d1.speed ?? 10,
                    onEnd: p1.onEnd ?? (()=>{})
                }, a1 = typeof d1 == "number" ? null : d1.from < d1.to ? 1 : -1, this.frame = typeof d1 == "number" ? d1 : d1.from, this.trigger("animStart", b1);
            },
            stop () {
                if (!u) return;
                let b1 = u.name;
                u = null, this.trigger("animEnd", b1);
            },
            numFrames () {
                return s1?.frames.length ?? 0;
            },
            curAnim () {
                return u?.name;
            },
            onAnimEnd (b1) {
                return this.on("animEnd", b1);
            },
            onAnimStart (b1) {
                return this.on("animStart", b1);
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$de($adc7cb3c45508c7c$var$T(0), this.width, this.height);
            },
            inspect () {
                if (typeof t1 == "string") return `"${t1}"`;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Cn, "sprite");
    function Rs(t1, r = {}) {
        function s1(a1) {
            let h1 = Xe(Object.assign(Qe(a1), {
                text: a1.text + "",
                size: a1.textSize,
                font: a1.font,
                width: r.width && a1.width,
                align: a1.align,
                letterSpacing: a1.letterSpacing,
                lineSpacing: a1.lineSpacing,
                transform: a1.textTransform,
                styles: a1.textStyles
            }));
            return r.width || (a1.width = h1.width / (a1.scale?.x || 1)), a1.height = h1.height / (a1.scale?.y || 1), h1;
        }
        $adc7cb3c45508c7c$var$i(s1, "update");
        let u = {
            id: "text",
            set text (a){
                t1 = a, s1(this);
            },
            get text () {
                return t1;
            },
            textSize: r.size ?? $adc7cb3c45508c7c$var$ji,
            font: r.font,
            width: r.width ?? 0,
            height: 0,
            align: r.align,
            lineSpacing: r.lineSpacing,
            letterSpacing: r.letterSpacing,
            textTransform: r.transform,
            textStyles: r.styles,
            add () {
                Tn(()=>s1(this));
            },
            draw () {
                Je(s1(this));
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$de($adc7cb3c45508c7c$var$T(0), this.width, this.height);
            }
        };
        return s1(u), u;
    }
    $adc7cb3c45508c7c$var$i(Rs, "text");
    function Ps(t1, r = {}) {
        if (t1.length < 3) throw new Error(`Polygon's need more than two points, ${t1.length} points provided`);
        return {
            id: "polygon",
            pts: t1,
            colors: r.colors,
            radius: r.radius,
            draw () {
                z(Object.assign(Qe(this), {
                    pts: this.pts,
                    colors: this.colors,
                    radius: this.radius,
                    fill: r.fill
                }));
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$Ke(this.pts);
            },
            inspect () {
                return this.pts.map((s1)=>`[${s1.x},${s1.y}]`).join(",");
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Ps, "polygon");
    function Ds(t1, r, s1 = {}) {
        return {
            id: "rect",
            width: t1,
            height: r,
            radius: s1.radius || 0,
            draw () {
                ge(Object.assign(Qe(this), {
                    width: this.width,
                    height: this.height,
                    radius: this.radius,
                    fill: s1.fill
                }));
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$de($adc7cb3c45508c7c$var$T(0), this.width, this.height);
            },
            inspect () {
                return `${Math.ceil(this.width)}, ${Math.ceil(this.height)}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Ds, "rect");
    function Ms(t1, r) {
        return {
            id: "rect",
            width: t1,
            height: r,
            draw () {
                Be(Object.assign(Qe(this), {
                    width: this.width,
                    height: this.height
                }));
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$de($adc7cb3c45508c7c$var$T(0), this.width, this.height);
            },
            inspect () {
                return `${Math.ceil(this.width)}, ${Math.ceil(this.height)}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Ms, "uvquad");
    function Gs(t1, r = {}) {
        return {
            id: "circle",
            radius: t1,
            draw () {
                L(Object.assign(Qe(this), {
                    radius: this.radius,
                    fill: r.fill
                }));
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$de(new $adc7cb3c45508c7c$var$v(this.anchor ? 0 : -this.radius), this.radius * 2, this.radius * 2);
            },
            inspect () {
                return `${Math.ceil(this.radius)}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Gs, "circle");
    function Bs(t1 = 1, r = $adc7cb3c45508c7c$var$J(0, 0, 0)) {
        return {
            id: "outline",
            outline: {
                width: t1,
                color: r
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Bs, "outline");
    function An() {
        return {
            id: "timer",
            wait (t1, r) {
                let s1 = [];
                r && s1.push(r);
                let u = 0, a1 = this.onUpdate(()=>{
                    u += Me(), u >= t1 && (s1.forEach((h1)=>h1()), a1.cancel());
                });
                return {
                    get paused () {
                        return a1.paused;
                    },
                    set paused (h){
                        a1.paused = h;
                    },
                    cancel: a1.cancel,
                    onEnd (h1) {
                        s1.push(h1);
                    },
                    then (h1) {
                        return this.onEnd(h1), this;
                    }
                };
            },
            loop (t1, r) {
                let s1 = null, u = $adc7cb3c45508c7c$var$i(()=>{
                    s1 = this.wait(t1, u), r();
                }, "newAction");
                return s1 = this.wait(0, u), {
                    get paused () {
                        return s1.paused;
                    },
                    set paused (a){
                        s1.paused = a;
                    },
                    cancel: ()=>s1.cancel()
                };
            },
            tween (t1, r, s1, u, a1 = $adc7cb3c45508c7c$var$Ct.linear) {
                let h1 = 0, f = [], b1 = this.onUpdate(()=>{
                    h1 += Me();
                    let p1 = Math.min(h1 / s1, 1);
                    u($adc7cb3c45508c7c$var$Ve(t1, r, a1(p1))), p1 === 1 && (b1.cancel(), u(r), f.forEach((d1)=>d1()));
                });
                return {
                    get paused () {
                        return b1.paused;
                    },
                    set paused (p){
                        b1.paused = p;
                    },
                    onEnd (p1) {
                        f.push(p1);
                    },
                    then (p1) {
                        return this.onEnd(p1), this;
                    },
                    cancel () {
                        b1.cancel();
                    },
                    finish () {
                        b1.cancel(), u(r), f.forEach((p1)=>p1());
                    }
                };
            }
        };
    }
    $adc7cb3c45508c7c$var$i(An, "timer");
    let Fs = 640, Is = 65536;
    function Ls(t1 = {}) {
        let r = null, s1 = null, u = !1;
        return {
            id: "body",
            require: [
                "pos",
                "area"
            ],
            vel: new $adc7cb3c45508c7c$var$v(0),
            jumpForce: t1.jumpForce ?? Fs,
            gravityScale: t1.gravityScale ?? 1,
            isStatic: t1.isStatic ?? !1,
            mass: t1.mass ?? 1,
            add () {
                if (this.mass === 0) throw new Error("Can't set body mass to 0");
                this.onCollideUpdate((a1, h1)=>{
                    if (a1.is("body") && !h1.resolved && (this.trigger("beforePhysicsResolve", h1), a1.trigger("beforePhysicsResolve", h1.reverse()), !h1.resolved && !(this.isStatic && a1.isStatic))) {
                        if (!this.isStatic && !a1.isStatic) {
                            let f = this.mass + a1.mass;
                            this.pos = this.pos.add(h1.displacement.scale(a1.mass / f)), a1.pos = a1.pos.add(h1.displacement.scale(-this.mass / f)), this.transform = jt(this), a1.transform = jt(a1);
                        } else {
                            let f = !this.isStatic && a1.isStatic ? h1 : h1.reverse();
                            f.source.pos = f.source.pos.add(f.displacement), f.source.transform = jt(f.source);
                        }
                        h1.resolved = !0, this.trigger("physicsResolve", h1), a1.trigger("physicsResolve", h1.reverse());
                    }
                }), this.onPhysicsResolve((a1)=>{
                    C.gravity && (a1.isBottom() && this.isFalling() ? (this.vel.y = 0, r = a1.target, s1 = a1.target.pos, u ? u = !1 : this.trigger("ground", r)) : a1.isTop() && this.isJumping() && (this.vel.y = 0, this.trigger("headbutt", a1.target)));
                });
            },
            update () {
                if (!C.gravity || this.isStatic) return;
                if (u && (r = null, s1 = null, this.trigger("fallOff"), u = !1), r) {
                    if (!this.isColliding(r) || !r.exists() || !r.is("body")) u = !0;
                    else {
                        !r.pos.eq(s1) && t1.stickToPlatform !== !1 && this.moveBy(r.pos.sub(s1)), s1 = r.pos;
                        return;
                    }
                }
                let a1 = this.vel.y;
                this.vel.y += C.gravity * this.gravityScale * Me(), this.vel.y = Math.min(this.vel.y, t1.maxVelocity ?? Is), a1 < 0 && this.vel.y >= 0 && this.trigger("fall"), this.move(this.vel);
            },
            onPhysicsResolve (a1) {
                return this.on("physicsResolve", a1);
            },
            onBeforePhysicsResolve (a1) {
                return this.on("beforePhysicsResolve", a1);
            },
            curPlatform () {
                return r;
            },
            isGrounded () {
                return r !== null;
            },
            isFalling () {
                return this.vel.y > 0;
            },
            isJumping () {
                return this.vel.y < 0;
            },
            jump (a1) {
                r = null, s1 = null, this.vel.y = -a1 || -this.jumpForce;
            },
            onGround (a1) {
                return this.on("ground", a1);
            },
            onFall (a1) {
                return this.on("fall", a1);
            },
            onFallOff (a1) {
                return this.on("fallOff", a1);
            },
            onHeadbutt (a1) {
                return this.on("headbutt", a1);
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Ls, "body");
    function Vs(t1 = 2) {
        let r = t1;
        return {
            id: "doubleJump",
            require: [
                "body"
            ],
            numJumps: t1,
            add () {
                this.onGround(()=>{
                    r = this.numJumps;
                });
            },
            doubleJump (s1) {
                r <= 0 || (r < this.numJumps && this.trigger("doubleJump"), r--, this.jump(s1));
            },
            onDoubleJump (s1) {
                return this.on("doubleJump", s1);
            },
            inspect () {
                return `${r}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Vs, "doubleJump");
    function _s(t1, r) {
        return {
            id: "shader",
            shader: t1,
            ...typeof r == "function" ? {
                uniform: r(),
                update () {
                    this.uniform = r();
                }
            } : {
                uniform: r
            }
        };
    }
    $adc7cb3c45508c7c$var$i(_s, "shader");
    function ks() {
        return {
            id: "fixed",
            fixed: !0
        };
    }
    $adc7cb3c45508c7c$var$i(ks, "fixed");
    function or(t1) {
        return {
            id: "stay",
            stay: !0,
            scenesToStay: t1
        };
    }
    $adc7cb3c45508c7c$var$i(or, "stay");
    function Ns(t1, r) {
        if (t1 == null) throw new Error("health() requires the initial amount of hp");
        return {
            id: "health",
            hurt (s1 = 1) {
                this.setHP(t1 - s1), this.trigger("hurt", s1);
            },
            heal (s1 = 1) {
                let u = t1;
                this.setHP(t1 + s1), this.trigger("heal", t1 - u);
            },
            hp () {
                return t1;
            },
            maxHP () {
                return r ?? null;
            },
            setMaxHP (s1) {
                r = s1;
            },
            setHP (s1) {
                t1 = r ? Math.min(r, s1) : s1, t1 <= 0 && this.trigger("death");
            },
            onHurt (s1) {
                return this.on("hurt", s1);
            },
            onHeal (s1) {
                return this.on("heal", s1);
            },
            onDeath (s1) {
                return this.on("death", s1);
            },
            inspect () {
                return `${t1}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Ns, "health");
    function js(t1, r = {}) {
        if (t1 == null) throw new Error("lifespan() requires time");
        let s1 = r.fade ?? 0;
        return {
            id: "lifespan",
            async add () {
                await hr(t1), s1 > 0 && this.opacity && await Rn(this.opacity, 0, s1, (u)=>this.opacity = u, $adc7cb3c45508c7c$var$Ct.linear), this.destroy();
            }
        };
    }
    $adc7cb3c45508c7c$var$i(js, "lifespan");
    function Hs(t1, r, s1) {
        if (!t1) throw new Error("state() requires an initial state");
        let u = {};
        function a1(p1) {
            u[p1] || (u[p1] = {
                enter: new $adc7cb3c45508c7c$var$be,
                end: new $adc7cb3c45508c7c$var$be,
                update: new $adc7cb3c45508c7c$var$be,
                draw: new $adc7cb3c45508c7c$var$be
            });
        }
        $adc7cb3c45508c7c$var$i(a1, "initStateEvents");
        function h1(p1, d1, w) {
            return a1(d1), u[d1][p1].add(w);
        }
        $adc7cb3c45508c7c$var$i(h1, "on");
        function f(p1, d1, ...w) {
            a1(d1), u[d1][p1].trigger(...w);
        }
        $adc7cb3c45508c7c$var$i(f, "trigger");
        let b1 = !1;
        return {
            id: "state",
            state: t1,
            enterState (p1, ...d1) {
                if (b1 = !0, r && !r.includes(p1)) throw new Error(`State not found: ${p1}`);
                let w = this.state;
                if (s1) {
                    if (!s1?.[w]) return;
                    let A = typeof s1[w] == "string" ? [
                        s1[w]
                    ] : s1[w];
                    if (!A.includes(p1)) throw new Error(`Cannot transition state from "${w}" to "${p1}". Available transitions: ${A.map((D)=>`"${D}"`).join(", ")}`);
                }
                f("end", w, ...d1), this.state = p1, f("enter", p1, ...d1), f("enter", `${w} -> ${p1}`, ...d1);
            },
            onStateTransition (p1, d1, w) {
                return h1("enter", `${p1} -> ${d1}`, w);
            },
            onStateEnter (p1, d1) {
                return h1("enter", p1, d1);
            },
            onStateUpdate (p1, d1) {
                return h1("update", p1, d1);
            },
            onStateDraw (p1, d1) {
                return h1("draw", p1, d1);
            },
            onStateEnd (p1, d1) {
                return h1("end", p1, d1);
            },
            update () {
                b1 || (f("enter", t1), b1 = !0), f("update", this.state);
            },
            draw () {
                f("draw", this.state);
            },
            inspect () {
                return this.state;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Hs, "state");
    function qs(t1 = 1) {
        let r = 0, s1 = !1;
        return {
            require: [
                "opacity"
            ],
            add () {
                this.opacity = 0;
            },
            update () {
                s1 || (r += Me(), this.opacity = $adc7cb3c45508c7c$var$_e(r, 0, t1, 0, 1), r >= t1 && (this.opacity = 1, s1 = !0));
            }
        };
    }
    $adc7cb3c45508c7c$var$i(qs, "fadeIn");
    function $s(t1 = "intersect") {
        return {
            id: "mask",
            mask: t1
        };
    }
    $adc7cb3c45508c7c$var$i($s, "mask");
    function zs(t1) {
        return {
            add () {
                this.canvas = t1;
            }
        };
    }
    $adc7cb3c45508c7c$var$i(zs, "drawon");
    function Tn(t1) {
        k.loaded ? t1() : C.events.on("load", t1);
    }
    $adc7cb3c45508c7c$var$i(Tn, "onLoad");
    function Ks(t1, r) {
        C.scenes[t1] = r;
    }
    $adc7cb3c45508c7c$var$i(Ks, "scene");
    function Ys(t1, ...r) {
        if (!C.scenes[t1]) throw new Error(`Scene not found: ${t1}`);
        C.events.onOnce("frameEnd", ()=>{
            C.events.trigger("sceneLeave", t1), y.events.clear(), C.events.clear(), C.objEvents.clear(), [
                ...C.root.children
            ].forEach((s1)=>{
                (!s1.stay || s1.scenesToStay && !s1.scenesToStay.includes(t1)) && C.root.remove(s1);
            }), C.root.clearEvents(), pr(), C.cam = {
                pos: null,
                scale: $adc7cb3c45508c7c$var$T(1),
                angle: 0,
                shake: 0,
                transform: new $adc7cb3c45508c7c$var$Ue
            }, C.scenes[t1](...r);
        });
    }
    $adc7cb3c45508c7c$var$i(Ys, "go");
    function Ws(t1) {
        return C.events.on("sceneLeave", t1);
    }
    $adc7cb3c45508c7c$var$i(Ws, "onSceneLeave");
    function Xs(t1, r) {
        try {
            return JSON.parse(window.localStorage[t1]);
        } catch  {
            return r ? (ar(t1, r), r) : null;
        }
    }
    $adc7cb3c45508c7c$var$i(Xs, "getData");
    function ar(t1, r) {
        window.localStorage[t1] = JSON.stringify(r);
    }
    $adc7cb3c45508c7c$var$i(ar, "setData");
    function ur(t1, ...r) {
        let s1 = t1(Ze), u;
        typeof s1 == "function" ? u = s1(...r)(Ze) : u = s1;
        for(let a1 in u)Ze[a1] = u[a1], n.global !== !1 && (window[a1] = u[a1]);
        return Ze;
    }
    $adc7cb3c45508c7c$var$i(ur, "plug");
    function zt() {
        return $adc7cb3c45508c7c$var$T(we() / 2, xe() / 2);
    }
    $adc7cb3c45508c7c$var$i(zt, "center");
    let Js;
    ((O)=>(O[O.None = 0] = "None", O[O.Left = 1] = "Left", O[O.Top = 2] = "Top", O[O.LeftTop = 3] = "LeftTop", O[O.Right = 4] = "Right", O[O.Horizontal = 5] = "Horizontal", O[O.RightTop = 6] = "RightTop", O[O.HorizontalTop = 7] = "HorizontalTop", O[O.Bottom = 8] = "Bottom", O[O.LeftBottom = 9] = "LeftBottom", O[O.Vertical = 10] = "Vertical", O[O.LeftVertical = 11] = "LeftVertical", O[O.RightBottom = 12] = "RightBottom", O[O.HorizontalBottom = 13] = "HorizontalBottom", O[O.RightVertical = 14] = "RightVertical", O[O.All = 15] = "All"))(Js ||= {});
    function cr(t1 = {}) {
        let r = $adc7cb3c45508c7c$var$T(0), s1 = t1.isObstacle ?? !1, u = t1.cost ?? 0, a1 = t1.edges ?? [], h1 = $adc7cb3c45508c7c$var$i(()=>{
            let b1 = {
                left: 1,
                top: 2,
                right: 4,
                bottom: 8
            };
            return a1.map((p1)=>b1[p1] || 0).reduce((p1, d1)=>p1 | d1, 0);
        }, "getEdgeMask"), f = h1();
        return {
            id: "tile",
            tilePosOffset: t1.offset ?? $adc7cb3c45508c7c$var$T(0),
            set tilePos (b){
                let p1 = this.getLevel();
                r = b.clone(), this.pos = $adc7cb3c45508c7c$var$T(this.tilePos.x * p1.tileWidth(), this.tilePos.y * p1.tileHeight()).add(this.tilePosOffset);
            },
            get tilePos () {
                return r;
            },
            set isObstacle (b){
                s1 !== b && (s1 = b, this.getLevel().invalidateNavigationMap());
            },
            get isObstacle () {
                return s1;
            },
            set cost (b){
                u !== b && (u = b, this.getLevel().invalidateNavigationMap());
            },
            get cost () {
                return u;
            },
            set edges (b){
                a1 = b, f = h1(), this.getLevel().invalidateNavigationMap();
            },
            get edges () {
                return a1;
            },
            get edgeMask () {
                return f;
            },
            getLevel () {
                return this.parent;
            },
            moveLeft () {
                this.tilePos = this.tilePos.add($adc7cb3c45508c7c$var$T(-1, 0));
            },
            moveRight () {
                this.tilePos = this.tilePos.add($adc7cb3c45508c7c$var$T(1, 0));
            },
            moveUp () {
                this.tilePos = this.tilePos.add($adc7cb3c45508c7c$var$T(0, -1));
            },
            moveDown () {
                this.tilePos = this.tilePos.add($adc7cb3c45508c7c$var$T(0, 1));
            }
        };
    }
    $adc7cb3c45508c7c$var$i(cr, "tile");
    function Qs(t1, r) {
        if (!r.tileWidth || !r.tileHeight) throw new Error("Must provide tileWidth and tileHeight.");
        let s1 = gt([
            qt(r.pos ?? $adc7cb3c45508c7c$var$T(0))
        ]), u = t1.length, a1 = 0, h1 = null, f = null, b1 = null, p1 = null, d1 = $adc7cb3c45508c7c$var$i((U)=>U.x + U.y * a1, "tile2Hash"), w = $adc7cb3c45508c7c$var$i((U)=>$adc7cb3c45508c7c$var$T(Math.floor(U % a1), Math.floor(U / a1)), "hash2Tile"), A = $adc7cb3c45508c7c$var$i(()=>{
            h1 = [];
            for (let U of s1.children)D(U);
        }, "createSpatialMap"), D = $adc7cb3c45508c7c$var$i((U)=>{
            let G = d1(U.tilePos);
            h1[G] ? h1[G].push(U) : h1[G] = [
                U
            ];
        }, "insertIntoSpatialMap"), N = $adc7cb3c45508c7c$var$i((U)=>{
            let G = d1(U.tilePos);
            if (h1[G]) {
                let B = h1[G].indexOf(U);
                B >= 0 && h1[G].splice(B, 1);
            }
        }, "removeFromSpatialMap"), _ = $adc7cb3c45508c7c$var$i(()=>{
            let U = !1;
            for (let G of s1.children){
                let B = s1.pos2Tile(G.pos);
                (G.tilePos.x != B.x || G.tilePos.y != B.y) && (U = !0, N(G), G.tilePos.x = B.x, G.tilePos.y = B.y, D(G));
            }
            U && s1.trigger("spatial_map_changed");
        }, "updateSpatialMap"), M1 = $adc7cb3c45508c7c$var$i(()=>{
            let U = s1.getSpatialMap(), G = s1.numRows() * s1.numColumns();
            f ? f.length = G : f = new Array(G), f.fill(1, 0, G);
            for(let B = 0; B < U.length; B++){
                let F = U[B];
                if (F) {
                    let Y = 0;
                    for (let ee of F)if (ee.isObstacle) {
                        Y = 1 / 0;
                        break;
                    } else Y += ee.cost;
                    f[B] = Y || 1;
                }
            }
        }, "createCostMap"), O = $adc7cb3c45508c7c$var$i(()=>{
            let U = s1.getSpatialMap(), G = s1.numRows() * s1.numColumns();
            b1 ? b1.length = G : b1 = new Array(G), b1.fill(15, 0, G);
            for(let B = 0; B < U.length; B++){
                let F = U[B];
                if (F) {
                    let Y = F.length, ee = 15;
                    for(let ue = 0; ue < Y; ue++)ee |= F[ue].edgeMask;
                    b1[B] = ee;
                }
            }
        }, "createEdgeMap"), ie = $adc7cb3c45508c7c$var$i(()=>{
            let U = s1.numRows() * s1.numColumns(), G = $adc7cb3c45508c7c$var$i((F, Y)=>{
                let ee = [];
                for(ee.push(F); ee.length > 0;){
                    let ue = ee.pop();
                    V(ue).forEach((me)=>{
                        p1[me] < 0 && (p1[me] = Y, ee.push(me));
                    });
                }
            }, "traverse");
            p1 ? p1.length = U : p1 = new Array(U), p1.fill(-1, 0, U);
            let B = 0;
            for(let F = 0; F < f.length; F++){
                if (p1[F] >= 0) {
                    B++;
                    continue;
                }
                G(F, B), B++;
            }
        }, "createConnectivityMap"), Z = $adc7cb3c45508c7c$var$i((U, G)=>f[G], "getCost"), H = $adc7cb3c45508c7c$var$i((U, G)=>{
            let B = w(U), F = w(G);
            return B.dist(F);
        }, "getHeuristic"), V = $adc7cb3c45508c7c$var$i((U, G)=>{
            let B = [], F = Math.floor(U % a1), Y = F > 0 && b1[U] & 1 && f[U - 1] !== 1 / 0, ee = U >= a1 && b1[U] & 2 && f[U - a1] !== 1 / 0, ue = F < a1 - 1 && b1[U] & 4 && f[U + 1] !== 1 / 0, me = U < a1 * u - a1 - 1 && b1[U] & 8 && f[U + a1] !== 1 / 0;
            return G ? (Y && (ee && B.push(U - a1 - 1), B.push(U - 1), me && B.push(U + a1 - 1)), ee && B.push(U - a1), ue && (ee && B.push(U - a1 + 1), B.push(U + 1), me && B.push(U + a1 + 1)), me && B.push(U + a1)) : (Y && B.push(U - 1), ee && B.push(U - a1), ue && B.push(U + 1), me && B.push(U + a1)), B;
        }, "getNeighbours"), fe = {
            id: "level",
            tileWidth () {
                return r.tileWidth;
            },
            tileHeight () {
                return r.tileHeight;
            },
            spawn (U, ...G) {
                let B = $adc7cb3c45508c7c$var$T(...G), F = (()=>{
                    if (typeof U == "string") {
                        if (r.tiles[U]) {
                            if (typeof r.tiles[U] != "function") throw new Error("Level symbol def must be a function returning a component list");
                            return r.tiles[U](B);
                        } else if (r.wildcardTile) return r.wildcardTile(U, B);
                    } else {
                        if (Array.isArray(U)) return U;
                        throw new Error("Expected a symbol or a component list");
                    }
                })();
                if (!F) return null;
                let Y = !1, ee = !1;
                for (let me of F)me.id === "tile" && (ee = !0), me.id === "pos" && (Y = !0);
                Y || F.push(qt()), ee || F.push(cr());
                let ue = s1.add(F);
                return Y && (ue.tilePosOffset = ue.pos.clone()), ue.tilePos = B, h1 && (D(ue), this.trigger("spatial_map_changed"), this.trigger("navigation_map_invalid")), ue;
            },
            numColumns () {
                return a1;
            },
            numRows () {
                return u;
            },
            levelWidth () {
                return a1 * this.tileWidth();
            },
            levelHeight () {
                return u * this.tileHeight();
            },
            tile2Pos (...U) {
                return $adc7cb3c45508c7c$var$T(...U).scale(this.tileWidth(), this.tileHeight());
            },
            pos2Tile (...U) {
                let G = $adc7cb3c45508c7c$var$T(...U);
                return $adc7cb3c45508c7c$var$T(Math.floor(G.x / this.tileWidth()), Math.floor(G.y / this.tileHeight()));
            },
            getSpatialMap () {
                return h1 || A(), h1;
            },
            onSpatialMapChanged (U) {
                return this.on("spatial_map_changed", U);
            },
            onNavigationMapInvalid (U) {
                return this.on("navigation_map_invalid", U);
            },
            getAt (U) {
                h1 || A();
                let G = d1(U);
                return h1[G] || [];
            },
            update () {
                h1 && _();
            },
            invalidateNavigationMap () {
                f = null, b1 = null, p1 = null;
            },
            onNavigationMapChanged (U) {
                return this.on("navigation_map_changed", U);
            },
            getTilePath (U, G, B = {}) {
                if (f || M1(), b1 || O(), p1 || ie(), U.x < 0 || U.x >= a1 || U.y < 0 || U.y >= u || G.x < 0 || G.x >= a1 || G.y < 0 || G.y >= u) return null;
                let F = d1(U), Y = d1(G);
                if (f[Y] === 1 / 0) return null;
                if (F === Y) return [];
                if (p1[F] != -1 && p1[F] !== p1[Y]) return null;
                let ee = new $adc7cb3c45508c7c$var$Yt((Fe, Mn)=>Fe.cost < Mn.cost);
                ee.insert({
                    cost: 0,
                    node: F
                });
                let ue = new Map;
                ue.set(F, F);
                let me = new Map;
                for(me.set(F, 0); ee.length !== 0;){
                    let Fe = ee.remove()?.node;
                    if (Fe === Y) break;
                    let Mn = V(Fe, B.allowDiagonals);
                    for (let et of Mn){
                        let Gn = (me.get(Fe) || 0) + Z(Fe, et) + H(et, Y);
                        (!me.has(et) || Gn < me.get(et)) && (me.set(et, Gn), ee.insert({
                            cost: Gn,
                            node: et
                        }), ue.set(et, Fe));
                    }
                }
                let Dn = [], wt = Y, vi = w(wt);
                for(Dn.push(vi); wt !== F;){
                    wt = ue.get(wt);
                    let Fe = w(wt);
                    Dn.push(Fe);
                }
                return Dn.reverse();
            },
            getPath (U, G, B = {}) {
                let F = this.tileWidth(), Y = this.tileHeight(), ee = this.getTilePath(this.pos2Tile(U), this.pos2Tile(G), B);
                return ee ? [
                    U,
                    ...ee.slice(1, -1).map((ue)=>ue.scale(F, Y).add(F / 2, Y / 2)),
                    G
                ] : null;
            }
        };
        return s1.use(fe), s1.onNavigationMapInvalid(()=>{
            s1.invalidateNavigationMap(), s1.trigger("navigation_map_changed");
        }), t1.forEach((U, G)=>{
            let B = U.split("");
            a1 = Math.max(B.length, a1), B.forEach((F, Y)=>{
                s1.spawn(F, $adc7cb3c45508c7c$var$T(Y, G));
            });
        }), s1;
    }
    $adc7cb3c45508c7c$var$i(Qs, "addLevel");
    function Zs(t1 = {}) {
        let r = null, s1 = null, u = null, a1 = null;
        return {
            id: "agent",
            require: [
                "pos",
                "tile"
            ],
            agentSpeed: t1.speed ?? 100,
            allowDiagonals: t1.allowDiagonals ?? !0,
            getDistanceToTarget () {
                return r ? this.pos.dist(r) : 0;
            },
            getNextLocation () {
                return s1 && u ? s1[u] : null;
            },
            getPath () {
                return s1 ? s1.slice() : null;
            },
            getTarget () {
                return r;
            },
            isNavigationFinished () {
                return s1 ? u === null : !0;
            },
            isTargetReachable () {
                return s1 !== null;
            },
            isTargetReached () {
                return r ? this.pos.eq(r) : !0;
            },
            setTarget (h1) {
                r = h1, s1 = this.getLevel().getPath(this.pos, r, {
                    allowDiagonals: this.allowDiagonals
                }), u = s1 ? 0 : null, s1 ? (a1 || (a1 = this.getLevel().onNavigationMapChanged(()=>{
                    s1 && u !== null && (s1 = this.getLevel().getPath(this.pos, r, {
                        allowDiagonals: this.allowDiagonals
                    }), u = s1 ? 0 : null, s1 ? this.trigger("navigation-next", this, s1[u]) : this.trigger("navigation-ended", this));
                }), this.onDestroy(()=>a1.cancel())), this.trigger("navigation-started", this), this.trigger("navigation-next", this, s1[u])) : this.trigger("navigation-ended", this);
            },
            update () {
                if (s1 && u !== null) {
                    if (this.pos.sdist(s1[u]) < 2) {
                        if (u === s1.length - 1) {
                            this.pos = r.clone(), u = null, this.trigger("navigation-ended", this), this.trigger("target-reached", this);
                            return;
                        } else u++, this.trigger("navigation-next", this, s1[u]);
                    }
                    this.moveTo(s1[u], this.agentSpeed);
                }
            },
            onNavigationStarted (h1) {
                return this.on("navigation-started", h1);
            },
            onNavigationNext (h1) {
                return this.on("navigation-next", h1);
            },
            onNavigationEnded (h1) {
                return this.on("navigation-ended", h1);
            },
            onTargetReached (h1) {
                return this.on("target-reached", h1);
            },
            inspect () {
                return JSON.stringify({
                    target: JSON.stringify(r),
                    path: JSON.stringify(s1)
                });
            }
        };
    }
    $adc7cb3c45508c7c$var$i(Zs, "agent");
    function ei(t1) {
        let r = y.canvas.captureStream(t1), s1 = te.ctx.createMediaStreamDestination();
        te.masterNode.connect(s1);
        let u = new MediaRecorder(r), a1 = [];
        return u.ondataavailable = (h1)=>{
            h1.data.size > 0 && a1.push(h1.data);
        }, u.onerror = ()=>{
            te.masterNode.disconnect(s1), r.getTracks().forEach((h1)=>h1.stop());
        }, u.start(), {
            resume () {
                u.resume();
            },
            pause () {
                u.pause();
            },
            stop () {
                return u.stop(), te.masterNode.disconnect(s1), r.getTracks().forEach((h1)=>h1.stop()), new Promise((h1)=>{
                    u.onstop = ()=>{
                        h1(new Blob(a1, {
                            type: "video/mp4"
                        }));
                    };
                });
            },
            download (h1 = "kaboom.mp4") {
                this.stop().then((f)=>$adc7cb3c45508c7c$var$Nn(h1, f));
            }
        };
    }
    $adc7cb3c45508c7c$var$i(ei, "record");
    function ti() {
        return document.activeElement === y.canvas;
    }
    $adc7cb3c45508c7c$var$i(ti, "isFocused");
    function ni(t1) {
        t1.destroy();
    }
    $adc7cb3c45508c7c$var$i(ni, "destroy");
    let gt = C.root.add.bind(C.root), ri = C.root.readd.bind(C.root), si = C.root.removeAll.bind(C.root), On = C.root.get.bind(C.root), hr = C.root.wait.bind(C.root), ii = C.root.loop.bind(C.root), Rn = C.root.tween.bind(C.root);
    function lr(t1 = 2, r = 1) {
        let s1 = 0;
        return {
            require: [
                "scale"
            ],
            update () {
                let u = Math.sin(s1 * t1) * r;
                u < 0 && this.destroy(), this.scale = $adc7cb3c45508c7c$var$T(u), s1 += Me();
            }
        };
    }
    $adc7cb3c45508c7c$var$i(lr, "boom");
    let oi = Ye(null, $adc7cb3c45508c7c$var$qr), ai = Ye(null, $adc7cb3c45508c7c$var$$r);
    function ui(t1, r = {}) {
        let s1 = gt([
            qt(t1),
            or()
        ]), u = (r.speed || 1) * 5, a1 = r.scale || 1;
        s1.add([
            Cn(ai),
            $t(0),
            Sn("center"),
            lr(u, a1),
            ...r.comps ?? []
        ]);
        let h1 = s1.add([
            Cn(oi),
            $t(0),
            Sn("center"),
            An(),
            ...r.comps ?? []
        ]);
        return h1.wait(.4 / u, ()=>h1.use(lr(u, a1))), h1.onDestroy(()=>s1.destroy()), s1;
    }
    $adc7cb3c45508c7c$var$i(ui, "addKaboom");
    function dr() {
        C.root.update();
    }
    $adc7cb3c45508c7c$var$i(dr, "updateFrame");
    class Pn {
        static{
            $adc7cb3c45508c7c$var$i(this, "Collision");
        }
        source;
        target;
        displacement;
        resolved = !1;
        constructor(r, s1, u, a1 = !1){
            this.source = r, this.target = s1, this.displacement = u, this.resolved = a1;
        }
        reverse() {
            return new Pn(this.target, this.source, this.displacement.scale(-1), this.resolved);
        }
        hasOverlap() {
            return !this.displacement.isZero();
        }
        isLeft() {
            return this.displacement.x > 0;
        }
        isRight() {
            return this.displacement.x < 0;
        }
        isTop() {
            return this.displacement.y > 0;
        }
        isBottom() {
            return this.displacement.y < 0;
        }
        preventResolution() {
            this.resolved = !0;
        }
    }
    function ci() {
        let t1 = {}, r = n.hashGridSize || $adc7cb3c45508c7c$var$Hi, s1 = new $adc7cb3c45508c7c$var$Ue, u = [];
        function a1(h1) {
            if (u.push(s1.clone()), h1.pos && s1.translate(h1.pos), h1.scale && s1.scale(h1.scale), h1.angle && s1.rotate(h1.angle), h1.transform = s1.clone(), h1.c("area") && !h1.paused) {
                let f = h1, p1 = f.worldArea().bbox(), d1 = Math.floor(p1.pos.x / r), w = Math.floor(p1.pos.y / r), A = Math.ceil((p1.pos.x + p1.width) / r), D = Math.ceil((p1.pos.y + p1.height) / r), N = new Set;
                for(let _ = d1; _ <= A; _++)for(let M1 = w; M1 <= D; M1++)if (!t1[_]) t1[_] = {}, t1[_][M1] = [
                    f
                ];
                else if (!t1[_][M1]) t1[_][M1] = [
                    f
                ];
                else {
                    let O = t1[_][M1];
                    e: for (let ie of O){
                        if (ie.paused || !ie.exists() || N.has(ie.id)) continue;
                        for (let H of f.collisionIgnore)if (ie.is(H)) continue e;
                        for (let H of ie.collisionIgnore)if (f.is(H)) continue e;
                        let Z = $adc7cb3c45508c7c$var$Or(f.worldArea(), ie.worldArea());
                        if (Z) {
                            let H = new Pn(f, ie, Z);
                            f.trigger("collideUpdate", ie, H);
                            let V = H.reverse();
                            V.resolved = H.resolved, ie.trigger("collideUpdate", f, V);
                        }
                        N.add(ie.id);
                    }
                    O.push(f);
                }
            }
            h1.children.forEach(a1), s1 = u.pop();
        }
        $adc7cb3c45508c7c$var$i(a1, "checkObj"), a1(C.root);
    }
    $adc7cb3c45508c7c$var$i(ci, "checkFrame");
    function hi() {
        let t1 = C.cam, r = $adc7cb3c45508c7c$var$v.fromAngle($adc7cb3c45508c7c$var$xt(0, 360)).scale(t1.shake);
        t1.shake = $adc7cb3c45508c7c$var$Ve(t1.shake, 0, 5 * Me()), t1.transform = new $adc7cb3c45508c7c$var$Ue().translate(zt()).scale(t1.scale).rotate(t1.angle).translate((t1.pos ?? zt()).scale(-1).add(r)), C.root.draw(), Pe();
    }
    $adc7cb3c45508c7c$var$i(hi, "drawFrame");
    function li() {
        let t1 = $();
        C.events.numListeners("loading") > 0 ? C.events.trigger("loading", t1) : Ce(()=>{
            let r = we() / 2, s1 = 24, u = $adc7cb3c45508c7c$var$T(we() / 2, xe() / 2).sub($adc7cb3c45508c7c$var$T(r / 2, s1 / 2));
            ge({
                pos: $adc7cb3c45508c7c$var$T(0),
                width: we(),
                height: xe(),
                color: $adc7cb3c45508c7c$var$J(0, 0, 0)
            }), ge({
                pos: u,
                width: r,
                height: s1,
                fill: !1,
                outline: {
                    width: 4
                }
            }), ge({
                pos: u,
                width: r * t1,
                height: s1
            });
        });
    }
    $adc7cb3c45508c7c$var$i(li, "drawLoadScreen");
    function fr(t1, r) {
        Ce(()=>{
            let s1 = $adc7cb3c45508c7c$var$T(8);
            le(), ne(t1);
            let u = Xe({
                text: r,
                font: $adc7cb3c45508c7c$var$nn,
                size: 16,
                pos: s1,
                color: $adc7cb3c45508c7c$var$J(255, 255, 255),
                fixed: !0
            }), a1 = u.width + s1.x * 2, h1 = u.height + s1.x * 2;
            t1.x + a1 >= we() && ne($adc7cb3c45508c7c$var$T(-a1, 0)), t1.y + h1 >= xe() && ne($adc7cb3c45508c7c$var$T(0, -h1)), ge({
                width: a1,
                height: h1,
                color: $adc7cb3c45508c7c$var$J(0, 0, 0),
                radius: 4,
                opacity: .8,
                fixed: !0
            }), Je(u), ae();
        });
    }
    $adc7cb3c45508c7c$var$i(fr, "drawInspectText");
    function di() {
        if (re.inspect) {
            let t1 = null;
            for (let r of C.root.get("*", {
                recursive: !0
            }))if (r.c("area") && r.isHovering()) {
                t1 = r;
                break;
            }
            if (C.root.drawInspect(), t1) {
                let r = [], s1 = t1.inspect();
                for(let u in s1)s1[u] ? r.push(`${u}: ${s1[u]}`) : r.push(`${u}`);
                fr(ns(Nt()), r.join(`
`));
            }
            fr($adc7cb3c45508c7c$var$T(8), `FPS: ${re.fps()}`);
        }
        re.paused && Ce(()=>{
            le(), ne(we(), 0), ne(-8, 8);
            let t1 = 32;
            ge({
                width: t1,
                height: t1,
                anchor: "topright",
                color: $adc7cb3c45508c7c$var$J(0, 0, 0),
                opacity: .8,
                radius: 4,
                fixed: !0
            });
            for(let r = 1; r <= 2; r++)ge({
                width: 4,
                height: t1 * .6,
                anchor: "center",
                pos: $adc7cb3c45508c7c$var$T(-t1 / 3 * r, t1 * .5),
                color: $adc7cb3c45508c7c$var$J(255, 255, 255),
                radius: 2,
                fixed: !0
            });
            ae();
        }), re.timeScale !== 1 && Ce(()=>{
            le(), ne(we(), xe()), ne(-8, -8);
            let t1 = 8, r = Xe({
                text: re.timeScale.toFixed(1),
                font: $adc7cb3c45508c7c$var$nn,
                size: 16,
                color: $adc7cb3c45508c7c$var$J(255, 255, 255),
                pos: $adc7cb3c45508c7c$var$T(-t1),
                anchor: "botright",
                fixed: !0
            });
            ge({
                width: r.width + t1 * 2 + t1 * 4,
                height: r.height + t1 * 2,
                anchor: "botright",
                color: $adc7cb3c45508c7c$var$J(0, 0, 0),
                opacity: .8,
                radius: 4,
                fixed: !0
            });
            for(let s1 = 0; s1 < 2; s1++){
                let u = re.timeScale < 1;
                R({
                    p1: $adc7cb3c45508c7c$var$T(-r.width - t1 * (u ? 2 : 3.5), -t1),
                    p2: $adc7cb3c45508c7c$var$T(-r.width - t1 * (u ? 2 : 3.5), -t1 - r.height),
                    p3: $adc7cb3c45508c7c$var$T(-r.width - t1 * (u ? 3.5 : 2), -t1 - r.height / 2),
                    pos: $adc7cb3c45508c7c$var$T(-s1 * t1 * 1 + (u ? -t1 * .5 : 0), 0),
                    color: $adc7cb3c45508c7c$var$J(255, 255, 255),
                    fixed: !0
                });
            }
            Je(r), ae();
        }), re.curRecording && Ce(()=>{
            le(), ne(0, xe()), ne(24, -24), L({
                radius: 12,
                color: $adc7cb3c45508c7c$var$J(255, 0, 0),
                opacity: $adc7cb3c45508c7c$var$In(0, 1, y.time() * 4),
                fixed: !0
            }), ae();
        }), re.showLog && C.logs.length > 0 && Ce(()=>{
            le(), ne(0, xe()), ne(8, -8);
            let t1 = 8, r = [];
            for (let u of C.logs){
                let a1 = "", h1 = u.msg instanceof Error ? "error" : "info";
                a1 += `[time]${u.time.toFixed(2)}[/time]`, a1 += " ", a1 += `[${h1}]${u.msg?.toString ? u.msg.toString() : u.msg}[/${h1}]`, r.push(a1);
            }
            C.logs = C.logs.filter((u)=>y.time() - u.time < (n.logTime || $adc7cb3c45508c7c$var$$i));
            let s1 = Xe({
                text: r.join(`
`),
                font: $adc7cb3c45508c7c$var$nn,
                pos: $adc7cb3c45508c7c$var$T(t1, -t1),
                anchor: "botleft",
                size: 16,
                width: we() * .6,
                lineSpacing: t1 / 2,
                fixed: !0,
                styles: {
                    time: {
                        color: $adc7cb3c45508c7c$var$J(127, 127, 127)
                    },
                    info: {
                        color: $adc7cb3c45508c7c$var$J(255, 255, 255)
                    },
                    error: {
                        color: $adc7cb3c45508c7c$var$J(255, 0, 127)
                    }
                }
            });
            ge({
                width: s1.width + t1 * 2,
                height: s1.height + t1 * 2,
                anchor: "botleft",
                color: $adc7cb3c45508c7c$var$J(0, 0, 0),
                radius: 4,
                opacity: .8,
                fixed: !0
            }), Je(s1), ae();
        });
    }
    $adc7cb3c45508c7c$var$i(di, "drawDebug");
    function fi(t1) {
        C.events.on("loading", t1);
    }
    $adc7cb3c45508c7c$var$i(fi, "onLoading");
    function mi(t1) {
        y.onResize(t1);
    }
    $adc7cb3c45508c7c$var$i(mi, "onResize");
    function pi(t1) {
        C.events.on("error", t1);
    }
    $adc7cb3c45508c7c$var$i(pi, "onError");
    function gi(t1) {
        console.error(t1), te.ctx.suspend(), y.run(()=>{
            dt(), Ce(()=>{
                let u = we(), a1 = xe(), h1 = {
                    size: 36,
                    width: u - 64,
                    letterSpacing: 4,
                    lineSpacing: 4,
                    font: $adc7cb3c45508c7c$var$nn,
                    fixed: !0
                };
                ge({
                    width: u,
                    height: a1,
                    color: $adc7cb3c45508c7c$var$J(0, 0, 255),
                    fixed: !0
                });
                let f = Xe({
                    ...h1,
                    text: "Error",
                    pos: $adc7cb3c45508c7c$var$T(32),
                    color: $adc7cb3c45508c7c$var$J(255, 128, 0),
                    fixed: !0
                });
                Je(f), tr({
                    ...h1,
                    text: t1.message,
                    pos: $adc7cb3c45508c7c$var$T(32, 32 + f.height + 16),
                    fixed: !0
                }), ae(), C.events.trigger("error", t1);
            }), ft();
        });
    }
    $adc7cb3c45508c7c$var$i(gi, "handleErr");
    function wi(t1) {
        X.push(t1);
    }
    $adc7cb3c45508c7c$var$i(wi, "onCleanup");
    function bi() {
        C.events.onOnce("frameEnd", ()=>{
            y.quit(), S.clear(S.COLOR_BUFFER_BIT | S.DEPTH_BUFFER_BIT | S.STENCIL_BUFFER_BIT);
            let t1 = S.getParameter(S.MAX_TEXTURE_IMAGE_UNITS);
            for(let r = 0; r < t1; r++)S.activeTexture(S.TEXTURE0 + r), S.bindTexture(S.TEXTURE_2D, null), S.bindTexture(S.TEXTURE_CUBE_MAP, null);
            S.bindBuffer(S.ARRAY_BUFFER, null), S.bindBuffer(S.ELEMENT_ARRAY_BUFFER, null), S.bindRenderbuffer(S.RENDERBUFFER, null), S.bindFramebuffer(S.FRAMEBUFFER, null), q.destroy(), X.forEach((r)=>r());
        });
    }
    $adc7cb3c45508c7c$var$i(bi, "quit");
    let Kt = !0;
    y.run(()=>{
        try {
            k.loaded || $() === 1 && !Kt && (k.loaded = !0, C.events.trigger("load")), !k.loaded && n.loadingScreen !== !1 || Kt ? (dt(), li(), ft()) : (re.paused || dr(), ci(), dt(), hi(), n.debug !== !1 && di(), ft()), Kt && (Kt = !1), C.events.trigger("frameEnd");
        } catch (t1) {
            gi(t1);
        }
    });
    function mr() {
        let t1 = P, r = S.drawingBufferWidth / t1, s1 = S.drawingBufferHeight / t1;
        if (n.letterbox) {
            if (!n.width || !n.height) throw new Error("Letterboxing requires width and height defined.");
            let u = r / s1, a1 = n.width / n.height;
            if (u > a1) {
                let h1 = s1 * a1, f = (r - h1) / 2;
                E.viewport = {
                    x: f,
                    y: 0,
                    width: h1,
                    height: s1
                };
            } else {
                let h1 = r / a1, f = (s1 - h1) / 2;
                E.viewport = {
                    x: 0,
                    y: f,
                    width: r,
                    height: h1
                };
            }
            return;
        }
        if (n.stretch && (!n.width || !n.height)) throw new Error("Stretching requires width and height defined.");
        E.viewport = {
            x: 0,
            y: 0,
            width: r,
            height: s1
        };
    }
    $adc7cb3c45508c7c$var$i(mr, "updateViewport");
    function pr() {
        y.onHide(()=>{
            n.backgroundAudio || te.ctx.suspend();
        }), y.onShow(()=>{
            !n.backgroundAudio && !re.paused && te.ctx.resume();
        }), y.onResize(()=>{
            if (y.isFullscreen()) return;
            let t1 = n.width && n.height;
            t1 && !n.stretch && !n.letterbox || (o.width = o.offsetWidth * P, o.height = o.offsetHeight * P, mr(), t1 || (E.frameBuffer.free(), E.frameBuffer = new $adc7cb3c45508c7c$var$rt(q, S.drawingBufferWidth, S.drawingBufferHeight), E.width = S.drawingBufferWidth / P, E.height = S.drawingBufferHeight / P));
        }), n.debug !== !1 && (y.onKeyPress("f1", ()=>re.inspect = !re.inspect), y.onKeyPress("f2", ()=>re.clearLog()), y.onKeyPress("f8", ()=>re.paused = !re.paused), y.onKeyPress("f7", ()=>{
            re.timeScale = mt($adc7cb3c45508c7c$var$Le(re.timeScale - .2, 0, 2), 1);
        }), y.onKeyPress("f9", ()=>{
            re.timeScale = mt($adc7cb3c45508c7c$var$Le(re.timeScale + .2, 0, 2), 1);
        }), y.onKeyPress("f10", ()=>re.stepFrame())), n.burp && y.onKeyPress("b", ()=>Lt());
    }
    $adc7cb3c45508c7c$var$i(pr, "initEvents"), mr(), pr();
    let Ze = {
        VERSION: $adc7cb3c45508c7c$var$ki,
        loadRoot: Te,
        loadProgress: $,
        loadSprite: Ye,
        loadSpriteAtlas: Ot,
        loadSound: ln,
        loadBitmapFont: on,
        loadFont: st,
        loadShader: cn,
        loadShaderURL: hn,
        loadAseprite: un,
        loadPedit: an,
        loadBean: dn,
        loadJSON: ye,
        load: Ae,
        getSprite: Pt,
        getSound: Dt,
        getFont: Mt,
        getBitmapFont: Gt,
        getShader: Bt,
        getAsset: fn,
        Asset: $adc7cb3c45508c7c$var$ve,
        SpriteData: K,
        SoundData: Q,
        width: we,
        height: xe,
        center: zt,
        dt: Me,
        time: y.time,
        screenshot: y.screenshot,
        record: ei,
        isFocused: ti,
        setCursor: y.setCursor,
        getCursor: y.getCursor,
        setCursorLocked: y.setCursorLocked,
        isCursorLocked: y.isCursorLocked,
        setFullscreen: y.setFullscreen,
        isFullscreen: y.isFullscreen,
        isTouchscreen: y.isTouchscreen,
        onLoad: Tn,
        onLoading: fi,
        onResize: mi,
        onGamepadConnect: y.onGamepadConnect,
        onGamepadDisconnect: y.onGamepadDisconnect,
        onError: pi,
        onCleanup: wi,
        camPos: rs,
        camScale: ss,
        camRot: is,
        shake: os,
        toScreen: rr,
        toWorld: sr,
        setGravity: gs,
        getGravity: ws,
        setBackground: bs,
        getBackground: vs,
        getGamepads: y.getGamepads,
        add: gt,
        make: Un,
        destroy: ni,
        destroyAll: si,
        get: On,
        readd: ri,
        pos: qt,
        scale: $t,
        rotate: ys,
        color: xs,
        opacity: Us,
        anchor: Sn,
        area: Os,
        sprite: Cn,
        text: Rs,
        polygon: Ps,
        rect: Ds,
        circle: Gs,
        uvquad: Ms,
        outline: Bs,
        body: Ls,
        doubleJump: Vs,
        shader: _s,
        timer: An,
        fixed: ks,
        stay: or,
        health: Ns,
        lifespan: js,
        z: Es,
        move: Cs,
        offscreen: Ts,
        follow: Ss,
        state: Hs,
        fadeIn: qs,
        mask: $s,
        drawon: zs,
        tile: cr,
        agent: Zs,
        on: ze,
        onUpdate: as,
        onDraw: us,
        onAdd: En,
        onDestroy: ir,
        onClick: ds,
        onCollide: cs,
        onCollideUpdate: hs,
        onCollideEnd: ls,
        onHover: fs,
        onHoverUpdate: ms,
        onHoverEnd: ps,
        onKeyDown: y.onKeyDown,
        onKeyPress: y.onKeyPress,
        onKeyPressRepeat: y.onKeyPressRepeat,
        onKeyRelease: y.onKeyRelease,
        onMouseDown: y.onMouseDown,
        onMousePress: y.onMousePress,
        onMouseRelease: y.onMouseRelease,
        onMouseMove: y.onMouseMove,
        onCharInput: y.onCharInput,
        onTouchStart: y.onTouchStart,
        onTouchMove: y.onTouchMove,
        onTouchEnd: y.onTouchEnd,
        onScroll: y.onScroll,
        onHide: y.onHide,
        onShow: y.onShow,
        onGamepadButtonDown: y.onGamepadButtonDown,
        onGamepadButtonPress: y.onGamepadButtonPress,
        onGamepadButtonRelease: y.onGamepadButtonRelease,
        onGamepadStick: y.onGamepadStick,
        mousePos: Nt,
        mouseDeltaPos: y.mouseDeltaPos,
        isKeyDown: y.isKeyDown,
        isKeyPressed: y.isKeyPressed,
        isKeyPressedRepeat: y.isKeyPressedRepeat,
        isKeyReleased: y.isKeyReleased,
        isMouseDown: y.isMouseDown,
        isMousePressed: y.isMousePressed,
        isMouseReleased: y.isMouseReleased,
        isMouseMoved: y.isMouseMoved,
        isGamepadButtonPressed: y.isGamepadButtonPressed,
        isGamepadButtonDown: y.isGamepadButtonDown,
        isGamepadButtonReleased: y.isGamepadButtonReleased,
        getGamepadStick: y.getGamepadStick,
        charInputted: y.charInputted,
        loop: ii,
        wait: hr,
        play: It,
        volume: gn,
        burp: Lt,
        audioCtx: te.ctx,
        Line: $adc7cb3c45508c7c$var$Ie,
        Rect: $adc7cb3c45508c7c$var$de,
        Circle: $adc7cb3c45508c7c$var$yt,
        Polygon: $adc7cb3c45508c7c$var$Ke,
        Vec2: $adc7cb3c45508c7c$var$v,
        Color: $adc7cb3c45508c7c$var$W,
        Mat4: $adc7cb3c45508c7c$var$Ue,
        Quad: $adc7cb3c45508c7c$var$oe,
        RNG: $adc7cb3c45508c7c$var$bt,
        rand: $adc7cb3c45508c7c$var$xt,
        randi: $adc7cb3c45508c7c$var$Ln,
        randSeed: $adc7cb3c45508c7c$var$yr,
        vec2: $adc7cb3c45508c7c$var$T,
        rgb: $adc7cb3c45508c7c$var$J,
        hsl2rgb: $adc7cb3c45508c7c$var$vr,
        quad: $adc7cb3c45508c7c$var$ce,
        choose: $adc7cb3c45508c7c$var$Ur,
        chance: $adc7cb3c45508c7c$var$xr,
        lerp: $adc7cb3c45508c7c$var$Ve,
        tween: Rn,
        easings: $adc7cb3c45508c7c$var$Ct,
        map: $adc7cb3c45508c7c$var$_e,
        mapc: $adc7cb3c45508c7c$var$br,
        wave: $adc7cb3c45508c7c$var$In,
        deg2rad: $adc7cb3c45508c7c$var$Ge,
        rad2deg: $adc7cb3c45508c7c$var$ot,
        clamp: $adc7cb3c45508c7c$var$Le,
        testLineLine: $adc7cb3c45508c7c$var$it,
        testRectRect: $adc7cb3c45508c7c$var$Er,
        testRectLine: $adc7cb3c45508c7c$var$Sr,
        testRectPoint: $adc7cb3c45508c7c$var$vt,
        testCirclePolygon: $adc7cb3c45508c7c$var$Tr,
        testLinePoint: $adc7cb3c45508c7c$var$Cr,
        testLineCircle: $adc7cb3c45508c7c$var$Vn,
        drawSprite: yn,
        drawText: tr,
        formatText: Xe,
        drawRect: ge,
        drawLine: l,
        drawLines: x,
        drawTriangle: R,
        drawCircle: L,
        drawEllipse: he,
        drawUVQuad: Be,
        drawPolygon: z,
        drawFormattedText: Je,
        drawMasked: $e,
        drawSubtracted: kt,
        pushTransform: le,
        popTransform: ae,
        pushTranslate: ne,
        pushScale: He,
        pushRotate: se,
        pushMatrix: _t,
        usePostEffect: Vt,
        makeCanvas: wn,
        debug: re,
        scene: Ks,
        go: Ys,
        onSceneLeave: Ws,
        addLevel: Qs,
        getData: Xs,
        setData: ar,
        download: $adc7cb3c45508c7c$var$Xt,
        downloadJSON: $adc7cb3c45508c7c$var$Dr,
        downloadText: $adc7cb3c45508c7c$var$kn,
        downloadBlob: $adc7cb3c45508c7c$var$Nn,
        plug: ur,
        ASCII_CHARS: $adc7cb3c45508c7c$var$zr,
        canvas: y.canvas,
        addKaboom: ui,
        LEFT: $adc7cb3c45508c7c$var$v.LEFT,
        RIGHT: $adc7cb3c45508c7c$var$v.RIGHT,
        UP: $adc7cb3c45508c7c$var$v.UP,
        DOWN: $adc7cb3c45508c7c$var$v.DOWN,
        RED: $adc7cb3c45508c7c$var$W.RED,
        GREEN: $adc7cb3c45508c7c$var$W.GREEN,
        BLUE: $adc7cb3c45508c7c$var$W.BLUE,
        YELLOW: $adc7cb3c45508c7c$var$W.YELLOW,
        MAGENTA: $adc7cb3c45508c7c$var$W.MAGENTA,
        CYAN: $adc7cb3c45508c7c$var$W.CYAN,
        WHITE: $adc7cb3c45508c7c$var$W.WHITE,
        BLACK: $adc7cb3c45508c7c$var$W.BLACK,
        quit: bi,
        Event: $adc7cb3c45508c7c$var$be,
        EventHandler: $adc7cb3c45508c7c$var$Ne,
        EventController: $adc7cb3c45508c7c$var$ke
    };
    if (n.plugins && n.plugins.forEach(ur), n.global !== !1) for(let t1 in Ze)window[t1] = Ze[t1];
    return n.focus !== !1 && y.canvas.focus(), Ze;
}, "default");


var $243a0fb2392e59c4$exports = {};
// colyseus.js@0.15.18 (@colyseus/schema 2.0.9)
(function(global1, factory) {
    factory($243a0fb2392e59c4$exports);
})($243a0fb2392e59c4$exports, function(exports1) {
    "use strict";
    function _mergeNamespaces(n, m) {
        m.forEach(function(e) {
            e && typeof e !== "string" && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
                if (k !== "default" && !(k in n)) {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function() {
                            return e[k];
                        }
                    });
                }
            });
        });
        return Object.freeze(n);
    }
    //
    // Polyfills for legacy environments
    //
    /*
     * Support Android 4.4.x
     */ if (!ArrayBuffer.isView) ArrayBuffer.isView = function(a) {
        return a !== null && typeof a === "object" && a.buffer instanceof ArrayBuffer;
    };
    // Define globalThis if not available.
    // https://github.com/colyseus/colyseus.js/issues/86
    if (typeof globalThis === "undefined" && typeof window !== "undefined") // @ts-ignore
    window["globalThis"] = window;
    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(g && (g = 0, op[0] && (_ = 0)), _)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __classPrivateFieldGet(receiver, state, kind, f) {
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
    }
    function __classPrivateFieldSet(receiver, state, value, kind, f) {
        if (kind === "m") throw new TypeError("Private method is not writable");
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
    }
    var CloseCode;
    (function(CloseCode) {
        CloseCode[CloseCode["CONSENTED"] = 4000] = "CONSENTED";
        CloseCode[CloseCode["DEVMODE_RESTART"] = 4010] = "DEVMODE_RESTART";
    })(CloseCode || (CloseCode = {}));
    var ServerError = /** @class */ function(_super) {
        __extends(ServerError, _super);
        function ServerError(code, message) {
            var _this = _super.call(this, message) || this;
            _this.name = "ServerError";
            _this.code = code;
            return _this;
        }
        return ServerError;
    }(Error);
    /**
     * Copyright (c) 2014 Ion Drive Software Ltd.
     * https://github.com/darrachequesne/notepack/
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */ /**
     * Patch for Colyseus:
     * -------------------
     * notepack.io@3.0.1
     *
     * added `offset` on Decoder constructor, for messages arriving with a code
     * before actual msgpack data
     */ //
    // DECODER
    //
    function Decoder(buffer, offset) {
        this._offset = offset;
        if (buffer instanceof ArrayBuffer) {
            this._buffer = buffer;
            this._view = new DataView(this._buffer);
        } else if (ArrayBuffer.isView(buffer)) {
            this._buffer = buffer.buffer;
            this._view = new DataView(this._buffer, buffer.byteOffset, buffer.byteLength);
        } else throw new Error("Invalid argument");
    }
    function utf8Read$1(view, offset, length) {
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view.getUint8(i);
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view.getUint8(++i) & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view.getUint8(++i) & 0x3f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    Decoder.prototype._array = function(length) {
        var value = new Array(length);
        for(var i = 0; i < length; i++)value[i] = this._parse();
        return value;
    };
    Decoder.prototype._map = function(length) {
        var key = "", value = {};
        for(var i = 0; i < length; i++){
            key = this._parse();
            value[key] = this._parse();
        }
        return value;
    };
    Decoder.prototype._str = function(length) {
        var value = utf8Read$1(this._view, this._offset, length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._bin = function(length) {
        var value = this._buffer.slice(this._offset, this._offset + length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._parse = function() {
        var prefix = this._view.getUint8(this._offset++);
        var value, length = 0, type = 0, hi = 0, lo = 0;
        if (prefix < 0xc0) {
            // positive fixint
            if (prefix < 0x80) return prefix;
            // fixmap
            if (prefix < 0x90) return this._map(prefix & 0x0f);
            // fixarray
            if (prefix < 0xa0) return this._array(prefix & 0x0f);
            // fixstr
            return this._str(prefix & 0x1f);
        }
        // negative fixint
        if (prefix > 0xdf) return (0xff - prefix + 1) * -1;
        switch(prefix){
            // nil
            case 0xc0:
                return null;
            // false
            case 0xc2:
                return false;
            // true
            case 0xc3:
                return true;
            // bin
            case 0xc4:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._bin(length);
            case 0xc5:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._bin(length);
            case 0xc6:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._bin(length);
            // ext
            case 0xc7:
                length = this._view.getUint8(this._offset);
                type = this._view.getInt8(this._offset + 1);
                this._offset += 2;
                if (type === -1) {
                    // timestamp 96
                    var ns = this._view.getUint32(this._offset);
                    hi = this._view.getInt32(this._offset + 4);
                    lo = this._view.getUint32(this._offset + 8);
                    this._offset += 12;
                    return new Date((hi * 0x100000000 + lo) * 1e3 + ns / 1e6);
                }
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc8:
                length = this._view.getUint16(this._offset);
                type = this._view.getInt8(this._offset + 2);
                this._offset += 3;
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc9:
                length = this._view.getUint32(this._offset);
                type = this._view.getInt8(this._offset + 4);
                this._offset += 5;
                return [
                    type,
                    this._bin(length)
                ];
            // float
            case 0xca:
                value = this._view.getFloat32(this._offset);
                this._offset += 4;
                return value;
            case 0xcb:
                value = this._view.getFloat64(this._offset);
                this._offset += 8;
                return value;
            // uint
            case 0xcc:
                value = this._view.getUint8(this._offset);
                this._offset += 1;
                return value;
            case 0xcd:
                value = this._view.getUint16(this._offset);
                this._offset += 2;
                return value;
            case 0xce:
                value = this._view.getUint32(this._offset);
                this._offset += 4;
                return value;
            case 0xcf:
                hi = this._view.getUint32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // int
            case 0xd0:
                value = this._view.getInt8(this._offset);
                this._offset += 1;
                return value;
            case 0xd1:
                value = this._view.getInt16(this._offset);
                this._offset += 2;
                return value;
            case 0xd2:
                value = this._view.getInt32(this._offset);
                this._offset += 4;
                return value;
            case 0xd3:
                hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // fixext
            case 0xd4:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    // custom encoding for 'undefined' (kept for backward-compatibility)
                    this._offset += 1;
                    return void 0;
                }
                return [
                    type,
                    this._bin(1)
                ];
            case 0xd5:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(2)
                ];
            case 0xd6:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === -1) {
                    // timestamp 32
                    value = this._view.getUint32(this._offset);
                    this._offset += 4;
                    return new Date(value * 1e3);
                }
                return [
                    type,
                    this._bin(4)
                ];
            case 0xd7:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    // custom date encoding (kept for backward-compatibility)
                    hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                    lo = this._view.getUint32(this._offset + 4);
                    this._offset += 8;
                    return new Date(hi + lo);
                }
                if (type === -1) {
                    // timestamp 64
                    hi = this._view.getUint32(this._offset);
                    lo = this._view.getUint32(this._offset + 4);
                    this._offset += 8;
                    var s = (hi & 0x3) * 0x100000000 + lo;
                    return new Date(s * 1e3 + (hi >>> 2) / 1e6);
                }
                return [
                    type,
                    this._bin(8)
                ];
            case 0xd8:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(16)
                ];
            // str
            case 0xd9:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._str(length);
            case 0xda:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._str(length);
            case 0xdb:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._str(length);
            // array
            case 0xdc:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._array(length);
            case 0xdd:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._array(length);
            // map
            case 0xde:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._map(length);
            case 0xdf:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._map(length);
        }
        throw new Error("Could not parse");
    };
    function decode(buffer, offset) {
        if (offset === void 0) offset = 0;
        var decoder = new Decoder(buffer, offset);
        var value = decoder._parse();
        if (decoder._offset !== buffer.byteLength) throw new Error(buffer.byteLength - decoder._offset + " trailing bytes");
        return value;
    }
    //
    // ENCODER
    //
    var TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
    var TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
    function utf8Write(view, offset, str) {
        var c = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) view.setUint8(offset++, c);
            else if (c < 0x800) {
                view.setUint8(offset++, 0xc0 | c >> 6);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else if (c < 0xd800 || c >= 0xe000) {
                view.setUint8(offset++, 0xe0 | c >> 12);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else {
                i++;
                c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                view.setUint8(offset++, 0xf0 | c >> 18);
                view.setUint8(offset++, 0x80 | c >> 12 & 0x3f);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            }
        }
    }
    function utf8Length$1(str) {
        var c = 0, length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length;
    }
    function _encode(bytes, defers, value) {
        var type = typeof value, i = 0, l = 0, hi = 0, lo = 0, length = 0, size = 0;
        if (type === "string") {
            length = utf8Length$1(value);
            // fixstr
            if (length < 0x20) {
                bytes.push(length | 0xa0);
                size = 1;
            } else if (length < 0x100) {
                bytes.push(0xd9, length);
                size = 2;
            } else if (length < 0x10000) {
                bytes.push(0xda, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdb, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("String too long");
            defers.push({
                _str: value,
                _length: length,
                _offset: bytes.length
            });
            return size + length;
        }
        if (type === "number") {
            // TODO: encode to float 32?
            // float 64
            if (Math.floor(value) !== value || !isFinite(value)) {
                bytes.push(0xcb);
                defers.push({
                    _float: value,
                    _length: 8,
                    _offset: bytes.length
                });
                return 9;
            }
            if (value >= 0) {
                // positive fixnum
                if (value < 0x80) {
                    bytes.push(value);
                    return 1;
                }
                // uint 8
                if (value < 0x100) {
                    bytes.push(0xcc, value);
                    return 2;
                }
                // uint 16
                if (value < 0x10000) {
                    bytes.push(0xcd, value >> 8, value);
                    return 3;
                }
                // uint 32
                if (value < 0x100000000) {
                    bytes.push(0xce, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // uint 64
                hi = value / Math.pow(2, 32) >> 0;
                lo = value >>> 0;
                bytes.push(0xcf, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            } else {
                // negative fixnum
                if (value >= -32) {
                    bytes.push(value);
                    return 1;
                }
                // int 8
                if (value >= -128) {
                    bytes.push(0xd0, value);
                    return 2;
                }
                // int 16
                if (value >= -32768) {
                    bytes.push(0xd1, value >> 8, value);
                    return 3;
                }
                // int 32
                if (value >= -2147483648) {
                    bytes.push(0xd2, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // int 64
                hi = Math.floor(value / Math.pow(2, 32));
                lo = value >>> 0;
                bytes.push(0xd3, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            }
        }
        if (type === "object") {
            // nil
            if (value === null) {
                bytes.push(0xc0);
                return 1;
            }
            if (Array.isArray(value)) {
                length = value.length;
                // fixarray
                if (length < 0x10) {
                    bytes.push(length | 0x90);
                    size = 1;
                } else if (length < 0x10000) {
                    bytes.push(0xdc, length >> 8, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdd, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Array too large");
                for(i = 0; i < length; i++)size += _encode(bytes, defers, value[i]);
                return size;
            }
            if (value instanceof Date) {
                var ms = value.getTime();
                var s = Math.floor(ms / 1e3);
                var ns = (ms - s * 1e3) * 1e6;
                if (s >= 0 && ns >= 0 && s <= TIMESTAMP64_MAX_SEC) {
                    if (ns === 0 && s <= TIMESTAMP32_MAX_SEC) {
                        // timestamp 32
                        bytes.push(0xd6, 0xff, s >> 24, s >> 16, s >> 8, s);
                        return 6;
                    } else {
                        // timestamp 64
                        hi = s / 0x100000000;
                        lo = s & 0xffffffff;
                        bytes.push(0xd7, 0xff, ns >> 22, ns >> 14, ns >> 6, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                        return 10;
                    }
                } else {
                    // timestamp 96
                    hi = Math.floor(s / 0x100000000);
                    lo = s >>> 0;
                    bytes.push(0xc7, 0x0c, 0xff, ns >> 24, ns >> 16, ns >> 8, ns, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                    return 15;
                }
            }
            if (value instanceof ArrayBuffer) {
                length = value.byteLength;
                // bin 8
                if (length < 0x100) {
                    bytes.push(0xc4, length);
                    size = 2;
                } else // bin 16
                if (length < 0x10000) {
                    bytes.push(0xc5, length >> 8, length);
                    size = 3;
                } else // bin 32
                if (length < 0x100000000) {
                    bytes.push(0xc6, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Buffer too large");
                defers.push({
                    _bin: value,
                    _length: length,
                    _offset: bytes.length
                });
                return size + length;
            }
            if (typeof value.toJSON === "function") return _encode(bytes, defers, value.toJSON());
            var keys = [], key = "";
            var allKeys = Object.keys(value);
            for(i = 0, l = allKeys.length; i < l; i++){
                key = allKeys[i];
                if (value[key] !== undefined && typeof value[key] !== "function") keys.push(key);
            }
            length = keys.length;
            // fixmap
            if (length < 0x10) {
                bytes.push(length | 0x80);
                size = 1;
            } else if (length < 0x10000) {
                bytes.push(0xde, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdf, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("Object too large");
            for(i = 0; i < length; i++){
                key = keys[i];
                size += _encode(bytes, defers, key);
                size += _encode(bytes, defers, value[key]);
            }
            return size;
        }
        // false/true
        if (type === "boolean") {
            bytes.push(value ? 0xc3 : 0xc2);
            return 1;
        }
        if (type === "undefined") {
            bytes.push(0xc0);
            return 1;
        }
        // custom types like BigInt (typeof value === 'bigint')
        if (typeof value.toJSON === "function") return _encode(bytes, defers, value.toJSON());
        throw new Error("Could not encode");
    }
    function encode(value) {
        var bytes = [];
        var defers = [];
        var size = _encode(bytes, defers, value);
        var buf = new ArrayBuffer(size);
        var view = new DataView(buf);
        var deferIndex = 0;
        var deferWritten = 0;
        var nextOffset = -1;
        if (defers.length > 0) nextOffset = defers[0]._offset;
        var defer, deferLength = 0, offset = 0;
        for(var i = 0, l = bytes.length; i < l; i++){
            view.setUint8(deferWritten + i, bytes[i]);
            if (i + 1 !== nextOffset) continue;
            defer = defers[deferIndex];
            deferLength = defer._length;
            offset = deferWritten + nextOffset;
            if (defer._bin) {
                var bin = new Uint8Array(defer._bin);
                for(var j = 0; j < deferLength; j++)view.setUint8(offset + j, bin[j]);
            } else if (defer._str) utf8Write(view, offset, defer._str);
            else if (defer._float !== undefined) view.setFloat64(offset, defer._float);
            deferIndex++;
            deferWritten += deferLength;
            if (defers[deferIndex]) nextOffset = defers[deferIndex]._offset;
        }
        return buf;
    }
    var browser = function() {
        throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
    };
    var WebSocket = globalThis.WebSocket || browser;
    var WebSocketTransport = /** @class */ function() {
        function WebSocketTransport(events) {
            this.events = events;
        }
        WebSocketTransport.prototype.send = function(data) {
            if (data instanceof ArrayBuffer) this.ws.send(data);
            else if (Array.isArray(data)) this.ws.send(new Uint8Array(data).buffer);
        };
        WebSocketTransport.prototype.connect = function(url) {
            this.ws = new WebSocket(url, this.protocols);
            this.ws.binaryType = "arraybuffer";
            this.ws.onopen = this.events.onopen;
            this.ws.onmessage = this.events.onmessage;
            this.ws.onclose = this.events.onclose;
            this.ws.onerror = this.events.onerror;
        };
        WebSocketTransport.prototype.close = function(code, reason) {
            this.ws.close(code, reason);
        };
        Object.defineProperty(WebSocketTransport.prototype, "isOpen", {
            get: function() {
                return this.ws.readyState === WebSocket.OPEN;
            },
            enumerable: false,
            configurable: true
        });
        return WebSocketTransport;
    }();
    var Connection = /** @class */ function() {
        function Connection() {
            this.events = {};
            this.transport = new WebSocketTransport(this.events);
        }
        Connection.prototype.send = function(data) {
            this.transport.send(data);
        };
        Connection.prototype.connect = function(url) {
            this.transport.connect(url);
        };
        Connection.prototype.close = function(code, reason) {
            this.transport.close(code, reason);
        };
        Object.defineProperty(Connection.prototype, "isOpen", {
            get: function() {
                return this.transport.isOpen;
            },
            enumerable: false,
            configurable: true
        });
        return Connection;
    }();
    // Use codes between 0~127 for lesser throughput (1 byte)
    exports1.Protocol = void 0;
    (function(Protocol) {
        // Room-related (10~19)
        Protocol[Protocol["HANDSHAKE"] = 9] = "HANDSHAKE";
        Protocol[Protocol["JOIN_ROOM"] = 10] = "JOIN_ROOM";
        Protocol[Protocol["ERROR"] = 11] = "ERROR";
        Protocol[Protocol["LEAVE_ROOM"] = 12] = "LEAVE_ROOM";
        Protocol[Protocol["ROOM_DATA"] = 13] = "ROOM_DATA";
        Protocol[Protocol["ROOM_STATE"] = 14] = "ROOM_STATE";
        Protocol[Protocol["ROOM_STATE_PATCH"] = 15] = "ROOM_STATE_PATCH";
        Protocol[Protocol["ROOM_DATA_SCHEMA"] = 16] = "ROOM_DATA_SCHEMA";
        Protocol[Protocol["ROOM_DATA_BYTES"] = 17] = "ROOM_DATA_BYTES";
    })(exports1.Protocol || (exports1.Protocol = {}));
    exports1.ErrorCode = void 0;
    (function(ErrorCode) {
        ErrorCode[ErrorCode["MATCHMAKE_NO_HANDLER"] = 4210] = "MATCHMAKE_NO_HANDLER";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_CRITERIA"] = 4211] = "MATCHMAKE_INVALID_CRITERIA";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_ROOM_ID"] = 4212] = "MATCHMAKE_INVALID_ROOM_ID";
        ErrorCode[ErrorCode["MATCHMAKE_UNHANDLED"] = 4213] = "MATCHMAKE_UNHANDLED";
        ErrorCode[ErrorCode["MATCHMAKE_EXPIRED"] = 4214] = "MATCHMAKE_EXPIRED";
        ErrorCode[ErrorCode["AUTH_FAILED"] = 4215] = "AUTH_FAILED";
        ErrorCode[ErrorCode["APPLICATION_ERROR"] = 4216] = "APPLICATION_ERROR";
    })(exports1.ErrorCode || (exports1.ErrorCode = {}));
    function utf8Read(view, offset) {
        var length = view[offset++];
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view[i];
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view[++i] & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view[++i] & 0x3f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    // Faster for short strings than Buffer.byteLength
    function utf8Length(str) {
        if (str === void 0) str = "";
        var c = 0;
        var length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length + 1;
    }
    var serializers = {};
    function registerSerializer(id, serializer) {
        serializers[id] = serializer;
    }
    function getSerializer(id) {
        var serializer = serializers[id];
        if (!serializer) throw new Error("missing serializer: " + id);
        return serializer;
    }
    /**
     * The MIT License (MIT)
     *
     * Copyright 2016 Andrey Sitnik <andrey@sitnik.ru>
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy of
     * this software and associated documentation files (the "Software"), to deal in
     * the Software without restriction, including without limitation the rights to
     * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
     * the Software, and to permit persons to whom the Software is furnished to do so,
     * subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
     * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
     * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
     * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
     * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     */ var createNanoEvents = function() {
        return {
            emit: function(event) {
                var args = [];
                for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                var callbacks = this.events[event] || [];
                for(var i = 0, length_1 = callbacks.length; i < length_1; i++)callbacks[i].apply(callbacks, args);
            },
            events: {},
            on: function(event, cb) {
                var _this = this;
                var _a;
                ((_a = this.events[event]) === null || _a === void 0 ? void 0 : _a.push(cb)) || (this.events[event] = [
                    cb
                ]);
                return function() {
                    var _a;
                    _this.events[event] = (_a = _this.events[event]) === null || _a === void 0 ? void 0 : _a.filter(function(i) {
                        return cb !== i;
                    });
                };
            }
        };
    };
    var EventEmitter = /** @class */ function() {
        function EventEmitter() {
            this.handlers = [];
        }
        EventEmitter.prototype.register = function(cb, once) {
            this.handlers.push(cb);
            return this;
        };
        EventEmitter.prototype.invoke = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            this.handlers.forEach(function(handler) {
                return handler.apply(_this, args);
            });
        };
        EventEmitter.prototype.invokeAsync = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return Promise.all(this.handlers.map(function(handler) {
                return handler.apply(_this, args);
            }));
        };
        EventEmitter.prototype.remove = function(cb) {
            var index = this.handlers.indexOf(cb);
            this.handlers[index] = this.handlers[this.handlers.length - 1];
            this.handlers.pop();
        };
        EventEmitter.prototype.clear = function() {
            this.handlers = [];
        };
        return EventEmitter;
    }();
    function createSignal() {
        var emitter = new EventEmitter();
        function register(cb) {
            return emitter.register(cb, this === null);
        }
        register.once = function(cb) {
            var callback = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                cb.apply(this, args);
                emitter.remove(callback);
            };
            emitter.register(callback);
        };
        register.remove = function(cb) {
            return emitter.remove(cb);
        };
        register.invoke = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invoke.apply(emitter, args);
        };
        register.invokeAsync = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invokeAsync.apply(emitter, args);
        };
        register.clear = function() {
            return emitter.clear();
        };
        return register;
    }
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function createCommonjsModule(fn) {
        var module = {
            exports: {}
        };
        return fn(module, module.exports), module.exports;
    }
    var umd = createCommonjsModule(function(module, exports1) {
        (function(global1, factory) {
            factory(exports1);
        })(commonjsGlobal, function(exports1) {
            /******************************************************************************
        Copyright (c) Microsoft Corporation.

        Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.

        THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
                extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
                return extendStatics(d, b);
            };
            function __extends(d, b) {
                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            }
            function __decorate(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            }
            function __spreadArray(to, from, pack) {
                if (pack || arguments.length === 2) {
                    for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                        ar[i] = from[i];
                    }
                }
                return to.concat(ar || Array.prototype.slice.call(from));
            }
            // export const SWITCH_TO_STRUCTURE = 193; (easily collides with DELETE_AND_ADD + fieldIndex = 2)
            var SWITCH_TO_STRUCTURE = 255; // (decoding collides with DELETE_AND_ADD + fieldIndex = 63)
            var TYPE_ID = 213;
            /**
         * Encoding Schema field operations.
         */ exports1.OPERATION = void 0;
            (function(OPERATION) {
                // add new structure/primitive
                OPERATION[OPERATION["ADD"] = 128] = "ADD";
                // replace structure/primitive
                OPERATION[OPERATION["REPLACE"] = 0] = "REPLACE";
                // delete field
                OPERATION[OPERATION["DELETE"] = 64] = "DELETE";
                // DELETE field, followed by an ADD
                OPERATION[OPERATION["DELETE_AND_ADD"] = 192] = "DELETE_AND_ADD";
                // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
                // touches are NOT encoded.
                OPERATION[OPERATION["TOUCH"] = 1] = "TOUCH";
                // MapSchema Operations
                OPERATION[OPERATION["CLEAR"] = 10] = "CLEAR";
            })(exports1.OPERATION || (exports1.OPERATION = {}));
            // export enum OPERATION {
            //     // add new structure/primitive
            //     // (128)
            //     ADD = 128, // 10000000,
            //     // replace structure/primitive
            //     REPLACE = 1,// 00000001
            //     // delete field
            //     DELETE = 192, // 11000000
            //     // DELETE field, followed by an ADD
            //     DELETE_AND_ADD = 224, // 11100000
            //     // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
            //     // touches are NOT encoded.
            //     TOUCH = 0, // 00000000
            //     // MapSchema Operations
            //     CLEAR = 10,
            // }
            var ChangeTree = /** @class */ function() {
                function ChangeTree(ref, parent, root) {
                    this.changed = false;
                    this.changes = new Map();
                    this.allChanges = new Set();
                    // cached indexes for filtering
                    this.caches = {};
                    this.currentCustomOperation = 0;
                    this.ref = ref;
                    this.setParent(parent, root);
                }
                ChangeTree.prototype.setParent = function(parent, root, parentIndex) {
                    var _this = this;
                    if (!this.indexes) this.indexes = this.ref instanceof Schema ? this.ref["_definition"].indexes : {};
                    this.parent = parent;
                    this.parentIndex = parentIndex;
                    // avoid setting parents with empty `root`
                    if (!root) return;
                    this.root = root;
                    //
                    // assign same parent on child structures
                    //
                    if (this.ref instanceof Schema) {
                        var definition = this.ref["_definition"];
                        for(var field in definition.schema){
                            var value = this.ref[field];
                            if (value && value["$changes"]) {
                                var parentIndex_1 = definition.indexes[field];
                                value["$changes"].setParent(this.ref, root, parentIndex_1);
                            }
                        }
                    } else if (typeof this.ref === "object") this.ref.forEach(function(value, key) {
                        if (value instanceof Schema) {
                            var changeTreee = value["$changes"];
                            var parentIndex_2 = _this.ref["$changes"].indexes[key];
                            changeTreee.setParent(_this.ref, _this.root, parentIndex_2);
                        }
                    });
                };
                ChangeTree.prototype.operation = function(op) {
                    this.changes.set(--this.currentCustomOperation, op);
                };
                ChangeTree.prototype.change = function(fieldName, operation) {
                    if (operation === void 0) operation = exports1.OPERATION.ADD;
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    var previousChange = this.changes.get(index);
                    if (!previousChange || previousChange.op === exports1.OPERATION.DELETE || previousChange.op === exports1.OPERATION.TOUCH // (mazmorra.io's BattleAction issue)
                    ) this.changes.set(index, {
                        op: !previousChange ? operation : previousChange.op === exports1.OPERATION.DELETE ? exports1.OPERATION.DELETE_AND_ADD : operation,
                        // : OPERATION.REPLACE,
                        index: index
                    });
                    this.allChanges.add(index);
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.touch = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    if (!this.changes.has(index)) this.changes.set(index, {
                        op: exports1.OPERATION.TOUCH,
                        index: index
                    });
                    this.allChanges.add(index);
                    // ensure touch is placed until the $root is found.
                    this.touchParents();
                };
                ChangeTree.prototype.touchParents = function() {
                    if (this.parent) this.parent["$changes"].touch(this.parentIndex);
                };
                ChangeTree.prototype.getType = function(index) {
                    if (this.ref["_definition"]) {
                        var definition = this.ref["_definition"];
                        return definition.schema[definition.fieldsByIndex[index]];
                    } else {
                        var definition = this.parent["_definition"];
                        var parentType = definition.schema[definition.fieldsByIndex[this.parentIndex]];
                        //
                        // Get the child type from parent structure.
                        // - ["string"] => "string"
                        // - { map: "string" } => "string"
                        // - { set: "string" } => "string"
                        //
                        return Object.values(parentType)[0];
                    }
                };
                ChangeTree.prototype.getChildrenFilter = function() {
                    var childFilters = this.parent["_definition"].childFilters;
                    return childFilters && childFilters[this.parentIndex];
                };
                //
                // used during `.encode()`
                //
                ChangeTree.prototype.getValue = function(index) {
                    return this.ref["getByIndex"](index);
                };
                ChangeTree.prototype.delete = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    if (index === undefined) {
                        console.warn("@colyseus/schema ".concat(this.ref.constructor.name, ": trying to delete non-existing index: ").concat(fieldName, " (").concat(index, ")"));
                        return;
                    }
                    var previousValue = this.getValue(index);
                    // console.log("$changes.delete =>", { fieldName, index, previousValue });
                    this.changes.set(index, {
                        op: exports1.OPERATION.DELETE,
                        index: index
                    });
                    this.allChanges.delete(index);
                    // delete cache
                    delete this.caches[index];
                    // remove `root` reference
                    if (previousValue && previousValue["$changes"]) previousValue["$changes"].parent = undefined;
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.discard = function(changed, discardAll) {
                    var _this = this;
                    if (changed === void 0) changed = false;
                    if (discardAll === void 0) discardAll = false;
                    //
                    // Map, Array, etc:
                    // Remove cached key to ensure ADD operations is unsed instead of
                    // REPLACE in case same key is used on next patches.
                    //
                    // TODO: refactor this. this is not relevant for Collection and Set.
                    //
                    if (!(this.ref instanceof Schema)) this.changes.forEach(function(change) {
                        if (change.op === exports1.OPERATION.DELETE) {
                            var index = _this.ref["getIndex"](change.index);
                            delete _this.indexes[index];
                        }
                    });
                    this.changes.clear();
                    this.changed = changed;
                    if (discardAll) this.allChanges.clear();
                    // re-set `currentCustomOperation`
                    this.currentCustomOperation = 0;
                };
                /**
             * Recursively discard all changes from this, and child structures.
             */ ChangeTree.prototype.discardAll = function() {
                    var _this = this;
                    this.changes.forEach(function(change) {
                        var value = _this.getValue(change.index);
                        if (value && value["$changes"]) value["$changes"].discardAll();
                    });
                    this.discard();
                };
                // cache(field: number, beginIndex: number, endIndex: number) {
                ChangeTree.prototype.cache = function(field, cachedBytes) {
                    this.caches[field] = cachedBytes;
                };
                ChangeTree.prototype.clone = function() {
                    return new ChangeTree(this.ref, this.parent, this.root);
                };
                ChangeTree.prototype.ensureRefId = function() {
                    // skip if refId is already set.
                    if (this.refId !== undefined) return;
                    this.refId = this.root.getNextUniqueId();
                };
                ChangeTree.prototype.assertValidIndex = function(index, fieldName) {
                    if (index === undefined) throw new Error('ChangeTree: missing index for field "'.concat(fieldName, '"'));
                };
                return ChangeTree;
            }();
            function addCallback($callbacks, op, callback, existing) {
                // initialize list of callbacks
                if (!$callbacks[op]) $callbacks[op] = [];
                $callbacks[op].push(callback);
                //
                // Trigger callback for existing elements
                // - OPERATION.ADD
                // - OPERATION.REPLACE
                //
                existing === null || existing === void 0 || existing.forEach(function(item, key) {
                    return callback(item, key);
                });
                return function() {
                    return spliceOne($callbacks[op], $callbacks[op].indexOf(callback));
                };
            }
            function removeChildRefs(changes) {
                var _this = this;
                var needRemoveRef = typeof this.$changes.getType() !== "string";
                this.$items.forEach(function(item, key) {
                    changes.push({
                        refId: _this.$changes.refId,
                        op: exports1.OPERATION.DELETE,
                        field: key,
                        value: undefined,
                        previousValue: item
                    });
                    if (needRemoveRef) _this.$changes.root.removeRef(item["$changes"].refId);
                });
            }
            function spliceOne(arr, index) {
                // manually splice an array
                if (index === -1 || index >= arr.length) return false;
                var len = arr.length - 1;
                for(var i = index; i < len; i++)arr[i] = arr[i + 1];
                arr.length = len;
                return true;
            }
            var DEFAULT_SORT = function(a, b) {
                var A = a.toString();
                var B = b.toString();
                if (A < B) return -1;
                else if (A > B) return 1;
                else return 0;
            };
            function getArrayProxy(value) {
                value["$proxy"] = true;
                //
                // compatibility with @colyseus/schema 0.5.x
                // - allow `map["key"]`
                // - allow `map["key"] = "xxx"`
                // - allow `delete map["key"]`
                //
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && !isNaN(prop) // https://stackoverflow.com/a/175787/892698
                        ) return obj.at(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && !isNaN(prop)) {
                            var indexes = Array.from(obj["$items"].keys());
                            var key = parseInt(indexes[prop] || prop);
                            if (setValue === undefined || setValue === null) obj.deleteAt(key);
                            else obj.setAt(key, setValue);
                        } else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        if (typeof prop === "number") obj.deleteAt(prop);
                        else delete obj[prop];
                        return true;
                    }
                });
                return value;
            }
            var ArraySchema = /** @class */ function() {
                function ArraySchema() {
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    this.push.apply(this, items);
                }
                ArraySchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                ArraySchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                ArraySchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                ArraySchema.is = function(type) {
                    return(// type format: ["string"]
                    Array.isArray(type) || // type format: { array: "string" }
                    type["array"] !== undefined);
                };
                Object.defineProperty(ArraySchema.prototype, "length", {
                    get: function() {
                        return this.$items.size;
                    },
                    set: function(value) {
                        if (value === 0) this.clear();
                        else this.splice(value, this.length - value);
                    },
                    enumerable: false,
                    configurable: true
                });
                ArraySchema.prototype.push = function() {
                    var _this = this;
                    var values = [];
                    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
                    var lastIndex;
                    values.forEach(function(value) {
                        // set "index" for reference.
                        lastIndex = _this.$refId++;
                        _this.setAt(lastIndex, value);
                    });
                    return lastIndex;
                };
                /**
             * Removes the last element from an array and returns it.
             */ ArraySchema.prototype.pop = function() {
                    var key = Array.from(this.$indexes.values()).pop();
                    if (key === undefined) return undefined;
                    this.$changes.delete(key);
                    this.$indexes.delete(key);
                    var value = this.$items.get(key);
                    this.$items.delete(key);
                    return value;
                };
                ArraySchema.prototype.at = function(index) {
                    //
                    // FIXME: this should be O(1)
                    //
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                ArraySchema.prototype.setAt = function(index, value) {
                    var _a, _b;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                };
                ArraySchema.prototype.deleteAt = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    if (key === undefined) return false;
                    return this.$deleteAt(key);
                };
                ArraySchema.prototype.$deleteAt = function(index) {
                    // delete at internal index
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                ArraySchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                /**
             * Combines two or more arrays.
             * @param items Additional items to add to the end of array1.
             */ // @ts-ignore
                ArraySchema.prototype.concat = function() {
                    var _a;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    return new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], (_a = Array.from(this.$items.values())).concat.apply(_a, items), false)))();
                };
                /**
             * Adds all the elements of an array separated by the specified separator string.
             * @param separator A string used to separate one element of an array from the next in the resulting String. If omitted, the array elements are separated with a comma.
             */ ArraySchema.prototype.join = function(separator) {
                    return Array.from(this.$items.values()).join(separator);
                };
                /**
             * Reverses the elements in an Array.
             */ // @ts-ignore
                ArraySchema.prototype.reverse = function() {
                    var _this = this;
                    var indexes = Array.from(this.$items.keys());
                    var reversedItems = Array.from(this.$items.values()).reverse();
                    reversedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes the first element from an array and returns it.
             */ ArraySchema.prototype.shift = function() {
                    var indexes = Array.from(this.$items.keys());
                    var shiftAt = indexes.shift();
                    if (shiftAt === undefined) return undefined;
                    var value = this.$items.get(shiftAt);
                    this.$deleteAt(shiftAt);
                    return value;
                };
                /**
             * Returns a section of an array.
             * @param start The beginning of the specified portion of the array.
             * @param end The end of the specified portion of the array. This is exclusive of the element at the index 'end'.
             */ ArraySchema.prototype.slice = function(start, end) {
                    var sliced = new ArraySchema();
                    sliced.push.apply(sliced, Array.from(this.$items.values()).slice(start, end));
                    return sliced;
                };
                /**
             * Sorts an array.
             * @param compareFn Function used to determine the order of the elements. It is expected to return
             * a negative value if first argument is less than second argument, zero if they're equal and a positive
             * value otherwise. If omitted, the elements are sorted in ascending, ASCII character order.
             * ```ts
             * [11,2,22,1].sort((a, b) => a - b)
             * ```
             */ ArraySchema.prototype.sort = function(compareFn) {
                    var _this = this;
                    if (compareFn === void 0) compareFn = DEFAULT_SORT;
                    var indexes = Array.from(this.$items.keys());
                    var sortedItems = Array.from(this.$items.values()).sort(compareFn);
                    sortedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes elements from an array and, if necessary, inserts new elements in their place, returning the deleted elements.
             * @param start The zero-based location in the array from which to start removing elements.
             * @param deleteCount The number of elements to remove.
             * @param items Elements to insert into the array in place of the deleted elements.
             */ ArraySchema.prototype.splice = function(start, deleteCount) {
                    if (deleteCount === void 0) deleteCount = this.length - start;
                    var indexes = Array.from(this.$items.keys());
                    var removedItems = [];
                    for(var i = start; i < start + deleteCount; i++){
                        removedItems.push(this.$items.get(indexes[i]));
                        this.$deleteAt(indexes[i]);
                    }
                    return removedItems;
                };
                /**
             * Inserts new elements at the start of an array.
             * @param items  Elements to insert at the start of the Array.
             */ ArraySchema.prototype.unshift = function() {
                    var _this = this;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    var length = this.length;
                    var addedLength = items.length;
                    // const indexes = Array.from(this.$items.keys());
                    var previousValues = Array.from(this.$items.values());
                    items.forEach(function(item, i) {
                        _this.setAt(i, item);
                    });
                    previousValues.forEach(function(previousValue, i) {
                        _this.setAt(addedLength + i, previousValue);
                    });
                    return length + addedLength;
                };
                /**
             * Returns the index of the first occurrence of a value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
             */ ArraySchema.prototype.indexOf = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).indexOf(searchElement, fromIndex);
                };
                /**
             * Returns the index of the last occurrence of a specified value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at the last index in the array.
             */ ArraySchema.prototype.lastIndexOf = function(searchElement, fromIndex) {
                    if (fromIndex === void 0) fromIndex = this.length - 1;
                    return Array.from(this.$items.values()).lastIndexOf(searchElement, fromIndex);
                };
                /**
             * Determines whether all the members of an array satisfy the specified test.
             * @param callbackfn A function that accepts up to three arguments. The every method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value false, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.every = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).every(callbackfn, thisArg);
                };
                /**
             * Determines whether the specified callback function returns true for any element of an array.
             * @param callbackfn A function that accepts up to three arguments. The some method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value true, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.some = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).some(callbackfn, thisArg);
                };
                /**
             * Performs the specified action for each element in an array.
             * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array.
             * @param thisArg  An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.forEach = function(callbackfn, thisArg) {
                    Array.from(this.$items.values()).forEach(callbackfn, thisArg);
                };
                /**
             * Calls a defined callback function on each element of an array, and returns an array that contains the results.
             * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.map = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).map(callbackfn, thisArg);
                };
                ArraySchema.prototype.filter = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).filter(callbackfn, thisArg);
                };
                /**
             * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduce = function(callbackfn, initialValue) {
                    return Array.prototype.reduce.apply(Array.from(this.$items.values()), arguments);
                };
                /**
             * Calls the specified callback function for all the elements in an array, in descending order. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduceRight method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduceRight = function(callbackfn, initialValue) {
                    return Array.prototype.reduceRight.apply(Array.from(this.$items.values()), arguments);
                };
                /**
             * Returns the value of the first element in the array where predicate is true, and undefined
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found, find
             * immediately returns that element value. Otherwise, find returns undefined.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.find = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).find(predicate, thisArg);
                };
                /**
             * Returns the index of the first element in the array where predicate is true, and -1
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found,
             * findIndex immediately returns that element index. Otherwise, findIndex returns -1.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.findIndex = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).findIndex(predicate, thisArg);
                };
                /**
             * Returns the this object after filling the section identified by start and end with value
             * @param value value to fill array section with
             * @param start index to start filling the array at. If start is negative, it is treated as
             * length+start where length is the length of the array.
             * @param end index to stop filling the array at. If end is negative, it is treated as
             * length+end.
             */ ArraySchema.prototype.fill = function(value, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#fill() not implemented");
                };
                /**
             * Returns the this object after copying a section of the array identified by start and end
             * to the same array starting at position target
             * @param target If target is negative, it is treated as length+target where length is the
             * length of the array.
             * @param start If start is negative, it is treated as length+start. If end is negative, it
             * is treated as length+end.
             * @param end If not specified, length of the this object is used as its default value.
             */ ArraySchema.prototype.copyWithin = function(target, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#copyWithin() not implemented");
                };
                /**
             * Returns a string representation of an array.
             */ ArraySchema.prototype.toString = function() {
                    return this.$items.toString();
                };
                /**
             * Returns a string representation of an array. The elements are converted to string using their toLocalString methods.
             */ ArraySchema.prototype.toLocaleString = function() {
                    return this.$items.toLocaleString();
                };
                /** Iterator */ ArraySchema.prototype[Symbol.iterator] = function() {
                    return Array.from(this.$items.values())[Symbol.iterator]();
                };
                /**
             * Returns an iterable of key, value pairs for every entry in the array
             */ ArraySchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                /**
             * Returns an iterable of keys in the array
             */ ArraySchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                /**
             * Returns an iterable of values in the array
             */ ArraySchema.prototype.values = function() {
                    return this.$items.values();
                };
                /**
             * Determines whether an array includes a certain element, returning true or false as appropriate.
             * @param searchElement The element to search for.
             * @param fromIndex The position in this array at which to begin searching for searchElement.
             */ ArraySchema.prototype.includes = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).includes(searchElement, fromIndex);
                };
                /**
             * Calls a defined callback function on each element of an array. Then, flattens the result into
             * a new array.
             * This is identical to a map followed by flat with depth 1.
             *
             * @param callback A function that accepts up to three arguments. The flatMap method calls the
             * callback function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callback function. If
             * thisArg is omitted, undefined is used as the this value.
             */ // @ts-ignore
                ArraySchema.prototype.flatMap = function(callback, thisArg) {
                    // @ts-ignore
                    throw new Error("ArraySchema#flatMap() is not supported.");
                };
                /**
             * Returns a new array with all sub-array elements concatenated into it recursively up to the
             * specified depth.
             *
             * @param depth The maximum recursion depth
             */ // @ts-ignore
                ArraySchema.prototype.flat = function(depth) {
                    throw new Error("ArraySchema#flat() is not supported.");
                };
                ArraySchema.prototype.findLast = function() {
                    var arr = Array.from(this.$items.values());
                    // @ts-ignore
                    return arr.findLast.apply(arr, arguments);
                };
                ArraySchema.prototype.findLastIndex = function() {
                    var arr = Array.from(this.$items.values());
                    // @ts-ignore
                    return arr.findLastIndex.apply(arr, arguments);
                };
                // get size () {
                //     return this.$items.size;
                // }
                ArraySchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                ArraySchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                ArraySchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                ArraySchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                ArraySchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                ArraySchema.prototype.toJSON = function() {
                    return this.toArray().map(function(value) {
                        return typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                };
                //
                // Decoding utilities
                //
                ArraySchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], Array.from(this.$items.values()), false)))();
                    else cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], this.map(function(item) {
                        return item["$changes"] ? item.clone() : item;
                    }), false)))();
                    return cloned;
                };
                return ArraySchema;
            }();
            function getMapProxy(value) {
                value["$proxy"] = true;
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && // accessing properties
                        typeof obj[prop] === "undefined") return obj.get(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && prop.indexOf("$") === -1 && prop !== "onAdd" && prop !== "onRemove" && prop !== "onChange") obj.set(prop, setValue);
                        else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        obj.delete(prop);
                        return true;
                    }
                });
                return value;
            }
            var MapSchema = /** @class */ function() {
                function MapSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) {
                        if (initialValues instanceof Map || initialValues instanceof MapSchema) initialValues.forEach(function(v, k) {
                            return _this.set(k, v);
                        });
                        else for(var k in initialValues)this.set(k, initialValues[k]);
                    }
                }
                MapSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                MapSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                MapSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                MapSchema.is = function(type) {
                    return type["map"] !== undefined;
                };
                /** Iterator */ MapSchema.prototype[Symbol.iterator] = function() {
                    return this.$items[Symbol.iterator]();
                };
                Object.defineProperty(MapSchema.prototype, Symbol.toStringTag, {
                    get: function() {
                        return this.$items[Symbol.toStringTag];
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.set = function(key, value) {
                    if (value === undefined || value === null) throw new Error("MapSchema#set('".concat(key, "', ").concat(value, "): trying to set ").concat(value, " value on '").concat(key, "'."));
                    // get "index" for this value.
                    var hasIndex = typeof this.$changes.indexes[key] !== "undefined";
                    var index = hasIndex ? this.$changes.indexes[key] : this.$refId++;
                    var operation = hasIndex ? exports1.OPERATION.REPLACE : exports1.OPERATION.ADD;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    //
                    // (encoding)
                    // set a unique id to relate directly with this key/value.
                    //
                    if (!hasIndex) {
                        this.$changes.indexes[key] = index;
                        this.$indexes.set(index, key);
                    } else if (isRef && // if is schema, force ADD operation if value differ from previous one.
                    this.$items.get(key) !== value) operation = exports1.OPERATION.ADD;
                    this.$items.set(key, value);
                    this.$changes.change(key, operation);
                    return this;
                };
                MapSchema.prototype.get = function(key) {
                    return this.$items.get(key);
                };
                MapSchema.prototype.delete = function(key) {
                    //
                    // TODO: add a "purge" method after .encode() runs, to cleanup removed `$indexes`
                    //
                    // We don't remove $indexes to allow setting the same key in the same patch
                    // (See "should allow to remove and set an item in the same place" test)
                    //
                    // // const index = this.$changes.indexes[key];
                    // // this.$indexes.delete(index);
                    this.$changes.delete(key);
                    return this.$items.delete(key);
                };
                MapSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                MapSchema.prototype.has = function(key) {
                    return this.$items.has(key);
                };
                MapSchema.prototype.forEach = function(callbackfn) {
                    this.$items.forEach(callbackfn);
                };
                MapSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                MapSchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                MapSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(MapSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                MapSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                MapSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                MapSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                MapSchema.prototype.toJSON = function() {
                    var map = {};
                    this.forEach(function(value, key) {
                        map[key] = typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                    return map;
                };
                //
                // Decoding utilities
                //
                MapSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new MapSchema(), this);
                    else {
                        // server-side
                        cloned = new MapSchema();
                        this.forEach(function(value, key) {
                            if (value["$changes"]) cloned.set(key, value["clone"]());
                            else cloned.set(key, value);
                        });
                    }
                    return cloned;
                };
                return MapSchema;
            }();
            var registeredTypes = {};
            function registerType(identifier, definition) {
                registeredTypes[identifier] = definition;
            }
            function getType(identifier) {
                return registeredTypes[identifier];
            }
            var SchemaDefinition = /** @class */ function() {
                function SchemaDefinition() {
                    //
                    // TODO: use a "field" structure combining all these properties per-field.
                    //
                    this.indexes = {};
                    this.fieldsByIndex = {};
                    this.deprecated = {};
                    this.descriptors = {};
                }
                SchemaDefinition.create = function(parent) {
                    var definition = new SchemaDefinition();
                    // support inheritance
                    definition.schema = Object.assign({}, parent && parent.schema || {});
                    definition.indexes = Object.assign({}, parent && parent.indexes || {});
                    definition.fieldsByIndex = Object.assign({}, parent && parent.fieldsByIndex || {});
                    definition.descriptors = Object.assign({}, parent && parent.descriptors || {});
                    definition.deprecated = Object.assign({}, parent && parent.deprecated || {});
                    return definition;
                };
                SchemaDefinition.prototype.addField = function(field, type) {
                    var index = this.getNextFieldIndex();
                    this.fieldsByIndex[index] = field;
                    this.indexes[field] = index;
                    this.schema[field] = Array.isArray(type) ? {
                        array: type[0]
                    } : type;
                };
                SchemaDefinition.prototype.hasField = function(field) {
                    return this.indexes[field] !== undefined;
                };
                SchemaDefinition.prototype.addFilter = function(field, cb) {
                    if (!this.filters) {
                        this.filters = {};
                        this.indexesWithFilters = [];
                    }
                    this.filters[this.indexes[field]] = cb;
                    this.indexesWithFilters.push(this.indexes[field]);
                    return true;
                };
                SchemaDefinition.prototype.addChildrenFilter = function(field, cb) {
                    var index = this.indexes[field];
                    var type = this.schema[field];
                    if (getType(Object.keys(type)[0])) {
                        if (!this.childFilters) this.childFilters = {};
                        this.childFilters[index] = cb;
                        return true;
                    } else console.warn("@filterChildren: field '".concat(field, "' can't have children. Ignoring filter."));
                };
                SchemaDefinition.prototype.getChildrenFilter = function(field) {
                    return this.childFilters && this.childFilters[this.indexes[field]];
                };
                SchemaDefinition.prototype.getNextFieldIndex = function() {
                    return Object.keys(this.schema || {}).length;
                };
                return SchemaDefinition;
            }();
            function hasFilter(klass) {
                return klass._context && klass._context.useFilters;
            }
            var Context = /** @class */ function() {
                function Context() {
                    this.types = {};
                    this.schemas = new Map();
                    this.useFilters = false;
                }
                Context.prototype.has = function(schema) {
                    return this.schemas.has(schema);
                };
                Context.prototype.get = function(typeid) {
                    return this.types[typeid];
                };
                Context.prototype.add = function(schema, typeid) {
                    if (typeid === void 0) typeid = this.schemas.size;
                    // FIXME: move this to somewhere else?
                    // support inheritance
                    schema._definition = SchemaDefinition.create(schema._definition);
                    schema._typeid = typeid;
                    this.types[typeid] = schema;
                    this.schemas.set(schema, typeid);
                };
                Context.create = function(options) {
                    if (options === void 0) options = {};
                    return function(definition) {
                        if (!options.context) options.context = new Context();
                        return type(definition, options);
                    };
                };
                return Context;
            }();
            var globalContext = new Context();
            /**
         * [See documentation](https://docs.colyseus.io/state/schema/)
         *
         * Annotate a Schema property to be serializeable.
         * \@type()'d fields are automatically flagged as "dirty" for the next patch.
         *
         * @example Standard usage, with automatic change tracking.
         * ```
         * \@type("string") propertyName: string;
         * ```
         *
         * @example You can provide the "manual" option if you'd like to manually control your patches via .setDirty().
         * ```
         * \@type("string", { manual: true })
         * ```
         */ function type(type, options) {
                if (options === void 0) options = {};
                return function(target, field) {
                    var context = options.context || globalContext;
                    var constructor = target.constructor;
                    constructor._context = context;
                    if (!type) throw new Error("".concat(constructor.name, ': @type() reference provided for "').concat(field, "\" is undefined. Make sure you don't have any circular dependencies."));
                    /*
                 * static schema
                 */ if (!context.has(constructor)) context.add(constructor);
                    var definition = constructor._definition;
                    definition.addField(field, type);
                    /**
                 * skip if descriptor already exists for this field (`@deprecated()`)
                 */ if (definition.descriptors[field]) {
                        if (definition.deprecated[field]) // do not create accessors for deprecated properties.
                        return;
                        else // trying to define same property multiple times across inheritance.
                        // https://github.com/colyseus/colyseus-unity3d/issues/131#issuecomment-814308572
                        try {
                            throw new Error("@colyseus/schema: Duplicate '".concat(field, "' definition on '").concat(constructor.name, "'.\nCheck @type() annotation"));
                        } catch (e) {
                            var definitionAtLine = e.stack.split("\n")[4].trim();
                            throw new Error("".concat(e.message, " ").concat(definitionAtLine));
                        }
                    }
                    var isArray = ArraySchema.is(type);
                    var isMap = !isArray && MapSchema.is(type);
                    // TODO: refactor me.
                    // Allow abstract intermediary classes with no fields to be serialized
                    // (See "should support an inheritance with a Schema type without fields" test)
                    if (typeof type !== "string" && !Schema.is(type)) {
                        var childType = Object.values(type)[0];
                        if (typeof childType !== "string" && !context.has(childType)) context.add(childType);
                    }
                    if (options.manual) {
                        // do not declare getter/setter descriptor
                        definition.descriptors[field] = {
                            enumerable: true,
                            configurable: true,
                            writable: true
                        };
                        return;
                    }
                    var fieldCached = "_".concat(field);
                    definition.descriptors[fieldCached] = {
                        enumerable: false,
                        configurable: false,
                        writable: true
                    };
                    definition.descriptors[field] = {
                        get: function() {
                            return this[fieldCached];
                        },
                        set: function(value) {
                            /**
                         * Create Proxy for array or map items
                         */ // skip if value is the same as cached.
                            if (value === this[fieldCached]) return;
                            if (value !== undefined && value !== null) {
                                // automaticallty transform Array into ArraySchema
                                if (isArray && !(value instanceof ArraySchema)) value = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                                    void 0
                                ], value, false)))();
                                // automaticallty transform Map into MapSchema
                                if (isMap && !(value instanceof MapSchema)) value = new MapSchema(value);
                                // try to turn provided structure into a Proxy
                                if (value["$proxy"] === undefined) {
                                    if (isMap) value = getMapProxy(value);
                                    else if (isArray) value = getArrayProxy(value);
                                }
                                // flag the change for encoding.
                                this.$changes.change(field);
                                //
                                // call setParent() recursively for this and its child
                                // structures.
                                //
                                if (value["$changes"]) value["$changes"].setParent(this, this.$changes.root, this._definition.indexes[field]);
                            } else if (this[fieldCached]) //
                            // Setting a field to `null` or `undefined` will delete it.
                            //
                            this.$changes.delete(field);
                            this[fieldCached] = value;
                        },
                        enumerable: true,
                        configurable: true
                    };
                };
            }
            /**
         * `@filter()` decorator for defining data filters per client
         */ function filter(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            function filterChildren(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addChildrenFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            /**
         * `@deprecated()` flag a field as deprecated.
         * The previous `@type()` annotation should remain along with this one.
         */ function deprecated(throws) {
                if (throws === void 0) throws = true;
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    definition.deprecated[field] = true;
                    if (throws) definition.descriptors[field] = {
                        get: function() {
                            throw new Error("".concat(field, " is deprecated."));
                        },
                        set: function(value) {},
                        enumerable: false,
                        configurable: true
                    };
                };
            }
            function defineTypes(target, fields, options) {
                if (options === void 0) options = {};
                if (!options.context) options.context = target._context || options.context || globalContext;
                for(var field in fields)type(fields[field], options)(target.prototype, field);
                return target;
            }
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ /**
         * msgpack implementation highly based on notepack.io
         * https://github.com/darrachequesne/notepack
         */ function utf8Length(str) {
                var c = 0, length = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) length += 1;
                    else if (c < 0x800) length += 2;
                    else if (c < 0xd800 || c >= 0xe000) length += 3;
                    else {
                        i++;
                        length += 4;
                    }
                }
                return length;
            }
            function utf8Write(view, offset, str) {
                var c = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) view[offset++] = c;
                    else if (c < 0x800) {
                        view[offset++] = 0xc0 | c >> 6;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else if (c < 0xd800 || c >= 0xe000) {
                        view[offset++] = 0xe0 | c >> 12;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else {
                        i++;
                        c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                        view[offset++] = 0xf0 | c >> 18;
                        view[offset++] = 0x80 | c >> 12 & 0x3f;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    }
                }
            }
            function int8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function uint8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function int16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function uint16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function int32$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
                bytes.push(value >> 16 & 255);
                bytes.push(value >> 24 & 255);
            }
            function uint32$1(bytes, value) {
                var b4 = value >> 24;
                var b3 = value >> 16;
                var b2 = value >> 8;
                var b1 = value;
                bytes.push(b1 & 255);
                bytes.push(b2 & 255);
                bytes.push(b3 & 255);
                bytes.push(b4 & 255);
            }
            function int64$1(bytes, value) {
                var high = Math.floor(value / Math.pow(2, 32));
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function uint64$1(bytes, value) {
                var high = value / Math.pow(2, 32) >> 0;
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function float32$1(bytes, value) {
                writeFloat32(bytes, value);
            }
            function float64$1(bytes, value) {
                writeFloat64(bytes, value);
            }
            var _int32$1 = new Int32Array(2);
            var _float32$1 = new Float32Array(_int32$1.buffer);
            var _float64$1 = new Float64Array(_int32$1.buffer);
            function writeFloat32(bytes, value) {
                _float32$1[0] = value;
                int32$1(bytes, _int32$1[0]);
            }
            function writeFloat64(bytes, value) {
                _float64$1[0] = value;
                int32$1(bytes, _int32$1[0]);
                int32$1(bytes, _int32$1[1]);
            }
            function boolean$1(bytes, value) {
                return uint8$1(bytes, value ? 1 : 0);
            }
            function string$1(bytes, value) {
                // encode `null` strings as empty.
                if (!value) value = "";
                var length = utf8Length(value);
                var size = 0;
                // fixstr
                if (length < 0x20) {
                    bytes.push(length | 0xa0);
                    size = 1;
                } else if (length < 0x100) {
                    bytes.push(0xd9);
                    uint8$1(bytes, length);
                    size = 2;
                } else if (length < 0x10000) {
                    bytes.push(0xda);
                    uint16$1(bytes, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdb);
                    uint32$1(bytes, length);
                    size = 5;
                } else throw new Error("String too long");
                utf8Write(bytes, bytes.length, value);
                return size + length;
            }
            function number$1(bytes, value) {
                if (isNaN(value)) return number$1(bytes, 0);
                else if (!isFinite(value)) return number$1(bytes, value > 0 ? Number.MAX_SAFE_INTEGER : -Number.MAX_SAFE_INTEGER);
                else if (value !== (value | 0)) {
                    bytes.push(0xcb);
                    writeFloat64(bytes, value);
                    return 9;
                // TODO: encode float 32?
                // is it possible to differentiate between float32 / float64 here?
                // // float 32
                // bytes.push(0xca);
                // writeFloat32(bytes, value);
                // return 5;
                }
                if (value >= 0) {
                    // positive fixnum
                    if (value < 0x80) {
                        uint8$1(bytes, value);
                        return 1;
                    }
                    // uint 8
                    if (value < 0x100) {
                        bytes.push(0xcc);
                        uint8$1(bytes, value);
                        return 2;
                    }
                    // uint 16
                    if (value < 0x10000) {
                        bytes.push(0xcd);
                        uint16$1(bytes, value);
                        return 3;
                    }
                    // uint 32
                    if (value < 0x100000000) {
                        bytes.push(0xce);
                        uint32$1(bytes, value);
                        return 5;
                    }
                    // uint 64
                    bytes.push(0xcf);
                    uint64$1(bytes, value);
                    return 9;
                } else {
                    // negative fixnum
                    if (value >= -32) {
                        bytes.push(0xe0 | value + 0x20);
                        return 1;
                    }
                    // int 8
                    if (value >= -128) {
                        bytes.push(0xd0);
                        int8$1(bytes, value);
                        return 2;
                    }
                    // int 16
                    if (value >= -32768) {
                        bytes.push(0xd1);
                        int16$1(bytes, value);
                        return 3;
                    }
                    // int 32
                    if (value >= -2147483648) {
                        bytes.push(0xd2);
                        int32$1(bytes, value);
                        return 5;
                    }
                    // int 64
                    bytes.push(0xd3);
                    int64$1(bytes, value);
                    return 9;
                }
            }
            var encode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                utf8Write: utf8Write,
                int8: int8$1,
                uint8: uint8$1,
                int16: int16$1,
                uint16: uint16$1,
                int32: int32$1,
                uint32: uint32$1,
                int64: int64$1,
                uint64: uint64$1,
                float32: float32$1,
                float64: float64$1,
                writeFloat32: writeFloat32,
                writeFloat64: writeFloat64,
                boolean: boolean$1,
                string: string$1,
                number: number$1
            });
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ function utf8Read(bytes, offset, length) {
                var string = "", chr = 0;
                for(var i = offset, end = offset + length; i < end; i++){
                    var byte = bytes[i];
                    if ((byte & 0x80) === 0x00) {
                        string += String.fromCharCode(byte);
                        continue;
                    }
                    if ((byte & 0xe0) === 0xc0) {
                        string += String.fromCharCode((byte & 0x1f) << 6 | bytes[++i] & 0x3f);
                        continue;
                    }
                    if ((byte & 0xf0) === 0xe0) {
                        string += String.fromCharCode((byte & 0x0f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0);
                        continue;
                    }
                    if ((byte & 0xf8) === 0xf0) {
                        chr = (byte & 0x07) << 18 | (bytes[++i] & 0x3f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0;
                        if (chr >= 0x010000) {
                            chr -= 0x010000;
                            string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                        } else string += String.fromCharCode(chr);
                        continue;
                    }
                    console.error("Invalid byte " + byte.toString(16));
                // (do not throw error to avoid server/client from crashing due to hack attemps)
                // throw new Error('Invalid byte ' + byte.toString(16));
                }
                return string;
            }
            function int8(bytes, it) {
                return uint8(bytes, it) << 24 >> 24;
            }
            function uint8(bytes, it) {
                return bytes[it.offset++];
            }
            function int16(bytes, it) {
                return uint16(bytes, it) << 16 >> 16;
            }
            function uint16(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8;
            }
            function int32(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8 | bytes[it.offset++] << 16 | bytes[it.offset++] << 24;
            }
            function uint32(bytes, it) {
                return int32(bytes, it) >>> 0;
            }
            function float32(bytes, it) {
                return readFloat32(bytes, it);
            }
            function float64(bytes, it) {
                return readFloat64(bytes, it);
            }
            function int64(bytes, it) {
                var low = uint32(bytes, it);
                var high = int32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            function uint64(bytes, it) {
                var low = uint32(bytes, it);
                var high = uint32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            var _int32 = new Int32Array(2);
            var _float32 = new Float32Array(_int32.buffer);
            var _float64 = new Float64Array(_int32.buffer);
            function readFloat32(bytes, it) {
                _int32[0] = int32(bytes, it);
                return _float32[0];
            }
            function readFloat64(bytes, it) {
                _int32[0] = int32(bytes, it);
                _int32[1] = int32(bytes, it);
                return _float64[0];
            }
            function boolean(bytes, it) {
                return uint8(bytes, it) > 0;
            }
            function string(bytes, it) {
                var prefix = bytes[it.offset++];
                var length;
                if (prefix < 0xc0) // fixstr
                length = prefix & 0x1f;
                else if (prefix === 0xd9) length = uint8(bytes, it);
                else if (prefix === 0xda) length = uint16(bytes, it);
                else if (prefix === 0xdb) length = uint32(bytes, it);
                var value = utf8Read(bytes, it.offset, length);
                it.offset += length;
                return value;
            }
            function stringCheck(bytes, it) {
                var prefix = bytes[it.offset];
                return(// fixstr
                prefix < 0xc0 && prefix > 0xa0 || // str 8
                prefix === 0xd9 || // str 16
                prefix === 0xda || // str 32
                prefix === 0xdb);
            }
            function number(bytes, it) {
                var prefix = bytes[it.offset++];
                if (prefix < 0x80) // positive fixint
                return prefix;
                else if (prefix === 0xca) // float 32
                return readFloat32(bytes, it);
                else if (prefix === 0xcb) // float 64
                return readFloat64(bytes, it);
                else if (prefix === 0xcc) // uint 8
                return uint8(bytes, it);
                else if (prefix === 0xcd) // uint 16
                return uint16(bytes, it);
                else if (prefix === 0xce) // uint 32
                return uint32(bytes, it);
                else if (prefix === 0xcf) // uint 64
                return uint64(bytes, it);
                else if (prefix === 0xd0) // int 8
                return int8(bytes, it);
                else if (prefix === 0xd1) // int 16
                return int16(bytes, it);
                else if (prefix === 0xd2) // int 32
                return int32(bytes, it);
                else if (prefix === 0xd3) // int 64
                return int64(bytes, it);
                else if (prefix > 0xdf) // negative fixint
                return (0xff - prefix + 1) * -1;
            }
            function numberCheck(bytes, it) {
                var prefix = bytes[it.offset];
                // positive fixint - 0x00 - 0x7f
                // float 32        - 0xca
                // float 64        - 0xcb
                // uint 8          - 0xcc
                // uint 16         - 0xcd
                // uint 32         - 0xce
                // uint 64         - 0xcf
                // int 8           - 0xd0
                // int 16          - 0xd1
                // int 32          - 0xd2
                // int 64          - 0xd3
                return prefix < 0x80 || prefix >= 0xca && prefix <= 0xd3;
            }
            function arrayCheck(bytes, it) {
                return bytes[it.offset] < 0xa0;
            // const prefix = bytes[it.offset] ;
            // if (prefix < 0xa0) {
            //   return prefix;
            // // array
            // } else if (prefix === 0xdc) {
            //   it.offset += 2;
            // } else if (0xdd) {
            //   it.offset += 4;
            // }
            // return prefix;
            }
            function switchStructureCheck(bytes, it) {
                return(// previous byte should be `SWITCH_TO_STRUCTURE`
                bytes[it.offset - 1] === SWITCH_TO_STRUCTURE && // next byte should be a number
                (bytes[it.offset] < 0x80 || bytes[it.offset] >= 0xca && bytes[it.offset] <= 0xd3));
            }
            var decode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                int8: int8,
                uint8: uint8,
                int16: int16,
                uint16: uint16,
                int32: int32,
                uint32: uint32,
                float32: float32,
                float64: float64,
                int64: int64,
                uint64: uint64,
                readFloat32: readFloat32,
                readFloat64: readFloat64,
                boolean: boolean,
                string: string,
                stringCheck: stringCheck,
                number: number,
                numberCheck: numberCheck,
                arrayCheck: arrayCheck,
                switchStructureCheck: switchStructureCheck
            });
            var CollectionSchema = /** @class */ function() {
                function CollectionSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                CollectionSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                CollectionSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                CollectionSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                CollectionSchema.is = function(type) {
                    return type["collection"] !== undefined;
                };
                CollectionSchema.prototype.add = function(value) {
                    // set "index" for reference.
                    var index = this.$refId++;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index);
                    return index;
                };
                CollectionSchema.prototype.at = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                CollectionSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                CollectionSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                CollectionSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                CollectionSchema.prototype.has = function(value) {
                    return Array.from(this.$items.values()).some(function(v) {
                        return v === value;
                    });
                };
                CollectionSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                CollectionSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(CollectionSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                CollectionSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                CollectionSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                CollectionSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                CollectionSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                CollectionSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                CollectionSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                CollectionSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new CollectionSchema(), this);
                    else {
                        // server-side
                        cloned = new CollectionSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                return CollectionSchema;
            }();
            var SetSchema = /** @class */ function() {
                function SetSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                SetSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                SetSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                SetSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                SetSchema.is = function(type) {
                    return type["set"] !== undefined;
                };
                SetSchema.prototype.add = function(value) {
                    var _a, _b;
                    // immediatelly return false if value already added.
                    if (this.has(value)) return false;
                    // set "index" for reference.
                    var index = this.$refId++;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                    return index;
                };
                SetSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                SetSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                SetSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                SetSchema.prototype.has = function(value) {
                    var values = this.$items.values();
                    var has = false;
                    var entry;
                    while(entry = values.next()){
                        if (entry.done) break;
                        if (value === entry.value) {
                            has = true;
                            break;
                        }
                    }
                    return has;
                };
                SetSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                SetSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(SetSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                SetSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                SetSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                SetSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                SetSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                SetSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                SetSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                SetSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new SetSchema(), this);
                    else {
                        // server-side
                        cloned = new SetSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                return SetSchema;
            }();
            var ClientState = /** @class */ function() {
                function ClientState() {
                    this.refIds = new WeakSet();
                    this.containerIndexes = new WeakMap();
                }
                // containerIndexes = new Map<ChangeTree, Set<number>>();
                ClientState.prototype.addRefId = function(changeTree) {
                    if (!this.refIds.has(changeTree)) {
                        this.refIds.add(changeTree);
                        this.containerIndexes.set(changeTree, new Set());
                    }
                };
                ClientState.get = function(client) {
                    if (client.$filterState === undefined) client.$filterState = new ClientState();
                    return client.$filterState;
                };
                return ClientState;
            }();
            var ReferenceTracker = /** @class */ function() {
                function ReferenceTracker() {
                    //
                    // Relation of refId => Schema structure
                    // For direct access of structures during decoding time.
                    //
                    this.refs = new Map();
                    this.refCounts = {};
                    this.deletedRefs = new Set();
                    this.nextUniqueId = 0;
                }
                ReferenceTracker.prototype.getNextUniqueId = function() {
                    return this.nextUniqueId++;
                };
                // for decoding
                ReferenceTracker.prototype.addRef = function(refId, ref, incrementCount) {
                    if (incrementCount === void 0) incrementCount = true;
                    this.refs.set(refId, ref);
                    if (incrementCount) this.refCounts[refId] = (this.refCounts[refId] || 0) + 1;
                };
                // for decoding
                ReferenceTracker.prototype.removeRef = function(refId) {
                    this.refCounts[refId] = this.refCounts[refId] - 1;
                    this.deletedRefs.add(refId);
                };
                ReferenceTracker.prototype.clearRefs = function() {
                    this.refs.clear();
                    this.deletedRefs.clear();
                    this.refCounts = {};
                };
                // for decoding
                ReferenceTracker.prototype.garbageCollectDeletedRefs = function() {
                    var _this = this;
                    this.deletedRefs.forEach(function(refId) {
                        //
                        // Skip active references.
                        //
                        if (_this.refCounts[refId] > 0) return;
                        var ref = _this.refs.get(refId);
                        //
                        // Ensure child schema instances have their references removed as well.
                        //
                        if (ref instanceof Schema) {
                            for(var fieldName in ref["_definition"].schema)if (typeof ref["_definition"].schema[fieldName] !== "string" && ref[fieldName] && ref[fieldName]["$changes"]) _this.removeRef(ref[fieldName]["$changes"].refId);
                        } else {
                            var definition = ref["$changes"].parent._definition;
                            var type = definition.schema[definition.fieldsByIndex[ref["$changes"].parentIndex]];
                            if (typeof Object.values(type)[0] === "function") Array.from(ref.values()).forEach(function(child) {
                                return _this.removeRef(child["$changes"].refId);
                            });
                        }
                        _this.refs.delete(refId);
                        delete _this.refCounts[refId];
                    });
                    // clear deleted refs.
                    this.deletedRefs.clear();
                };
                return ReferenceTracker;
            }();
            var EncodeSchemaError = /** @class */ function(_super) {
                __extends(EncodeSchemaError, _super);
                function EncodeSchemaError() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return EncodeSchemaError;
            }(Error);
            function assertType(value, type, klass, field) {
                var typeofTarget;
                var allowNull = false;
                switch(type){
                    case "number":
                    case "int8":
                    case "uint8":
                    case "int16":
                    case "uint16":
                    case "int32":
                    case "uint32":
                    case "int64":
                    case "uint64":
                    case "float32":
                    case "float64":
                        typeofTarget = "number";
                        if (isNaN(value)) console.log('trying to encode "NaN" in '.concat(klass.constructor.name, "#").concat(field));
                        break;
                    case "string":
                        typeofTarget = "string";
                        allowNull = true;
                        break;
                    case "boolean":
                        // boolean is always encoded as true/false based on truthiness
                        return;
                }
                if (typeof value !== typeofTarget && (!allowNull || allowNull && value !== null)) {
                    var foundValue = "'".concat(JSON.stringify(value), "'").concat(value && value.constructor && " (".concat(value.constructor.name, ")") || "");
                    throw new EncodeSchemaError("a '".concat(typeofTarget, "' was expected, but ").concat(foundValue, " was provided in ").concat(klass.constructor.name, "#").concat(field));
                }
            }
            function assertInstanceType(value, type, klass, field) {
                if (!(value instanceof type)) throw new EncodeSchemaError("a '".concat(type.name, "' was expected, but '").concat(value.constructor.name, "' was provided in ").concat(klass.constructor.name, "#").concat(field));
            }
            function encodePrimitiveType(type, bytes, value, klass, field) {
                assertType(value, type, klass, field);
                var encodeFunc = encode[type];
                if (encodeFunc) encodeFunc(bytes, value);
                else throw new EncodeSchemaError("a '".concat(type, "' was expected, but ").concat(value, " was provided in ").concat(klass.constructor.name, "#").concat(field));
            }
            function decodePrimitiveType(type, bytes, it) {
                return decode[type](bytes, it);
            }
            /**
         * Schema encoder / decoder
         */ var Schema = /** @class */ function() {
                // allow inherited classes to have a constructor
                function Schema() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    // fix enumerability of fields for end-user
                    Object.defineProperties(this, {
                        $changes: {
                            value: new ChangeTree(this, undefined, new ReferenceTracker()),
                            enumerable: false,
                            writable: true
                        },
                        // $listeners: {
                        //     value: undefined,
                        //     enumerable: false,
                        //     writable: true
                        // },
                        $callbacks: {
                            value: undefined,
                            enumerable: false,
                            writable: true
                        }
                    });
                    var descriptors = this._definition.descriptors;
                    if (descriptors) Object.defineProperties(this, descriptors);
                    //
                    // Assign initial values
                    //
                    if (args[0]) this.assign(args[0]);
                }
                Schema.onError = function(e) {
                    console.error(e);
                };
                Schema.is = function(type) {
                    return type["_definition"] && type["_definition"].schema !== undefined;
                };
                Schema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                Schema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                Schema.prototype.assign = function(props) {
                    Object.assign(this, props);
                    return this;
                };
                Object.defineProperty(Schema.prototype, "_definition", {
                    get: function() {
                        return this.constructor._definition;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
             * (Server-side): Flag a property to be encoded for the next patch.
             * @param instance Schema instance
             * @param property string representing the property name, or number representing the index of the property.
             * @param operation OPERATION to perform (detected automatically)
             */ Schema.prototype.setDirty = function(property, operation) {
                    this.$changes.change(property, operation);
                };
                /**
             * Client-side: listen for changes on property.
             * @param prop the property name
             * @param callback callback to be triggered on property change
             * @param immediate trigger immediatelly if property has been already set.
             */ Schema.prototype.listen = function(prop, callback, immediate) {
                    var _this = this;
                    if (immediate === void 0) immediate = true;
                    if (!this.$callbacks) this.$callbacks = {};
                    if (!this.$callbacks[prop]) this.$callbacks[prop] = [];
                    this.$callbacks[prop].push(callback);
                    if (immediate && this[prop] !== undefined) callback(this[prop], undefined);
                    // return un-register callback.
                    return function() {
                        return spliceOne(_this.$callbacks[prop], _this.$callbacks[prop].indexOf(callback));
                    };
                };
                Schema.prototype.decode = function(bytes, it, ref) {
                    var _a;
                    if (it === void 0) it = {
                        offset: 0
                    };
                    if (ref === void 0) ref = this;
                    var allChanges = [];
                    var $root = this.$changes.root;
                    var totalBytes = bytes.length;
                    var refId = 0;
                    $root.refs.set(refId, this);
                    while(it.offset < totalBytes){
                        var byte = bytes[it.offset++];
                        if (byte == SWITCH_TO_STRUCTURE) {
                            refId = number(bytes, it);
                            var nextRef = $root.refs.get(refId);
                            //
                            // Trying to access a reference that haven't been decoded yet.
                            //
                            if (!nextRef) throw new Error('"refId" not found: '.concat(refId));
                            ref = nextRef;
                            continue;
                        }
                        var changeTree = ref["$changes"];
                        var isSchema = ref["_definition"] !== undefined;
                        var operation = isSchema ? byte >> 6 << 6 // "compressed" index + operation
                         : byte; // "uncompressed" index + operation (array/map items)
                        if (operation === exports1.OPERATION.CLEAR) {
                            //
                            // TODO: refactor me!
                            // The `.clear()` method is calling `$root.removeRef(refId)` for
                            // each item inside this collection
                            //
                            ref.clear(allChanges);
                            continue;
                        }
                        var fieldIndex = isSchema ? byte % (operation || 255 // if "REPLACE" operation (0), use 255
                        ) : number(bytes, it);
                        var fieldName = isSchema ? ref["_definition"].fieldsByIndex[fieldIndex] : "";
                        var type = changeTree.getType(fieldIndex);
                        var value = void 0;
                        var previousValue = void 0;
                        var dynamicIndex = void 0;
                        if (!isSchema) {
                            previousValue = ref["getByIndex"](fieldIndex);
                            if ((operation & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) {
                                dynamicIndex = ref instanceof MapSchema ? string(bytes, it) : fieldIndex;
                                ref["setIndex"](fieldIndex, dynamicIndex);
                            } else // here
                            dynamicIndex = ref["getIndex"](fieldIndex);
                        } else previousValue = ref["_".concat(fieldName)];
                        //
                        // Delete operations
                        //
                        if ((operation & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE) {
                            if (operation !== exports1.OPERATION.DELETE_AND_ADD) ref["deleteByIndex"](fieldIndex);
                            // Flag `refId` for garbage collection.
                            if (previousValue && previousValue["$changes"]) $root.removeRef(previousValue["$changes"].refId);
                            value = null;
                        }
                        if (fieldName === undefined) {
                            console.warn("@colyseus/schema: definition mismatch");
                            //
                            // keep skipping next bytes until reaches a known structure
                            // by local decoder.
                            //
                            var nextIterator = {
                                offset: it.offset
                            };
                            while(it.offset < totalBytes){
                                if (switchStructureCheck(bytes, it)) {
                                    nextIterator.offset = it.offset + 1;
                                    if ($root.refs.has(number(bytes, nextIterator))) break;
                                }
                                it.offset++;
                            }
                            continue;
                        } else if (operation === exports1.OPERATION.DELETE) ;
                        else if (Schema.is(type)) {
                            var refId_1 = number(bytes, it);
                            value = $root.refs.get(refId_1);
                            if (operation !== exports1.OPERATION.REPLACE) {
                                var childType = this.getSchemaType(bytes, it, type);
                                if (!value) {
                                    value = this.createTypeInstance(childType);
                                    value.$changes.refId = refId_1;
                                    if (previousValue) {
                                        value.$callbacks = previousValue.$callbacks;
                                        // value.$listeners = previousValue.$listeners;
                                        if (previousValue["$changes"].refId && refId_1 !== previousValue["$changes"].refId) $root.removeRef(previousValue["$changes"].refId);
                                    }
                                }
                                $root.addRef(refId_1, value, value !== previousValue);
                            }
                        } else if (typeof type === "string") //
                        // primitive value (number, string, boolean, etc)
                        //
                        value = decodePrimitiveType(type, bytes, it);
                        else {
                            var typeDef = getType(Object.keys(type)[0]);
                            var refId_2 = number(bytes, it);
                            var valueRef = $root.refs.has(refId_2) ? previousValue || $root.refs.get(refId_2) : new typeDef.constructor();
                            value = valueRef.clone(true);
                            value.$changes.refId = refId_2;
                            // preserve schema callbacks
                            if (previousValue) {
                                value["$callbacks"] = previousValue["$callbacks"];
                                if (previousValue["$changes"].refId && refId_2 !== previousValue["$changes"].refId) {
                                    $root.removeRef(previousValue["$changes"].refId);
                                    //
                                    // Trigger onRemove if structure has been replaced.
                                    //
                                    var entries = previousValue.entries();
                                    var iter = void 0;
                                    while((iter = entries.next()) && !iter.done){
                                        var key = (_a = iter.value, _a[0]), value_1 = _a[1];
                                        allChanges.push({
                                            refId: refId_2,
                                            op: exports1.OPERATION.DELETE,
                                            field: key,
                                            value: undefined,
                                            previousValue: value_1
                                        });
                                    }
                                }
                            }
                            $root.addRef(refId_2, value, valueRef !== previousValue);
                        }
                        if (value !== null && value !== undefined) {
                            if (value["$changes"]) value["$changes"].setParent(changeTree.ref, changeTree.root, fieldIndex);
                            if (ref instanceof Schema) ref[fieldName] = value;
                            else if (ref instanceof MapSchema) {
                                // const key = ref['$indexes'].get(field);
                                var key = dynamicIndex;
                                // ref.set(key, value);
                                ref["$items"].set(key, value);
                                ref["$changes"].allChanges.add(fieldIndex);
                            } else if (ref instanceof ArraySchema) // const key = ref['$indexes'][field];
                            // console.log("SETTING FOR ArraySchema =>", { field, key, value });
                            // ref[key] = value;
                            ref.setAt(fieldIndex, value);
                            else if (ref instanceof CollectionSchema) {
                                var index = ref.add(value);
                                ref["setIndex"](fieldIndex, index);
                            } else if (ref instanceof SetSchema) {
                                var index = ref.add(value);
                                if (index !== false) ref["setIndex"](fieldIndex, index);
                            }
                        }
                        if (previousValue !== value) allChanges.push({
                            refId: refId,
                            op: operation,
                            field: fieldName,
                            dynamicIndex: dynamicIndex,
                            value: value,
                            previousValue: previousValue
                        });
                    }
                    this._triggerChanges(allChanges);
                    // drop references of unused schemas
                    $root.garbageCollectDeletedRefs();
                    return allChanges;
                };
                Schema.prototype.encode = function(encodeAll, bytes, useFilters) {
                    if (encodeAll === void 0) encodeAll = false;
                    if (bytes === void 0) bytes = [];
                    if (useFilters === void 0) useFilters = false;
                    var rootChangeTree = this.$changes;
                    var refIdsVisited = new WeakSet();
                    var changeTrees = [
                        rootChangeTree
                    ];
                    var numChangeTrees = 1;
                    for(var i = 0; i < numChangeTrees; i++){
                        var changeTree = changeTrees[i];
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        // Generate unique refId for the ChangeTree.
                        changeTree.ensureRefId();
                        // mark this ChangeTree as visited.
                        refIdsVisited.add(changeTree);
                        // root `refId` is skipped.
                        if (changeTree !== rootChangeTree && (changeTree.changed || encodeAll)) {
                            uint8$1(bytes, SWITCH_TO_STRUCTURE);
                            number$1(bytes, changeTree.refId);
                        }
                        var changes = encodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var operation = encodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            var fieldIndex = operation.index;
                            var field = isSchema ? ref["_definition"].fieldsByIndex && ref["_definition"].fieldsByIndex[fieldIndex] : fieldIndex;
                            // cache begin index if `useFilters`
                            var beginIndex = bytes.length;
                            // encode field index + operation
                            if (operation.op !== exports1.OPERATION.TOUCH) {
                                if (isSchema) //
                                // Compress `fieldIndex` + `operation` into a single byte.
                                // This adds a limitaion of 64 fields per Schema structure
                                //
                                uint8$1(bytes, fieldIndex | operation.op);
                                else {
                                    uint8$1(bytes, operation.op);
                                    // custom operations
                                    if (operation.op === exports1.OPERATION.CLEAR) continue;
                                    // indexed operations
                                    number$1(bytes, fieldIndex);
                                }
                            }
                            //
                            // encode "alias" for dynamic fields (maps)
                            //
                            if (!isSchema && (operation.op & exports1.OPERATION.ADD) == exports1.OPERATION.ADD // ADD or DELETE_AND_ADD
                            ) {
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(bytes, dynamicIndex);
                                }
                            }
                            if (operation.op === exports1.OPERATION.DELETE) continue;
                            // const type = changeTree.childType || ref._schema[field];
                            var type = changeTree.getType(fieldIndex);
                            // const type = changeTree.getType(fieldIndex);
                            var value = changeTree.getValue(fieldIndex);
                            // Enqueue ChangeTree to be visited
                            if (value && value["$changes"] && !refIdsVisited.has(value["$changes"])) {
                                changeTrees.push(value["$changes"]);
                                value["$changes"].ensureRefId();
                                numChangeTrees++;
                            }
                            if (operation.op === exports1.OPERATION.TOUCH) continue;
                            if (Schema.is(type)) {
                                assertInstanceType(value, type, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                                // Try to encode inherited TYPE_ID if it's an ADD operation.
                                if ((operation.op & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) this.tryEncodeTypeId(bytes, type, value.constructor);
                            } else if (typeof type === "string") //
                            // Primitive values
                            //
                            encodePrimitiveType(type, bytes, value, ref, field);
                            else {
                                //
                                // Custom type (MapSchema, ArraySchema, etc)
                                //
                                var definition = getType(Object.keys(type)[0]);
                                //
                                // ensure a ArraySchema has been provided
                                //
                                assertInstanceType(ref["_".concat(field)], definition.constructor, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                            }
                            if (useFilters) // cache begin / end index
                            changeTree.cache(fieldIndex, bytes.slice(beginIndex));
                        }
                        if (!encodeAll && !useFilters) changeTree.discard();
                    }
                    return bytes;
                };
                Schema.prototype.encodeAll = function(useFilters) {
                    return this.encode(true, [], useFilters);
                };
                Schema.prototype.applyFilters = function(client, encodeAll) {
                    var _a, _b;
                    if (encodeAll === void 0) encodeAll = false;
                    var root = this;
                    var refIdsDissallowed = new Set();
                    var $filterState = ClientState.get(client);
                    var changeTrees = [
                        this.$changes
                    ];
                    var numChangeTrees = 1;
                    var filteredBytes = [];
                    var _loop_1 = function(i) {
                        var changeTree = changeTrees[i];
                        if (refIdsDissallowed.has(changeTree.refId)) return "continue";
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        uint8$1(filteredBytes, SWITCH_TO_STRUCTURE);
                        number$1(filteredBytes, changeTree.refId);
                        var clientHasRefId = $filterState.refIds.has(changeTree);
                        var isEncodeAll = encodeAll || !clientHasRefId;
                        // console.log("REF:", ref.constructor.name);
                        // console.log("Encode all?", isEncodeAll);
                        //
                        // include `changeTree` on list of known refIds by this client.
                        //
                        $filterState.addRefId(changeTree);
                        var containerIndexes = $filterState.containerIndexes.get(changeTree);
                        var changes = isEncodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        //
                        // WORKAROUND: tries to re-evaluate previously not included @filter() attributes
                        // - see "DELETE a field of Schema" test case.
                        //
                        if (!encodeAll && isSchema && ref._definition.indexesWithFilters) {
                            var indexesWithFilters = ref._definition.indexesWithFilters;
                            indexesWithFilters.forEach(function(indexWithFilter) {
                                if (!containerIndexes.has(indexWithFilter) && changeTree.allChanges.has(indexWithFilter)) {
                                    if (isEncodeAll) changes.push(indexWithFilter);
                                    else changes.push({
                                        op: exports1.OPERATION.ADD,
                                        index: indexWithFilter
                                    });
                                }
                            });
                        }
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var change = isEncodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            // custom operations
                            if (change.op === exports1.OPERATION.CLEAR) {
                                uint8$1(filteredBytes, change.op);
                                continue;
                            }
                            var fieldIndex = change.index;
                            //
                            // Deleting fields: encode the operation + field index
                            //
                            if (change.op === exports1.OPERATION.DELETE) {
                                //
                                // DELETE operations also need to go through filtering.
                                //
                                // TODO: cache the previous value so we can access the value (primitive or `refId`)
                                // (check against `$filterState.refIds`)
                                //
                                if (isSchema) uint8$1(filteredBytes, change.op | fieldIndex);
                                else {
                                    uint8$1(filteredBytes, change.op);
                                    number$1(filteredBytes, fieldIndex);
                                }
                                continue;
                            }
                            // indexed operation
                            var value = changeTree.getValue(fieldIndex);
                            var type = changeTree.getType(fieldIndex);
                            if (isSchema) {
                                // Is a Schema!
                                var filter = ref._definition.filters && ref._definition.filters[fieldIndex];
                                if (filter && !filter.call(ref, client, value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            } else {
                                // Is a collection! (map, array, etc.)
                                var parent = changeTree.parent;
                                var filter = changeTree.getChildrenFilter();
                                if (filter && !filter.call(parent, client, ref["$indexes"].get(fieldIndex), value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            }
                            // visit child ChangeTree on further iteration.
                            if (value["$changes"]) {
                                changeTrees.push(value["$changes"]);
                                numChangeTrees++;
                            }
                            //
                            // Copy cached bytes
                            //
                            if (change.op !== exports1.OPERATION.TOUCH) {
                                //
                                // TODO: refactor me!
                                //
                                if (change.op === exports1.OPERATION.ADD || isSchema) {
                                    //
                                    // use cached bytes directly if is from Schema type.
                                    //
                                    filteredBytes.push.apply(filteredBytes, (_a = changeTree.caches[fieldIndex]) !== null && _a !== void 0 ? _a : []);
                                    containerIndexes.add(fieldIndex);
                                } else if (containerIndexes.has(fieldIndex)) //
                                // use cached bytes if already has the field
                                //
                                filteredBytes.push.apply(filteredBytes, (_b = changeTree.caches[fieldIndex]) !== null && _b !== void 0 ? _b : []);
                                else {
                                    //
                                    // force ADD operation if field is not known by this client.
                                    //
                                    containerIndexes.add(fieldIndex);
                                    uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                    number$1(filteredBytes, fieldIndex);
                                    if (ref instanceof MapSchema) {
                                        //
                                        // MapSchema dynamic key
                                        //
                                        var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                        string$1(filteredBytes, dynamicIndex);
                                    }
                                    if (value["$changes"]) number$1(filteredBytes, value["$changes"].refId);
                                    else // "encodePrimitiveType" without type checking.
                                    // the type checking has been done on the first .encode() call.
                                    encode[type](filteredBytes, value);
                                }
                            } else if (value["$changes"] && !isSchema) {
                                //
                                // TODO:
                                // - track ADD/REPLACE/DELETE instances on `$filterState`
                                // - do NOT always encode dynamicIndex for MapSchema.
                                //   (If client already has that key, only the first index is necessary.)
                                //
                                uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                number$1(filteredBytes, fieldIndex);
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(filteredBytes, dynamicIndex);
                                }
                                number$1(filteredBytes, value["$changes"].refId);
                            }
                        }
                    };
                    for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                    return filteredBytes;
                };
                Schema.prototype.clone = function() {
                    var _a;
                    var cloned = new this.constructor;
                    var schema = this._definition.schema;
                    for(var field in schema)if (typeof this[field] === "object" && typeof ((_a = this[field]) === null || _a === void 0 ? void 0 : _a.clone) === "function") // deep clone
                    cloned[field] = this[field].clone();
                    else // primitive values
                    cloned[field] = this[field];
                    return cloned;
                };
                Schema.prototype.toJSON = function() {
                    var schema = this._definition.schema;
                    var deprecated = this._definition.deprecated;
                    var obj = {};
                    for(var field in schema)if (!deprecated[field] && this[field] !== null && typeof this[field] !== "undefined") obj[field] = typeof this[field]["toJSON"] === "function" ? this[field]["toJSON"]() : this["_".concat(field)];
                    return obj;
                };
                Schema.prototype.discardAllChanges = function() {
                    this.$changes.discardAll();
                };
                Schema.prototype.getByIndex = function(index) {
                    return this[this._definition.fieldsByIndex[index]];
                };
                Schema.prototype.deleteByIndex = function(index) {
                    this[this._definition.fieldsByIndex[index]] = undefined;
                };
                Schema.prototype.tryEncodeTypeId = function(bytes, type, targetType) {
                    if (type._typeid !== targetType._typeid) {
                        uint8$1(bytes, TYPE_ID);
                        number$1(bytes, targetType._typeid);
                    }
                };
                Schema.prototype.getSchemaType = function(bytes, it, defaultType) {
                    var type;
                    if (bytes[it.offset] === TYPE_ID) {
                        it.offset++;
                        type = this.constructor._context.get(number(bytes, it));
                    }
                    return type || defaultType;
                };
                Schema.prototype.createTypeInstance = function(type) {
                    var instance = new type();
                    // assign root on $changes
                    instance.$changes.root = this.$changes.root;
                    return instance;
                };
                Schema.prototype._triggerChanges = function(changes) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    var uniqueRefIds = new Set();
                    var $refs = this.$changes.root.refs;
                    var _loop_2 = function(i) {
                        var change = changes[i];
                        var refId = change.refId;
                        var ref = $refs.get(refId);
                        var $callbacks = ref["$callbacks"];
                        //
                        // trigger onRemove on child structure.
                        //
                        if ((change.op & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE && change.previousValue instanceof Schema) (_b = (_a = change.previousValue["$callbacks"]) === null || _a === void 0 ? void 0 : _a[exports1.OPERATION.DELETE]) === null || _b === void 0 || _b.forEach(function(callback) {
                            return callback();
                        });
                        // no callbacks defined, skip this structure!
                        if (!$callbacks) return "continue";
                        if (ref instanceof Schema) {
                            if (!uniqueRefIds.has(refId)) try {
                                // trigger onChange
                                (_c = $callbacks === null || $callbacks === void 0 ? void 0 : $callbacks[exports1.OPERATION.REPLACE]) === null || _c === void 0 || _c.forEach(function(callback) {
                                    return callback(changes);
                                });
                            } catch (e) {
                                Schema.onError(e);
                            }
                            try {
                                if ($callbacks.hasOwnProperty(change.field)) (_d = $callbacks[change.field]) === null || _d === void 0 || _d.forEach(function(callback) {
                                    return callback(change.value, change.previousValue);
                                });
                            } catch (e) {
                                Schema.onError(e);
                            }
                        } else {
                            // is a collection of items
                            if (change.op === exports1.OPERATION.ADD && change.previousValue === undefined) // triger onAdd
                            (_e = $callbacks[exports1.OPERATION.ADD]) === null || _e === void 0 || _e.forEach(function(callback) {
                                var _a;
                                return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                            });
                            else if (change.op === exports1.OPERATION.DELETE) //
                            // FIXME: `previousValue` should always be available.
                            // ADD + DELETE operations are still encoding DELETE operation.
                            //
                            {
                                if (change.previousValue !== undefined) // triger onRemove
                                (_f = $callbacks[exports1.OPERATION.DELETE]) === null || _f === void 0 || _f.forEach(function(callback) {
                                    var _a;
                                    return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                            } else if (change.op === exports1.OPERATION.DELETE_AND_ADD) {
                                // triger onRemove
                                if (change.previousValue !== undefined) (_g = $callbacks[exports1.OPERATION.DELETE]) === null || _g === void 0 || _g.forEach(function(callback) {
                                    var _a;
                                    return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                                // triger onAdd
                                (_h = $callbacks[exports1.OPERATION.ADD]) === null || _h === void 0 || _h.forEach(function(callback) {
                                    var _a;
                                    return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                            }
                            // trigger onChange
                            if (change.value !== change.previousValue) (_j = $callbacks[exports1.OPERATION.REPLACE]) === null || _j === void 0 || _j.forEach(function(callback) {
                                var _a;
                                return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                            });
                        }
                        uniqueRefIds.add(refId);
                    };
                    for(var i = 0; i < changes.length; i++)_loop_2(i);
                };
                Schema._definition = SchemaDefinition.create();
                return Schema;
            }();
            function dumpChanges(schema) {
                var changeTrees = [
                    schema["$changes"]
                ];
                var numChangeTrees = 1;
                var dump = {};
                var currentStructure = dump;
                var _loop_1 = function(i) {
                    var changeTree = changeTrees[i];
                    changeTree.changes.forEach(function(change) {
                        var ref = changeTree.ref;
                        var fieldIndex = change.index;
                        var field = ref["_definition"] ? ref["_definition"].fieldsByIndex[fieldIndex] : ref["$indexes"].get(fieldIndex);
                        currentStructure[field] = changeTree.getValue(fieldIndex);
                    });
                };
                for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                return dump;
            }
            var reflectionContext = {
                context: new Context()
            };
            /**
         * Reflection
         */ var ReflectionField = /** @class */ function(_super) {
                __extends(ReflectionField, _super);
                function ReflectionField() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "name", void 0);
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "type", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionField.prototype, "referencedType", void 0);
                return ReflectionField;
            }(Schema);
            var ReflectionType = /** @class */ function(_super) {
                __extends(ReflectionType, _super);
                function ReflectionType() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.fields = new ArraySchema();
                    return _this;
                }
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionType.prototype, "id", void 0);
                __decorate([
                    type([
                        ReflectionField
                    ], reflectionContext)
                ], ReflectionType.prototype, "fields", void 0);
                return ReflectionType;
            }(Schema);
            var Reflection = /** @class */ function(_super) {
                __extends(Reflection, _super);
                function Reflection() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.types = new ArraySchema();
                    return _this;
                }
                Reflection.encode = function(instance) {
                    var rootSchemaType = instance.constructor;
                    var reflection = new Reflection();
                    reflection.rootType = rootSchemaType._typeid;
                    var buildType = function(currentType, schema) {
                        for(var fieldName in schema){
                            var field = new ReflectionField();
                            field.name = fieldName;
                            var fieldType = void 0;
                            if (typeof schema[fieldName] === "string") fieldType = schema[fieldName];
                            else {
                                var type_1 = schema[fieldName];
                                var childTypeSchema = void 0;
                                //
                                // TODO: refactor below.
                                //
                                if (Schema.is(type_1)) {
                                    fieldType = "ref";
                                    childTypeSchema = schema[fieldName];
                                } else {
                                    fieldType = Object.keys(type_1)[0];
                                    if (typeof type_1[fieldType] === "string") fieldType += ":" + type_1[fieldType]; // array:string
                                    else childTypeSchema = type_1[fieldType];
                                }
                                field.referencedType = childTypeSchema ? childTypeSchema._typeid : -1;
                            }
                            field.type = fieldType;
                            currentType.fields.push(field);
                        }
                        reflection.types.push(currentType);
                    };
                    var types = rootSchemaType._context.types;
                    for(var typeid in types){
                        var type_2 = new ReflectionType();
                        type_2.id = Number(typeid);
                        buildType(type_2, types[typeid]._definition.schema);
                    }
                    return reflection.encodeAll();
                };
                Reflection.decode = function(bytes, it) {
                    var context = new Context();
                    var reflection = new Reflection();
                    reflection.decode(bytes, it);
                    var schemaTypes = reflection.types.reduce(function(types, reflectionType) {
                        var schema = /** @class */ function(_super) {
                            __extends(_, _super);
                            function _() {
                                return _super !== null && _super.apply(this, arguments) || this;
                            }
                            return _;
                        }(Schema);
                        var typeid = reflectionType.id;
                        types[typeid] = schema;
                        context.add(schema, typeid);
                        return types;
                    }, {});
                    reflection.types.forEach(function(reflectionType) {
                        var schemaType = schemaTypes[reflectionType.id];
                        reflectionType.fields.forEach(function(field) {
                            var _a;
                            if (field.referencedType !== undefined) {
                                var fieldType = field.type;
                                var refType = schemaTypes[field.referencedType];
                                // map or array of primitive type (-1)
                                if (!refType) {
                                    var typeInfo = field.type.split(":");
                                    fieldType = typeInfo[0];
                                    refType = typeInfo[1];
                                }
                                if (fieldType === "ref") type(refType, {
                                    context: context
                                })(schemaType.prototype, field.name);
                                else type((_a = {}, _a[fieldType] = refType, _a), {
                                    context: context
                                })(schemaType.prototype, field.name);
                            } else type(field.type, {
                                context: context
                            })(schemaType.prototype, field.name);
                        });
                    });
                    var rootType = schemaTypes[reflection.rootType];
                    var rootInstance = new rootType();
                    /**
                 * auto-initialize referenced types on root type
                 * to allow registering listeners immediatelly on client-side
                 */ for(var fieldName in rootType._definition.schema){
                        var fieldType = rootType._definition.schema[fieldName];
                        if (typeof fieldType !== "string") rootInstance[fieldName] = typeof fieldType === "function" ? new fieldType() // is a schema reference
                         : new (getType(Object.keys(fieldType)[0])).constructor(); // is a "collection"
                    }
                    return rootInstance;
                };
                __decorate([
                    type([
                        ReflectionType
                    ], reflectionContext)
                ], Reflection.prototype, "types", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], Reflection.prototype, "rootType", void 0);
                return Reflection;
            }(Schema);
            registerType("map", {
                constructor: MapSchema
            });
            registerType("array", {
                constructor: ArraySchema
            });
            registerType("set", {
                constructor: SetSchema
            });
            registerType("collection", {
                constructor: CollectionSchema
            });
            exports1.ArraySchema = ArraySchema;
            exports1.CollectionSchema = CollectionSchema;
            exports1.Context = Context;
            exports1.MapSchema = MapSchema;
            exports1.Reflection = Reflection;
            exports1.ReflectionField = ReflectionField;
            exports1.ReflectionType = ReflectionType;
            exports1.Schema = Schema;
            exports1.SchemaDefinition = SchemaDefinition;
            exports1.SetSchema = SetSchema;
            exports1.decode = decode;
            exports1.defineTypes = defineTypes;
            exports1.deprecated = deprecated;
            exports1.dumpChanges = dumpChanges;
            exports1.encode = encode;
            exports1.filter = filter;
            exports1.filterChildren = filterChildren;
            exports1.hasFilter = hasFilter;
            exports1.registerType = registerType;
            exports1.type = type;
            Object.defineProperty(exports1, "__esModule", {
                value: true
            });
        });
    });
    var Room = /** @class */ function() {
        function Room(name, rootSchema) {
            var _this = this;
            // Public signals
            this.onStateChange = createSignal();
            this.onError = createSignal();
            this.onLeave = createSignal();
            this.onJoin = createSignal();
            this.hasJoined = false;
            this.onMessageHandlers = createNanoEvents();
            this.roomId = null;
            this.name = name;
            if (rootSchema) {
                this.serializer = new (getSerializer("schema"));
                this.rootSchema = rootSchema;
                this.serializer.state = new rootSchema();
            }
            this.onError(function(code, message) {
                var _a;
                return (_a = console.warn) === null || _a === void 0 ? void 0 : _a.call(console, "colyseus.js - onError => (".concat(code, ") ").concat(message));
            });
            this.onLeave(function() {
                return _this.removeAllListeners();
            });
        }
        Object.defineProperty(Room.prototype, "id", {
            // TODO: deprecate me on version 1.0
            get: function() {
                return this.roomId;
            },
            enumerable: false,
            configurable: true
        });
        Room.prototype.connect = function(endpoint, devModeCloseCallback, room // when reconnecting on devMode, re-use previous room intance for handling events.
        ) {
            if (room === void 0) room = this;
            var connection = new Connection();
            room.connection = connection;
            connection.events.onmessage = Room.prototype.onMessageCallback.bind(room);
            connection.events.onclose = function(e) {
                var _a;
                if (!room.hasJoined) {
                    (_a = console.warn) === null || _a === void 0 || _a.call(console, "Room connection was closed unexpectedly (".concat(e.code, "): ").concat(e.reason));
                    room.onError.invoke(e.code, e.reason);
                    return;
                }
                if (e.code === CloseCode.DEVMODE_RESTART && devModeCloseCallback) devModeCloseCallback();
                else {
                    room.onLeave.invoke(e.code);
                    room.destroy();
                }
            };
            connection.events.onerror = function(e) {
                var _a;
                (_a = console.warn) === null || _a === void 0 || _a.call(console, "Room, onError (".concat(e.code, "): ").concat(e.reason));
                room.onError.invoke(e.code, e.reason);
            };
            connection.connect(endpoint);
        };
        Room.prototype.leave = function(consented) {
            var _this = this;
            if (consented === void 0) consented = true;
            return new Promise(function(resolve) {
                _this.onLeave(function(code) {
                    return resolve(code);
                });
                if (_this.connection) {
                    if (consented) _this.connection.send([
                        exports1.Protocol.LEAVE_ROOM
                    ]);
                    else _this.connection.close();
                } else _this.onLeave.invoke(CloseCode.CONSENTED);
            });
        };
        Room.prototype.onMessage = function(type, callback) {
            return this.onMessageHandlers.on(this.getMessageHandlerKey(type), callback);
        };
        Room.prototype.send = function(type, message) {
            var initialBytes = [
                exports1.Protocol.ROOM_DATA
            ];
            if (typeof type === "string") umd.encode.string(initialBytes, type);
            else umd.encode.number(initialBytes, type);
            var arr;
            if (message !== undefined) {
                var encoded = encode(message);
                arr = new Uint8Array(initialBytes.length + encoded.byteLength);
                arr.set(new Uint8Array(initialBytes), 0);
                arr.set(new Uint8Array(encoded), initialBytes.length);
            } else arr = new Uint8Array(initialBytes);
            this.connection.send(arr.buffer);
        };
        Room.prototype.sendBytes = function(type, bytes) {
            var initialBytes = [
                exports1.Protocol.ROOM_DATA_BYTES
            ];
            if (typeof type === "string") umd.encode.string(initialBytes, type);
            else umd.encode.number(initialBytes, type);
            var arr;
            arr = new Uint8Array(initialBytes.length + (bytes.byteLength || bytes.length));
            arr.set(new Uint8Array(initialBytes), 0);
            arr.set(new Uint8Array(bytes), initialBytes.length);
            this.connection.send(arr.buffer);
        };
        Object.defineProperty(Room.prototype, "state", {
            get: function() {
                return this.serializer.getState();
            },
            enumerable: false,
            configurable: true
        });
        Room.prototype.removeAllListeners = function() {
            this.onJoin.clear();
            this.onStateChange.clear();
            this.onError.clear();
            this.onLeave.clear();
            this.onMessageHandlers.events = {};
        };
        Room.prototype.onMessageCallback = function(event) {
            var bytes = Array.from(new Uint8Array(event.data));
            var code = bytes[0];
            if (code === exports1.Protocol.JOIN_ROOM) {
                var offset = 1;
                var reconnectionToken = utf8Read(bytes, offset);
                offset += utf8Length(reconnectionToken);
                this.serializerId = utf8Read(bytes, offset);
                offset += utf8Length(this.serializerId);
                // Instantiate serializer if not locally available.
                if (!this.serializer) {
                    var serializer = getSerializer(this.serializerId);
                    this.serializer = new serializer();
                }
                if (bytes.length > offset && this.serializer.handshake) this.serializer.handshake(bytes, {
                    offset: offset
                });
                this.reconnectionToken = "".concat(this.roomId, ":").concat(reconnectionToken);
                this.hasJoined = true;
                this.onJoin.invoke();
                // acknowledge successfull JOIN_ROOM
                this.connection.send([
                    exports1.Protocol.JOIN_ROOM
                ]);
            } else if (code === exports1.Protocol.ERROR) {
                var it_1 = {
                    offset: 1
                };
                var code_1 = umd.decode.number(bytes, it_1);
                var message = umd.decode.string(bytes, it_1);
                this.onError.invoke(code_1, message);
            } else if (code === exports1.Protocol.LEAVE_ROOM) this.leave();
            else if (code === exports1.Protocol.ROOM_DATA_SCHEMA) {
                var it_2 = {
                    offset: 1
                };
                var context_1 = this.serializer.getState().constructor._context;
                var type = context_1.get(umd.decode.number(bytes, it_2));
                var message = new type();
                message.decode(bytes, it_2);
                this.dispatchMessage(type, message);
            } else if (code === exports1.Protocol.ROOM_STATE) {
                bytes.shift(); // drop `code` byte
                this.setState(bytes);
            } else if (code === exports1.Protocol.ROOM_STATE_PATCH) {
                bytes.shift(); // drop `code` byte
                this.patch(bytes);
            } else if (code === exports1.Protocol.ROOM_DATA) {
                var it_3 = {
                    offset: 1
                };
                var type = umd.decode.stringCheck(bytes, it_3) ? umd.decode.string(bytes, it_3) : umd.decode.number(bytes, it_3);
                var message = bytes.length > it_3.offset ? decode(event.data, it_3.offset) : undefined;
                this.dispatchMessage(type, message);
            } else if (code === exports1.Protocol.ROOM_DATA_BYTES) {
                var it_4 = {
                    offset: 1
                };
                var type = umd.decode.stringCheck(bytes, it_4) ? umd.decode.string(bytes, it_4) : umd.decode.number(bytes, it_4);
                this.dispatchMessage(type, new Uint8Array(bytes.slice(it_4.offset)));
            }
        };
        Room.prototype.setState = function(encodedState) {
            this.serializer.setState(encodedState);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.patch = function(binaryPatch) {
            this.serializer.patch(binaryPatch);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.dispatchMessage = function(type, message) {
            var _a;
            var messageType = this.getMessageHandlerKey(type);
            if (this.onMessageHandlers.events[messageType]) this.onMessageHandlers.emit(messageType, message);
            else if (this.onMessageHandlers.events["*"]) this.onMessageHandlers.emit("*", type, message);
            else (_a = console.warn) === null || _a === void 0 || _a.call(console, "colyseus.js: onMessage() not registered for type '".concat(type, "'."));
        };
        Room.prototype.destroy = function() {
            if (this.serializer) this.serializer.teardown();
        };
        Room.prototype.getMessageHandlerKey = function(type) {
            switch(typeof type){
                // typeof Schema
                case "function":
                    return "$".concat(type._typeid);
                // string
                case "string":
                    return type;
                // number
                case "number":
                    return "i".concat(type);
                default:
                    throw new Error("invalid message type.");
            }
        };
        return Room;
    }();
    function apply(src, tar) {
        tar.statusMessage = src.statusText;
        tar.statusCode = src.status;
        tar.data = src.body;
    }
    function send(method, uri, opts) {
        opts = opts || {};
        var timer, ctrl, tmp = opts.body;
        opts.method = method;
        opts.headers = opts.headers || {};
        if (tmp instanceof FormData) ;
        else if (tmp && typeof tmp == "object") {
            opts.headers["content-type"] = "application/json";
            opts.body = JSON.stringify(tmp);
        }
        if (opts.withCredentials) opts.credentials = "include";
        if (opts.timeout) {
            ctrl = new AbortController;
            opts.signal = ctrl.signal;
            timer = setTimeout(ctrl.abort, opts.timeout);
        }
        return new Promise((res, rej)=>{
            fetch(uri, opts).then((rr, reply)=>{
                clearTimeout(timer);
                apply(rr, rr); //=> rr.headers
                reply = rr.status >= 400 ? rej : res;
                tmp = rr.headers.get("content-type");
                if (!tmp || !~tmp.indexOf("application/json")) reply(rr);
                else rr.text().then((str)=>{
                    try {
                        rr.data = JSON.parse(str, opts.reviver);
                        reply(rr);
                    } catch (err) {
                        err.headers = rr.headers;
                        apply(rr, err);
                        rej(err);
                    }
                });
            }).catch((err)=>{
                err.timeout = ctrl && ctrl.signal.aborted;
                rej(err);
            });
        });
    }
    var get = /*#__PURE__*/ send.bind(send, "GET");
    var post = /*#__PURE__*/ send.bind(send, "POST");
    var patch = /*#__PURE__*/ send.bind(send, "PATCH");
    var del = /*#__PURE__*/ send.bind(send, "DELETE");
    var put = /*#__PURE__*/ send.bind(send, "PUT");
    var del_1 = del;
    var get_1 = get;
    var patch_1 = patch;
    var post_1 = post;
    var put_1 = put;
    var send_1 = send;
    var fetch_1 = {
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    };
    var httpie = /*#__PURE__*/ _mergeNamespaces({
        __proto__: null,
        "default": fetch_1,
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    }, [
        fetch_1
    ]);
    var HTTP = /** @class */ function() {
        function HTTP(client) {
            this.client = client;
        }
        HTTP.prototype.get = function(path, options) {
            if (options === void 0) options = {};
            return this.request("get", path, options);
        };
        HTTP.prototype.post = function(path, options) {
            if (options === void 0) options = {};
            return this.request("post", path, options);
        };
        HTTP.prototype.del = function(path, options) {
            if (options === void 0) options = {};
            return this.request("del", path, options);
        };
        HTTP.prototype.put = function(path, options) {
            if (options === void 0) options = {};
            return this.request("put", path, options);
        };
        HTTP.prototype.request = function(method, path, options) {
            if (options === void 0) options = {};
            return httpie[method](this.client["getHttpEndpoint"](path), this.getOptions(options)).catch(function(e) {
                var _a;
                throw new ServerError(e.statusCode || -1, ((_a = e.data) === null || _a === void 0 ? void 0 : _a.error) || e.statusMessage || e.message || "offline");
            });
        };
        HTTP.prototype.getOptions = function(options) {
            if (this.authToken) {
                if (!options.headers) options.headers = {};
                options.headers["Authorization"] = "Bearer ".concat(this.authToken);
                options.withCredentials = true;
            }
            return options;
        };
        return HTTP;
    }();
    /// <reference path="../typings/cocos-creator.d.ts" />
    /**
     * We do not assign 'storage' to window.localStorage immediatelly for React
     * Native compatibility. window.localStorage is not present when this module is
     * loaded.
     */ var storage;
    function getStorage() {
        if (!storage) try {
            storage = typeof cc !== "undefined" && cc.sys && cc.sys.localStorage ? cc.sys.localStorage // compatibility with cocos creator
             : window.localStorage; // RN does have window object at this point, but localStorage is not defined
        } catch (e) {
        // ignore error
        }
        if (!storage) // mock localStorage if not available (Node.js or RN environment)
        storage = {
            cache: {},
            setItem: function(key, value) {
                this.cache[key] = value;
            },
            getItem: function(key) {
                this.cache[key];
            },
            removeItem: function(key) {
                delete this.cache[key];
            }
        };
        return storage;
    }
    function setItem(key, value) {
        getStorage().setItem(key, value);
    }
    function removeItem(key) {
        getStorage().removeItem(key);
    }
    function getItem(key, callback) {
        var value = getStorage().getItem(key);
        if (typeof Promise === "undefined" || // old browsers
        !(value instanceof Promise)) // browser has synchronous return
        callback(value);
        else // react-native is asynchronous
        value.then(function(id) {
            return callback(id);
        });
    }
    var _Auth__initialized, _Auth__initializationPromise, _Auth__signInWindow, _Auth__events;
    var Auth = /** @class */ function() {
        function Auth(http) {
            var _this = this;
            this.http = http;
            this.settings = {
                path: "/auth",
                key: "colyseus-auth-token"
            };
            _Auth__initialized.set(this, false);
            _Auth__initializationPromise.set(this, void 0);
            _Auth__signInWindow.set(this, undefined);
            _Auth__events.set(this, createNanoEvents());
            getItem(this.settings.key, function(token) {
                return _this.token = token;
            });
        }
        Object.defineProperty(Auth.prototype, "token", {
            get: function() {
                return this.http.authToken;
            },
            set: function(token) {
                this.http.authToken = token;
            },
            enumerable: false,
            configurable: true
        });
        Auth.prototype.onChange = function(callback) {
            var _this = this;
            var unbindChange = __classPrivateFieldGet(this, _Auth__events, "f").on("change", callback);
            if (!__classPrivateFieldGet(this, _Auth__initialized, "f")) __classPrivateFieldSet(this, _Auth__initializationPromise, new Promise(function(resolve, reject) {
                _this.getUserData().then(function(userData) {
                    _this.emitChange(__assign(__assign({}, userData), {
                        token: _this.token
                    }));
                }).catch(function(e) {
                    // user is not logged in, or service is down
                    _this.emitChange({
                        user: null,
                        token: undefined
                    });
                }).finally(function() {
                    resolve();
                });
            }), "f");
            __classPrivateFieldSet(this, _Auth__initialized, true, "f");
            return unbindChange;
        };
        Auth.prototype.getUserData = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!this.token) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.http.get("".concat(this.settings.path, "/userdata"))
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                        case 2:
                            throw new Error("missing auth.token");
                    }
                });
            });
        };
        Auth.prototype.registerWithEmailAndPassword = function(email, password, options) {
            return __awaiter(this, void 0, void 0, function() {
                var data;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("".concat(this.settings.path, "/register"), {
                                    body: {
                                        email: email,
                                        password: password,
                                        options: options
                                    }
                                })
                            ];
                        case 1:
                            data = _a.sent().data;
                            this.emitChange(data);
                            return [
                                2 /*return*/ ,
                                data
                            ];
                    }
                });
            });
        };
        Auth.prototype.signInWithEmailAndPassword = function(email, password) {
            return __awaiter(this, void 0, void 0, function() {
                var data;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("".concat(this.settings.path, "/login"), {
                                    body: {
                                        email: email,
                                        password: password
                                    }
                                })
                            ];
                        case 1:
                            data = _a.sent().data;
                            this.emitChange(data);
                            return [
                                2 /*return*/ ,
                                data
                            ];
                    }
                });
            });
        };
        Auth.prototype.signInAnonymously = function(options) {
            return __awaiter(this, void 0, void 0, function() {
                var data;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("".concat(this.settings.path, "/anonymous"), {
                                    body: {
                                        options: options
                                    }
                                })
                            ];
                        case 1:
                            data = _a.sent().data;
                            this.emitChange(data);
                            return [
                                2 /*return*/ ,
                                data
                            ];
                    }
                });
            });
        };
        Auth.prototype.sendPasswordResetEmail = function(email) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("".concat(this.settings.path, "/forgot-password"), {
                                    body: {
                                        email: email
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Auth.prototype.signInWithProvider = function(providerName, settings) {
            if (settings === void 0) settings = {};
            return __awaiter(this, void 0, void 0, function() {
                var _this = this;
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var w = settings.width || 480;
                            var h = settings.height || 768;
                            // forward existing token for upgrading
                            var upgradingToken = _this.token ? "?token=".concat(_this.token) : "";
                            // Capitalize first letter of providerName
                            var title = "Login with ".concat(providerName[0].toUpperCase() + providerName.substring(1));
                            var url = _this.http["client"]["getHttpEndpoint"]("".concat(settings.prefix || "".concat(_this.settings.path, "/provider"), "/").concat(providerName).concat(upgradingToken));
                            var left = screen.width / 2 - w / 2;
                            var top = screen.height / 2 - h / 2;
                            __classPrivateFieldSet(_this, _Auth__signInWindow, window.open(url, title, "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left), "f");
                            var onMessage = function(event) {
                                // TODO: it is a good idea to check if event.origin can be trusted!
                                // if (event.origin.indexOf(window.location.hostname) === -1) { return; }
                                // require 'user' and 'token' inside received data.
                                if (event.data.user === undefined && event.data.token === undefined) return;
                                clearInterval(rejectionChecker);
                                __classPrivateFieldGet(_this, _Auth__signInWindow, "f").close();
                                __classPrivateFieldSet(_this, _Auth__signInWindow, undefined, "f");
                                window.removeEventListener("message", onMessage);
                                if (event.data.error !== undefined) reject(event.data.error);
                                else {
                                    resolve(event.data);
                                    _this.emitChange(event.data);
                                }
                            };
                            var rejectionChecker = setInterval(function() {
                                if (!__classPrivateFieldGet(_this, _Auth__signInWindow, "f") || __classPrivateFieldGet(_this, _Auth__signInWindow, "f").closed) {
                                    __classPrivateFieldSet(_this, _Auth__signInWindow, undefined, "f");
                                    reject("cancelled");
                                    window.removeEventListener("message", onMessage);
                                }
                            }, 200);
                            window.addEventListener("message", onMessage);
                        })
                    ];
                });
            });
        };
        Auth.prototype.signOut = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.emitChange({
                        user: null,
                        token: null
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        Auth.prototype.emitChange = function(authData) {
            if (authData.token !== undefined) {
                this.token = authData.token;
                if (authData.token === null) removeItem(this.settings.key);
                else // store key in localStorage
                setItem(this.settings.key, authData.token);
            }
            __classPrivateFieldGet(this, _Auth__events, "f").emit("change", authData);
        };
        return Auth;
    }();
    _Auth__initialized = new WeakMap(), _Auth__initializationPromise = new WeakMap(), _Auth__signInWindow = new WeakMap(), _Auth__events = new WeakMap();
    var _a;
    var MatchMakeError = /** @class */ function(_super) {
        __extends(MatchMakeError, _super);
        function MatchMakeError(message, code) {
            var _this = _super.call(this, message) || this;
            _this.code = code;
            Object.setPrototypeOf(_this, MatchMakeError.prototype);
            return _this;
        }
        return MatchMakeError;
    }(Error);
    // - React Native does not provide `window.location`
    // - Cocos Creator (Native) does not provide `window.location.hostname`
    var DEFAULT_ENDPOINT = typeof window !== "undefined" && typeof ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) !== "undefined" ? "".concat(window.location.protocol.replace("http", "ws"), "//").concat(window.location.hostname).concat(window.location.port && ":".concat(window.location.port)) : "ws://127.0.0.1:2567";
    var Client = /** @class */ function() {
        function Client(settings) {
            if (settings === void 0) settings = DEFAULT_ENDPOINT;
            if (typeof settings === "string") {
                //
                // endpoint by url
                //
                var url = new URL(settings);
                var secure = url.protocol === "https:" || url.protocol === "wss:";
                var port = Number(url.port || (secure ? 443 : 80));
                this.settings = {
                    hostname: url.hostname,
                    pathname: url.pathname,
                    port: port,
                    secure: secure
                };
            } else {
                //
                // endpoint by settings
                //
                if (settings.port === undefined) settings.port = settings.secure ? 443 : 80;
                if (settings.pathname === undefined) settings.pathname = "";
                this.settings = settings;
            }
            // make sure pathname does not end with "/"
            if (this.settings.pathname.endsWith("/")) this.settings.pathname = this.settings.pathname.slice(0, -1);
            this.http = new HTTP(this);
            this.auth = new Auth(this.http);
        }
        Client.prototype.joinOrCreate = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinOrCreate", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.create = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("create", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.join = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("join", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.joinById = function(roomId, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinById", roomId, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        /**
         * Re-establish connection with a room this client was previously connected to.
         *
         * @param reconnectionToken The `room.reconnectionToken` from previously connected room.
         * @param rootSchema (optional) Concrete root schema definition
         * @returns Promise<Room>
         */ Client.prototype.reconnect = function(reconnectionToken, rootSchema) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, roomId, token;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (typeof reconnectionToken === "string" && typeof rootSchema === "string") throw new Error("DEPRECATED: .reconnect() now only accepts 'reconnectionToken' as argument.\nYou can get this token from previously connected `room.reconnectionToken`");
                            _a = reconnectionToken.split(":"), roomId = _a[0], token = _a[1];
                            if (!roomId || !token) throw new Error("Invalid reconnection token format.\nThe format should be roomId:reconnectionToken");
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("reconnect", roomId, {
                                    reconnectionToken: token
                                }, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _b.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.getAvailableRooms = function(roomName) {
            if (roomName === void 0) roomName = "";
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.get("matchmake/".concat(roomName), {
                                    headers: {
                                        "Accept": "application/json"
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Client.prototype.consumeSeatReservation = function(response, rootSchema, reuseRoomInstance // used in devMode
        ) {
            return __awaiter(this, void 0, void 0, function() {
                var room, options, targetRoom;
                var _this = this;
                return __generator(this, function(_a) {
                    room = this.createRoom(response.room.name, rootSchema);
                    room.roomId = response.room.roomId;
                    room.sessionId = response.sessionId;
                    options = {
                        sessionId: room.sessionId
                    };
                    // forward "reconnection token" in case of reconnection.
                    if (response.reconnectionToken) options.reconnectionToken = response.reconnectionToken;
                    targetRoom = reuseRoomInstance || room;
                    room.connect(this.buildEndpoint(response.room, options), response.devMode && function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var retryCount, retryMaxRetries, retryReconnection;
                            var _this = this;
                            return __generator(this, function(_a) {
                                console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x1F504), " Re-establishing connection with room id '").concat(room.roomId, "'...")); // 🔄
                                retryCount = 0;
                                retryMaxRetries = 8;
                                retryReconnection = function() {
                                    return __awaiter(_this, void 0, void 0, function() {
                                        return __generator(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    retryCount++;
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.consumeSeatReservation(response, rootSchema, targetRoom)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x2705), " Successfully re-established connection with room '").concat(room.roomId, "'")); // ✅
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    _a.sent();
                                                    if (retryCount < retryMaxRetries) {
                                                        console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x1F504), " retrying... (").concat(retryCount, " out of ").concat(retryMaxRetries, ")")); // 🔄
                                                        setTimeout(retryReconnection, 2000);
                                                    } else console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x274C), " Failed to reconnect. Is your server running? Please check server logs.")); // ❌
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 4:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                };
                                setTimeout(retryReconnection, 2000);
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    }, targetRoom);
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var onError = function(code, message) {
                                return reject(new ServerError(code, message));
                            };
                            targetRoom.onError.once(onError);
                            targetRoom["onJoin"].once(function() {
                                targetRoom.onError.remove(onError);
                                resolve(targetRoom);
                            });
                        })
                    ];
                });
            });
        };
        Client.prototype.createMatchMakeRequest = function(method, roomName, options, rootSchema, reuseRoomInstance) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                var response;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("matchmake/".concat(method, "/").concat(roomName), {
                                    headers: {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify(options)
                                })
                            ];
                        case 1:
                            response = _a.sent().data;
                            // FIXME: HTTP class is already handling this as ServerError.
                            if (response.error) throw new MatchMakeError(response.error, response.code);
                            // forward reconnection token during "reconnect" methods.
                            if (method === "reconnect") response.reconnectionToken = options.reconnectionToken;
                            return [
                                4 /*yield*/ ,
                                this.consumeSeatReservation(response, rootSchema, reuseRoomInstance)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.createRoom = function(roomName, rootSchema) {
            return new Room(roomName, rootSchema);
        };
        Client.prototype.buildEndpoint = function(room, options) {
            if (options === void 0) options = {};
            var params = [];
            // append provided options
            for(var name_1 in options){
                if (!options.hasOwnProperty(name_1)) continue;
                params.push("".concat(name_1, "=").concat(options[name_1]));
            }
            var endpoint = this.settings.secure ? "wss://" : "ws://";
            if (room.publicAddress) endpoint += "".concat(room.publicAddress);
            else endpoint += "".concat(this.settings.hostname).concat(this.getEndpointPort()).concat(this.settings.pathname);
            return "".concat(endpoint, "/").concat(room.processId, "/").concat(room.roomId, "?").concat(params.join("&"));
        };
        Client.prototype.getHttpEndpoint = function(segments) {
            if (segments === void 0) segments = "";
            var path = segments.startsWith("/") ? segments : "/".concat(segments);
            return "".concat(this.settings.secure ? "https" : "http", "://").concat(this.settings.hostname).concat(this.getEndpointPort()).concat(this.settings.pathname).concat(path);
        };
        Client.prototype.getEndpointPort = function() {
            return this.settings.port !== 80 && this.settings.port !== 443 ? ":".concat(this.settings.port) : "";
        };
        return Client;
    }();
    var SchemaSerializer = /** @class */ function() {
        function SchemaSerializer() {}
        SchemaSerializer.prototype.setState = function(rawState) {
            return this.state.decode(rawState);
        };
        SchemaSerializer.prototype.getState = function() {
            return this.state;
        };
        SchemaSerializer.prototype.patch = function(patches) {
            return this.state.decode(patches);
        };
        SchemaSerializer.prototype.teardown = function() {
            var _a, _b;
            (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a["$changes"]) === null || _b === void 0 || _b.root.clearRefs();
        };
        SchemaSerializer.prototype.handshake = function(bytes, it) {
            if (this.state) {
                // TODO: validate client/server definitinos
                var reflection = new umd.Reflection();
                reflection.decode(bytes, it);
            } else // initialize reflected state from server
            this.state = umd.Reflection.decode(bytes, it);
        };
        return SchemaSerializer;
    }();
    var NoneSerializer = /** @class */ function() {
        function NoneSerializer() {}
        NoneSerializer.prototype.setState = function(rawState) {};
        NoneSerializer.prototype.getState = function() {
            return null;
        };
        NoneSerializer.prototype.patch = function(patches) {};
        NoneSerializer.prototype.teardown = function() {};
        NoneSerializer.prototype.handshake = function(bytes) {};
        return NoneSerializer;
    }();
    registerSerializer("schema", SchemaSerializer);
    registerSerializer("none", NoneSerializer);
    exports1.Auth = Auth;
    exports1.Client = Client;
    exports1.Room = Room;
    exports1.SchemaSerializer = SchemaSerializer;
    exports1.registerSerializer = registerSerializer;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



function $db66ba7ef0c12961$export$c176e62365027b8f() {
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).scene("menu", ()=>{
        $db66ba7ef0c12961$var$loadScreenAssets();
        location.hash = "";
        // Add background
        $db66ba7ef0c12961$export$3dd7623ec89fddaf();
        // Add logo
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("logo"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.2),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            "host-btn"
        ]);
        // Add host button
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("button"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).center()),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            "host-btn"
        ]);
        const hostText = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("HOST", {
                size: 60
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).center()),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center")
        ]);
        const clickListener = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onClick("host-btn", ()=>{
            clickListener.cancel();
            hostText.text = "Connecting ...";
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).play("destroyed");
            (0, $ad2bcec7a0192558$export$388e0302ca0d9a41).create("my_room").then((room)=>{
                console.log(room.sessionId, "joined", room.name, room.id);
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).play("bg-music", {
                    volume: 0.3,
                    loop: true
                });
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).go("host-waiting", room);
            }).catch((e)=>{
                console.log("JOIN ERROR", e);
            });
        });
        // Credits Text: Bernard
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("Made by FireredPlays", {
                size: 42
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.8),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).color((0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLUE),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            "credit-text-fireredplays"
        ]);
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onClick("credit-text-fireredplays", ()=>{
            window.open("https://www.youtube.com/fireredplays", "_blank").focus();
        });
        // Credits Text: Graphics
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("Graphics by GameDeveloperStudio", {
                size: 32
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.8 + 42),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).color((0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLUE),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            "credit-text-graphics"
        ]);
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onClick("credit-text-graphics", ()=>{
            window.open("https://www.gamedeveloperstudio.com/", "_blank").focus();
        });
        // Credits Text: Music
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("Music by Clement Panchout", {
                size: 32
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.8 + 84),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).color((0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLUE),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            "credit-text-clement"
        ]);
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onClick("credit-text-clement", ()=>{
            window.open("https://www.clementpanchout.com", "_blank").focus();
        });
    });
}


















function $db66ba7ef0c12961$var$loadScreenAssets() {
    // Load background
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("cloud-bg", (parcelRequire("dMrst")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("midground_mountains", (parcelRequire("5fPAV")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("mid_ground_cloud_1", (parcelRequire("hzI90")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("farground_cloud_1", (parcelRequire("lFo5J")));
    // Load bullet
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("bullet1", (parcelRequire("l6Gsm")));
    // Load planes
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("plane_1_Blue", (parcelRequire("4b9q4")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("plane_2_Blue", (parcelRequire("gMZyJ")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("plane_3_Blue", (parcelRequire("h8hLB")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("plane_1_Red", (parcelRequire("eu2SF")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("plane_2_Red", (parcelRequire("6lz8J")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("plane_3_Red", (parcelRequire("do74n")));
    // Load explosion spritesheet
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("explosion", (parcelRequire("hBAKe")), {
        sliceX: 3,
        sliceY: 3,
        anims: {
            explode: {
                from: 0,
                to: 8,
                speed: 24
            }
        }
    });
    // Load smoke effects
    let smokeOpt = {
        sliceX: 5,
        sliceY: 3,
        anims: {
            explode: {
                from: 0,
                to: 14,
                speed: 24,
                loop: true
            }
        }
    };
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("white-smoke", (parcelRequire("ikgU7")), smokeOpt);
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("black-smoke", (parcelRequire("6ZeC8")), smokeOpt);
    // Load required sounds
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSound("destroyed", (parcelRequire("b51Pn")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSound("player-joined", (parcelRequire("5TVnK")));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSound("bg-music", (parcelRequire("4V4tw")));
    // Load logo
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("logo", (parcelRequire("4qKe5")));
}
function $db66ba7ef0c12961$export$3dd7623ec89fddaf() {
    const SPEED = 100;
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).setBackground(65, 217, 255);
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("farground_cloud_1"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(0, 40),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).z(0)
    ]);
    // Mid Cloud
    const midGroundCloud1 = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("mid_ground_cloud_1"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(0, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() - 900),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).move(0, -SPEED),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).z(0)
    ]);
    const midGroundCloud2 = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("mid_ground_cloud_1"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(2048, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() - 900),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).move(0, -SPEED),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).z(0)
    ]);
    midGroundCloud1.onUpdate(midResetBg.bind(midGroundCloud1));
    midGroundCloud2.onUpdate(midResetBg.bind(midGroundCloud2));
    function midResetBg() {
        if (this.pos.x <= -2048) this.pos.x = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width();
    }
    // Top cloud
    const cloud1 = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("cloud-bg"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(0, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() - 474),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).move(0, SPEED),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).z(0)
    ]);
    const cloud2 = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("cloud-bg"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(-2048, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() - 474),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).move(0, SPEED),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).z(0)
    ]);
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("midground_mountains"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(0, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() - 119),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).z(0)
    ]);
    cloud1.onUpdate(resetBg.bind(cloud1));
    cloud2.onUpdate(resetBg.bind(cloud2));
    function resetBg() {
        if (this.pos.x > (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width()) this.pos.x = -2048;
    }
}





const $3bb57e0082fd26be$var$PLAYER_MAX_HEALTH = 30;
const $3bb57e0082fd26be$var$BULLET_INTERVAL = 0.2;
let $3bb57e0082fd26be$var$killfeeds = [];
function $3bb57e0082fd26be$export$24987696a9498776() {
    let players = {};
    $3bb57e0082fd26be$var$killfeeds = [];
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).scene("gameplay", (room)=>{
        // Reset player
        players = {};
        // Add background
        (0, $db66ba7ef0c12961$export$3dd7623ec89fddaf)();
        // Spawn player
        let indexTeam0 = 0;
        let indexTeam1 = 0;
        room.state.players.forEach((player, sessionId)=>{
            // Add player plane
            const playerSprite = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
                // List of components, each offers a set of functionalities
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite(`plane_${player.spriteId}_${$3bb57e0082fd26be$export$778eb3b71add413c(player.teamId)}`, {
                    flipX: player.teamId != 0
                }),
                player.teamId == 0 ? (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(100, 200 + 150 * indexTeam0++) : (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() - 100, 200 + 150 * indexTeam1++),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).health($3bb57e0082fd26be$var$PLAYER_MAX_HEALTH),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).rotate(0),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).z(2),
                "player",
                `team${player.teamId}`,
                {
                    username: player.name,
                    smokeSpawnTimer: 0
                }
            ]);
            // Add player name
            const playerText = playerSprite.add([
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text(player.name, {
                    size: 12
                }),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(0, 0),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center")
            ]);
            // Set default velocity
            playerSprite.onUpdate(()=>{
                let serverPlayer = room.state.players.get(sessionId);
                let localPlayer = players[sessionId];
                const speed = 300;
                const angleSpeed = 90;
                if (serverPlayer == null) return;
                // Move forward constantly
                if (serverPlayer.teamId == 0) playerSprite.pos = playerSprite.pos.add((0, $ad2bcec7a0192558$export$342063e11d6c3cad).Vec2.fromAngle(playerSprite.angle).scale(speed * (0, $ad2bcec7a0192558$export$342063e11d6c3cad).dt()));
                else playerSprite.pos = playerSprite.pos.sub((0, $ad2bcec7a0192558$export$342063e11d6c3cad).Vec2.fromAngle(playerSprite.angle).scale(speed * (0, $ad2bcec7a0192558$export$342063e11d6c3cad).dt()));
                // Update angle based on movement
                if (localPlayer.movement != 0) playerSprite.angle -= angleSpeed * (serverPlayer.teamId == 0 ? localPlayer.movement : -localPlayer.movement) * (0, $ad2bcec7a0192558$export$342063e11d6c3cad).dt();
                // Shooting
                localPlayer.bulletTimer += (0, $ad2bcec7a0192558$export$342063e11d6c3cad).dt();
                if (localPlayer.isShooting && localPlayer.bulletTimer > $3bb57e0082fd26be$var$BULLET_INTERVAL && serverPlayer.bulletLeft > 0) {
                    $3bb57e0082fd26be$var$createProjectile(playerSprite.pos.x, playerSprite.pos.y, serverPlayer.teamId == 0 ? playerSprite.angle : (playerSprite.angle - 180) % 360, serverPlayer.teamId == 0 ? "team1" : "team0", serverPlayer.name);
                    localPlayer.bulletTimer = 0;
                    room.send("minus-bullet", sessionId);
                }
                /* BOUNDS */ // When reaches end, restart at 0
                if (playerSprite.pos.x > (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width()) playerSprite.pos.x = 0;
                else if (playerSprite.pos.x < 0) playerSprite.pos.x = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width();
                if (playerSprite.pos.y > (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() || playerSprite.pos.y < 0) {
                    $3bb57e0082fd26be$var$killfeeds.push([
                        undefined,
                        serverPlayer.name
                    ]);
                    $3bb57e0082fd26be$var$addMessage(`${serverPlayer.name} crashed!`);
                    playerSprite.hurt(100);
                }
                /* SMOKE EFFECT appear when HP is low */ playerSprite.smokeSpawnTimer += (0, $ad2bcec7a0192558$export$342063e11d6c3cad).dt();
                if (playerSprite.hp() <= $3bb57e0082fd26be$var$PLAYER_MAX_HEALTH * 0.5 && playerSprite.smokeSpawnTimer >= 0.05) {
                    playerSprite.smokeSpawnTimer = 0;
                    $3bb57e0082fd26be$var$addSmoke(playerSprite.pos, playerSprite.hp() <= $3bb57e0082fd26be$var$PLAYER_MAX_HEALTH * 0.2 ? "black" : "white");
                }
            });
            playerSprite.on("death", ()=>{
                room.send("controller-game-over", sessionId);
                $3bb57e0082fd26be$var$addExplosion(playerSprite.pos);
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).destroy(playerSprite);
                delete players[sessionId];
                // Check if there are still existing plane, if not, we send screen-game-over message.
                let team0Count = countPlayersByTeamId(0);
                let team1Count = countPlayersByTeamId(1);
                if (team0Count == 0 && team1Count == 0) room.send("screen-game-over", {
                    winnerId: -1,
                    killfeeds: $3bb57e0082fd26be$var$killfeeds
                });
                else if (team0Count == 0) room.send("screen-game-over", {
                    winnerId: 1,
                    killfeeds: $3bb57e0082fd26be$var$killfeeds
                });
                else if (team1Count == 0) room.send("screen-game-over", {
                    winnerId: 0,
                    killfeeds: $3bb57e0082fd26be$var$killfeeds
                });
            });
            // Add to list of player objects
            players[sessionId] = {
                playerSprite: playerSprite,
                playerText: playerText,
                movement: 0,
                isShooting: false,
                bulletTimer: $3bb57e0082fd26be$var$BULLET_INTERVAL,
                teamId: player.teamId
            };
        });
        room.onMessage("movement-change", (message)=>{
            let senderId = message.senderId;
            let movement = message.movement;
            players[senderId].movement = movement;
        });
        room.onMessage("shooting-change", (message)=>{
            let senderId = message.senderId;
            let isShooting = message.isShooting;
            players[senderId].isShooting = isShooting;
        });
        room.onMessage("screen-game-over", (winnerId)=>{
            room.removeAllListeners();
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).go("screen-game-over-scene", room, winnerId);
        });
        room.onMessage("player-left", (playerId)=>{
            players[playerId].playerSprite.hurt(100);
        });
    });
    function countPlayersByTeamId(teamId) {
        return Object.values(players).reduce((count, player)=>{
            if (player.teamId === teamId) count++;
            return count;
        }, 0);
    }
}
function $3bb57e0082fd26be$var$createProjectile(x, y, angle, targetTag, ownerName) {
    const BULLET_SPEED = 2200;
    const projectile = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("bullet1"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(x, y),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).move(angle, BULLET_SPEED),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).rotate(angle),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).offscreen({
            destroy: true
        }),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).z(1)
    ]);
    projectile.onCollide(targetTag, (target)=>{
        const DAMAGE = 1;
        $3bb57e0082fd26be$var$addExplosion(projectile.pos, 0.3);
        // Check if target will be destoryed on this shot?
        if (target.hp() <= DAMAGE) {
            $3bb57e0082fd26be$var$killfeeds.push([
                ownerName,
                target.username
            ]);
            $3bb57e0082fd26be$var$addMessage(`${ownerName} destroyed ${target.username}'s plane!`);
        }
        // Damage target
        target.hurt(DAMAGE);
        // Delete projectile
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).destroy(projectile);
    });
}
function $3bb57e0082fd26be$var$addMessage(message) {
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text(message, {
            size: 48
        }),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.15),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).color(255, 120, 60),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).lifespan(2),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).move(-90, 60)
    ]);
}
function $3bb57e0082fd26be$export$778eb3b71add413c(teamId) {
    return teamId == 0 ? "Blue" : "Red";
}
function $3bb57e0082fd26be$var$addExplosion(pos, scale = 1) {
    // k.addKaboom(pos);
    const explosive = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("explosion", {
            anim: "explode"
        }),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(pos),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).scale(scale),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).stay()
    ]);
    explosive.onAnimEnd(()=>{
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).destroy(explosive);
    });
}
function $3bb57e0082fd26be$var$addSmoke(pos, color) {
    const smoke = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite(`${color}-smoke`, {
            anim: "explode"
        }),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(pos.x, pos.y + 10),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).opacity(1),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).scale(0.7),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).lifespan(1.2, {
            fade: 1
        })
    ]);
}



function $aff5493c4b0f6dcb$export$a8fc8cdbeb17e167() {
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).scene("host-waiting", (room)=>{
        // Add background
        (0, $db66ba7ef0c12961$export$3dd7623ec89fddaf)();
        // Set URL hash
        location.hash = room.id;
        $aff5493c4b0f6dcb$var$showQRCode();
        // Initial show (before new state come)
        $aff5493c4b0f6dcb$var$showLoadedPlayers(room);
        // Whenever state change
        const controllerStateChange = room.onStateChange((state)=>{
            console.log(room.name, "has new state:", state);
            // Remove all rendered player first
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).destroyAll("waiting-ui");
            // Show loaded players
            $aff5493c4b0f6dcb$var$showLoadedPlayers(room);
        });
        room.onMessage("start-game", ()=>{
            controllerStateChange.clear();
            room.removeAllListeners();
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).go("gameplay", room);
        });
    });
}

function $aff5493c4b0f6dcb$var$showQRCode() {
    const qrcode = (parcelRequire("3v9yr"));
    // Add QR Code
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).loadSprite("qr_code", qrcode("airparty.app/" + window.location.hash));
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("qr_code"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).center()),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).scale(0.75, 0.75),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
        "qr_code"
    ]);
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("SCAN TO JOIN", {
            size: 60
        }),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2 - 220)),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).color(0, 0, 0)
    ]);
    // For easier debugging on phone
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onClick("qr_code", ()=>{
        window.open(window.location.href, "mywindow" + Math.random().toString(16).slice(2), "menubar=1,resizable=1,width=360,height=720").focus();
    });
}
let $aff5493c4b0f6dcb$var$loadedPlayers = 0;
function $aff5493c4b0f6dcb$var$showLoadedPlayers(room) {
    // Loop through the array of players
    let indexTeam0 = 0;
    let indexTeam1 = 0;
    room.state.players.forEach((player, sessionId)=>{
        // Add player plane
        const playerSprite = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            // List of components, each offers a set of functionalities
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite(`plane_${player.spriteId}_${(0, $3bb57e0082fd26be$export$778eb3b71add413c)(player.teamId)}`, {
                flipX: player.teamId != 0
            }),
            player.teamId == 0 ? (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(100, 200 + 150 * indexTeam0++) : (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() - 100, 200 + 150 * indexTeam1++),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).health(8),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).rotate(0),
            "waiting-ui"
        ]);
        // Add player name
        playerSprite.add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text(player.name, {
                size: 12
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(0, 0),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            "waiting-ui"
        ]);
        // Show ready state
        if (!player.isHost) playerSprite.add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text(player.ready ? "READY" : "NOT READY", {
                size: 12
            }),
            player.ready ? (0, $ad2bcec7a0192558$export$342063e11d6c3cad).color(0, 255, 0) : (0, $ad2bcec7a0192558$export$342063e11d6c3cad).color(255, 0, 0),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(0, 20),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            "waiting-ui"
        ]);
        else playerSprite.add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("HOST", {
                size: 12
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).color(0, 255, 0),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos(0, 20),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            "waiting-ui"
        ]);
    });
    // Play sound when new player join
    if ($aff5493c4b0f6dcb$var$loadedPlayers < indexTeam0 + indexTeam1) (0, $ad2bcec7a0192558$export$342063e11d6c3cad).play("player-joined");
    $aff5493c4b0f6dcb$var$loadedPlayers = indexTeam0 + indexTeam1;
}



function $80724bba80cf29f0$export$950db519dcdb75ac() {
    let currentMovement = 0;
    let isShooting = false;
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).scene("controller", (room)=>{
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).setBackground(40, 30, 90);
        let gameStarted = false;
        let player = room.state.players.get(room.sessionId);
        let playerName = player != null ? player.name : room.sessionId;
        // Add ready button
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("button"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).center()),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            "ready-btn",
            "ready-ui"
        ]);
        const readyText = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text(player != null && player.isHost ? "START" : "READY", {
                size: 60
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).center()),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            "ready-ui"
        ]);
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onClick("ready-btn", ()=>{
            if (!player) return;
            // If player, we switch from ready to unready.
            if (!player.isHost) room.send("ready", readyText.text == "READY");
            else {
                for (const playerId of room.state.players){
                    const player = room.state.players[playerId[0]];
                    if (!player.ready) {
                        alert("Not all players ready!");
                        return;
                    }
                }
                // All player ready, start the game
                room.send("start-game");
            }
        });
        // Keep updating player state
        room.onStateChange((_state)=>{
            player = _state.players.get(room.sessionId);
            if (!player) return;
            // Update readyText based on player.ready
            readyText.text = player.ready ? "UNREADY" : "READY";
            // If is host, and text is default ("READY"/"UNREADY"), then we need to change to "START"
            if (player.isHost && readyText.text != "START") readyText.text = "START";
        });
        room.onMessage("start-game", ()=>{
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).destroyAll("ready-ui");
            gameStarted = true;
            room.onMessage("controller-game-over", (winnerId = null)=>{
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).go("controller-game-over-scene", room, winnerId);
            });
        });
        // Add rename button
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("button"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2 + 200),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            "rename-btn",
            "ready-ui"
        ]);
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("RENAME", {
                size: 60
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2 + 200),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            "ready-ui"
        ]);
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onClick("rename-btn", ()=>{
            let enteredName = prompt("Enter your username:", playerName);
            if (enteredName != null && enteredName != "") {
                playerName = enteredName;
                room.send("rename", playerName);
            }
        });
        // Add random button
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("button"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2 + 400),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
            "random-btn",
            "ready-ui"
        ]);
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("RANDOMIZE TEAM", {
                size: 60
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2 + 400),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
            "ready-ui"
        ]);
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onClick("random-btn", ()=>{
            room.send("randomize-team");
        });
        // Draw button and textbox
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onDraw(()=>{
            // If game has started, draw the controller
            if (gameStarted && player != null) {
                // Up button
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).drawRect({
                    width: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2,
                    height: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2,
                    pos: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2(0, 0),
                    color: currentMovement == 1 ? (0, $ad2bcec7a0192558$export$342063e11d6c3cad).CYAN : (0, $ad2bcec7a0192558$export$342063e11d6c3cad).YELLOW,
                    outline: {
                        color: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLACK,
                        width: 2
                    }
                });
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).drawText({
                    text: "UP",
                    size: 48,
                    width: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2,
                    align: "center",
                    font: "sans-serif",
                    pos: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2(0, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.25),
                    color: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLACK
                });
                // Down button
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).drawRect({
                    width: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2,
                    height: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2,
                    pos: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2(0, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2),
                    color: currentMovement == -1 ? (0, $ad2bcec7a0192558$export$342063e11d6c3cad).CYAN : (0, $ad2bcec7a0192558$export$342063e11d6c3cad).YELLOW,
                    outline: {
                        color: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLACK,
                        width: 2
                    }
                });
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).drawText({
                    text: "DOWN",
                    size: 48,
                    width: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2,
                    align: "center",
                    font: "sans-serif",
                    pos: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2(0, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.75),
                    color: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLACK
                });
                // Shoot Button
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).drawRect({
                    width: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2,
                    height: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2,
                    pos: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2),
                    color: isShooting ? (0, $ad2bcec7a0192558$export$342063e11d6c3cad).CYAN : (0, $ad2bcec7a0192558$export$342063e11d6c3cad).YELLOW,
                    outline: {
                        color: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLACK,
                        width: 2
                    }
                });
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).drawText({
                    text: player.reloadTimer == 0 ? `SHOOT\n(${player.bulletLeft}/20)` : (3000 - player.reloadTimer) / 1000 + "s",
                    size: 32,
                    width: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2,
                    align: "center",
                    font: "sans-serif",
                    pos: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.75),
                    color: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLACK
                });
            } else {
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).drawRect({
                    width: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() * 0.6,
                    height: 100,
                    pos: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2 - (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() * 0.6 / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2 - 250),
                    outline: {
                        color: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLACK,
                        width: 2
                    }
                });
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).drawText({
                    text: playerName,
                    size: 48,
                    width: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2,
                    align: "left",
                    font: "sans-serif",
                    pos: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2 - (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() * 0.6 / 2 + 10, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2 - 220),
                    color: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).BLACK
                });
            }
        });
        // Input Events
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onTouchStart((pos, t)=>{
            onClick(pos);
        });
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onTouchEnd((pos, t)=>{
            onUnclick(pos);
        });
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onMousePress((m)=>{
            onClick((0, $ad2bcec7a0192558$export$342063e11d6c3cad).mousePos());
        });
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onMouseRelease((m)=>{
            onUnclick((0, $ad2bcec7a0192558$export$342063e11d6c3cad).mousePos());
        });
        function onClick(pos) {
            if (!gameStarted) return;
            console.log("shoot once");
            // If it is on the left side, means it's up or down
            if (pos.x < (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2) {
                if (pos.y < (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2) currentMovement = 1;
                else currentMovement = -1;
                room.send("movement", currentMovement);
            } else {
                if (pos.y > (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2) isShooting = true;
                room.send("isShooting", isShooting);
            }
        }
        function onUnclick(pos) {
            if (!gameStarted) return;
            // Unclick on left side is always movement stop
            if (pos.x < (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2) {
                currentMovement = 0;
                room.send("movement", 0);
            } else // Bottom right is stop shooting
            if (pos.y > (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() / 2) {
                isShooting = false;
                room.send("isShooting", false);
            }
        }
    });
}




function $798722542a97bbbb$export$fcf043fe5400fa31() {
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).scene("controller-game-over-scene", (room, winnerId)=>{
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).setBackground(40, 30, 90);
        // If there are still existing players in-game from both team, we show game over only.
        if (winnerId == null) (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("GAME OVER!", {
                size: 60
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).center()),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center")
        ]);
        else {
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text(winnerId != -1 ? `TEAM ${(0, $3bb57e0082fd26be$export$778eb3b71add413c)(winnerId)} WIN!` : "TIE", {
                    size: 60
                }),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).center()),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center")
            ]);
            const player = room.state.players.get(room.sessionId);
            if (player != null && player.isHost) {
                // Add host button
                const restartBtn = (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
                    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).sprite("button"),
                    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.75),
                    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center"),
                    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).area(),
                    "restart-btn"
                ]);
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
                    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("RESTART", {
                        size: 60
                    }),
                    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.75),
                    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center")
                ]);
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onClick("restart-btn", ()=>{
                    room.send("restart");
                });
            }
            room.onMessage("restart", ()=>{
                room.removeAllListeners();
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).go("controller", room);
            });
        }
    });
}





function $b4401dd0e1b90ff3$export$b00c5e6af0f31606() {
    (0, $ad2bcec7a0192558$export$342063e11d6c3cad).scene("screen-game-over-scene", (room, message)=>{
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).setBackground(40, 30, 90);
        let winnerId = message.winnerId;
        let killfeeds = message.killfeeds;
        // Center text to show winner team
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text(winnerId != -1 ? `TEAM ${(0, $3bb57e0082fd26be$export$778eb3b71add413c)(winnerId)} WIN!` : "TIE", {
                size: 60
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).center()),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center")
        ]);
        // Bottom text to show host restart prompt
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text("WAITING FOR HOST TO RESTART", {
                size: 22
            }),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() / 2, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() - 100),
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("center")
        ]);
        // Top right corner text to show killfeeds
        console.log(killfeeds);
        let index = 0;
        for (let killfeed of killfeeds){
            let killer = killfeed[0];
            let victim = killfeed[1];
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).add([
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).text(killer != null ? `${killer} killed ${victim}` : `${victim} crashed`, {
                    size: 22
                }),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).pos((0, $ad2bcec7a0192558$export$342063e11d6c3cad).width() * 0.9, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() * 0.1 + 26 * index++),
                (0, $ad2bcec7a0192558$export$342063e11d6c3cad).anchor("right")
            ]);
        }
        // Auto restart timer
        var timer = 5;
        function startRestartTimer() {
            setTimeout(()=>{
                timer -= 1;
                if (timer >= 1) startRestartTimer();
                else room.send("restart");
            }, 1000);
        }
        startRestartTimer();
        // Bottom text to show auto restart timer
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onDraw(()=>{
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).drawText({
                text: timer >= 1 ? `(auto restart in ${timer}s)` : "RESTARTING ...",
                size: 18,
                width: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).width(),
                align: "center",
                font: "sans-serif",
                pos: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).vec2(0, (0, $ad2bcec7a0192558$export$342063e11d6c3cad).height() - 60),
                color: (0, $ad2bcec7a0192558$export$342063e11d6c3cad).WHITE
            });
        });
        // Restart on mouse press anywhere on screen
        (0, $ad2bcec7a0192558$export$342063e11d6c3cad).onMousePress(()=>{
            room.send("restart");
        });
        // When received restart message, we restart
        room.onMessage("restart", ()=>{
            room.removeAllListeners();
            (0, $ad2bcec7a0192558$export$342063e11d6c3cad).go("host-waiting", room);
        });
    });
}


const $ad2bcec7a0192558$export$342063e11d6c3cad = (0, $adc7cb3c45508c7c$export$2e2bcd8739ae039)({
    background: "41D9FF"
});

// Load button sprite
$ad2bcec7a0192558$export$342063e11d6c3cad.loadSprite("button", (parcelRequire("bd78o")));
var $ad2bcec7a0192558$export$388e0302ca0d9a41 = new $243a0fb2392e59c4$exports.Client({
    hostname: "server.airparty.app",
    secure: true
}); // { hostname: "server.airparty.app", secure: true }
// Create scenes
(0, $db66ba7ef0c12961$export$c176e62365027b8f)();
(0, $aff5493c4b0f6dcb$export$a8fc8cdbeb17e167)();
(0, $80724bba80cf29f0$export$950db519dcdb75ac)();
(0, $798722542a97bbbb$export$fcf043fe5400fa31)();
(0, $3bb57e0082fd26be$export$24987696a9498776)();
(0, $b4401dd0e1b90ff3$export$b00c5e6af0f31606)();
// Only allow running on whitelisted domain
var $ad2bcec7a0192558$var$whitelistedDomains = [
    "192.168.1.39:1234",
    "127.0.0.1:1234",
    "airparty.app"
];
if ($ad2bcec7a0192558$var$whitelistedDomains.includes(window.location.host)) {
    if (location.hash != "") $ad2bcec7a0192558$export$388e0302ca0d9a41.joinById(location.hash.substring(1)).then((room)=>{
        $ad2bcec7a0192558$export$342063e11d6c3cad.go("controller", room);
    }).catch((e)=>{
        location.hash = "";
        location.reload();
    });
    else $ad2bcec7a0192558$export$342063e11d6c3cad.go("menu");
}


//# sourceMappingURL=index.430533af.js.map
